export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: string | number; output: string | number };
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string };
  Decimal: { input: number; output: number };
  FileUpload: { input: globalThis.File; output: globalThis.File };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Json: { input: any; output: any };
};

export const AccessRestrictionMode = {
  Blacklist: 'Blacklist',
  Whitelist: 'Whitelist',
} as const;

export type AccessRestrictionMode =
  (typeof AccessRestrictionMode)[keyof typeof AccessRestrictionMode];
export type AccessRestrictionModeFilter = {
  equals?: InputMaybe<AccessRestrictionMode>;
  in?: InputMaybe<Array<AccessRestrictionMode>>;
  not?: InputMaybe<AccessRestrictionModeFilter>;
  notIn?: InputMaybe<Array<AccessRestrictionMode>>;
};

export const ActiveInactive = {
  Active: 'Active',
  Inactive: 'Inactive',
} as const;

export type ActiveInactive = (typeof ActiveInactive)[keyof typeof ActiveInactive];
export type ActiveInactiveFilter = {
  equals?: InputMaybe<ActiveInactive>;
  in?: InputMaybe<Array<ActiveInactive>>;
  not?: InputMaybe<ActiveInactiveFilter>;
  notIn?: InputMaybe<Array<ActiveInactive>>;
};

export type ActiveInactiveUpdate = {
  set?: InputMaybe<ActiveInactive>;
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  authorDisplayName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyDisplayName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['ID']['output']>;
  heading: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inboxItem: InboxItem;
  inboxItemId: Scalars['ID']['output'];
  platformStaff?: Maybe<PlatformStaff>;
  platformStaffId?: Maybe<Scalars['ID']['output']>;
  type: ActivityLogType;
  updatedAt: Scalars['DateTime']['output'];
  visibleFor: Array<ActivityLogVisibleFor>;
};

export type ActivityLogCreate = {
  authorDisplayName?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyDisplayName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<FileCreateRelationWithoutActivityLogFiles>;
  heading: Scalars['String']['input'];
  inboxItem: InboxItemCreateRelationWithoutActivityLogs;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutActivityLogs>;
  type?: InputMaybe<ActivityLogType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visibleFor?: InputMaybe<Array<ActivityLogVisibleFor>>;
};

export type ActivityLogCreateMany = {
  authorDisplayName?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyDisplayName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  heading: Scalars['String']['input'];
  inboxItemId: Scalars['ID']['input'];
  platformStaffId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ActivityLogType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visibleFor?: InputMaybe<Array<ActivityLogVisibleFor>>;
};

export type ActivityLogCreateRelationListWithoutFile = {
  connect?: InputMaybe<Array<ActivityLogWhereUnique>>;
  create?: InputMaybe<Array<ActivityLogCreateWithoutFile>>;
};

export type ActivityLogCreateRelationListWithoutInboxItem = {
  connect?: InputMaybe<Array<ActivityLogWhereUnique>>;
  create?: InputMaybe<Array<ActivityLogCreateWithoutInboxItem>>;
};

export type ActivityLogCreateRelationListWithoutPlatformStaff = {
  connect?: InputMaybe<Array<ActivityLogWhereUnique>>;
  create?: InputMaybe<Array<ActivityLogCreateWithoutPlatformStaff>>;
};

export type ActivityLogCreateWithoutFile = {
  authorDisplayName?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyDisplayName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading: Scalars['String']['input'];
  inboxItem: InboxItemCreateRelationWithoutActivityLogs;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutActivityLogs>;
  type?: InputMaybe<ActivityLogType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visibleFor?: InputMaybe<Array<ActivityLogVisibleFor>>;
};

export type ActivityLogCreateWithoutInboxItem = {
  authorDisplayName?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyDisplayName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<FileCreateRelationWithoutActivityLogFiles>;
  heading: Scalars['String']['input'];
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutActivityLogs>;
  type?: InputMaybe<ActivityLogType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visibleFor?: InputMaybe<Array<ActivityLogVisibleFor>>;
};

export type ActivityLogCreateWithoutPlatformStaff = {
  authorDisplayName?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyDisplayName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<FileCreateRelationWithoutActivityLogFiles>;
  heading: Scalars['String']['input'];
  inboxItem: InboxItemCreateRelationWithoutActivityLogs;
  type?: InputMaybe<ActivityLogType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visibleFor?: InputMaybe<Array<ActivityLogVisibleFor>>;
};

export type ActivityLogOrderBy = {
  authorDisplayName?: InputMaybe<SortOrderInput>;
  comment?: InputMaybe<SortOrderInput>;
  companyDisplayName?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  file?: InputMaybe<FileOrderBy>;
  fileId?: InputMaybe<SortOrderInput>;
  heading?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inboxItem?: InputMaybe<InboxItemOrderBy>;
  inboxItemId?: InputMaybe<SortOrder>;
  platformStaff?: InputMaybe<PlatformStaffOrderBy>;
  platformStaffId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export const ActivityLogType = {
  Accepted: 'Accepted',
  AdminNoteAdded: 'Admin_Note_Added',
  Commented: 'Commented',
  Declined: 'Declined',
  DisputeCreated: 'Dispute_Created',
  Downloaded: 'Downloaded',
  Requested: 'Requested',
  Sent: 'Sent',
  Viewed: 'Viewed',
} as const;

export type ActivityLogType = (typeof ActivityLogType)[keyof typeof ActivityLogType];
export type ActivityLogTypeFilter = {
  equals?: InputMaybe<ActivityLogType>;
  in?: InputMaybe<Array<ActivityLogType>>;
  not?: InputMaybe<ActivityLogTypeFilter>;
  notIn?: InputMaybe<Array<ActivityLogType>>;
};

export type ActivityLogTypeUpdate = {
  set?: InputMaybe<ActivityLogType>;
};

export type ActivityLogUpdate = {
  authorDisplayName?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyDisplayName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<FileUpdateRelationWithoutActivityLogFiles>;
  heading?: InputMaybe<Scalars['String']['input']>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutActivityLogs>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutActivityLogs>;
  type?: InputMaybe<ActivityLogType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visibleFor?: InputMaybe<ActivityLogVisibleForListUpdate>;
};

export type ActivityLogUpdateMany = {
  authorDisplayName?: InputMaybe<StringUpdate>;
  comment?: InputMaybe<StringUpdate>;
  companyDisplayName?: InputMaybe<StringUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  fileId?: InputMaybe<IdUpdate>;
  heading?: InputMaybe<StringUpdate>;
  inboxItemId?: InputMaybe<IdUpdate>;
  platformStaffId?: InputMaybe<IdUpdate>;
  type?: InputMaybe<ActivityLogTypeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  visibleFor?: InputMaybe<ActivityLogVisibleForListUpdate>;
};

export type ActivityLogUpdateRelationListWithoutFile = {
  connect?: InputMaybe<Array<ActivityLogWhereUnique>>;
  create?: InputMaybe<Array<ActivityLogCreateWithoutFile>>;
  disconnect?: InputMaybe<Array<ActivityLogWhereUnique>>;
  set?: InputMaybe<Array<ActivityLogWhereUnique>>;
};

export type ActivityLogUpdateRelationListWithoutInboxItem = {
  connect?: InputMaybe<Array<ActivityLogWhereUnique>>;
  create?: InputMaybe<Array<ActivityLogCreateWithoutInboxItem>>;
  disconnect?: InputMaybe<Array<ActivityLogWhereUnique>>;
  set?: InputMaybe<Array<ActivityLogWhereUnique>>;
};

export type ActivityLogUpdateRelationListWithoutPlatformStaff = {
  connect?: InputMaybe<Array<ActivityLogWhereUnique>>;
  create?: InputMaybe<Array<ActivityLogCreateWithoutPlatformStaff>>;
  disconnect?: InputMaybe<Array<ActivityLogWhereUnique>>;
  set?: InputMaybe<Array<ActivityLogWhereUnique>>;
};

export const ActivityLogVisibleFor = {
  Employee: 'Employee',
  Employer: 'Employer',
  PeoOrProvider: 'Peo_Or_Provider',
  Verifier: 'Verifier',
} as const;

export type ActivityLogVisibleFor =
  (typeof ActivityLogVisibleFor)[keyof typeof ActivityLogVisibleFor];
export type ActivityLogVisibleForListFilter = {
  equals?: InputMaybe<Array<ActivityLogVisibleFor>>;
  has?: InputMaybe<ActivityLogVisibleFor>;
  hasEvery?: InputMaybe<Array<ActivityLogVisibleFor>>;
  hasSome?: InputMaybe<Array<ActivityLogVisibleFor>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityLogVisibleForListUpdate = {
  push?: InputMaybe<Array<ActivityLogVisibleFor>>;
  set?: InputMaybe<Array<ActivityLogVisibleFor>>;
};

export type ActivityLogWhere = {
  AND?: InputMaybe<Array<ActivityLogWhere>>;
  NOT?: InputMaybe<Array<ActivityLogWhere>>;
  OR?: InputMaybe<Array<ActivityLogWhere>>;
  authorDisplayName?: InputMaybe<StringFilter>;
  comment?: InputMaybe<StringFilter>;
  companyDisplayName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<FileWhere>;
  fileId?: InputMaybe<IdFilter>;
  heading?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  inboxItem?: InputMaybe<InboxItemWhere>;
  inboxItemId?: InputMaybe<IdFilter>;
  platformStaff?: InputMaybe<PlatformStaffWhere>;
  platformStaffId?: InputMaybe<IdFilter>;
  type?: InputMaybe<ActivityLogTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visibleFor?: InputMaybe<ActivityLogVisibleForListFilter>;
};

export type ActivityLogWhereRelationList = {
  every?: InputMaybe<ActivityLogWhere>;
  none?: InputMaybe<ActivityLogWhere>;
  some?: InputMaybe<ActivityLogWhere>;
};

export type ActivityLogWhereUnique = {
  id: Scalars['ID']['input'];
};

export type ActivityLogsListItem = {
  __typename?: 'ActivityLogsListItem';
  authorDisplayName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyDisplayName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<FileResponse>;
  heading: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  platformStaffId?: Maybe<Scalars['ID']['output']>;
  type: ActivityLogType;
  visibleFor: Array<ActivityLogVisibleFor>;
};

export type Address = {
  __typename?: 'Address';
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employee?: Maybe<Employee>;
  employeePosition?: Maybe<Position>;
  employerHeadquarters?: Maybe<Employer>;
  id: Scalars['ID']['output'];
  peoPayrollProvidersCount: Scalars['Int']['output'];
  peoPayrollProvidersList: Array<PeoPayrollProvider>;
  peosCount: Scalars['Int']['output'];
  peosList: Array<Peo>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  verifier?: Maybe<Verifier>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressPeoPayrollProvidersCountArgs = {
  where?: InputMaybe<PeoPayrollProviderWhere>;
};

export type AddressPeoPayrollProvidersListArgs = {
  orderBy?: InputMaybe<Array<PeoPayrollProviderOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoPayrollProviderWhere>;
};

export type AddressPeosCountArgs = {
  where?: InputMaybe<PeoWhere>;
};

export type AddressPeosListArgs = {
  orderBy?: InputMaybe<Array<PeoOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoWhere>;
};

export type AddressCreate = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeCreateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionCreateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerCreateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoCreateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateMany = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateRelationWithoutEmployee = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutEmployee>;
};

export type AddressCreateRelationWithoutEmployeePosition = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutEmployeePosition>;
};

export type AddressCreateRelationWithoutEmployerHeadquarters = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutEmployerHeadquarters>;
};

export type AddressCreateRelationWithoutPeoPayrollProviders = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutPeoPayrollProviders>;
};

export type AddressCreateRelationWithoutPeos = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutPeos>;
};

export type AddressCreateRelationWithoutUser = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutUser>;
};

export type AddressCreateRelationWithoutVerifier = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutVerifier>;
};

export type AddressCreateWithoutEmployee = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employeePosition?: InputMaybe<PositionCreateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerCreateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoCreateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateWithoutEmployeePosition = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeCreateRelationWithoutHomeAddress>;
  employerHeadquarters?: InputMaybe<EmployerCreateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoCreateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateWithoutEmployerHeadquarters = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeCreateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionCreateRelationWithoutWorkLocationAddress>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoCreateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateWithoutPeoPayrollProviders = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeCreateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionCreateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerCreateRelationWithoutHeadquarters>;
  peos?: InputMaybe<PeoCreateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateWithoutPeos = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeCreateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionCreateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerCreateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateWithoutUser = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeCreateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionCreateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerCreateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoCreateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateWithoutVerifier = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeCreateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionCreateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerCreateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoCreateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressFields = {
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressOrderBy = {
  apartment?: InputMaybe<SortOrderInput>;
  city?: InputMaybe<SortOrderInput>;
  county?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employeePosition?: InputMaybe<PositionOrderBy>;
  employerHeadquarters?: InputMaybe<EmployerOrderBy>;
  id?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrderInput>;
  street?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  verifier?: InputMaybe<VerifierOrderBy>;
  zipCode?: InputMaybe<SortOrderInput>;
};

export type AddressUpdate = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionUpdateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerUpdateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateMany = {
  apartment?: InputMaybe<StringUpdate>;
  city?: InputMaybe<StringUpdate>;
  county?: InputMaybe<StringUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  state?: InputMaybe<StringUpdate>;
  street?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  zipCode?: InputMaybe<StringUpdate>;
};

export type AddressUpdateRelationWithoutEmployee = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutEmployee>;
  disconnect?: InputMaybe<AddressWhereUnique>;
  update?: InputMaybe<AddressUpdateWithoutEmployee>;
};

export type AddressUpdateRelationWithoutEmployeePosition = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutEmployeePosition>;
  disconnect?: InputMaybe<AddressWhereUnique>;
  update?: InputMaybe<AddressUpdateWithoutEmployeePosition>;
};

export type AddressUpdateRelationWithoutEmployerHeadquarters = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutEmployerHeadquarters>;
  disconnect?: InputMaybe<AddressWhereUnique>;
  update?: InputMaybe<AddressUpdateWithoutEmployerHeadquarters>;
};

export type AddressUpdateRelationWithoutPeoPayrollProviders = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutPeoPayrollProviders>;
  disconnect?: InputMaybe<AddressWhereUnique>;
  update?: InputMaybe<AddressUpdateWithoutPeoPayrollProviders>;
};

export type AddressUpdateRelationWithoutPeos = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutPeos>;
  disconnect?: InputMaybe<AddressWhereUnique>;
  update?: InputMaybe<AddressUpdateWithoutPeos>;
};

export type AddressUpdateRelationWithoutUser = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutUser>;
  disconnect?: InputMaybe<AddressWhereUnique>;
  update?: InputMaybe<AddressUpdateWithoutUser>;
};

export type AddressUpdateRelationWithoutVerifier = {
  connect?: InputMaybe<AddressWhereUnique>;
  create?: InputMaybe<AddressCreateWithoutVerifier>;
  disconnect?: InputMaybe<AddressWhereUnique>;
  update?: InputMaybe<AddressUpdateWithoutVerifier>;
};

export type AddressUpdateWithoutEmployee = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employeePosition?: InputMaybe<PositionUpdateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerUpdateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateWithoutEmployeePosition = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutHomeAddress>;
  employerHeadquarters?: InputMaybe<EmployerUpdateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateWithoutEmployerHeadquarters = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionUpdateRelationWithoutWorkLocationAddress>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateWithoutPeoPayrollProviders = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionUpdateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerUpdateRelationWithoutHeadquarters>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateWithoutPeos = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionUpdateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerUpdateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutAddress>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateWithoutUser = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionUpdateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerUpdateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateWithoutVerifier = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutHomeAddress>;
  employeePosition?: InputMaybe<PositionUpdateRelationWithoutWorkLocationAddress>;
  employerHeadquarters?: InputMaybe<EmployerUpdateRelationWithoutHeadquarters>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutHeadquarters>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutHeadquarters>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutAddress>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressWhere = {
  AND?: InputMaybe<Array<AddressWhere>>;
  NOT?: InputMaybe<Array<AddressWhere>>;
  OR?: InputMaybe<Array<AddressWhere>>;
  apartment?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  county?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employee?: InputMaybe<EmployeeWhere>;
  employeePosition?: InputMaybe<PositionWhere>;
  employerHeadquarters?: InputMaybe<EmployerWhere>;
  id?: InputMaybe<IdFilter>;
  peoPayrollProviders?: InputMaybe<PeoPayrollProviderWhereRelationList>;
  peos?: InputMaybe<PeoWhereRelationList>;
  state?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  verifier?: InputMaybe<VerifierWhere>;
  zipCode?: InputMaybe<StringFilter>;
};

export type AddressWhereUnique = {
  id: Scalars['ID']['input'];
};

export type AnnualFreeReportData = {
  __typename?: 'AnnualFreeReportData';
  createdAt: Scalars['DateTime']['output'];
  file: FileResponse;
};

export const AnnualFreeReportStatus = {
  AlreadyExists: 'ALREADY_EXISTS',
  Generated: 'GENERATED',
} as const;

export type AnnualFreeReportStatus =
  (typeof AnnualFreeReportStatus)[keyof typeof AnnualFreeReportStatus];
export type ApiToken = {
  __typename?: 'ApiToken';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: UserRole;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ApiTokenCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  role: UserRole;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiTokenCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  role: UserRole;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiTokenOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ApiTokenUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiTokenUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  name?: InputMaybe<StringUpdate>;
  role?: InputMaybe<UserRoleUpdate>;
  token?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type ApiTokenWhere = {
  AND?: InputMaybe<Array<ApiTokenWhere>>;
  NOT?: InputMaybe<Array<ApiTokenWhere>>;
  OR?: InputMaybe<Array<ApiTokenWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  role?: InputMaybe<UserRoleFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ApiTokenWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ApiVerificationRequest = {
  __typename?: 'ApiVerificationRequest';
  createdAt: Scalars['DateTime']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  generatedReportsCount: Scalars['Int']['output'];
  generatedReportsList: Array<GeneratedReport>;
  id: Scalars['ID']['output'];
  inboxItem: InboxItem;
  inboxItemId: Scalars['ID']['output'];
  integration: Integration;
  integrationId: Scalars['ID']['output'];
  mdmMetadata?: Maybe<Scalars['Json']['output']>;
  mdmMetadataObjectHash?: Maybe<Scalars['String']['output']>;
  type: VerificationRequestType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ApiVerificationRequestGeneratedReportsCountArgs = {
  where?: InputMaybe<GeneratedReportWhere>;
};

export type ApiVerificationRequestGeneratedReportsListArgs = {
  orderBy?: InputMaybe<Array<GeneratedReportOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GeneratedReportWhere>;
};

export type ApiVerificationRequestCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutApiVerificationRequests;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutApiVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutApiVerificationRequest;
  integration: IntegrationCreateRelationWithoutApiVerificationRequests;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type: VerificationRequestType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiVerificationRequestCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId: Scalars['ID']['input'];
  inboxItemId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type: VerificationRequestType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiVerificationRequestCreateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<ApiVerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<ApiVerificationRequestCreateWithoutEmployee>>;
};

export type ApiVerificationRequestCreateRelationListWithoutIntegration = {
  connect?: InputMaybe<Array<ApiVerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<ApiVerificationRequestCreateWithoutIntegration>>;
};

export type ApiVerificationRequestCreateRelationWithoutGeneratedReports = {
  connect?: InputMaybe<ApiVerificationRequestWhereUnique>;
  create?: InputMaybe<ApiVerificationRequestCreateWithoutGeneratedReports>;
};

export type ApiVerificationRequestCreateRelationWithoutInboxItem = {
  connect?: InputMaybe<ApiVerificationRequestWhereUnique>;
  create?: InputMaybe<ApiVerificationRequestCreateWithoutInboxItem>;
};

export type ApiVerificationRequestCreateWithoutEmployee = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutApiVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutApiVerificationRequest;
  integration: IntegrationCreateRelationWithoutApiVerificationRequests;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type: VerificationRequestType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiVerificationRequestCreateWithoutGeneratedReports = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutApiVerificationRequests;
  inboxItem: InboxItemCreateRelationWithoutApiVerificationRequest;
  integration: IntegrationCreateRelationWithoutApiVerificationRequests;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type: VerificationRequestType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiVerificationRequestCreateWithoutInboxItem = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutApiVerificationRequests;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutApiVerificationRequest>;
  integration: IntegrationCreateRelationWithoutApiVerificationRequests;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type: VerificationRequestType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiVerificationRequestCreateWithoutIntegration = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutApiVerificationRequests;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutApiVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutApiVerificationRequest;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type: VerificationRequestType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiVerificationRequestOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inboxItem?: InputMaybe<InboxItemOrderBy>;
  inboxItemId?: InputMaybe<SortOrder>;
  integration?: InputMaybe<IntegrationOrderBy>;
  integrationId?: InputMaybe<SortOrder>;
  mdmMetadata?: InputMaybe<SortOrderInput>;
  mdmMetadataObjectHash?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ApiVerificationRequestUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutApiVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutApiVerificationRequest>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutApiVerificationRequest>;
  integration?: InputMaybe<IntegrationUpdateRelationWithoutApiVerificationRequests>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiVerificationRequestUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  employeeId?: InputMaybe<IdUpdate>;
  inboxItemId?: InputMaybe<IdUpdate>;
  integrationId?: InputMaybe<IdUpdate>;
  mdmMetadata?: InputMaybe<JsonUpdate>;
  mdmMetadataObjectHash?: InputMaybe<StringUpdate>;
  type?: InputMaybe<VerificationRequestTypeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type ApiVerificationRequestUpdateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<ApiVerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<ApiVerificationRequestCreateWithoutEmployee>>;
  disconnect?: InputMaybe<Array<ApiVerificationRequestWhereUnique>>;
  set?: InputMaybe<Array<ApiVerificationRequestWhereUnique>>;
};

export type ApiVerificationRequestUpdateRelationListWithoutIntegration = {
  connect?: InputMaybe<Array<ApiVerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<ApiVerificationRequestCreateWithoutIntegration>>;
  disconnect?: InputMaybe<Array<ApiVerificationRequestWhereUnique>>;
  set?: InputMaybe<Array<ApiVerificationRequestWhereUnique>>;
};

export type ApiVerificationRequestUpdateRelationWithoutGeneratedReports = {
  connect?: InputMaybe<ApiVerificationRequestWhereUnique>;
  create?: InputMaybe<ApiVerificationRequestCreateWithoutGeneratedReports>;
  disconnect?: InputMaybe<ApiVerificationRequestWhereUnique>;
  update?: InputMaybe<ApiVerificationRequestUpdateWithoutGeneratedReports>;
};

export type ApiVerificationRequestUpdateRelationWithoutInboxItem = {
  connect?: InputMaybe<ApiVerificationRequestWhereUnique>;
  create?: InputMaybe<ApiVerificationRequestCreateWithoutInboxItem>;
  disconnect?: InputMaybe<ApiVerificationRequestWhereUnique>;
  update?: InputMaybe<ApiVerificationRequestUpdateWithoutInboxItem>;
};

export type ApiVerificationRequestUpdateWithoutGeneratedReports = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutApiVerificationRequests>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutApiVerificationRequest>;
  integration?: InputMaybe<IntegrationUpdateRelationWithoutApiVerificationRequests>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiVerificationRequestUpdateWithoutInboxItem = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutApiVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutApiVerificationRequest>;
  integration?: InputMaybe<IntegrationUpdateRelationWithoutApiVerificationRequests>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiVerificationRequestWhere = {
  AND?: InputMaybe<Array<ApiVerificationRequestWhere>>;
  NOT?: InputMaybe<Array<ApiVerificationRequestWhere>>;
  OR?: InputMaybe<Array<ApiVerificationRequestWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employee?: InputMaybe<EmployeeWhere>;
  employeeId?: InputMaybe<IdFilter>;
  generatedReports?: InputMaybe<GeneratedReportWhereRelationList>;
  id?: InputMaybe<IdFilter>;
  inboxItem?: InputMaybe<InboxItemWhere>;
  inboxItemId?: InputMaybe<IdFilter>;
  integration?: InputMaybe<IntegrationWhere>;
  integrationId?: InputMaybe<IdFilter>;
  mdmMetadataObjectHash?: InputMaybe<StringFilter>;
  type?: InputMaybe<VerificationRequestTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ApiVerificationRequestWhereRelationList = {
  every?: InputMaybe<ApiVerificationRequestWhere>;
  none?: InputMaybe<ApiVerificationRequestWhere>;
  some?: InputMaybe<ApiVerificationRequestWhere>;
};

export type ApiVerificationRequestWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  inboxItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type ApproveVerificationRequestByVerifierResponse = {
  __typename?: 'ApproveVerificationRequestByVerifierResponse';
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Attestation = {
  __typename?: 'Attestation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pdf?: Maybe<File>;
  pdfId?: Maybe<Scalars['ID']['output']>;
  purpose?: Maybe<Scalars['Json']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AttestationCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  pdf?: InputMaybe<FileCreateRelationWithoutAttestationPdfs>;
  purpose?: InputMaybe<Scalars['Json']['input']>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AttestationCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  pdfId?: InputMaybe<Scalars['ID']['input']>;
  purpose?: InputMaybe<Scalars['Json']['input']>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AttestationCreateRelationListWithoutPdf = {
  connect?: InputMaybe<Array<AttestationWhereUnique>>;
  create?: InputMaybe<Array<AttestationCreateWithoutPdf>>;
};

export type AttestationCreateWithoutPdf = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  purpose?: InputMaybe<Scalars['Json']['input']>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AttestationOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pdf?: InputMaybe<FileOrderBy>;
  pdfId?: InputMaybe<SortOrderInput>;
  purpose?: InputMaybe<SortOrderInput>;
  text?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AttestationUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pdf?: InputMaybe<FileUpdateRelationWithoutAttestationPdfs>;
  purpose?: InputMaybe<Scalars['Json']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AttestationUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  name?: InputMaybe<StringUpdate>;
  pdfId?: InputMaybe<IdUpdate>;
  purpose?: InputMaybe<JsonUpdate>;
  text?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type AttestationUpdateRelationListWithoutPdf = {
  connect?: InputMaybe<Array<AttestationWhereUnique>>;
  create?: InputMaybe<Array<AttestationCreateWithoutPdf>>;
  disconnect?: InputMaybe<Array<AttestationWhereUnique>>;
  set?: InputMaybe<Array<AttestationWhereUnique>>;
};

export type AttestationWhere = {
  AND?: InputMaybe<Array<AttestationWhere>>;
  NOT?: InputMaybe<Array<AttestationWhere>>;
  OR?: InputMaybe<Array<AttestationWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  pdf?: InputMaybe<FileWhere>;
  pdfId?: InputMaybe<IdFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AttestationWhereRelationList = {
  every?: InputMaybe<AttestationWhere>;
  none?: InputMaybe<AttestationWhere>;
  some?: InputMaybe<AttestationWhere>;
};

export type AttestationWhereUnique = {
  id: Scalars['ID']['input'];
};

export type AuthCredentials = {
  __typename?: 'AuthCredentials';
  accessToken?: Maybe<Scalars['String']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
};

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilter>;
};

export type BooleanUpdate = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BusinessFields = {
  address?: InputMaybe<AddressFields>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeUserPasswordResponse = {
  __typename?: 'ChangeUserPasswordResponse';
  mfaSession?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CheckDeletionClearVerifyStaffResponse = {
  __typename?: 'CheckDeletionClearVerifyStaffResponse';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CheckDeletionEmployeeUserResponse = {
  __typename?: 'CheckDeletionEmployeeUserResponse';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CheckDeletionEmployerStaffResponse = {
  __typename?: 'CheckDeletionEmployerStaffResponse';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CheckDeletionPeoStaffResponse = {
  __typename?: 'CheckDeletionPeoStaffResponse';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CheckDeletionVerifierResponse = {
  __typename?: 'CheckDeletionVerifierResponse';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CheckDeletionVerifierStaffResponse = {
  __typename?: 'CheckDeletionVerifierStaffResponse';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CheckEmployeeResponse = {
  __typename?: 'CheckEmployeeResponse';
  isEmployeeFrozen: Scalars['Boolean']['output'];
};

export type CheckIsAdditionalVerifierAdminResponse = {
  __typename?: 'CheckIsAdditionalVerifierAdminResponse';
  isAdditionalVerifierAdmin: Scalars['Boolean']['output'];
};

export type ClearVerifyStaffAccessInput = {
  isFinancialReportAvailable: Scalars['Boolean']['input'];
  isRecipientForMonthlyFinancialReport: Scalars['Boolean']['input'];
  role: ClearVerifyStaffRole;
};

export const ClearVerifyStaffRole = {
  Admin: 'Admin',
  Manager: 'Manager',
  SuperAdmin: 'Super_Admin',
} as const;

export type ClearVerifyStaffRole = (typeof ClearVerifyStaffRole)[keyof typeof ClearVerifyStaffRole];
export type CognitoGetCurrentUserAuthStatusResponse = {
  __typename?: 'CognitoGetCurrentUserAuthStatusResponse';
  mfaEnabled: Scalars['Boolean']['output'];
  mfaRequired: Scalars['Boolean']['output'];
  ssoEnabled: Scalars['Boolean']['output'];
};

export type CognitoGetUserMfaStatusResponse = {
  __typename?: 'CognitoGetUserMfaStatusResponse';
  mfaEnabled: Scalars['Boolean']['output'];
};

export const CompanyType = {
  Employer: 'Employer',
  Peo: 'Peo',
  PeoPayrollProvider: 'Peo_Payroll_Provider',
} as const;

export type CompanyType = (typeof CompanyType)[keyof typeof CompanyType];
export type CompanyTypeFilter = {
  equals?: InputMaybe<CompanyType>;
  in?: InputMaybe<Array<CompanyType>>;
  not?: InputMaybe<CompanyTypeFilter>;
  notIn?: InputMaybe<Array<CompanyType>>;
};

export type CompanyTypeUpdate = {
  set?: InputMaybe<CompanyType>;
};

export type CreateDataDisputeByEmployeeResponse = {
  __typename?: 'CreateDataDisputeByEmployeeResponse';
  dataDisputeId: Scalars['ID']['output'];
};

export type CreatePermissiblePurposeResponse = {
  __typename?: 'CreatePermissiblePurposeResponse';
  id: Scalars['ID']['output'];
};

export type CreateReverificationRequestResponse = {
  __typename?: 'CreateReverificationRequestResponse';
  inboxItemId?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateTestVerificationRequest = {
  __typename?: 'CreateTestVerificationRequest';
  inboxItemId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateVerificationRequestResponse = {
  __typename?: 'CreateVerificationRequestResponse';
  inboxItemId?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CurrentUserAddress = {
  __typename?: 'CurrentUserAddress';
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CurrentUserEmployee = {
  __typename?: 'CurrentUserEmployee';
  id: Scalars['ID']['output'];
  role: EmployeeRole;
};

export type CurrentUserEmployerStaff = {
  __typename?: 'CurrentUserEmployerStaff';
  employerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  role: EmployerStaffRole;
};

export type CurrentUserPeoPayrollProviderStaff = {
  __typename?: 'CurrentUserPeoPayrollProviderStaff';
  id: Scalars['ID']['output'];
  isPartnershipCompany: Scalars['Boolean']['output'];
  peoPayrollProviderId: Scalars['ID']['output'];
  role: PeoPayrollProviderStaffRole;
};

export type CurrentUserPeoStaff = {
  __typename?: 'CurrentUserPeoStaff';
  id: Scalars['ID']['output'];
  isPartnershipCompany: Scalars['Boolean']['output'];
  peoId: Scalars['ID']['output'];
  role: PeoStaffRole;
};

export type CurrentUserPlatformStaff = {
  __typename?: 'CurrentUserPlatformStaff';
  id: Scalars['ID']['output'];
  role: PlatformStaffRole;
};

export type CurrentUserResponse = {
  __typename?: 'CurrentUserResponse';
  address?: Maybe<CurrentUserAddress>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  employee?: Maybe<CurrentUserEmployee>;
  employerStaff?: Maybe<CurrentUserEmployerStaff>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastPasswordChangeAt?: Maybe<Scalars['DateTime']['output']>;
  peoPayrollProviderStaff?: Maybe<CurrentUserPeoPayrollProviderStaff>;
  peoStaff?: Maybe<CurrentUserPeoStaff>;
  platformStaff?: Maybe<CurrentUserPlatformStaff>;
  role: UserRole;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verifierStaff?: Maybe<CurrentUserVerifierStaff>;
};

export type CurrentUserVerifierStaff = {
  __typename?: 'CurrentUserVerifierStaff';
  id: Scalars['ID']['output'];
  role: VerifierStaffRole;
  verifierId: Scalars['ID']['output'];
};

export type DashboardCvAdminVerifiersDataResponse = {
  __typename?: 'DashboardCVAdminVerifiersDataResponse';
  averageCertificationHours: Scalars['Decimal']['output'];
  commercialVerifiersCount: Scalars['BigInt']['output'];
  governmentalVerifiersCount: Scalars['BigInt']['output'];
};

export type DashboardCvRevenueByVerificationTypeItem = {
  __typename?: 'DashboardCvRevenueByVerificationTypeItem';
  chargeAmount: Scalars['Decimal']['output'];
  month: Scalars['String']['output'];
  type: DashboardVerificationRequestGroup;
};

export type DashboardDataDisputeItemsCountGroupByStatus = {
  __typename?: 'DashboardDataDisputeItemsCountGroupByStatus';
  count: Scalars['Int']['output'];
  status: DataDisputeItemStatus;
};

export type DashboardEmployeeUserStatsBreakdown = {
  __typename?: 'DashboardEmployeeUserStatsBreakdown';
  Active: Scalars['Int']['output'];
  Inactive: Scalars['Int']['output'];
  Pending: Scalars['Int']['output'];
};

export type DashboardEmployeeUserStatsResponse = {
  __typename?: 'DashboardEmployeeUserStatsResponse';
  breakdown: DashboardEmployeeUserStatsBreakdown;
  percentage: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
};

export type DashboardPlatformAdminFinancialDataResponse = {
  __typename?: 'DashboardPlatformAdminFinancialDataResponse';
  commercialVerifications: Scalars['Int']['output'];
  platformRevenue: Scalars['Int']['output'];
  revenueShareOwed: Scalars['Int']['output'];
  revenueSharePaid: Scalars['Int']['output'];
  reverification: Scalars['Int']['output'];
  valueOfRecord: Scalars['Decimal']['output'];
  voe: Scalars['Int']['output'];
  voi: Scalars['Int']['output'];
};

export type DashboardPlatformAdminRevenueDistributionItem = {
  __typename?: 'DashboardPlatformAdminRevenueDistributionItem';
  month: Scalars['String']['output'];
  revenueSharePayedAmount: Scalars['BigInt']['output'];
  type: CompanyType;
};

export type DashboardPlatformAdminTopVerifierData = {
  __typename?: 'DashboardPlatformAdminTopVerifierData';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type: VerifierType;
  verificationRequestsCount: Scalars['BigInt']['output'];
};

export type DashboardRecordsActivityActiveGroup = {
  __typename?: 'DashboardRecordsActivityActiveGroup';
  Active: Scalars['Int']['output'];
  FMLA: Scalars['Int']['output'];
  IFMLA: Scalars['Int']['output'];
  Intern: Scalars['Int']['output'];
  On_Leave: Scalars['Int']['output'];
};

export type DashboardRecordsActivityInactiveGroup = {
  __typename?: 'DashboardRecordsActivityInactiveGroup';
  Deceased: Scalars['Int']['output'];
  Inactive: Scalars['Int']['output'];
  Retired: Scalars['Int']['output'];
  Separated: Scalars['Int']['output'];
  Severed_With_Pay: Scalars['Int']['output'];
  Temporarily_Inactive: Scalars['Int']['output'];
  Terminated: Scalars['Int']['output'];
  Unknown: Scalars['Int']['output'];
};

export type DashboardRecordsActivityResponse = {
  __typename?: 'DashboardRecordsActivityResponse';
  active: DashboardRecordsActivityActiveGroup;
  inactive: DashboardRecordsActivityInactiveGroup;
};

export type DashboardReportAndRevenueResponse = {
  __typename?: 'DashboardReportAndRevenueResponse';
  dashboardReportData: DashboardReportAndRevenueResponseReport;
  dashboardRevenueShareData: DashboardReportAndRevenueResponseRevenue;
};

export type DashboardReportAndRevenueResponseReport = {
  __typename?: 'DashboardReportAndRevenueResponseReport';
  activeRecordAmount: Scalars['Int']['output'];
  inactiveRecordAmount: Scalars['Int']['output'];
  pendingDataDisputeAmount: Scalars['Int']['output'];
  resolvedDataDisputeAmount: Scalars['Int']['output'];
};

export type DashboardReportAndRevenueResponseRevenue = {
  __typename?: 'DashboardReportAndRevenueResponseRevenue';
  revenueShareOwedAmount: Scalars['Int']['output'];
  revenueSharePayedAmount: Scalars['Int']['output'];
};

export type DashboardRevenueShareData = {
  __typename?: 'DashboardRevenueShareData';
  createdAt: Scalars['DateTime']['output'];
  employer?: Maybe<Employer>;
  id: Scalars['ID']['output'];
  peo?: Maybe<Peo>;
  peoPayrollProvider?: Maybe<PeoPayrollProvider>;
  revenueShareAmount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DashboardRevenueShareDatumCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutDashboardRevenueShareData>;
  peo?: InputMaybe<PeoCreateRelationWithoutDashboardRevenueShareData>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutDashboardRevenueShareData>;
  revenueShareAmount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardRevenueShareDatumCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  revenueShareAmount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardRevenueShareDatumCreateRelationWithoutEmployer = {
  connect?: InputMaybe<DashboardRevenueShareDatumWhereUnique>;
  create?: InputMaybe<DashboardRevenueShareDatumCreateWithoutEmployer>;
};

export type DashboardRevenueShareDatumCreateRelationWithoutPeo = {
  connect?: InputMaybe<DashboardRevenueShareDatumWhereUnique>;
  create?: InputMaybe<DashboardRevenueShareDatumCreateWithoutPeo>;
};

export type DashboardRevenueShareDatumCreateRelationWithoutPeoPayrollProvider = {
  connect?: InputMaybe<DashboardRevenueShareDatumWhereUnique>;
  create?: InputMaybe<DashboardRevenueShareDatumCreateWithoutPeoPayrollProvider>;
};

export type DashboardRevenueShareDatumCreateWithoutEmployer = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peo?: InputMaybe<PeoCreateRelationWithoutDashboardRevenueShareData>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutDashboardRevenueShareData>;
  revenueShareAmount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardRevenueShareDatumCreateWithoutPeo = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutDashboardRevenueShareData>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutDashboardRevenueShareData>;
  revenueShareAmount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardRevenueShareDatumCreateWithoutPeoPayrollProvider = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutDashboardRevenueShareData>;
  peo?: InputMaybe<PeoCreateRelationWithoutDashboardRevenueShareData>;
  revenueShareAmount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardRevenueShareDatumOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  employer?: InputMaybe<EmployerOrderBy>;
  id?: InputMaybe<SortOrder>;
  peo?: InputMaybe<PeoOrderBy>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderOrderBy>;
  revenueShareAmount?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DashboardRevenueShareDatumUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutDashboardRevenueShareData>;
  peo?: InputMaybe<PeoUpdateRelationWithoutDashboardRevenueShareData>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutDashboardRevenueShareData>;
  revenueShareAmount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardRevenueShareDatumUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  revenueShareAmount?: InputMaybe<IntUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type DashboardRevenueShareDatumUpdateRelationWithoutEmployer = {
  connect?: InputMaybe<DashboardRevenueShareDatumWhereUnique>;
  create?: InputMaybe<DashboardRevenueShareDatumCreateWithoutEmployer>;
  disconnect?: InputMaybe<DashboardRevenueShareDatumWhereUnique>;
  update?: InputMaybe<DashboardRevenueShareDatumUpdateWithoutEmployer>;
};

export type DashboardRevenueShareDatumUpdateRelationWithoutPeo = {
  connect?: InputMaybe<DashboardRevenueShareDatumWhereUnique>;
  create?: InputMaybe<DashboardRevenueShareDatumCreateWithoutPeo>;
  disconnect?: InputMaybe<DashboardRevenueShareDatumWhereUnique>;
  update?: InputMaybe<DashboardRevenueShareDatumUpdateWithoutPeo>;
};

export type DashboardRevenueShareDatumUpdateRelationWithoutPeoPayrollProvider = {
  connect?: InputMaybe<DashboardRevenueShareDatumWhereUnique>;
  create?: InputMaybe<DashboardRevenueShareDatumCreateWithoutPeoPayrollProvider>;
  disconnect?: InputMaybe<DashboardRevenueShareDatumWhereUnique>;
  update?: InputMaybe<DashboardRevenueShareDatumUpdateWithoutPeoPayrollProvider>;
};

export type DashboardRevenueShareDatumUpdateWithoutEmployer = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peo?: InputMaybe<PeoUpdateRelationWithoutDashboardRevenueShareData>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutDashboardRevenueShareData>;
  revenueShareAmount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardRevenueShareDatumUpdateWithoutPeo = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutDashboardRevenueShareData>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutDashboardRevenueShareData>;
  revenueShareAmount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardRevenueShareDatumUpdateWithoutPeoPayrollProvider = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutDashboardRevenueShareData>;
  peo?: InputMaybe<PeoUpdateRelationWithoutDashboardRevenueShareData>;
  revenueShareAmount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardRevenueShareDatumWhere = {
  AND?: InputMaybe<Array<DashboardRevenueShareDatumWhere>>;
  NOT?: InputMaybe<Array<DashboardRevenueShareDatumWhere>>;
  OR?: InputMaybe<Array<DashboardRevenueShareDatumWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employer?: InputMaybe<EmployerWhere>;
  id?: InputMaybe<IdFilter>;
  peo?: InputMaybe<PeoWhere>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderWhere>;
  revenueShareAmount?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DashboardRevenueShareDatumWhereUnique = {
  id: Scalars['ID']['input'];
};

export type DashboardUsageReportItem = {
  __typename?: 'DashboardUsageReportItem';
  count: Scalars['BigInt']['output'];
  month: Scalars['String']['output'];
  type: DashboardVerificationRequestGroup;
};

export const DashboardVerificationRequestGroup = {
  Governmental: 'Governmental',
  Reverification: 'Reverification',
  VerificationOfEmployment: 'Verification_Of_Employment',
  VerificationOfIncome: 'Verification_Of_Income',
} as const;

export type DashboardVerificationRequestGroup =
  (typeof DashboardVerificationRequestGroup)[keyof typeof DashboardVerificationRequestGroup];
export type DashboardVerificationRequestsCountGroupByIsManual = {
  __typename?: 'DashboardVerificationRequestsCountGroupByIsManual';
  count: Scalars['Int']['output'];
  isManual: Scalars['Boolean']['output'];
};

export type DashboardVerificationRequestsCountGroupByStatus = {
  __typename?: 'DashboardVerificationRequestsCountGroupByStatus';
  count: Scalars['Int']['output'];
  status: VerificationRequestStatus;
};

export type DashboardVerifiersCountGroupByCredentialStatus = {
  __typename?: 'DashboardVerifiersCountGroupByCredentialStatus';
  count: Scalars['Int']['output'];
  status: VerifierCredentialStatus;
};

export type DashboardWorkLetterUsageItem = {
  __typename?: 'DashboardWorkLetterUsageItem';
  count: Scalars['BigInt']['output'];
  month: Scalars['String']['output'];
  type: EmployeeWorkLetterType;
};

export type DataDispute = {
  __typename?: 'DataDispute';
  createdAt: Scalars['DateTime']['output'];
  dataDisputeItemsCount: Scalars['Int']['output'];
  dataDisputeItemsList: Array<DataDisputeItem>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  inboxItem: InboxItem;
  inboxItemId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verificationRequest?: Maybe<VerificationRequest>;
  verificationRequestId?: Maybe<Scalars['ID']['output']>;
};

export type DataDisputeDataDisputeItemsCountArgs = {
  where?: InputMaybe<DataDisputeItemWhere>;
};

export type DataDisputeDataDisputeItemsListArgs = {
  orderBy?: InputMaybe<Array<DataDisputeItemOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataDisputeItemWhere>;
};

export type DataDisputeCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutDataDispute>;
  employee: EmployeeCreateRelationWithoutDataDisputes;
  inboxItem: InboxItemCreateRelationWithoutDataDispute;
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutDataDisputes>;
};

export type DataDisputeCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId: Scalars['ID']['input'];
  inboxItemId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type DataDisputeCreateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<DataDisputeWhereUnique>>;
  create?: InputMaybe<Array<DataDisputeCreateWithoutEmployee>>;
};

export type DataDisputeCreateRelationListWithoutVerificationRequest = {
  connect?: InputMaybe<Array<DataDisputeWhereUnique>>;
  create?: InputMaybe<Array<DataDisputeCreateWithoutVerificationRequest>>;
};

export type DataDisputeCreateRelationWithoutDataDisputeItems = {
  connect?: InputMaybe<DataDisputeWhereUnique>;
  create?: InputMaybe<DataDisputeCreateWithoutDataDisputeItems>;
};

export type DataDisputeCreateRelationWithoutInboxItem = {
  connect?: InputMaybe<DataDisputeWhereUnique>;
  create?: InputMaybe<DataDisputeCreateWithoutInboxItem>;
};

export type DataDisputeCreateWithoutDataDisputeItems = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutDataDisputes;
  inboxItem: InboxItemCreateRelationWithoutDataDispute;
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutDataDisputes>;
};

export type DataDisputeCreateWithoutEmployee = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutDataDispute>;
  inboxItem: InboxItemCreateRelationWithoutDataDispute;
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutDataDisputes>;
};

export type DataDisputeCreateWithoutInboxItem = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutDataDispute>;
  employee: EmployeeCreateRelationWithoutDataDisputes;
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutDataDisputes>;
};

export type DataDisputeCreateWithoutVerificationRequest = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutDataDispute>;
  employee: EmployeeCreateRelationWithoutDataDisputes;
  inboxItem: InboxItemCreateRelationWithoutDataDispute;
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DataDisputeItem = {
  __typename?: 'DataDisputeItem';
  createdAt: Scalars['DateTime']['output'];
  dataDispute: DataDispute;
  dataDisputeId: Scalars['ID']['output'];
  employer: Employer;
  employerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status: DataDisputeItemStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type DataDisputeItemCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute: DataDisputeCreateRelationWithoutDataDisputeItems;
  employer: EmployerCreateRelationWithoutDataDisputeItems;
  status?: InputMaybe<DataDisputeItemStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DataDisputeItemCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputeId: Scalars['ID']['input'];
  employerId: Scalars['ID']['input'];
  status?: InputMaybe<DataDisputeItemStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DataDisputeItemCreateRelationListWithoutDataDispute = {
  connect?: InputMaybe<Array<DataDisputeItemWhereUnique>>;
  create?: InputMaybe<Array<DataDisputeItemCreateWithoutDataDispute>>;
};

export type DataDisputeItemCreateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<DataDisputeItemWhereUnique>>;
  create?: InputMaybe<Array<DataDisputeItemCreateWithoutEmployer>>;
};

export type DataDisputeItemCreateWithoutDataDispute = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer: EmployerCreateRelationWithoutDataDisputeItems;
  status?: InputMaybe<DataDisputeItemStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DataDisputeItemCreateWithoutEmployer = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute: DataDisputeCreateRelationWithoutDataDisputeItems;
  status?: InputMaybe<DataDisputeItemStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DataDisputeItemOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  dataDispute?: InputMaybe<DataDisputeOrderBy>;
  dataDisputeId?: InputMaybe<SortOrder>;
  employer?: InputMaybe<EmployerOrderBy>;
  employerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export const DataDisputeItemStatus = {
  InProgress: 'In_Progress',
  Resolved: 'Resolved',
} as const;

export type DataDisputeItemStatus =
  (typeof DataDisputeItemStatus)[keyof typeof DataDisputeItemStatus];
export type DataDisputeItemStatusFilter = {
  equals?: InputMaybe<DataDisputeItemStatus>;
  in?: InputMaybe<Array<DataDisputeItemStatus>>;
  not?: InputMaybe<DataDisputeItemStatusFilter>;
  notIn?: InputMaybe<Array<DataDisputeItemStatus>>;
};

export type DataDisputeItemStatusUpdate = {
  set?: InputMaybe<DataDisputeItemStatus>;
};

export type DataDisputeItemUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeUpdateRelationWithoutDataDisputeItems>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutDataDisputeItems>;
  status?: InputMaybe<DataDisputeItemStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DataDisputeItemUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  dataDisputeId?: InputMaybe<IdUpdate>;
  employerId?: InputMaybe<IdUpdate>;
  status?: InputMaybe<DataDisputeItemStatusUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type DataDisputeItemUpdateRelationListWithoutDataDispute = {
  connect?: InputMaybe<Array<DataDisputeItemWhereUnique>>;
  create?: InputMaybe<Array<DataDisputeItemCreateWithoutDataDispute>>;
  disconnect?: InputMaybe<Array<DataDisputeItemWhereUnique>>;
  set?: InputMaybe<Array<DataDisputeItemWhereUnique>>;
};

export type DataDisputeItemUpdateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<DataDisputeItemWhereUnique>>;
  create?: InputMaybe<Array<DataDisputeItemCreateWithoutEmployer>>;
  disconnect?: InputMaybe<Array<DataDisputeItemWhereUnique>>;
  set?: InputMaybe<Array<DataDisputeItemWhereUnique>>;
};

export type DataDisputeItemWhere = {
  AND?: InputMaybe<Array<DataDisputeItemWhere>>;
  NOT?: InputMaybe<Array<DataDisputeItemWhere>>;
  OR?: InputMaybe<Array<DataDisputeItemWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataDispute?: InputMaybe<DataDisputeWhere>;
  dataDisputeId?: InputMaybe<IdFilter>;
  employer?: InputMaybe<EmployerWhere>;
  employerId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  status?: InputMaybe<DataDisputeItemStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DataDisputeItemWhereRelationList = {
  every?: InputMaybe<DataDisputeItemWhere>;
  none?: InputMaybe<DataDisputeItemWhere>;
  some?: InputMaybe<DataDisputeItemWhere>;
};

export type DataDisputeItemWhereUnique = {
  id: Scalars['ID']['input'];
};

export type DataDisputeOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inboxItem?: InputMaybe<InboxItemOrderBy>;
  inboxItemId?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verificationRequest?: InputMaybe<VerificationRequestOrderBy>;
  verificationRequestId?: InputMaybe<SortOrderInput>;
};

export type DataDisputeUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutDataDispute>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutDataDisputes>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutDataDispute>;
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutDataDisputes>;
};

export type DataDisputeUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  employeeId?: InputMaybe<IdUpdate>;
  inboxItemId?: InputMaybe<IdUpdate>;
  reason?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  verificationRequestId?: InputMaybe<IdUpdate>;
};

export type DataDisputeUpdateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<DataDisputeWhereUnique>>;
  create?: InputMaybe<Array<DataDisputeCreateWithoutEmployee>>;
  disconnect?: InputMaybe<Array<DataDisputeWhereUnique>>;
  set?: InputMaybe<Array<DataDisputeWhereUnique>>;
};

export type DataDisputeUpdateRelationListWithoutVerificationRequest = {
  connect?: InputMaybe<Array<DataDisputeWhereUnique>>;
  create?: InputMaybe<Array<DataDisputeCreateWithoutVerificationRequest>>;
  disconnect?: InputMaybe<Array<DataDisputeWhereUnique>>;
  set?: InputMaybe<Array<DataDisputeWhereUnique>>;
};

export type DataDisputeUpdateRelationWithoutDataDisputeItems = {
  connect?: InputMaybe<DataDisputeWhereUnique>;
  create?: InputMaybe<DataDisputeCreateWithoutDataDisputeItems>;
  disconnect?: InputMaybe<DataDisputeWhereUnique>;
  update?: InputMaybe<DataDisputeUpdateWithoutDataDisputeItems>;
};

export type DataDisputeUpdateRelationWithoutInboxItem = {
  connect?: InputMaybe<DataDisputeWhereUnique>;
  create?: InputMaybe<DataDisputeCreateWithoutInboxItem>;
  disconnect?: InputMaybe<DataDisputeWhereUnique>;
  update?: InputMaybe<DataDisputeUpdateWithoutInboxItem>;
};

export type DataDisputeUpdateWithoutDataDisputeItems = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutDataDisputes>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutDataDispute>;
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutDataDisputes>;
};

export type DataDisputeUpdateWithoutInboxItem = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutDataDispute>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutDataDisputes>;
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutDataDisputes>;
};

export type DataDisputeWhere = {
  AND?: InputMaybe<Array<DataDisputeWhere>>;
  NOT?: InputMaybe<Array<DataDisputeWhere>>;
  OR?: InputMaybe<Array<DataDisputeWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataDisputeItems?: InputMaybe<DataDisputeItemWhereRelationList>;
  employee?: InputMaybe<EmployeeWhere>;
  employeeId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  inboxItem?: InputMaybe<InboxItemWhere>;
  inboxItemId?: InputMaybe<IdFilter>;
  reason?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verificationRequest?: InputMaybe<VerificationRequestWhere>;
  verificationRequestId?: InputMaybe<IdFilter>;
};

export type DataDisputeWhereRelationList = {
  every?: InputMaybe<DataDisputeWhere>;
  none?: InputMaybe<DataDisputeWhere>;
  some?: InputMaybe<DataDisputeWhere>;
};

export type DataDisputeWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  inboxItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type DateFilter = {
  equals?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilter>;
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeUpdate = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateUpdate = {
  set?: InputMaybe<Scalars['Date']['input']>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<DecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalUpdate = {
  decrement?: InputMaybe<Scalars['Decimal']['input']>;
  divide?: InputMaybe<Scalars['Decimal']['input']>;
  increment?: InputMaybe<Scalars['Decimal']['input']>;
  multiply?: InputMaybe<Scalars['Decimal']['input']>;
  set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type Disclaimer = {
  __typename?: 'Disclaimer';
  createdAt: Scalars['DateTime']['output'];
  disclaimer: Scalars['String']['output'];
  employer: Employer;
  employerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  titles: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DisclaimerCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimer: Scalars['String']['input'];
  employer: EmployerCreateRelationWithoutDisclaimers;
  name: Scalars['String']['input'];
  titles: Array<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DisclaimerCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimer: Scalars['String']['input'];
  employerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  titles: Array<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DisclaimerCreateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<DisclaimerWhereUnique>>;
  create?: InputMaybe<Array<DisclaimerCreateWithoutEmployer>>;
};

export type DisclaimerCreateWithoutEmployer = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimer: Scalars['String']['input'];
  name: Scalars['String']['input'];
  titles: Array<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DisclaimerOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  disclaimer?: InputMaybe<SortOrder>;
  employer?: InputMaybe<EmployerOrderBy>;
  employerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DisclaimerUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutDisclaimers>;
  name?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<StringListUpdate>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DisclaimerUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  disclaimer?: InputMaybe<StringUpdate>;
  employerId?: InputMaybe<IdUpdate>;
  name?: InputMaybe<StringUpdate>;
  titles?: InputMaybe<StringListUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type DisclaimerUpdateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<DisclaimerWhereUnique>>;
  create?: InputMaybe<Array<DisclaimerCreateWithoutEmployer>>;
  disconnect?: InputMaybe<Array<DisclaimerWhereUnique>>;
  set?: InputMaybe<Array<DisclaimerWhereUnique>>;
};

export type DisclaimerWhere = {
  AND?: InputMaybe<Array<DisclaimerWhere>>;
  NOT?: InputMaybe<Array<DisclaimerWhere>>;
  OR?: InputMaybe<Array<DisclaimerWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disclaimer?: InputMaybe<StringFilter>;
  employer?: InputMaybe<EmployerWhere>;
  employerId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  titles?: InputMaybe<StringListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DisclaimerWhereRelationList = {
  every?: InputMaybe<DisclaimerWhere>;
  none?: InputMaybe<DisclaimerWhere>;
  some?: InputMaybe<DisclaimerWhere>;
};

export type DisclaimerWhereUnique = {
  id: Scalars['ID']['input'];
};

export type EmailActivityItem = {
  __typename?: 'EmailActivityItem';
  clicks_count: Scalars['Int']['output'];
  from_email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last_event_time: Scalars['String']['output'];
  opens_count: Scalars['Int']['output'];
  status: EmailDeliveryStatus;
  subject: Scalars['String']['output'];
  to_email: Scalars['String']['output'];
};

export const EmailDeliveryStatus = {
  Delivered: 'delivered',
  NotDelivered: 'not_delivered',
  Processing: 'processing',
} as const;

export type EmailDeliveryStatus = (typeof EmailDeliveryStatus)[keyof typeof EmailDeliveryStatus];
export type Employee = {
  __typename?: 'Employee';
  annualFreeReportsCount: Scalars['Int']['output'];
  annualFreeReportsList: Array<EmployeeAnnualFreeReport>;
  apiVerificationRequestsCount: Scalars['Int']['output'];
  apiVerificationRequestsList: Array<ApiVerificationRequest>;
  createdAt: Scalars['DateTime']['output'];
  dataDeletedAt?: Maybe<Scalars['DateTime']['output']>;
  dataDisputesCount: Scalars['Int']['output'];
  dataDisputesList: Array<DataDispute>;
  deleteRequestSentAt?: Maybe<Scalars['DateTime']['output']>;
  freeze?: Maybe<ActiveInactive>;
  homeAddress?: Maybe<Address>;
  homeAddressId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  last4OfSsn: Scalars['String']['output'];
  notesCount: Scalars['Int']['output'];
  notesList: Array<EmployeeNote>;
  peoStaffBlacklistedCount: Scalars['Int']['output'];
  peoStaffBlacklistedList: Array<PeoStaff>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  piiDataAccessLogsCount: Scalars['Int']['output'];
  piiDataAccessLogsList: Array<PiiDataAccessLog>;
  positionsCount: Scalars['Int']['output'];
  positionsList: Array<Position>;
  requestAutoApprove?: Maybe<ActiveInactive>;
  role: EmployeeRole;
  ssn: Scalars['String']['output'];
  testVerificationRequestsCount: Scalars['Int']['output'];
  testVerificationRequestsList: Array<TestVerificationRequest>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  verificationRequestsCount: Scalars['Int']['output'];
  verificationRequestsList: Array<VerificationRequest>;
  voiReport?: Maybe<File>;
  voiReportId?: Maybe<Scalars['ID']['output']>;
  workEmail?: Maybe<Scalars['String']['output']>;
  workLettersCount: Scalars['Int']['output'];
  workLettersList: Array<EmployeeWorkLetter>;
};

export type EmployeeAnnualFreeReportsCountArgs = {
  where?: InputMaybe<EmployeeAnnualFreeReportWhere>;
};

export type EmployeeAnnualFreeReportsListArgs = {
  orderBy?: InputMaybe<Array<EmployeeAnnualFreeReportOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeAnnualFreeReportWhere>;
};

export type EmployeeApiVerificationRequestsCountArgs = {
  where?: InputMaybe<ApiVerificationRequestWhere>;
};

export type EmployeeApiVerificationRequestsListArgs = {
  orderBy?: InputMaybe<Array<ApiVerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiVerificationRequestWhere>;
};

export type EmployeeDataDisputesCountArgs = {
  where?: InputMaybe<DataDisputeWhere>;
};

export type EmployeeDataDisputesListArgs = {
  orderBy?: InputMaybe<Array<DataDisputeOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataDisputeWhere>;
};

export type EmployeeNotesCountArgs = {
  where?: InputMaybe<EmployeeNoteWhere>;
};

export type EmployeeNotesListArgs = {
  orderBy?: InputMaybe<Array<EmployeeNoteOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeNoteWhere>;
};

export type EmployeePeoStaffBlacklistedCountArgs = {
  where?: InputMaybe<PeoStaffWhere>;
};

export type EmployeePeoStaffBlacklistedListArgs = {
  orderBy?: InputMaybe<Array<PeoStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoStaffWhere>;
};

export type EmployeePiiDataAccessLogsCountArgs = {
  where?: InputMaybe<PiiDataAccessLogWhere>;
};

export type EmployeePiiDataAccessLogsListArgs = {
  orderBy?: InputMaybe<Array<PiiDataAccessLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PiiDataAccessLogWhere>;
};

export type EmployeePositionsCountArgs = {
  where?: InputMaybe<PositionWhere>;
};

export type EmployeePositionsListArgs = {
  orderBy?: InputMaybe<Array<PositionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PositionWhere>;
};

export type EmployeeTestVerificationRequestsCountArgs = {
  where?: InputMaybe<TestVerificationRequestWhere>;
};

export type EmployeeTestVerificationRequestsListArgs = {
  orderBy?: InputMaybe<Array<TestVerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestVerificationRequestWhere>;
};

export type EmployeeVerificationRequestsCountArgs = {
  where?: InputMaybe<VerificationRequestWhere>;
};

export type EmployeeVerificationRequestsListArgs = {
  orderBy?: InputMaybe<Array<VerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerificationRequestWhere>;
};

export type EmployeeWorkLettersCountArgs = {
  where?: InputMaybe<EmployeeWorkLetterWhere>;
};

export type EmployeeWorkLettersListArgs = {
  orderBy?: InputMaybe<Array<EmployeeWorkLetterOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeWorkLetterWhere>;
};

export type EmployeeAnnualFreeReport = {
  __typename?: 'EmployeeAnnualFreeReport';
  createdAt: Scalars['DateTime']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  file: File;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  mdmMetadata?: Maybe<Scalars['Json']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeAnnualFreeReportCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutAnnualFreeReports;
  file: FileCreateRelationWithoutEmployeeAnnualFreeReports;
  mdmMetadata: Scalars['Json']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeAnnualFreeReportCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  mdmMetadata: Scalars['Json']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeAnnualFreeReportCreateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<EmployeeAnnualFreeReportWhereUnique>>;
  create?: InputMaybe<Array<EmployeeAnnualFreeReportCreateWithoutEmployee>>;
};

export type EmployeeAnnualFreeReportCreateRelationListWithoutFile = {
  connect?: InputMaybe<Array<EmployeeAnnualFreeReportWhereUnique>>;
  create?: InputMaybe<Array<EmployeeAnnualFreeReportCreateWithoutFile>>;
};

export type EmployeeAnnualFreeReportCreateWithoutEmployee = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file: FileCreateRelationWithoutEmployeeAnnualFreeReports;
  mdmMetadata: Scalars['Json']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeAnnualFreeReportCreateWithoutFile = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutAnnualFreeReports;
  mdmMetadata: Scalars['Json']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeAnnualFreeReportOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employeeId?: InputMaybe<SortOrder>;
  file?: InputMaybe<FileOrderBy>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mdmMetadata?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmployeeAnnualFreeReportUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutAnnualFreeReports>;
  file?: InputMaybe<FileUpdateRelationWithoutEmployeeAnnualFreeReports>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeAnnualFreeReportUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  employeeId?: InputMaybe<IdUpdate>;
  fileId?: InputMaybe<IdUpdate>;
  mdmMetadata?: InputMaybe<JsonUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<EmployeeAnnualFreeReportWhereUnique>>;
  create?: InputMaybe<Array<EmployeeAnnualFreeReportCreateWithoutEmployee>>;
  disconnect?: InputMaybe<Array<EmployeeAnnualFreeReportWhereUnique>>;
  set?: InputMaybe<Array<EmployeeAnnualFreeReportWhereUnique>>;
};

export type EmployeeAnnualFreeReportUpdateRelationListWithoutFile = {
  connect?: InputMaybe<Array<EmployeeAnnualFreeReportWhereUnique>>;
  create?: InputMaybe<Array<EmployeeAnnualFreeReportCreateWithoutFile>>;
  disconnect?: InputMaybe<Array<EmployeeAnnualFreeReportWhereUnique>>;
  set?: InputMaybe<Array<EmployeeAnnualFreeReportWhereUnique>>;
};

export type EmployeeAnnualFreeReportWhere = {
  AND?: InputMaybe<Array<EmployeeAnnualFreeReportWhere>>;
  NOT?: InputMaybe<Array<EmployeeAnnualFreeReportWhere>>;
  OR?: InputMaybe<Array<EmployeeAnnualFreeReportWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employee?: InputMaybe<EmployeeWhere>;
  employeeId?: InputMaybe<IdFilter>;
  file?: InputMaybe<FileWhere>;
  fileId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmployeeAnnualFreeReportWhereRelationList = {
  every?: InputMaybe<EmployeeAnnualFreeReportWhere>;
  none?: InputMaybe<EmployeeAnnualFreeReportWhere>;
  some?: InputMaybe<EmployeeAnnualFreeReportWhere>;
};

export type EmployeeAnnualFreeReportWhereUnique = {
  id: Scalars['ID']['input'];
};

export type EmployeeCreate = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddressId?: InputMaybe<Scalars['ID']['input']>;
  last4OfSsn: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  voiReportId?: InputMaybe<Scalars['ID']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeCreateRelationListWithoutPeoStaffBlacklisted = {
  connect?: InputMaybe<Array<EmployeeWhereUnique>>;
  create?: InputMaybe<Array<EmployeeCreateWithoutPeoStaffBlacklisted>>;
};

export type EmployeeCreateRelationListWithoutVoiReport = {
  connect?: InputMaybe<Array<EmployeeWhereUnique>>;
  create?: InputMaybe<Array<EmployeeCreateWithoutVoiReport>>;
};

export type EmployeeCreateRelationWithoutAnnualFreeReports = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutAnnualFreeReports>;
};

export type EmployeeCreateRelationWithoutApiVerificationRequests = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutApiVerificationRequests>;
};

export type EmployeeCreateRelationWithoutDataDisputes = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutDataDisputes>;
};

export type EmployeeCreateRelationWithoutHomeAddress = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutHomeAddress>;
};

export type EmployeeCreateRelationWithoutNotes = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutNotes>;
};

export type EmployeeCreateRelationWithoutPiiDataAccessLogs = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutPiiDataAccessLogs>;
};

export type EmployeeCreateRelationWithoutPositions = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutPositions>;
};

export type EmployeeCreateRelationWithoutTestVerificationRequests = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutTestVerificationRequests>;
};

export type EmployeeCreateRelationWithoutUser = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutUser>;
};

export type EmployeeCreateRelationWithoutVerificationRequests = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutVerificationRequests>;
};

export type EmployeeCreateRelationWithoutWorkLetters = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutWorkLetters>;
};

export type EmployeeCreateWithoutAnnualFreeReports = {
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutApiVerificationRequests = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutDataDisputes = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutHomeAddress = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutNotes = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutPeoStaffBlacklisted = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutPiiDataAccessLogs = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutPositions = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutTestVerificationRequests = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutUser = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutVerificationRequests = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutVoiReport = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployee>;
};

export type EmployeeCreateWithoutWorkLetters = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressCreateRelationWithoutEmployee>;
  last4OfSsn: Scalars['String']['input'];
  notes?: InputMaybe<EmployeeNoteCreateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn: Scalars['String']['input'];
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileCreateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeData = {
  __typename?: 'EmployeeData';
  dataDeleteRequestSent: Scalars['Boolean']['output'];
  dataDeletedAt?: Maybe<Scalars['DateTime']['output']>;
  employmentRecords: Array<EmployeeDataEmploymentRecord>;
  id?: Maybe<Scalars['ID']['output']>;
  last4OfSsn: Scalars['String']['output'];
  user?: Maybe<EmployeeDataUserInformation>;
};

export type EmployeeDataEmploymentRecord = {
  __typename?: 'EmployeeDataEmploymentRecord';
  averageBasePay?: Maybe<Scalars['String']['output']>;
  averageHoursPerPayPeriod?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  employeeDateOfBirth?: Maybe<Scalars['Date']['output']>;
  employeeFirstName?: Maybe<Scalars['String']['output']>;
  employeeLast4OfSsn: Scalars['String']['output'];
  employeeLastName?: Maybe<Scalars['String']['output']>;
  employeePositionTitle?: Maybe<Scalars['String']['output']>;
  employerDisplayName?: Maybe<Scalars['String']['output']>;
  employerEmployeeId?: Maybe<Scalars['String']['output']>;
  employerFein: Scalars['String']['output'];
  employerId?: Maybe<Scalars['ID']['output']>;
  employerLocation?: Maybe<Scalars['String']['output']>;
  employerLocationAddress?: Maybe<Scalars['String']['output']>;
  employerLogoUrl?: Maybe<Scalars['String']['output']>;
  employerRegisteredBusinessName?: Maybe<Scalars['String']['output']>;
  employmentEndDate?: Maybe<Scalars['Date']['output']>;
  employmentHireDate?: Maybe<Scalars['Date']['output']>;
  employmentMostRecentEmployment?: Maybe<Scalars['String']['output']>;
  employmentOriginalHireDate?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<PositionEmploymentStatus>;
  employmentTotalTimeWithEmployer?: Maybe<Scalars['String']['output']>;
  employmentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  isEmployerLive: Scalars['Boolean']['output'];
  isEmploymentActive: Scalars['Boolean']['output'];
  peoDisplayName?: Maybe<Scalars['String']['output']>;
  peoId?: Maybe<Scalars['ID']['output']>;
};

export type EmployeeDataInviteLinkScope = {
  __typename?: 'EmployeeDataInviteLinkScope';
  entityDisplayName?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  paramKey: Scalars['String']['output'];
  route: Scalars['String']['output'];
};

export type EmployeeDataSearchResponse = {
  __typename?: 'EmployeeDataSearchResponse';
  employmentRecordsCursor?: Maybe<Scalars['ID']['output']>;
  employmentRecordsHasNextPage: Scalars['Boolean']['output'];
  result: EmployeeData;
};

export type EmployeeDataUserInformation = {
  __typename?: 'EmployeeDataUserInformation';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
};

export type EmployeeForPeoAccessSearch = {
  __typename?: 'EmployeeForPeoAccessSearch';
  companyId: Scalars['ID']['output'];
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4OfSsn: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type EmployeeInfoForVerificationRequest = {
  __typename?: 'EmployeeInfoForVerificationRequest';
  email?: Maybe<Scalars['String']['output']>;
  freeze?: Maybe<ActiveInactive>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type EmployeeInviteEmailOption = {
  __typename?: 'EmployeeInviteEmailOption';
  email: Scalars['String']['output'];
  employerDisplayNames: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
};

export type EmployeeNote = {
  __typename?: 'EmployeeNote';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeNoteCreate = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  employee: EmployeeCreateRelationWithoutNotes;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeNoteCreateMany = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  employeeId: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeNoteCreateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<EmployeeNoteWhereUnique>>;
  create?: InputMaybe<Array<EmployeeNoteCreateWithoutEmployee>>;
};

export type EmployeeNoteCreateWithoutEmployee = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeNoteOrderBy = {
  comment?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmployeeNoteUpdate = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutNotes>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeNoteUpdateMany = {
  comment?: InputMaybe<StringUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  createdBy?: InputMaybe<StringUpdate>;
  employeeId?: InputMaybe<IdUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type EmployeeNoteUpdateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<EmployeeNoteWhereUnique>>;
  create?: InputMaybe<Array<EmployeeNoteCreateWithoutEmployee>>;
  disconnect?: InputMaybe<Array<EmployeeNoteWhereUnique>>;
  set?: InputMaybe<Array<EmployeeNoteWhereUnique>>;
};

export type EmployeeNoteWhere = {
  AND?: InputMaybe<Array<EmployeeNoteWhere>>;
  NOT?: InputMaybe<Array<EmployeeNoteWhere>>;
  OR?: InputMaybe<Array<EmployeeNoteWhere>>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  employee?: InputMaybe<EmployeeWhere>;
  employeeId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmployeeNoteWhereRelationList = {
  every?: InputMaybe<EmployeeNoteWhere>;
  none?: InputMaybe<EmployeeNoteWhere>;
  some?: InputMaybe<EmployeeNoteWhere>;
};

export type EmployeeNoteWhereUnique = {
  id: Scalars['ID']['input'];
};

export type EmployeeOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  dataDeletedAt?: InputMaybe<SortOrderInput>;
  deleteRequestSentAt?: InputMaybe<SortOrderInput>;
  freeze?: InputMaybe<SortOrderInput>;
  homeAddress?: InputMaybe<AddressOrderBy>;
  homeAddressId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  last4OfSsn?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  requestAutoApprove?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrderInput>;
  voiReport?: InputMaybe<FileOrderBy>;
  voiReportId?: InputMaybe<SortOrderInput>;
  workEmail?: InputMaybe<SortOrderInput>;
};

export const EmployeeRole = {
  Employee: 'Employee',
} as const;

export type EmployeeRole = (typeof EmployeeRole)[keyof typeof EmployeeRole];
export type EmployeeRoleFilter = {
  equals?: InputMaybe<EmployeeRole>;
  in?: InputMaybe<Array<EmployeeRole>>;
  not?: InputMaybe<EmployeeRoleFilter>;
  notIn?: InputMaybe<Array<EmployeeRole>>;
};

export type EmployeeRoleUpdate = {
  set?: InputMaybe<EmployeeRole>;
};

export type EmployeeSearchCompanyFilterInput = {
  companyId: Scalars['ID']['input'];
  companyType: CompanyType;
};

export type EmployeeSearchInput = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  kind: EmployeeSearchInputKindEnum;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export const EmployeeSearchInputKindEnum = {
  Direct: 'Direct',
  Email: 'Email',
  EmployeeId: 'Employee_ID',
  PersonalInfo: 'Personal_Info',
  Phone: 'Phone',
} as const;

export type EmployeeSearchInputKindEnum =
  (typeof EmployeeSearchInputKindEnum)[keyof typeof EmployeeSearchInputKindEnum];
export type EmployeeSearchMatch = {
  __typename?: 'EmployeeSearchMatch';
  birthDate?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isPlatformDataDeleted: Scalars['Boolean']['output'];
  isPlatformUserExists: Scalars['Boolean']['output'];
  last4OfSsn: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  ssnEncrypted: Scalars['String']['output'];
};

export type EmployeeUpdate = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  dataDeletedAt?: InputMaybe<DateTimeUpdate>;
  deleteRequestSentAt?: InputMaybe<DateTimeUpdate>;
  freeze?: InputMaybe<ActiveInactiveUpdate>;
  homeAddressId?: InputMaybe<IdUpdate>;
  last4OfSsn?: InputMaybe<StringUpdate>;
  phoneNumber?: InputMaybe<StringUpdate>;
  requestAutoApprove?: InputMaybe<ActiveInactiveUpdate>;
  role?: InputMaybe<EmployeeRoleUpdate>;
  ssn?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  userId?: InputMaybe<IdUpdate>;
  voiReportId?: InputMaybe<IdUpdate>;
  workEmail?: InputMaybe<StringUpdate>;
};

export type EmployeeUpdateRelationListWithoutPeoStaffBlacklisted = {
  connect?: InputMaybe<Array<EmployeeWhereUnique>>;
  create?: InputMaybe<Array<EmployeeCreateWithoutPeoStaffBlacklisted>>;
  disconnect?: InputMaybe<Array<EmployeeWhereUnique>>;
  set?: InputMaybe<Array<EmployeeWhereUnique>>;
};

export type EmployeeUpdateRelationListWithoutVoiReport = {
  connect?: InputMaybe<Array<EmployeeWhereUnique>>;
  create?: InputMaybe<Array<EmployeeCreateWithoutVoiReport>>;
  disconnect?: InputMaybe<Array<EmployeeWhereUnique>>;
  set?: InputMaybe<Array<EmployeeWhereUnique>>;
};

export type EmployeeUpdateRelationWithoutAnnualFreeReports = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutAnnualFreeReports>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutAnnualFreeReports>;
};

export type EmployeeUpdateRelationWithoutApiVerificationRequests = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutApiVerificationRequests>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutApiVerificationRequests>;
};

export type EmployeeUpdateRelationWithoutDataDisputes = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutDataDisputes>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutDataDisputes>;
};

export type EmployeeUpdateRelationWithoutHomeAddress = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutHomeAddress>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutHomeAddress>;
};

export type EmployeeUpdateRelationWithoutNotes = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutNotes>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutNotes>;
};

export type EmployeeUpdateRelationWithoutPiiDataAccessLogs = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutPiiDataAccessLogs>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutPiiDataAccessLogs>;
};

export type EmployeeUpdateRelationWithoutPositions = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutPositions>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutPositions>;
};

export type EmployeeUpdateRelationWithoutTestVerificationRequests = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutTestVerificationRequests>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutTestVerificationRequests>;
};

export type EmployeeUpdateRelationWithoutUser = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutUser>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutUser>;
};

export type EmployeeUpdateRelationWithoutVerificationRequests = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutVerificationRequests>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutVerificationRequests>;
};

export type EmployeeUpdateRelationWithoutWorkLetters = {
  connect?: InputMaybe<EmployeeWhereUnique>;
  create?: InputMaybe<EmployeeCreateWithoutWorkLetters>;
  disconnect?: InputMaybe<EmployeeWhereUnique>;
  update?: InputMaybe<EmployeeUpdateWithoutWorkLetters>;
};

export type EmployeeUpdateWithoutAnnualFreeReports = {
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutApiVerificationRequests = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutDataDisputes = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutHomeAddress = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutNotes = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutPiiDataAccessLogs = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutPositions = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutTestVerificationRequests = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutUser = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutVerificationRequests = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployee>;
};

export type EmployeeUpdateWithoutWorkLetters = {
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutEmployee>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutEmployee>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutEmployee>;
  deleteRequestSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  freeze?: InputMaybe<ActiveInactive>;
  homeAddress?: InputMaybe<AddressUpdateRelationWithoutEmployee>;
  last4OfSsn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<EmployeeNoteUpdateRelationListWithoutEmployee>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployees>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployee>;
  requestAutoApprove?: InputMaybe<ActiveInactive>;
  role?: InputMaybe<EmployeeRole>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutEmployee>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutEmployee>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployee>;
  voiReport?: InputMaybe<FileUpdateRelationWithoutEmployeeVoiReports>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeWhere = {
  AND?: InputMaybe<Array<EmployeeWhere>>;
  NOT?: InputMaybe<Array<EmployeeWhere>>;
  OR?: InputMaybe<Array<EmployeeWhere>>;
  annualFreeReports?: InputMaybe<EmployeeAnnualFreeReportWhereRelationList>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestWhereRelationList>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataDeletedAt?: InputMaybe<DateTimeFilter>;
  dataDisputes?: InputMaybe<DataDisputeWhereRelationList>;
  deleteRequestSentAt?: InputMaybe<DateTimeFilter>;
  freeze?: InputMaybe<ActiveInactiveFilter>;
  homeAddress?: InputMaybe<AddressWhere>;
  homeAddressId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  last4OfSsn?: InputMaybe<StringFilter>;
  notes?: InputMaybe<EmployeeNoteWhereRelationList>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffWhereRelationList>;
  phoneNumber?: InputMaybe<StringFilter>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogWhereRelationList>;
  positions?: InputMaybe<PositionWhereRelationList>;
  requestAutoApprove?: InputMaybe<ActiveInactiveFilter>;
  role?: InputMaybe<EmployeeRoleFilter>;
  ssn?: InputMaybe<StringFilter>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestWhereRelationList>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
  verificationRequests?: InputMaybe<VerificationRequestWhereRelationList>;
  voiReport?: InputMaybe<FileWhere>;
  voiReportId?: InputMaybe<IdFilter>;
  workEmail?: InputMaybe<StringFilter>;
  workLetters?: InputMaybe<EmployeeWorkLetterWhereRelationList>;
};

export type EmployeeWhereRelationList = {
  every?: InputMaybe<EmployeeWhere>;
  none?: InputMaybe<EmployeeWhere>;
  some?: InputMaybe<EmployeeWhere>;
};

export type EmployeeWhereUnique = {
  homeAddressId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type EmployeeWorkLetter = {
  __typename?: 'EmployeeWorkLetter';
  createdAt: Scalars['DateTime']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  employer: Employer;
  employerId: Scalars['ID']['output'];
  file: File;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  mdmMetadata?: Maybe<Scalars['Json']['output']>;
  type: EmployeeWorkLetterType;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeWorkLetterCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutWorkLetters;
  employer: EmployerCreateRelationWithoutEmployeeWorkLetters;
  file: FileCreateRelationWithoutEmployeeWorkLetters;
  mdmMetadata: Scalars['Json']['input'];
  type: EmployeeWorkLetterType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeWorkLetterCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId: Scalars['ID']['input'];
  employerId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  mdmMetadata: Scalars['Json']['input'];
  type: EmployeeWorkLetterType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeWorkLetterCreateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
  create?: InputMaybe<Array<EmployeeWorkLetterCreateWithoutEmployee>>;
};

export type EmployeeWorkLetterCreateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
  create?: InputMaybe<Array<EmployeeWorkLetterCreateWithoutEmployer>>;
};

export type EmployeeWorkLetterCreateRelationListWithoutFile = {
  connect?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
  create?: InputMaybe<Array<EmployeeWorkLetterCreateWithoutFile>>;
};

export type EmployeeWorkLetterCreateWithoutEmployee = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer: EmployerCreateRelationWithoutEmployeeWorkLetters;
  file: FileCreateRelationWithoutEmployeeWorkLetters;
  mdmMetadata: Scalars['Json']['input'];
  type: EmployeeWorkLetterType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeWorkLetterCreateWithoutEmployer = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutWorkLetters;
  file: FileCreateRelationWithoutEmployeeWorkLetters;
  mdmMetadata: Scalars['Json']['input'];
  type: EmployeeWorkLetterType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeWorkLetterCreateWithoutFile = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutWorkLetters;
  employer: EmployerCreateRelationWithoutEmployeeWorkLetters;
  mdmMetadata: Scalars['Json']['input'];
  type: EmployeeWorkLetterType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeWorkLetterOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employeeId?: InputMaybe<SortOrder>;
  employer?: InputMaybe<EmployerOrderBy>;
  employerId?: InputMaybe<SortOrder>;
  file?: InputMaybe<FileOrderBy>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mdmMetadata?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export const EmployeeWorkLetterType = {
  Employment: 'Employment',
  EmploymentWithIncomeInfo: 'Employment_With_Income_Info',
  Immigration: 'Immigration',
} as const;

export type EmployeeWorkLetterType =
  (typeof EmployeeWorkLetterType)[keyof typeof EmployeeWorkLetterType];
export type EmployeeWorkLetterTypeFilter = {
  equals?: InputMaybe<EmployeeWorkLetterType>;
  in?: InputMaybe<Array<EmployeeWorkLetterType>>;
  not?: InputMaybe<EmployeeWorkLetterTypeFilter>;
  notIn?: InputMaybe<Array<EmployeeWorkLetterType>>;
};

export type EmployeeWorkLetterTypeUpdate = {
  set?: InputMaybe<EmployeeWorkLetterType>;
};

export type EmployeeWorkLetterUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutWorkLetters>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutEmployeeWorkLetters>;
  file?: InputMaybe<FileUpdateRelationWithoutEmployeeWorkLetters>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<EmployeeWorkLetterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeWorkLetterUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  employeeId?: InputMaybe<IdUpdate>;
  employerId?: InputMaybe<IdUpdate>;
  fileId?: InputMaybe<IdUpdate>;
  mdmMetadata?: InputMaybe<JsonUpdate>;
  type?: InputMaybe<EmployeeWorkLetterTypeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type EmployeeWorkLetterUpdateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
  create?: InputMaybe<Array<EmployeeWorkLetterCreateWithoutEmployee>>;
  disconnect?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
  set?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
};

export type EmployeeWorkLetterUpdateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
  create?: InputMaybe<Array<EmployeeWorkLetterCreateWithoutEmployer>>;
  disconnect?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
  set?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
};

export type EmployeeWorkLetterUpdateRelationListWithoutFile = {
  connect?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
  create?: InputMaybe<Array<EmployeeWorkLetterCreateWithoutFile>>;
  disconnect?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
  set?: InputMaybe<Array<EmployeeWorkLetterWhereUnique>>;
};

export type EmployeeWorkLetterWhere = {
  AND?: InputMaybe<Array<EmployeeWorkLetterWhere>>;
  NOT?: InputMaybe<Array<EmployeeWorkLetterWhere>>;
  OR?: InputMaybe<Array<EmployeeWorkLetterWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employee?: InputMaybe<EmployeeWhere>;
  employeeId?: InputMaybe<IdFilter>;
  employer?: InputMaybe<EmployerWhere>;
  employerId?: InputMaybe<IdFilter>;
  file?: InputMaybe<FileWhere>;
  fileId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  type?: InputMaybe<EmployeeWorkLetterTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmployeeWorkLetterWhereRelationList = {
  every?: InputMaybe<EmployeeWorkLetterWhere>;
  none?: InputMaybe<EmployeeWorkLetterWhere>;
  some?: InputMaybe<EmployeeWorkLetterWhere>;
};

export type EmployeeWorkLetterWhereUnique = {
  id: Scalars['ID']['input'];
};

export type Employer = {
  __typename?: 'Employer';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  controlledBy: CompanyType;
  corporateStructure?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dashboardRevenueShareData?: Maybe<DashboardRevenueShareData>;
  dashboardRevenueShareDataId?: Maybe<Scalars['ID']['output']>;
  dataDisputeItemsCount: Scalars['Int']['output'];
  dataDisputeItemsList: Array<DataDisputeItem>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  disclaimersCount: Scalars['Int']['output'];
  disclaimersList: Array<Disclaimer>;
  displayName?: Maybe<Scalars['String']['output']>;
  employeeWorkLettersCount: Scalars['Int']['output'];
  employeeWorkLettersList: Array<EmployeeWorkLetter>;
  employerStaffsCount: Scalars['Int']['output'];
  employerStaffsList: Array<EmployerStaff>;
  firstPinDigits?: Maybe<PinDigit>;
  generatedReportsCount: Scalars['Int']['output'];
  generatedReportsList: Array<GeneratedReport>;
  headquarters?: Maybe<Address>;
  headquartersId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  isMdmSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMdmSynced?: Maybe<Scalars['Boolean']['output']>;
  keepOwnRevenueShare: Scalars['Boolean']['output'];
  lastPinDigits?: Maybe<PinDigit>;
  legalBusinessName?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<File>;
  logoId?: Maybe<Scalars['ID']['output']>;
  mdmApiId?: Maybe<Scalars['String']['output']>;
  mdmSyncDate?: Maybe<Scalars['DateTime']['output']>;
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  paymentTransactionsCount: Scalars['Int']['output'];
  paymentTransactionsList: Array<PaymentTransaction>;
  peo?: Maybe<Peo>;
  peoId?: Maybe<Scalars['ID']['output']>;
  peoPayrollProvider?: Maybe<PeoPayrollProvider>;
  peoPayrollProviderId?: Maybe<Scalars['ID']['output']>;
  peoStaffBlacklistedCount: Scalars['Int']['output'];
  peoStaffBlacklistedList: Array<PeoStaff>;
  peoStaffWhitelistedCount: Scalars['Int']['output'];
  peoStaffWhitelistedList: Array<PeoStaff>;
  pinHint?: Maybe<Scalars['String']['output']>;
  pinLength?: Maybe<PinLength>;
  platformStaffHiddenCount: Scalars['Int']['output'];
  platformStaffHiddenList: Array<PlatformStaff>;
  platformStaffVisibleCount: Scalars['Int']['output'];
  platformStaffVisibleList: Array<PlatformStaff>;
  positionsCount: Scalars['Int']['output'];
  positionsList: Array<Position>;
  requestAutoAccept: Scalars['Boolean']['output'];
  revenueShareReportEnabled: Scalars['Boolean']['output'];
  revenueShareSetting?: Maybe<RevenueShareSetting>;
  revenueShareSettingId?: Maybe<Scalars['ID']['output']>;
  setLiveAt?: Maybe<Scalars['DateTime']['output']>;
  signUpMethod: SignUpMethod;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  taxYearEndDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verificationRequestsCount: Scalars['Int']['output'];
  verificationRequestsList: Array<VerificationRequest>;
  withdrawalSettings?: Maybe<EmployerWithdrawalSetting>;
};

export type EmployerDataDisputeItemsCountArgs = {
  where?: InputMaybe<DataDisputeItemWhere>;
};

export type EmployerDataDisputeItemsListArgs = {
  orderBy?: InputMaybe<Array<DataDisputeItemOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataDisputeItemWhere>;
};

export type EmployerDisclaimersCountArgs = {
  where?: InputMaybe<DisclaimerWhere>;
};

export type EmployerDisclaimersListArgs = {
  orderBy?: InputMaybe<Array<DisclaimerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclaimerWhere>;
};

export type EmployerEmployeeWorkLettersCountArgs = {
  where?: InputMaybe<EmployeeWorkLetterWhere>;
};

export type EmployerEmployeeWorkLettersListArgs = {
  orderBy?: InputMaybe<Array<EmployeeWorkLetterOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeWorkLetterWhere>;
};

export type EmployerEmployerStaffsCountArgs = {
  where?: InputMaybe<EmployerStaffWhere>;
};

export type EmployerEmployerStaffsListArgs = {
  orderBy?: InputMaybe<Array<EmployerStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerStaffWhere>;
};

export type EmployerGeneratedReportsCountArgs = {
  where?: InputMaybe<GeneratedReportWhere>;
};

export type EmployerGeneratedReportsListArgs = {
  orderBy?: InputMaybe<Array<GeneratedReportOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GeneratedReportWhere>;
};

export type EmployerPaymentTransactionsCountArgs = {
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type EmployerPaymentTransactionsListArgs = {
  orderBy?: InputMaybe<Array<PaymentTransactionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type EmployerPeoStaffBlacklistedCountArgs = {
  where?: InputMaybe<PeoStaffWhere>;
};

export type EmployerPeoStaffBlacklistedListArgs = {
  orderBy?: InputMaybe<Array<PeoStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoStaffWhere>;
};

export type EmployerPeoStaffWhitelistedCountArgs = {
  where?: InputMaybe<PeoStaffWhere>;
};

export type EmployerPeoStaffWhitelistedListArgs = {
  orderBy?: InputMaybe<Array<PeoStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoStaffWhere>;
};

export type EmployerPlatformStaffHiddenCountArgs = {
  where?: InputMaybe<PlatformStaffWhere>;
};

export type EmployerPlatformStaffHiddenListArgs = {
  orderBy?: InputMaybe<Array<PlatformStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlatformStaffWhere>;
};

export type EmployerPlatformStaffVisibleCountArgs = {
  where?: InputMaybe<PlatformStaffWhere>;
};

export type EmployerPlatformStaffVisibleListArgs = {
  orderBy?: InputMaybe<Array<PlatformStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlatformStaffWhere>;
};

export type EmployerPositionsCountArgs = {
  where?: InputMaybe<PositionWhere>;
};

export type EmployerPositionsListArgs = {
  orderBy?: InputMaybe<Array<PositionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PositionWhere>;
};

export type EmployerVerificationRequestsCountArgs = {
  where?: InputMaybe<VerificationRequestWhere>;
};

export type EmployerVerificationRequestsListArgs = {
  orderBy?: InputMaybe<Array<VerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerificationRequestWhere>;
};

export type EmployerCreate = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateMany = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareDataId?: InputMaybe<Scalars['ID']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquartersId?: InputMaybe<Scalars['ID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  peoId?: InputMaybe<Scalars['ID']['input']>;
  peoPayrollProviderId?: InputMaybe<Scalars['ID']['input']>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSettingId?: InputMaybe<Scalars['ID']['input']>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateRelationListWithoutLogo = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutLogo>>;
};

export type EmployerCreateRelationListWithoutPeo = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPeo>>;
};

export type EmployerCreateRelationListWithoutPeoPayrollProvider = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPeoPayrollProvider>>;
};

export type EmployerCreateRelationListWithoutPeoStaffBlacklisted = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPeoStaffBlacklisted>>;
};

export type EmployerCreateRelationListWithoutPeoStaffWhitelisted = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPeoStaffWhitelisted>>;
};

export type EmployerCreateRelationListWithoutPlatformStaffHidden = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPlatformStaffHidden>>;
};

export type EmployerCreateRelationListWithoutPlatformStaffVisible = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPlatformStaffVisible>>;
};

export type EmployerCreateRelationListWithoutVerificationRequests = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutVerificationRequests>>;
};

export type EmployerCreateRelationWithoutDashboardRevenueShareData = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutDashboardRevenueShareData>;
};

export type EmployerCreateRelationWithoutDataDisputeItems = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutDataDisputeItems>;
};

export type EmployerCreateRelationWithoutDisclaimers = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutDisclaimers>;
};

export type EmployerCreateRelationWithoutEmployeeWorkLetters = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutEmployeeWorkLetters>;
};

export type EmployerCreateRelationWithoutEmployerStaffs = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutEmployerStaffs>;
};

export type EmployerCreateRelationWithoutGeneratedReports = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutGeneratedReports>;
};

export type EmployerCreateRelationWithoutHeadquarters = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutHeadquarters>;
};

export type EmployerCreateRelationWithoutPaymentTransactions = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutPaymentTransactions>;
};

export type EmployerCreateRelationWithoutPositions = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutPositions>;
};

export type EmployerCreateRelationWithoutRevenueShareSetting = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutRevenueShareSetting>;
};

export type EmployerCreateWithoutDashboardRevenueShareData = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutDataDisputeItems = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutDisclaimers = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutEmployeeWorkLetters = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutEmployerStaffs = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutGeneratedReports = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutHeadquarters = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutLogo = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutPaymentTransactions = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutPeo = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutPeoPayrollProvider = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutPeoStaffBlacklisted = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutPeoStaffWhitelisted = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutPlatformStaffHidden = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutPlatformStaffVisible = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutPositions = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutRevenueShareSetting = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerCreateWithoutVerificationRequests = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemCreateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerCreateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffCreateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoCreateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffCreateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffCreateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffCreateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionCreateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerListItemForVerificationRequest = {
  __typename?: 'EmployerListItemForVerificationRequest';
  checksum: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  feinValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPayrollsAvailable: Scalars['Boolean']['output'];
  topLevelCompanyId: Scalars['ID']['output'];
};

export type EmployerOrderBy = {
  contactEmail?: InputMaybe<SortOrderInput>;
  contactPhoneNumber?: InputMaybe<SortOrderInput>;
  controlledBy?: InputMaybe<SortOrder>;
  corporateStructure?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumOrderBy>;
  dashboardRevenueShareDataId?: InputMaybe<SortOrderInput>;
  disclaimer?: InputMaybe<SortOrderInput>;
  displayName?: InputMaybe<SortOrderInput>;
  firstPinDigits?: InputMaybe<SortOrderInput>;
  headquarters?: InputMaybe<AddressOrderBy>;
  headquartersId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  industry?: InputMaybe<SortOrderInput>;
  isMdmSyncEnabled?: InputMaybe<SortOrderInput>;
  isMdmSynced?: InputMaybe<SortOrderInput>;
  keepOwnRevenueShare?: InputMaybe<SortOrder>;
  lastPinDigits?: InputMaybe<SortOrderInput>;
  legalBusinessName?: InputMaybe<SortOrderInput>;
  logo?: InputMaybe<FileOrderBy>;
  logoId?: InputMaybe<SortOrderInput>;
  mdmApiId?: InputMaybe<SortOrderInput>;
  mdmSyncDate?: InputMaybe<SortOrderInput>;
  numberOfEmployees?: InputMaybe<SortOrderInput>;
  peo?: InputMaybe<PeoOrderBy>;
  peoId?: InputMaybe<SortOrderInput>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderOrderBy>;
  peoPayrollProviderId?: InputMaybe<SortOrderInput>;
  pinHint?: InputMaybe<SortOrderInput>;
  pinLength?: InputMaybe<SortOrderInput>;
  requestAutoAccept?: InputMaybe<SortOrder>;
  revenueShareReportEnabled?: InputMaybe<SortOrder>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingOrderBy>;
  revenueShareSettingId?: InputMaybe<SortOrderInput>;
  setLiveAt?: InputMaybe<SortOrderInput>;
  signUpMethod?: InputMaybe<SortOrder>;
  stripeAccountId?: InputMaybe<SortOrderInput>;
  taxYearEndDate?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  withdrawalSettings?: InputMaybe<SortOrder>;
};

export type EmployerStaff = {
  __typename?: 'EmployerStaff';
  createdAt: Scalars['DateTime']['output'];
  employer: Employer;
  employerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  role: EmployerStaffRole;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type EmployerStaffCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer: EmployerCreateRelationWithoutEmployerStaffs;
  role?: InputMaybe<EmployerStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutEmployerStaff;
};

export type EmployerStaffCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employerId: Scalars['ID']['input'];
  role?: InputMaybe<EmployerStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type EmployerStaffCreateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<EmployerStaffWhereUnique>>;
  create?: InputMaybe<Array<EmployerStaffCreateWithoutEmployer>>;
};

export type EmployerStaffCreateRelationWithoutUser = {
  connect?: InputMaybe<EmployerStaffWhereUnique>;
  create?: InputMaybe<EmployerStaffCreateWithoutUser>;
};

export type EmployerStaffCreateWithoutEmployer = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<EmployerStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutEmployerStaff;
};

export type EmployerStaffCreateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer: EmployerCreateRelationWithoutEmployerStaffs;
  role?: InputMaybe<EmployerStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployerStaffOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  employer?: InputMaybe<EmployerOrderBy>;
  employerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
};

export const EmployerStaffRole = {
  EmployerAdmin: 'Employer_Admin',
  EmployerManager: 'Employer_Manager',
} as const;

export type EmployerStaffRole = (typeof EmployerStaffRole)[keyof typeof EmployerStaffRole];
export type EmployerStaffRoleFilter = {
  equals?: InputMaybe<EmployerStaffRole>;
  in?: InputMaybe<Array<EmployerStaffRole>>;
  not?: InputMaybe<EmployerStaffRoleFilter>;
  notIn?: InputMaybe<Array<EmployerStaffRole>>;
};

export type EmployerStaffUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployerStaffUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type EmployerStaffUpdateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<EmployerStaffWhereUnique>>;
  create?: InputMaybe<Array<EmployerStaffCreateWithoutEmployer>>;
  disconnect?: InputMaybe<Array<EmployerStaffWhereUnique>>;
  set?: InputMaybe<Array<EmployerStaffWhereUnique>>;
};

export type EmployerStaffUpdateRelationWithoutUser = {
  connect?: InputMaybe<EmployerStaffWhereUnique>;
  create?: InputMaybe<EmployerStaffCreateWithoutUser>;
  disconnect?: InputMaybe<EmployerStaffWhereUnique>;
  update?: InputMaybe<EmployerStaffUpdateWithoutUser>;
};

export type EmployerStaffUpdateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployerStaffWhere = {
  AND?: InputMaybe<Array<EmployerStaffWhere>>;
  NOT?: InputMaybe<Array<EmployerStaffWhere>>;
  OR?: InputMaybe<Array<EmployerStaffWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employer?: InputMaybe<EmployerWhere>;
  employerId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  role?: InputMaybe<EmployerStaffRoleFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
};

export type EmployerStaffWhereRelationList = {
  every?: InputMaybe<EmployerStaffWhere>;
  none?: InputMaybe<EmployerStaffWhere>;
  some?: InputMaybe<EmployerStaffWhere>;
};

export type EmployerStaffWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type EmployerUpdate = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerUpdateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerUpdateMany = {
  contactEmail?: InputMaybe<StringUpdate>;
  contactPhoneNumber?: InputMaybe<StringUpdate>;
  controlledBy?: InputMaybe<CompanyTypeUpdate>;
  corporateStructure?: InputMaybe<StringUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  dashboardRevenueShareDataId?: InputMaybe<IdUpdate>;
  disclaimer?: InputMaybe<StringUpdate>;
  displayName?: InputMaybe<StringUpdate>;
  firstPinDigits?: InputMaybe<PinDigitUpdate>;
  headquartersId?: InputMaybe<IdUpdate>;
  industry?: InputMaybe<StringUpdate>;
  isMdmSyncEnabled?: InputMaybe<BooleanUpdate>;
  isMdmSynced?: InputMaybe<BooleanUpdate>;
  keepOwnRevenueShare?: InputMaybe<BooleanUpdate>;
  lastPinDigits?: InputMaybe<PinDigitUpdate>;
  legalBusinessName?: InputMaybe<StringUpdate>;
  logoId?: InputMaybe<IdUpdate>;
  mdmApiId?: InputMaybe<StringUpdate>;
  mdmSyncDate?: InputMaybe<DateTimeUpdate>;
  numberOfEmployees?: InputMaybe<IntUpdate>;
  peoId?: InputMaybe<IdUpdate>;
  peoPayrollProviderId?: InputMaybe<IdUpdate>;
  pinHint?: InputMaybe<StringUpdate>;
  pinLength?: InputMaybe<PinLengthUpdate>;
  requestAutoAccept?: InputMaybe<BooleanUpdate>;
  revenueShareReportEnabled?: InputMaybe<BooleanUpdate>;
  revenueShareSettingId?: InputMaybe<IdUpdate>;
  setLiveAt?: InputMaybe<DateTimeUpdate>;
  signUpMethod?: InputMaybe<SignUpMethodUpdate>;
  stripeAccountId?: InputMaybe<StringUpdate>;
  taxYearEndDate?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSettingUpdate>;
};

export type EmployerUpdateRelationListWithoutLogo = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutLogo>>;
  disconnect?: InputMaybe<Array<EmployerWhereUnique>>;
  set?: InputMaybe<Array<EmployerWhereUnique>>;
};

export type EmployerUpdateRelationListWithoutPeo = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPeo>>;
  disconnect?: InputMaybe<Array<EmployerWhereUnique>>;
  set?: InputMaybe<Array<EmployerWhereUnique>>;
};

export type EmployerUpdateRelationListWithoutPeoPayrollProvider = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPeoPayrollProvider>>;
  disconnect?: InputMaybe<Array<EmployerWhereUnique>>;
  set?: InputMaybe<Array<EmployerWhereUnique>>;
};

export type EmployerUpdateRelationListWithoutPeoStaffBlacklisted = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPeoStaffBlacklisted>>;
  disconnect?: InputMaybe<Array<EmployerWhereUnique>>;
  set?: InputMaybe<Array<EmployerWhereUnique>>;
};

export type EmployerUpdateRelationListWithoutPeoStaffWhitelisted = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPeoStaffWhitelisted>>;
  disconnect?: InputMaybe<Array<EmployerWhereUnique>>;
  set?: InputMaybe<Array<EmployerWhereUnique>>;
};

export type EmployerUpdateRelationListWithoutPlatformStaffHidden = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPlatformStaffHidden>>;
  disconnect?: InputMaybe<Array<EmployerWhereUnique>>;
  set?: InputMaybe<Array<EmployerWhereUnique>>;
};

export type EmployerUpdateRelationListWithoutPlatformStaffVisible = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutPlatformStaffVisible>>;
  disconnect?: InputMaybe<Array<EmployerWhereUnique>>;
  set?: InputMaybe<Array<EmployerWhereUnique>>;
};

export type EmployerUpdateRelationListWithoutVerificationRequests = {
  connect?: InputMaybe<Array<EmployerWhereUnique>>;
  create?: InputMaybe<Array<EmployerCreateWithoutVerificationRequests>>;
  disconnect?: InputMaybe<Array<EmployerWhereUnique>>;
  set?: InputMaybe<Array<EmployerWhereUnique>>;
};

export type EmployerUpdateRelationWithoutDashboardRevenueShareData = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutDashboardRevenueShareData>;
  disconnect?: InputMaybe<EmployerWhereUnique>;
  update?: InputMaybe<EmployerUpdateWithoutDashboardRevenueShareData>;
};

export type EmployerUpdateRelationWithoutDataDisputeItems = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutDataDisputeItems>;
  disconnect?: InputMaybe<EmployerWhereUnique>;
  update?: InputMaybe<EmployerUpdateWithoutDataDisputeItems>;
};

export type EmployerUpdateRelationWithoutDisclaimers = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutDisclaimers>;
  disconnect?: InputMaybe<EmployerWhereUnique>;
  update?: InputMaybe<EmployerUpdateWithoutDisclaimers>;
};

export type EmployerUpdateRelationWithoutEmployeeWorkLetters = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutEmployeeWorkLetters>;
  disconnect?: InputMaybe<EmployerWhereUnique>;
  update?: InputMaybe<EmployerUpdateWithoutEmployeeWorkLetters>;
};

export type EmployerUpdateRelationWithoutGeneratedReports = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutGeneratedReports>;
  disconnect?: InputMaybe<EmployerWhereUnique>;
  update?: InputMaybe<EmployerUpdateWithoutGeneratedReports>;
};

export type EmployerUpdateRelationWithoutHeadquarters = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutHeadquarters>;
  disconnect?: InputMaybe<EmployerWhereUnique>;
  update?: InputMaybe<EmployerUpdateWithoutHeadquarters>;
};

export type EmployerUpdateRelationWithoutPaymentTransactions = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutPaymentTransactions>;
  disconnect?: InputMaybe<EmployerWhereUnique>;
  update?: InputMaybe<EmployerUpdateWithoutPaymentTransactions>;
};

export type EmployerUpdateRelationWithoutPositions = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutPositions>;
  disconnect?: InputMaybe<EmployerWhereUnique>;
  update?: InputMaybe<EmployerUpdateWithoutPositions>;
};

export type EmployerUpdateRelationWithoutRevenueShareSetting = {
  connect?: InputMaybe<EmployerWhereUnique>;
  create?: InputMaybe<EmployerCreateWithoutRevenueShareSetting>;
  disconnect?: InputMaybe<EmployerWhereUnique>;
  update?: InputMaybe<EmployerUpdateWithoutRevenueShareSetting>;
};

export type EmployerUpdateWithoutDashboardRevenueShareData = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerUpdateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerUpdateWithoutDataDisputeItems = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerUpdateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerUpdateWithoutDisclaimers = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerUpdateWithoutEmployeeWorkLetters = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerUpdateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerUpdateWithoutGeneratedReports = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerUpdateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerUpdateWithoutHeadquarters = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerUpdateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutEmployer>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerUpdateWithoutPaymentTransactions = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerUpdateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerUpdateWithoutPositions = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerUpdateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutEmployer>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerUpdateWithoutRevenueShareSetting = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  controlledBy?: InputMaybe<CompanyType>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutEmployer>;
  dataDisputeItems?: InputMaybe<DataDisputeItemUpdateRelationListWithoutEmployer>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimers?: InputMaybe<DisclaimerUpdateRelationListWithoutEmployer>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutEmployer>;
  employerStaffs?: InputMaybe<EmployerStaffUpdateRelationListWithoutEmployer>;
  firstPinDigits?: InputMaybe<PinDigit>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutEmployer>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutEmployerHeadquarters>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutEmployerLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutEmployer>;
  peo?: InputMaybe<PeoUpdateRelationWithoutEmployers>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutEmployers>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffUpdateRelationListWithoutBlacklistedEmployers>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffUpdateRelationListWithoutWhitelistedEmployers>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  platformStaffHidden?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersHidden>;
  platformStaffVisible?: InputMaybe<PlatformStaffUpdateRelationListWithoutEmployersVisible>;
  positions?: InputMaybe<PositionUpdateRelationListWithoutEmployer>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  setLiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutEmployers>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmployerWhere = {
  AND?: InputMaybe<Array<EmployerWhere>>;
  NOT?: InputMaybe<Array<EmployerWhere>>;
  OR?: InputMaybe<Array<EmployerWhere>>;
  contactEmail?: InputMaybe<StringFilter>;
  contactPhoneNumber?: InputMaybe<StringFilter>;
  controlledBy?: InputMaybe<CompanyTypeFilter>;
  corporateStructure?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumWhere>;
  dashboardRevenueShareDataId?: InputMaybe<IdFilter>;
  dataDisputeItems?: InputMaybe<DataDisputeItemWhereRelationList>;
  disclaimer?: InputMaybe<StringFilter>;
  disclaimers?: InputMaybe<DisclaimerWhereRelationList>;
  displayName?: InputMaybe<StringFilter>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterWhereRelationList>;
  employerStaffs?: InputMaybe<EmployerStaffWhereRelationList>;
  firstPinDigits?: InputMaybe<PinDigitFilter>;
  generatedReports?: InputMaybe<GeneratedReportWhereRelationList>;
  headquarters?: InputMaybe<AddressWhere>;
  headquartersId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  industry?: InputMaybe<StringFilter>;
  isMdmSyncEnabled?: InputMaybe<BooleanFilter>;
  isMdmSynced?: InputMaybe<BooleanFilter>;
  keepOwnRevenueShare?: InputMaybe<BooleanFilter>;
  lastPinDigits?: InputMaybe<PinDigitFilter>;
  legalBusinessName?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileWhere>;
  logoId?: InputMaybe<IdFilter>;
  mdmApiId?: InputMaybe<StringFilter>;
  mdmSyncDate?: InputMaybe<DateTimeFilter>;
  numberOfEmployees?: InputMaybe<IntFilter>;
  paymentTransactions?: InputMaybe<PaymentTransactionWhereRelationList>;
  peo?: InputMaybe<PeoWhere>;
  peoId?: InputMaybe<IdFilter>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderWhere>;
  peoPayrollProviderId?: InputMaybe<IdFilter>;
  peoStaffBlacklisted?: InputMaybe<PeoStaffWhereRelationList>;
  peoStaffWhitelisted?: InputMaybe<PeoStaffWhereRelationList>;
  pinHint?: InputMaybe<StringFilter>;
  pinLength?: InputMaybe<PinLengthFilter>;
  platformStaffHidden?: InputMaybe<PlatformStaffWhereRelationList>;
  platformStaffVisible?: InputMaybe<PlatformStaffWhereRelationList>;
  positions?: InputMaybe<PositionWhereRelationList>;
  requestAutoAccept?: InputMaybe<BooleanFilter>;
  revenueShareReportEnabled?: InputMaybe<BooleanFilter>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingWhere>;
  revenueShareSettingId?: InputMaybe<IdFilter>;
  setLiveAt?: InputMaybe<DateTimeFilter>;
  signUpMethod?: InputMaybe<SignUpMethodFilter>;
  stripeAccountId?: InputMaybe<StringFilter>;
  taxYearEndDate?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verificationRequests?: InputMaybe<VerificationRequestWhereRelationList>;
  withdrawalSettings?: InputMaybe<EmployerWithdrawalSettingFilter>;
};

export type EmployerWhereRelationList = {
  every?: InputMaybe<EmployerWhere>;
  none?: InputMaybe<EmployerWhere>;
  some?: InputMaybe<EmployerWhere>;
};

export type EmployerWhereUnique = {
  dashboardRevenueShareDataId?: InputMaybe<Scalars['ID']['input']>;
  headquartersId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  revenueShareSettingId?: InputMaybe<Scalars['ID']['input']>;
};

export const EmployerWithdrawalSetting = {
  Daily: 'Daily',
  Instantly: 'Instantly',
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
} as const;

export type EmployerWithdrawalSetting =
  (typeof EmployerWithdrawalSetting)[keyof typeof EmployerWithdrawalSetting];
export type EmployerWithdrawalSettingFilter = {
  equals?: InputMaybe<EmployerWithdrawalSetting>;
  in?: InputMaybe<Array<EmployerWithdrawalSetting>>;
  not?: InputMaybe<EmployerWithdrawalSettingFilter>;
  notIn?: InputMaybe<Array<EmployerWithdrawalSetting>>;
};

export type EmployerWithdrawalSettingUpdate = {
  set?: InputMaybe<EmployerWithdrawalSetting>;
};

export type EmploymentData = {
  __typename?: 'EmploymentData';
  benefitsInformation: EmploymentDataBenefitsInformation;
  companyInformation: EmploymentDataCompanyInformation;
  employeeInformation: EmploymentDataEmployeeInformation;
  headquartersAddress?: Maybe<EmploymentDataHeadquartersAddress>;
  historicalIncomeInformation: EmploymentDataPayrollItems;
  meta: EmploymentDataMeta;
  peoInformation?: Maybe<EmploymentDataPeoInformation>;
  positionInformation: EmploymentDataPositionInformation;
  summaryIncomeInformation: Array<EmploymentDataSummaryIncomeInformation>;
};

export type EmploymentDataBenefitsInformation = {
  __typename?: 'EmploymentDataBenefitsInformation';
  count: Scalars['Int']['output'];
  items: Array<EmploymentDataBenefitsInformationBenefitItem>;
};

export type EmploymentDataBenefitsInformationBenefitItem = {
  __typename?: 'EmploymentDataBenefitsInformationBenefitItem';
  dentalInsuranceCarrier?: Maybe<Scalars['String']['output']>;
  eligibleForDental?: Maybe<Scalars['Boolean']['output']>;
  eligibleForMedical?: Maybe<Scalars['Boolean']['output']>;
  enrolledInDental?: Maybe<Scalars['Boolean']['output']>;
  enrolledInMedical?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  medicalInsuranceCarrier?: Maybe<Scalars['String']['output']>;
};

export type EmploymentDataCompanyInformation = {
  __typename?: 'EmploymentDataCompanyInformation';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  employerDisclaimer?: Maybe<Scalars['String']['output']>;
  extLocationId?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  locationAddress: Scalars['String']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  positionDisclaimer?: Maybe<Scalars['String']['output']>;
  registeredBusinessName?: Maybe<Scalars['String']['output']>;
};

export type EmploymentDataEmployeeInformation = {
  __typename?: 'EmploymentDataEmployeeInformation';
  averageBaseWage?: Maybe<Scalars['String']['output']>;
  averageHoursPerPayPeriod?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employmentStatus: PositionEmploymentStatus;
  employmentType?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  mostRecentEmployment?: Maybe<Scalars['String']['output']>;
  mostRecentHireDate?: Maybe<Scalars['Date']['output']>;
  originalHireDate?: Maybe<Scalars['String']['output']>;
  payFrequency?: Maybe<Scalars['String']['output']>;
  rateOfPay?: Maybe<Scalars['String']['output']>;
  rehireDate?: Maybe<Scalars['Date']['output']>;
  ssn: Scalars['String']['output'];
  terminationDate?: Maybe<Scalars['Date']['output']>;
  totalTimeWithEmployer?: Maybe<Scalars['String']['output']>;
};

export type EmploymentDataHeadquartersAddress = {
  __typename?: 'EmploymentDataHeadquartersAddress';
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type EmploymentDataMeta = {
  __typename?: 'EmploymentDataMeta';
  companyId: Scalars['ID']['output'];
  consumerId?: Maybe<Scalars['ID']['output']>;
  employerId: Scalars['ID']['output'];
  headquartersId?: Maybe<Scalars['ID']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  mdmMetadata: EmploymentDataMetaMdmMetadata;
  peoId?: Maybe<Scalars['ID']['output']>;
  positionId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userStatus?: Maybe<UserStatus>;
};

export type EmploymentDataMetaMdmMetadata = {
  __typename?: 'EmploymentDataMetaMdmMetadata';
  employeeBirthDate?: Maybe<Scalars['String']['output']>;
  employeeFullName?: Maybe<Scalars['String']['output']>;
  employeeMdmApiId: Scalars['ID']['output'];
  extEmployeeId?: Maybe<Scalars['String']['output']>;
  feinCompanyMdmApiId: Scalars['ID']['output'];
  feinValue: Scalars['String']['output'];
  topLevelCompanyMdmApiId: Scalars['ID']['output'];
};

export type EmploymentDataPayrollItems = {
  __typename?: 'EmploymentDataPayrollItems';
  count: Scalars['Int']['output'];
  items: Array<EmploymentDataPayrollItemsPayrollItem>;
};

export type EmploymentDataPayrollItemsPayrollItem = {
  __typename?: 'EmploymentDataPayrollItemsPayrollItem';
  baseWage?: Maybe<Scalars['Int']['output']>;
  bonusesWage?: Maybe<Scalars['Int']['output']>;
  commissionWage?: Maybe<Scalars['Int']['output']>;
  federalWithholding?: Maybe<Scalars['Int']['output']>;
  grossHours?: Maybe<Scalars['Decimal']['output']>;
  grossWage?: Maybe<Scalars['Int']['output']>;
  holidayWage?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  incentiveWage?: Maybe<Scalars['Int']['output']>;
  miscWage?: Maybe<Scalars['Int']['output']>;
  mostRecentHireDate?: Maybe<Scalars['Date']['output']>;
  originalHireDate?: Maybe<Scalars['Date']['output']>;
  originalTerminationDate?: Maybe<Scalars['Date']['output']>;
  otherWage?: Maybe<Scalars['Int']['output']>;
  overtimeHours?: Maybe<Scalars['Decimal']['output']>;
  overtimeWage?: Maybe<Scalars['Int']['output']>;
  payFrequency?: Maybe<Scalars['String']['output']>;
  payType?: Maybe<Scalars['String']['output']>;
  paycheckId?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentPeriodEnd?: Maybe<Scalars['Date']['output']>;
  paymentPeriodStart?: Maybe<Scalars['Date']['output']>;
  pension?: Maybe<Scalars['Int']['output']>;
  positionFein?: Maybe<Scalars['String']['output']>;
  positionId: Scalars['ID']['output'];
  ptoPayoutWage?: Maybe<Scalars['Int']['output']>;
  ptoWage?: Maybe<Scalars['Int']['output']>;
  rateOfPay?: Maybe<Scalars['String']['output']>;
  severance?: Maybe<Scalars['Int']['output']>;
  shiftDifferential?: Maybe<Scalars['Int']['output']>;
  sickTimePayoutWage?: Maybe<Scalars['Int']['output']>;
  sickWage?: Maybe<Scalars['Int']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  stateWithholding?: Maybe<Scalars['Int']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  terminationDate?: Maybe<Scalars['Date']['output']>;
  tips?: Maybe<Scalars['Int']['output']>;
  vacationTimePayoutWage?: Maybe<Scalars['Int']['output']>;
  vacationWage?: Maybe<Scalars['Int']['output']>;
};

export type EmploymentDataPeoInformation = {
  __typename?: 'EmploymentDataPeoInformation';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
};

export type EmploymentDataPositionInformation = {
  __typename?: 'EmploymentDataPositionInformation';
  division?: Maybe<Scalars['String']['output']>;
  registeredBusinessName?: Maybe<Scalars['String']['output']>;
  statusPosition: EmploymentDataPositionInformationStatus;
  title?: Maybe<Scalars['String']['output']>;
  workCity?: Maybe<Scalars['String']['output']>;
  workCounty?: Maybe<Scalars['String']['output']>;
  workState?: Maybe<Scalars['String']['output']>;
  workStreet?: Maybe<Scalars['String']['output']>;
  workZipCode?: Maybe<Scalars['String']['output']>;
};

export const EmploymentDataPositionInformationStatus = {
  Current: 'Current',
  Previous: 'Previous',
} as const;

export type EmploymentDataPositionInformationStatus =
  (typeof EmploymentDataPositionInformationStatus)[keyof typeof EmploymentDataPositionInformationStatus];
export type EmploymentDataSummaryIncomeInformation = {
  __typename?: 'EmploymentDataSummaryIncomeInformation';
  baseWage?: Maybe<Scalars['Int']['output']>;
  bonusesWage?: Maybe<Scalars['Int']['output']>;
  commissionWage?: Maybe<Scalars['Int']['output']>;
  holidayWage?: Maybe<Scalars['Int']['output']>;
  incentiveWage?: Maybe<Scalars['Int']['output']>;
  miscWage?: Maybe<Scalars['Int']['output']>;
  otherWage?: Maybe<Scalars['Int']['output']>;
  overtimeWage?: Maybe<Scalars['Int']['output']>;
  pension?: Maybe<Scalars['Int']['output']>;
  ptoPayoutWage?: Maybe<Scalars['Int']['output']>;
  ptoWage?: Maybe<Scalars['Int']['output']>;
  severance?: Maybe<Scalars['Int']['output']>;
  sickTimePayoutWage?: Maybe<Scalars['Int']['output']>;
  sickWage?: Maybe<Scalars['Int']['output']>;
  tips?: Maybe<Scalars['Int']['output']>;
  totalWage?: Maybe<Scalars['Int']['output']>;
  vacationTimePayoutWage?: Maybe<Scalars['Int']['output']>;
  vacationWage?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export const ExistingVerificationRequestTotalChargeReason = {
  Reverification: 'Reverification',
  TryAgainPayment: 'Try_Again_Payment',
} as const;

export type ExistingVerificationRequestTotalChargeReason =
  (typeof ExistingVerificationRequestTotalChargeReason)[keyof typeof ExistingVerificationRequestTotalChargeReason];
export type ExportIntegrationUsageLogInput = {
  columns: Array<IntegrationUsageLogColumnKeyEnum>;
  format: IntegrationUsageLogFormatEnum;
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type ExternalAccounts = {
  __typename?: 'ExternalAccounts';
  last4: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: StripeExternalAccountType;
};

export type File = {
  __typename?: 'File';
  activityLogFilesCount: Scalars['Int']['output'];
  activityLogFilesList: Array<ActivityLog>;
  attestationPdfsCount: Scalars['Int']['output'];
  attestationPdfsList: Array<Attestation>;
  createdAt: Scalars['DateTime']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  employeeAnnualFreeReportsCount: Scalars['Int']['output'];
  employeeAnnualFreeReportsList: Array<EmployeeAnnualFreeReport>;
  employeeVoiReportsCount: Scalars['Int']['output'];
  employeeVoiReportsList: Array<Employee>;
  employeeWorkLettersCount: Scalars['Int']['output'];
  employeeWorkLettersList: Array<EmployeeWorkLetter>;
  employerLogosCount: Scalars['Int']['output'];
  employerLogosList: Array<Employer>;
  filename: Scalars['String']['output'];
  generatedReportReportsCount: Scalars['Int']['output'];
  generatedReportReportsList: Array<GeneratedReport>;
  id: Scalars['ID']['output'];
  integrationInputFileCount: Scalars['Int']['output'];
  integrationInputFileList: Array<IntegrationUsageLog>;
  integrationOutputFileCount: Scalars['Int']['output'];
  integrationOutputFileList: Array<IntegrationUsageLog>;
  key: Scalars['String']['output'];
  mime: Scalars['String']['output'];
  peoLogosCount: Scalars['Int']['output'];
  peoLogosList: Array<Peo>;
  peoPayrollProviderLogosCount: Scalars['Int']['output'];
  peoPayrollProviderLogosList: Array<PeoPayrollProvider>;
  positionWorkLetterPdfsCount: Scalars['Int']['output'];
  positionWorkLetterPdfsList: Array<Position>;
  public: Scalars['Boolean']['output'];
  resourceFilesCount: Scalars['Int']['output'];
  resourceFilesList: Array<Resource>;
  size: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAvatarsCount: Scalars['Int']['output'];
  userAvatarsList: Array<User>;
  verifierLogosCount: Scalars['Int']['output'];
  verifierLogosList: Array<Verifier>;
};

export type FileActivityLogFilesCountArgs = {
  where?: InputMaybe<ActivityLogWhere>;
};

export type FileActivityLogFilesListArgs = {
  orderBy?: InputMaybe<Array<ActivityLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityLogWhere>;
};

export type FileAttestationPdfsCountArgs = {
  where?: InputMaybe<AttestationWhere>;
};

export type FileAttestationPdfsListArgs = {
  orderBy?: InputMaybe<Array<AttestationOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AttestationWhere>;
};

export type FileEmployeeAnnualFreeReportsCountArgs = {
  where?: InputMaybe<EmployeeAnnualFreeReportWhere>;
};

export type FileEmployeeAnnualFreeReportsListArgs = {
  orderBy?: InputMaybe<Array<EmployeeAnnualFreeReportOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeAnnualFreeReportWhere>;
};

export type FileEmployeeVoiReportsCountArgs = {
  where?: InputMaybe<EmployeeWhere>;
};

export type FileEmployeeVoiReportsListArgs = {
  orderBy?: InputMaybe<Array<EmployeeOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeWhere>;
};

export type FileEmployeeWorkLettersCountArgs = {
  where?: InputMaybe<EmployeeWorkLetterWhere>;
};

export type FileEmployeeWorkLettersListArgs = {
  orderBy?: InputMaybe<Array<EmployeeWorkLetterOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeWorkLetterWhere>;
};

export type FileEmployerLogosCountArgs = {
  where?: InputMaybe<EmployerWhere>;
};

export type FileEmployerLogosListArgs = {
  orderBy?: InputMaybe<Array<EmployerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerWhere>;
};

export type FileGeneratedReportReportsCountArgs = {
  where?: InputMaybe<GeneratedReportWhere>;
};

export type FileGeneratedReportReportsListArgs = {
  orderBy?: InputMaybe<Array<GeneratedReportOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GeneratedReportWhere>;
};

export type FileIntegrationInputFileCountArgs = {
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type FileIntegrationInputFileListArgs = {
  orderBy?: InputMaybe<Array<IntegrationUsageLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type FileIntegrationOutputFileCountArgs = {
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type FileIntegrationOutputFileListArgs = {
  orderBy?: InputMaybe<Array<IntegrationUsageLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type FilePeoLogosCountArgs = {
  where?: InputMaybe<PeoWhere>;
};

export type FilePeoLogosListArgs = {
  orderBy?: InputMaybe<Array<PeoOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoWhere>;
};

export type FilePeoPayrollProviderLogosCountArgs = {
  where?: InputMaybe<PeoPayrollProviderWhere>;
};

export type FilePeoPayrollProviderLogosListArgs = {
  orderBy?: InputMaybe<Array<PeoPayrollProviderOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoPayrollProviderWhere>;
};

export type FilePositionWorkLetterPdfsCountArgs = {
  where?: InputMaybe<PositionWhere>;
};

export type FilePositionWorkLetterPdfsListArgs = {
  orderBy?: InputMaybe<Array<PositionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PositionWhere>;
};

export type FileResourceFilesCountArgs = {
  where?: InputMaybe<ResourceWhere>;
};

export type FileResourceFilesListArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ResourceWhere>;
};

export type FileUserAvatarsCountArgs = {
  where?: InputMaybe<UserWhere>;
};

export type FileUserAvatarsListArgs = {
  orderBy?: InputMaybe<Array<UserOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhere>;
};

export type FileVerifierLogosCountArgs = {
  where?: InputMaybe<VerifierWhere>;
};

export type FileVerifierLogosListArgs = {
  orderBy?: InputMaybe<Array<VerifierOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerifierWhere>;
};

export type FileCreate = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FileCreateRelationWithoutActivityLogFiles = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutActivityLogFiles>;
};

export type FileCreateRelationWithoutAttestationPdfs = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutAttestationPdfs>;
};

export type FileCreateRelationWithoutEmployeeAnnualFreeReports = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutEmployeeAnnualFreeReports>;
};

export type FileCreateRelationWithoutEmployeeVoiReports = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutEmployeeVoiReports>;
};

export type FileCreateRelationWithoutEmployeeWorkLetters = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutEmployeeWorkLetters>;
};

export type FileCreateRelationWithoutEmployerLogos = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutEmployerLogos>;
};

export type FileCreateRelationWithoutGeneratedReportReports = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutGeneratedReportReports>;
};

export type FileCreateRelationWithoutIntegrationInputFile = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutIntegrationInputFile>;
};

export type FileCreateRelationWithoutIntegrationOutputFile = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutIntegrationOutputFile>;
};

export type FileCreateRelationWithoutPeoLogos = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutPeoLogos>;
};

export type FileCreateRelationWithoutPeoPayrollProviderLogos = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutPeoPayrollProviderLogos>;
};

export type FileCreateRelationWithoutPositionWorkLetterPdfs = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutPositionWorkLetterPdfs>;
};

export type FileCreateRelationWithoutResourceFiles = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutResourceFiles>;
};

export type FileCreateRelationWithoutUserAvatars = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutUserAvatars>;
};

export type FileCreateRelationWithoutVerifierLogos = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutVerifierLogos>;
};

export type FileCreateWithoutActivityLogFiles = {
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutAttestationPdfs = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutEmployeeAnnualFreeReports = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutEmployeeVoiReports = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutEmployeeWorkLetters = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutEmployerLogos = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutGeneratedReportReports = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutIntegrationInputFile = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutIntegrationOutputFile = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutPeoLogos = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutPeoPayrollProviderLogos = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutPositionWorkLetterPdfs = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutResourceFiles = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutUserAvatars = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierLogos?: InputMaybe<VerifierCreateRelationListWithoutLogo>;
};

export type FileCreateWithoutVerifierLogos = {
  activityLogFiles?: InputMaybe<ActivityLogCreateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationCreateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportCreateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeCreateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterCreateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerCreateRelationListWithoutLogo>;
  filename: Scalars['String']['input'];
  generatedReportReports?: InputMaybe<GeneratedReportCreateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutOutputFile>;
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  peoLogos?: InputMaybe<PeoCreateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderCreateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionCreateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceCreateRelationListWithoutFile>;
  size: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserCreateRelationListWithoutAvatar>;
};

export type FileMetaResponse = {
  __typename?: 'FileMetaResponse';
  createdAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mime: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FileOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  downloadUrl?: InputMaybe<SortOrderInput>;
  filename?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  mime?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FileResponse = {
  __typename?: 'FileResponse';
  createdAt: Scalars['DateTime']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  mime: Scalars['String']['output'];
  public: Scalars['Boolean']['output'];
  size: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FileUpdate = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  downloadUrl?: InputMaybe<StringUpdate>;
  filename?: InputMaybe<StringUpdate>;
  key?: InputMaybe<StringUpdate>;
  mime?: InputMaybe<StringUpdate>;
  public?: InputMaybe<BooleanUpdate>;
  size?: InputMaybe<IntUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type FileUpdateRelationWithoutActivityLogFiles = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutActivityLogFiles>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutActivityLogFiles>;
};

export type FileUpdateRelationWithoutAttestationPdfs = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutAttestationPdfs>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutAttestationPdfs>;
};

export type FileUpdateRelationWithoutEmployeeAnnualFreeReports = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutEmployeeAnnualFreeReports>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutEmployeeAnnualFreeReports>;
};

export type FileUpdateRelationWithoutEmployeeVoiReports = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutEmployeeVoiReports>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutEmployeeVoiReports>;
};

export type FileUpdateRelationWithoutEmployeeWorkLetters = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutEmployeeWorkLetters>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutEmployeeWorkLetters>;
};

export type FileUpdateRelationWithoutEmployerLogos = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutEmployerLogos>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutEmployerLogos>;
};

export type FileUpdateRelationWithoutGeneratedReportReports = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutGeneratedReportReports>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutGeneratedReportReports>;
};

export type FileUpdateRelationWithoutIntegrationInputFile = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutIntegrationInputFile>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutIntegrationInputFile>;
};

export type FileUpdateRelationWithoutIntegrationOutputFile = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutIntegrationOutputFile>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutIntegrationOutputFile>;
};

export type FileUpdateRelationWithoutPeoLogos = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutPeoLogos>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutPeoLogos>;
};

export type FileUpdateRelationWithoutPeoPayrollProviderLogos = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutPeoPayrollProviderLogos>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutPeoPayrollProviderLogos>;
};

export type FileUpdateRelationWithoutPositionWorkLetterPdfs = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutPositionWorkLetterPdfs>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutPositionWorkLetterPdfs>;
};

export type FileUpdateRelationWithoutResourceFiles = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutResourceFiles>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutResourceFiles>;
};

export type FileUpdateRelationWithoutUserAvatars = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutUserAvatars>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutUserAvatars>;
};

export type FileUpdateRelationWithoutVerifierLogos = {
  connect?: InputMaybe<FileWhereUnique>;
  create?: InputMaybe<FileCreateWithoutVerifierLogos>;
  disconnect?: InputMaybe<FileWhereUnique>;
  update?: InputMaybe<FileUpdateWithoutVerifierLogos>;
};

export type FileUpdateWithoutActivityLogFiles = {
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutAttestationPdfs = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutEmployeeAnnualFreeReports = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutEmployeeVoiReports = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutEmployeeWorkLetters = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutEmployerLogos = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutGeneratedReportReports = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutIntegrationInputFile = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutIntegrationOutputFile = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutPeoLogos = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutPeoPayrollProviderLogos = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutPositionWorkLetterPdfs = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutResourceFiles = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutUserAvatars = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierLogos?: InputMaybe<VerifierUpdateRelationListWithoutLogo>;
};

export type FileUpdateWithoutVerifierLogos = {
  activityLogFiles?: InputMaybe<ActivityLogUpdateRelationListWithoutFile>;
  attestationPdfs?: InputMaybe<AttestationUpdateRelationListWithoutPdf>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportUpdateRelationListWithoutFile>;
  employeeVoiReports?: InputMaybe<EmployeeUpdateRelationListWithoutVoiReport>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterUpdateRelationListWithoutFile>;
  employerLogos?: InputMaybe<EmployerUpdateRelationListWithoutLogo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  generatedReportReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutReport>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutInputFile>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutOutputFile>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  peoLogos?: InputMaybe<PeoUpdateRelationListWithoutLogo>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderUpdateRelationListWithoutLogo>;
  positionWorkLetterPdfs?: InputMaybe<PositionUpdateRelationListWithoutWorkLetterPdf>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resourceFiles?: InputMaybe<ResourceUpdateRelationListWithoutFile>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAvatars?: InputMaybe<UserUpdateRelationListWithoutAvatar>;
};

export type FileWhere = {
  AND?: InputMaybe<Array<FileWhere>>;
  NOT?: InputMaybe<Array<FileWhere>>;
  OR?: InputMaybe<Array<FileWhere>>;
  activityLogFiles?: InputMaybe<ActivityLogWhereRelationList>;
  attestationPdfs?: InputMaybe<AttestationWhereRelationList>;
  createdAt?: InputMaybe<DateTimeFilter>;
  downloadUrl?: InputMaybe<StringFilter>;
  employeeAnnualFreeReports?: InputMaybe<EmployeeAnnualFreeReportWhereRelationList>;
  employeeVoiReports?: InputMaybe<EmployeeWhereRelationList>;
  employeeWorkLetters?: InputMaybe<EmployeeWorkLetterWhereRelationList>;
  employerLogos?: InputMaybe<EmployerWhereRelationList>;
  filename?: InputMaybe<StringFilter>;
  generatedReportReports?: InputMaybe<GeneratedReportWhereRelationList>;
  id?: InputMaybe<IdFilter>;
  integrationInputFile?: InputMaybe<IntegrationUsageLogWhereRelationList>;
  integrationOutputFile?: InputMaybe<IntegrationUsageLogWhereRelationList>;
  key?: InputMaybe<StringFilter>;
  mime?: InputMaybe<StringFilter>;
  peoLogos?: InputMaybe<PeoWhereRelationList>;
  peoPayrollProviderLogos?: InputMaybe<PeoPayrollProviderWhereRelationList>;
  positionWorkLetterPdfs?: InputMaybe<PositionWhereRelationList>;
  public?: InputMaybe<BooleanFilter>;
  resourceFiles?: InputMaybe<ResourceWhereRelationList>;
  size?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userAvatars?: InputMaybe<UserWhereRelationList>;
  verifierLogos?: InputMaybe<VerifierWhereRelationList>;
};

export type FileWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateAnnualFreeReportResponse = {
  __typename?: 'GenerateAnnualFreeReportResponse';
  file: FileResponse;
  status: AnnualFreeReportStatus;
};

export type GeneratedReport = {
  __typename?: 'GeneratedReport';
  apiVerificationRequest?: Maybe<ApiVerificationRequest>;
  apiVerificationRequestId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employer?: Maybe<Employer>;
  employerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  mdmMetadata?: Maybe<Scalars['Json']['output']>;
  mdmMetadataObjectHash?: Maybe<Scalars['String']['output']>;
  piiDataAccessLogsCount: Scalars['Int']['output'];
  piiDataAccessLogsList: Array<PiiDataAccessLog>;
  report?: Maybe<File>;
  reportId?: Maybe<Scalars['ID']['output']>;
  testVerificationRequest?: Maybe<TestVerificationRequest>;
  testVerificationRequestId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verificationRequest?: Maybe<VerificationRequest>;
  verificationRequestId?: Maybe<Scalars['ID']['output']>;
};

export type GeneratedReportPiiDataAccessLogsCountArgs = {
  where?: InputMaybe<PiiDataAccessLogWhere>;
};

export type GeneratedReportPiiDataAccessLogsListArgs = {
  orderBy?: InputMaybe<Array<PiiDataAccessLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PiiDataAccessLogWhere>;
};

export type GeneratedReportCreate = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutGeneratedReports>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutGeneratedReports>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedGeneratedReport>;
  report?: InputMaybe<FileCreateRelationWithoutGeneratedReportReports>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutGeneratedReports>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutGeneratedReports>;
};

export type GeneratedReportCreateMany = {
  apiVerificationRequestId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  testVerificationRequestId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type GeneratedReportCreateRelationListWithoutApiVerificationRequest = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutApiVerificationRequest>>;
};

export type GeneratedReportCreateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutEmployer>>;
};

export type GeneratedReportCreateRelationListWithoutReport = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutReport>>;
};

export type GeneratedReportCreateRelationListWithoutTestVerificationRequest = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutTestVerificationRequest>>;
};

export type GeneratedReportCreateRelationListWithoutVerificationRequest = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutVerificationRequest>>;
};

export type GeneratedReportCreateRelationWithoutPiiDataAccessLogs = {
  connect?: InputMaybe<GeneratedReportWhereUnique>;
  create?: InputMaybe<GeneratedReportCreateWithoutPiiDataAccessLogs>;
};

export type GeneratedReportCreateWithoutApiVerificationRequest = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutGeneratedReports>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedGeneratedReport>;
  report?: InputMaybe<FileCreateRelationWithoutGeneratedReportReports>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutGeneratedReports>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutGeneratedReports>;
};

export type GeneratedReportCreateWithoutEmployer = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutGeneratedReports>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedGeneratedReport>;
  report?: InputMaybe<FileCreateRelationWithoutGeneratedReportReports>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutGeneratedReports>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutGeneratedReports>;
};

export type GeneratedReportCreateWithoutPiiDataAccessLogs = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutGeneratedReports>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutGeneratedReports>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<FileCreateRelationWithoutGeneratedReportReports>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutGeneratedReports>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutGeneratedReports>;
};

export type GeneratedReportCreateWithoutReport = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutGeneratedReports>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutGeneratedReports>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedGeneratedReport>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutGeneratedReports>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutGeneratedReports>;
};

export type GeneratedReportCreateWithoutTestVerificationRequest = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutGeneratedReports>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutGeneratedReports>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedGeneratedReport>;
  report?: InputMaybe<FileCreateRelationWithoutGeneratedReportReports>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutGeneratedReports>;
};

export type GeneratedReportCreateWithoutVerificationRequest = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutGeneratedReports>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutGeneratedReports>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedGeneratedReport>;
  report?: InputMaybe<FileCreateRelationWithoutGeneratedReportReports>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutGeneratedReports>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GeneratedReportFilesArchiveResponse = {
  __typename?: 'GeneratedReportFilesArchiveResponse';
  downloadUrl: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GeneratedReportMeta = {
  __typename?: 'GeneratedReportMeta';
  createdAt: Scalars['DateTime']['output'];
  employerDisplayName?: Maybe<Scalars['String']['output']>;
  employerId?: Maybe<Scalars['ID']['output']>;
  feinValue?: Maybe<Scalars['String']['output']>;
  file: FileMetaResponse;
  id: Scalars['ID']['output'];
};

export type GeneratedReportOrderBy = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestOrderBy>;
  apiVerificationRequestId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  employer?: InputMaybe<EmployerOrderBy>;
  employerId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  mdmMetadata?: InputMaybe<SortOrderInput>;
  mdmMetadataObjectHash?: InputMaybe<SortOrderInput>;
  report?: InputMaybe<FileOrderBy>;
  reportId?: InputMaybe<SortOrderInput>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestOrderBy>;
  testVerificationRequestId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verificationRequest?: InputMaybe<VerificationRequestOrderBy>;
  verificationRequestId?: InputMaybe<SortOrderInput>;
};

export type GeneratedReportUpdate = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestUpdateRelationWithoutGeneratedReports>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutGeneratedReports>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedGeneratedReport>;
  report?: InputMaybe<FileUpdateRelationWithoutGeneratedReportReports>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestUpdateRelationWithoutGeneratedReports>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutGeneratedReports>;
};

export type GeneratedReportUpdateMany = {
  apiVerificationRequestId?: InputMaybe<IdUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  employerId?: InputMaybe<IdUpdate>;
  mdmMetadata?: InputMaybe<JsonUpdate>;
  mdmMetadataObjectHash?: InputMaybe<StringUpdate>;
  reportId?: InputMaybe<IdUpdate>;
  testVerificationRequestId?: InputMaybe<IdUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  verificationRequestId?: InputMaybe<IdUpdate>;
};

export type GeneratedReportUpdateRelationListWithoutApiVerificationRequest = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutApiVerificationRequest>>;
  disconnect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  set?: InputMaybe<Array<GeneratedReportWhereUnique>>;
};

export type GeneratedReportUpdateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutEmployer>>;
  disconnect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  set?: InputMaybe<Array<GeneratedReportWhereUnique>>;
};

export type GeneratedReportUpdateRelationListWithoutReport = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutReport>>;
  disconnect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  set?: InputMaybe<Array<GeneratedReportWhereUnique>>;
};

export type GeneratedReportUpdateRelationListWithoutTestVerificationRequest = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutTestVerificationRequest>>;
  disconnect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  set?: InputMaybe<Array<GeneratedReportWhereUnique>>;
};

export type GeneratedReportUpdateRelationListWithoutVerificationRequest = {
  connect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  create?: InputMaybe<Array<GeneratedReportCreateWithoutVerificationRequest>>;
  disconnect?: InputMaybe<Array<GeneratedReportWhereUnique>>;
  set?: InputMaybe<Array<GeneratedReportWhereUnique>>;
};

export type GeneratedReportUpdateRelationWithoutPiiDataAccessLogs = {
  connect?: InputMaybe<GeneratedReportWhereUnique>;
  create?: InputMaybe<GeneratedReportCreateWithoutPiiDataAccessLogs>;
  disconnect?: InputMaybe<GeneratedReportWhereUnique>;
  update?: InputMaybe<GeneratedReportUpdateWithoutPiiDataAccessLogs>;
};

export type GeneratedReportUpdateWithoutPiiDataAccessLogs = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestUpdateRelationWithoutGeneratedReports>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutGeneratedReports>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<FileUpdateRelationWithoutGeneratedReportReports>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestUpdateRelationWithoutGeneratedReports>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutGeneratedReports>;
};

export type GeneratedReportWhere = {
  AND?: InputMaybe<Array<GeneratedReportWhere>>;
  NOT?: InputMaybe<Array<GeneratedReportWhere>>;
  OR?: InputMaybe<Array<GeneratedReportWhere>>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestWhere>;
  apiVerificationRequestId?: InputMaybe<IdFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employer?: InputMaybe<EmployerWhere>;
  employerId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  mdmMetadataObjectHash?: InputMaybe<StringFilter>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogWhereRelationList>;
  report?: InputMaybe<FileWhere>;
  reportId?: InputMaybe<IdFilter>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestWhere>;
  testVerificationRequestId?: InputMaybe<IdFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verificationRequest?: InputMaybe<VerificationRequestWhere>;
  verificationRequestId?: InputMaybe<IdFilter>;
};

export type GeneratedReportWhereRelationList = {
  every?: InputMaybe<GeneratedReportWhere>;
  none?: InputMaybe<GeneratedReportWhere>;
  some?: InputMaybe<GeneratedReportWhere>;
};

export type GeneratedReportWhereUnique = {
  id: Scalars['ID']['input'];
};

export type GetEmailActivityResponse = {
  __typename?: 'GetEmailActivityResponse';
  messages: Array<EmailActivityItem>;
};

export type GetEmployerBasicInfoResponse = {
  __typename?: 'GetEmployerBasicInfoResponse';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<FileResponse>;
  pinHint?: Maybe<Scalars['String']['output']>;
  signUpMethod: SignUpMethod;
};

export type GetEmployersListForVerificationRequestByEmployeeDataResponse = {
  __typename?: 'GetEmployersListForVerificationRequestByEmployeeDataResponse';
  employers: Array<EmployerListItemForVerificationRequest>;
  isThereInactiveEmployers: Scalars['Boolean']['output'];
};

export type GetEmployersListForVerificationRequestResponse = {
  __typename?: 'GetEmployersListForVerificationRequestResponse';
  employers: Array<EmployerListItemForVerificationRequest>;
  isThereInactiveEmployers: Scalars['Boolean']['output'];
};

export type GetEmployersListForVerificationRequestResponseForMyVerify = {
  __typename?: 'GetEmployersListForVerificationRequestResponseForMyVerify';
  employers: Array<EmployerListItemForVerificationRequest>;
};

export type GetEmployersListForWorkLetterForAdminResponse = {
  __typename?: 'GetEmployersListForWorkLetterForAdminResponse';
  employers: Array<EmployerListItemForVerificationRequest>;
};

export type GetEmployersListForWorkLetterResponse = {
  __typename?: 'GetEmployersListForWorkLetterResponse';
  employers: Array<EmployerListItemForVerificationRequest>;
};

export type GetExistingVerificationRequestTotalChargeResponse = {
  __typename?: 'GetExistingVerificationRequestTotalChargeResponse';
  totalCharge: Scalars['Int']['output'];
};

export type GetHelpToClearVerifyStaffData = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  dataDispute?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  requestType: Scalars['String']['input'];
  user: UserType;
  verificationRequest?: InputMaybe<Scalars['String']['input']>;
};

export type GetInboxItemsRequestsQueryResponse = {
  __typename?: 'GetInboxItemsRequestsQueryResponse';
  count: Scalars['Int']['output'];
  items: Array<InboxItemRequest>;
};

export type GetInviteResponse = {
  __typename?: 'GetInviteResponse';
  email: Scalars['String']['output'];
  from?: Maybe<InviteFrom>;
  id: Scalars['ID']['output'];
  isAdditionalStaff: Scalars['Boolean']['output'];
  isBulkUploaded: Scalars['Boolean']['output'];
  isEmployerUnderPeo: Scalars['Boolean']['output'];
  isPeoUnderPeoPayrollProvider: Scalars['Boolean']['output'];
  predefinedSignUpMethod?: Maybe<SignUpMethod>;
  role?: Maybe<UserRole>;
};

export type GetIsEmailFreeQueryResponse = {
  __typename?: 'GetIsEmailFreeQueryResponse';
  isEmailFree: Scalars['Boolean']['output'];
};

export type GetMiddeskStatusResponse = {
  __typename?: 'GetMiddeskStatusResponse';
  isMiddeskEnabled: Scalars['Boolean']['output'];
};

export type GetPartnershipsResponse = {
  __typename?: 'GetPartnershipsResponse';
  count: Scalars['Int']['output'];
  items: Array<PartnershipItem>;
};

export type GetPartnershipsWhere = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type GetPeoBasicInfoResponse = {
  __typename?: 'GetPeoBasicInfoResponse';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<FileResponse>;
  pinHint?: Maybe<Scalars['String']['output']>;
  signUpMethod: SignUpMethod;
};

export type GetPeoPayrollProviderBasicInfoResponse = {
  __typename?: 'GetPeoPayrollProviderBasicInfoResponse';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<FileResponse>;
  pinHint?: Maybe<Scalars['String']['output']>;
  signUpMethod: SignUpMethod;
};

export type GetRevenueShareSettingWithStripeStatuses = {
  __typename?: 'GetRevenueShareSettingWithStripeStatuses';
  revenueShareSetting: RevenueShareSetting;
  stripeStatus?: Maybe<StripeAccountStatus>;
};

export type GetRevenueShareSettingsListWithStripeStatusesResponse = {
  __typename?: 'GetRevenueShareSettingsListWithStripeStatusesResponse';
  count: Scalars['Int']['output'];
  items: Array<GetRevenueShareSettingWithStripeStatuses>;
};

export type GetVerificationRequestTotalChargeResponse = {
  __typename?: 'GetVerificationRequestTotalChargeResponse';
  isOutstandingRequest: Scalars['Boolean']['output'];
  isReverification: Scalars['Boolean']['output'];
  totalCharge: Scalars['Int']['output'];
};

export type GetVerifierByEmailDomainQueryResponse = {
  __typename?: 'GetVerifierByEmailDomainQueryResponse';
  verifiers?: Maybe<Array<VerifierItem>>;
};

export type HrLogicsGetUnifiedReportingInfoQueryResponse = {
  __typename?: 'HrLogicsGetUnifiedReportingInfoQueryResponse';
  verificationRequestsCount: Scalars['Int']['output'];
};

export type IdFilter = {
  equals?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IdUpdate = {
  set?: InputMaybe<Scalars['ID']['input']>;
};

export type InboxItem = {
  __typename?: 'InboxItem';
  activityLogsCount: Scalars['Int']['output'];
  activityLogsList: Array<ActivityLog>;
  apiVerificationRequest?: Maybe<ApiVerificationRequest>;
  createdAt: Scalars['DateTime']['output'];
  dataDispute?: Maybe<DataDispute>;
  id: Scalars['ID']['output'];
  inboxItemUnreadStatusesCount: Scalars['Int']['output'];
  inboxItemUnreadStatusesList: Array<InboxItemUnreadStatus>;
  testVerificationRequest?: Maybe<TestVerificationRequest>;
  type: InboxItemType;
  updatedAt: Scalars['DateTime']['output'];
  verificationRequest?: Maybe<VerificationRequest>;
};

export type InboxItemActivityLogsCountArgs = {
  where?: InputMaybe<ActivityLogWhere>;
};

export type InboxItemActivityLogsListArgs = {
  orderBy?: InputMaybe<Array<ActivityLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityLogWhere>;
};

export type InboxItemInboxItemUnreadStatusesCountArgs = {
  where?: InputMaybe<InboxItemUnreadStatusWhere>;
};

export type InboxItemInboxItemUnreadStatusesListArgs = {
  orderBy?: InputMaybe<Array<InboxItemUnreadStatusOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InboxItemUnreadStatusWhere>;
};

export type InboxItemCreate = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeCreateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutInboxItem>;
};

export type InboxItemCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InboxItemCreateRelationWithoutActivityLogs = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutActivityLogs>;
};

export type InboxItemCreateRelationWithoutApiVerificationRequest = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutApiVerificationRequest>;
};

export type InboxItemCreateRelationWithoutDataDispute = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutDataDispute>;
};

export type InboxItemCreateRelationWithoutInboxItemUnreadStatuses = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutInboxItemUnreadStatuses>;
};

export type InboxItemCreateRelationWithoutTestVerificationRequest = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutTestVerificationRequest>;
};

export type InboxItemCreateRelationWithoutVerificationRequest = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutVerificationRequest>;
};

export type InboxItemCreateWithoutActivityLogs = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeCreateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutInboxItem>;
};

export type InboxItemCreateWithoutApiVerificationRequest = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeCreateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutInboxItem>;
};

export type InboxItemCreateWithoutDataDispute = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutInboxItem>;
};

export type InboxItemCreateWithoutInboxItemUnreadStatuses = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeCreateRelationWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutInboxItem>;
};

export type InboxItemCreateWithoutTestVerificationRequest = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeCreateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutInboxItem>;
};

export type InboxItemCreateWithoutVerificationRequest = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestCreateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeCreateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestCreateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InboxItemOrderBy = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestOrderBy>;
  createdAt?: InputMaybe<SortOrder>;
  dataDispute?: InputMaybe<DataDisputeOrderBy>;
  id?: InputMaybe<SortOrder>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestOrderBy>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verificationRequest?: InputMaybe<VerificationRequestOrderBy>;
};

export type InboxItemRequest = {
  __typename?: 'InboxItemRequest';
  companyName?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataDisputeStatus?: Maybe<DataDisputeItemStatus>;
  id: Scalars['ID']['output'];
  type: InboxItemType;
  verificationRequestStatus?: Maybe<VerificationRequestStatus>;
  verificationRequestType?: Maybe<VerificationRequestType>;
};

export const InboxItemType = {
  ApiVerificationRequest: 'Api_Verification_Request',
  DataDispute: 'Data_Dispute',
  TestVerificationRequest: 'Test_Verification_Request',
  VerificationRequest: 'Verification_Request',
} as const;

export type InboxItemType = (typeof InboxItemType)[keyof typeof InboxItemType];
export type InboxItemTypeFilter = {
  equals?: InputMaybe<InboxItemType>;
  in?: InputMaybe<Array<InboxItemType>>;
  not?: InputMaybe<InboxItemTypeFilter>;
  notIn?: InputMaybe<Array<InboxItemType>>;
};

export type InboxItemTypeUpdate = {
  set?: InputMaybe<InboxItemType>;
};

export type InboxItemUnreadStatus = {
  __typename?: 'InboxItemUnreadStatus';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inboxItem: InboxItem;
  inboxItemId: Scalars['ID']['output'];
  status?: Maybe<InboxItemUnreadStatusStatus>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type InboxItemUnreadStatusCompoundInboxItemIdUserId = {
  inboxItemId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type InboxItemUnreadStatusCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  inboxItem: InboxItemCreateRelationWithoutInboxItemUnreadStatuses;
  status?: InputMaybe<InboxItemUnreadStatusStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutInboxItemUnreadStatuses;
};

export type InboxItemUnreadStatusCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  inboxItemId: Scalars['ID']['input'];
  status?: InputMaybe<InboxItemUnreadStatusStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type InboxItemUnreadStatusCreateRelationListWithoutInboxItem = {
  connect?: InputMaybe<Array<InboxItemUnreadStatusWhereUnique>>;
  create?: InputMaybe<Array<InboxItemUnreadStatusCreateWithoutInboxItem>>;
};

export type InboxItemUnreadStatusCreateRelationListWithoutUser = {
  connect?: InputMaybe<Array<InboxItemUnreadStatusWhereUnique>>;
  create?: InputMaybe<Array<InboxItemUnreadStatusCreateWithoutUser>>;
};

export type InboxItemUnreadStatusCreateWithoutInboxItem = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InboxItemUnreadStatusStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutInboxItemUnreadStatuses;
};

export type InboxItemUnreadStatusCreateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  inboxItem: InboxItemCreateRelationWithoutInboxItemUnreadStatuses;
  status?: InputMaybe<InboxItemUnreadStatusStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InboxItemUnreadStatusOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inboxItem?: InputMaybe<InboxItemOrderBy>;
  inboxItemId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
};

export const InboxItemUnreadStatusStatus = {
  Read: 'Read',
  Unread: 'Unread',
} as const;

export type InboxItemUnreadStatusStatus =
  (typeof InboxItemUnreadStatusStatus)[keyof typeof InboxItemUnreadStatusStatus];
export type InboxItemUnreadStatusStatusFilter = {
  equals?: InputMaybe<InboxItemUnreadStatusStatus>;
  in?: InputMaybe<Array<InboxItemUnreadStatusStatus>>;
  not?: InputMaybe<InboxItemUnreadStatusStatusFilter>;
  notIn?: InputMaybe<Array<InboxItemUnreadStatusStatus>>;
};

export type InboxItemUnreadStatusStatusUpdate = {
  set?: InputMaybe<InboxItemUnreadStatusStatus>;
};

export type InboxItemUnreadStatusUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutInboxItemUnreadStatuses>;
  status?: InputMaybe<InboxItemUnreadStatusStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutInboxItemUnreadStatuses>;
};

export type InboxItemUnreadStatusUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  inboxItemId?: InputMaybe<IdUpdate>;
  status?: InputMaybe<InboxItemUnreadStatusStatusUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  userId?: InputMaybe<IdUpdate>;
};

export type InboxItemUnreadStatusUpdateRelationListWithoutInboxItem = {
  connect?: InputMaybe<Array<InboxItemUnreadStatusWhereUnique>>;
  create?: InputMaybe<Array<InboxItemUnreadStatusCreateWithoutInboxItem>>;
  disconnect?: InputMaybe<Array<InboxItemUnreadStatusWhereUnique>>;
  set?: InputMaybe<Array<InboxItemUnreadStatusWhereUnique>>;
};

export type InboxItemUnreadStatusUpdateRelationListWithoutUser = {
  connect?: InputMaybe<Array<InboxItemUnreadStatusWhereUnique>>;
  create?: InputMaybe<Array<InboxItemUnreadStatusCreateWithoutUser>>;
  disconnect?: InputMaybe<Array<InboxItemUnreadStatusWhereUnique>>;
  set?: InputMaybe<Array<InboxItemUnreadStatusWhereUnique>>;
};

export type InboxItemUnreadStatusWhere = {
  AND?: InputMaybe<Array<InboxItemUnreadStatusWhere>>;
  NOT?: InputMaybe<Array<InboxItemUnreadStatusWhere>>;
  OR?: InputMaybe<Array<InboxItemUnreadStatusWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  inboxItem?: InputMaybe<InboxItemWhere>;
  inboxItemId?: InputMaybe<IdFilter>;
  status?: InputMaybe<InboxItemUnreadStatusStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
};

export type InboxItemUnreadStatusWhereRelationList = {
  every?: InputMaybe<InboxItemUnreadStatusWhere>;
  none?: InputMaybe<InboxItemUnreadStatusWhere>;
  some?: InputMaybe<InboxItemUnreadStatusWhere>;
};

export type InboxItemUnreadStatusWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  inboxItemId_userId?: InputMaybe<InboxItemUnreadStatusCompoundInboxItemIdUserId>;
};

export type InboxItemUpdate = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestUpdateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeUpdateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestUpdateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutInboxItem>;
};

export type InboxItemUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  type?: InputMaybe<InboxItemTypeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type InboxItemUpdateRelationWithoutActivityLogs = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutActivityLogs>;
  disconnect?: InputMaybe<InboxItemWhereUnique>;
  update?: InputMaybe<InboxItemUpdateWithoutActivityLogs>;
};

export type InboxItemUpdateRelationWithoutApiVerificationRequest = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutApiVerificationRequest>;
  disconnect?: InputMaybe<InboxItemWhereUnique>;
  update?: InputMaybe<InboxItemUpdateWithoutApiVerificationRequest>;
};

export type InboxItemUpdateRelationWithoutDataDispute = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutDataDispute>;
  disconnect?: InputMaybe<InboxItemWhereUnique>;
  update?: InputMaybe<InboxItemUpdateWithoutDataDispute>;
};

export type InboxItemUpdateRelationWithoutInboxItemUnreadStatuses = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutInboxItemUnreadStatuses>;
  disconnect?: InputMaybe<InboxItemWhereUnique>;
  update?: InputMaybe<InboxItemUpdateWithoutInboxItemUnreadStatuses>;
};

export type InboxItemUpdateRelationWithoutTestVerificationRequest = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutTestVerificationRequest>;
  disconnect?: InputMaybe<InboxItemWhereUnique>;
  update?: InputMaybe<InboxItemUpdateWithoutTestVerificationRequest>;
};

export type InboxItemUpdateRelationWithoutVerificationRequest = {
  connect?: InputMaybe<InboxItemWhereUnique>;
  create?: InputMaybe<InboxItemCreateWithoutVerificationRequest>;
  disconnect?: InputMaybe<InboxItemWhereUnique>;
  update?: InputMaybe<InboxItemUpdateWithoutVerificationRequest>;
};

export type InboxItemUpdateWithoutActivityLogs = {
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestUpdateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeUpdateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestUpdateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutInboxItem>;
};

export type InboxItemUpdateWithoutApiVerificationRequest = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeUpdateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestUpdateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutInboxItem>;
};

export type InboxItemUpdateWithoutDataDispute = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestUpdateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestUpdateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutInboxItem>;
};

export type InboxItemUpdateWithoutInboxItemUnreadStatuses = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestUpdateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeUpdateRelationWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestUpdateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutInboxItem>;
};

export type InboxItemUpdateWithoutTestVerificationRequest = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestUpdateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeUpdateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutInboxItem>;
};

export type InboxItemUpdateWithoutVerificationRequest = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutInboxItem>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestUpdateRelationWithoutInboxItem>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataDispute?: InputMaybe<DataDisputeUpdateRelationWithoutInboxItem>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutInboxItem>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestUpdateRelationWithoutInboxItem>;
  type?: InputMaybe<InboxItemType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InboxItemWhere = {
  AND?: InputMaybe<Array<InboxItemWhere>>;
  NOT?: InputMaybe<Array<InboxItemWhere>>;
  OR?: InputMaybe<Array<InboxItemWhere>>;
  activityLogs?: InputMaybe<ActivityLogWhereRelationList>;
  apiVerificationRequest?: InputMaybe<ApiVerificationRequestWhere>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataDispute?: InputMaybe<DataDisputeWhere>;
  id?: InputMaybe<IdFilter>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusWhereRelationList>;
  testVerificationRequest?: InputMaybe<TestVerificationRequestWhere>;
  type?: InputMaybe<InboxItemTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verificationRequest?: InputMaybe<VerificationRequestWhere>;
};

export type InboxItemWhereUnique = {
  id: Scalars['ID']['input'];
};

export type InboxItemsListWhere = {
  createdAt?: InputMaybe<DateTimeFilter>;
  dataDisputeItemStatus?: InputMaybe<DataDisputeItemStatusFilter>;
  employeeSearchText?: InputMaybe<Scalars['String']['input']>;
  employerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<IdFilter>;
  peoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InboxItemTypeFilter>;
  verificationRequestStatus?: InputMaybe<VerificationRequestStatusFilter>;
  verificationRequestType?: InputMaybe<VerificationRequestTypeFilter>;
  verifierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  verifierType?: InputMaybe<VerifierTypeFilter>;
};

export type InboxListItem = {
  __typename?: 'InboxListItem';
  contributorCompanyName?: Maybe<Scalars['String']['output']>;
  contributorLogoUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employeeAvatarUrl?: Maybe<Scalars['String']['output']>;
  employeeFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isUnread: Scalars['Boolean']['output'];
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  lastActivityHeading?: Maybe<Scalars['String']['output']>;
  permissiblePurposeId?: Maybe<Scalars['ID']['output']>;
  stripePaymentStatus?: Maybe<VerificationRequestStripePaymentStatus>;
  subEntityStatus?: Maybe<Scalars['String']['output']>;
  subEntityType?: Maybe<Scalars['String']['output']>;
  type: InboxItemType;
  updatedAt: Scalars['DateTime']['output'];
  verifierCompanyName?: Maybe<Scalars['String']['output']>;
  verifierLogoUrl?: Maybe<Scalars['String']['output']>;
};

export type InitialBilling = {
  __typename?: 'InitialBilling';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revenueShareFlat: Scalars['Int']['output'];
  revenueSharePercents: Scalars['Decimal']['output'];
  revenueShareType: RevenueShareType;
  reverification: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  voE: Scalars['Int']['output'];
  voI: Scalars['Int']['output'];
};

export type InitialBillingCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  revenueShareFlat: Scalars['Int']['input'];
  revenueSharePercents: Scalars['Decimal']['input'];
  revenueShareType: RevenueShareType;
  reverification: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voE: Scalars['Int']['input'];
  voI: Scalars['Int']['input'];
};

export type InitialBillingCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  revenueShareFlat: Scalars['Int']['input'];
  revenueSharePercents: Scalars['Decimal']['input'];
  revenueShareType: RevenueShareType;
  reverification: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voE: Scalars['Int']['input'];
  voI: Scalars['Int']['input'];
};

export type InitialBillingOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  revenueShareFlat?: InputMaybe<SortOrder>;
  revenueSharePercents?: InputMaybe<SortOrder>;
  revenueShareType?: InputMaybe<SortOrder>;
  reverification?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  voE?: InputMaybe<SortOrder>;
  voI?: InputMaybe<SortOrder>;
};

export type InitialBillingUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  reverification?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voE?: InputMaybe<Scalars['Int']['input']>;
  voI?: InputMaybe<Scalars['Int']['input']>;
};

export type InitialBillingUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  revenueShareFlat?: InputMaybe<IntUpdate>;
  revenueSharePercents?: InputMaybe<DecimalUpdate>;
  revenueShareType?: InputMaybe<RevenueShareTypeUpdate>;
  reverification?: InputMaybe<IntUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  voE?: InputMaybe<IntUpdate>;
  voI?: InputMaybe<IntUpdate>;
};

export type InitialBillingWhere = {
  AND?: InputMaybe<Array<InitialBillingWhere>>;
  NOT?: InputMaybe<Array<InitialBillingWhere>>;
  OR?: InputMaybe<Array<InitialBillingWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  revenueShareFlat?: InputMaybe<IntFilter>;
  revenueSharePercents?: InputMaybe<DecimalFilter>;
  revenueShareType?: InputMaybe<RevenueShareTypeFilter>;
  reverification?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  voE?: InputMaybe<IntFilter>;
  voI?: InputMaybe<IntFilter>;
};

export type InitialBillingWhereUnique = {
  id: Scalars['ID']['input'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntUpdate = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type Integration = {
  __typename?: 'Integration';
  apiVerificationRequestsCount: Scalars['Int']['output'];
  apiVerificationRequestsList: Array<ApiVerificationRequest>;
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialsLimitAttempts: Scalars['Int']['output'];
  credentialsLimitWindow: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  ipLimitAttempts: Scalars['Int']['output'];
  ipLimitWindow: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  scope: Array<IntegrationScope>;
  status: ActiveInactive;
  tokenVersion: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageLogsCount: Scalars['Int']['output'];
  usageLogsList: Array<IntegrationUsageLog>;
  verifier?: Maybe<Verifier>;
  verifierId?: Maybe<Scalars['ID']['output']>;
  verifierLimitAttempts: Scalars['Int']['output'];
  verifierLimitWindow: Scalars['Int']['output'];
};

export type IntegrationApiVerificationRequestsCountArgs = {
  where?: InputMaybe<ApiVerificationRequestWhere>;
};

export type IntegrationApiVerificationRequestsListArgs = {
  orderBy?: InputMaybe<Array<ApiVerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiVerificationRequestWhere>;
};

export type IntegrationUsageLogsCountArgs = {
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type IntegrationUsageLogsListArgs = {
  orderBy?: InputMaybe<Array<IntegrationUsageLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type IntegrationCreate = {
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutIntegration>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialsLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  credentialsLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  ipLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  ipLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  scope?: InputMaybe<Array<IntegrationScope>>;
  status?: InputMaybe<ActiveInactive>;
  tokenVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  usageLogs?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutIntegration>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutIntegrations>;
  verifierLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  verifierLimitWindow?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationCreateMany = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialsLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  credentialsLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  ipLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  ipLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  scope?: InputMaybe<Array<IntegrationScope>>;
  status?: InputMaybe<ActiveInactive>;
  tokenVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierId?: InputMaybe<Scalars['ID']['input']>;
  verifierLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  verifierLimitWindow?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationCreateRelationListWithoutVerifier = {
  connect?: InputMaybe<Array<IntegrationWhereUnique>>;
  create?: InputMaybe<Array<IntegrationCreateWithoutVerifier>>;
};

export type IntegrationCreateRelationWithoutApiVerificationRequests = {
  connect?: InputMaybe<IntegrationWhereUnique>;
  create?: InputMaybe<IntegrationCreateWithoutApiVerificationRequests>;
};

export type IntegrationCreateRelationWithoutUsageLogs = {
  connect?: InputMaybe<IntegrationWhereUnique>;
  create?: InputMaybe<IntegrationCreateWithoutUsageLogs>;
};

export type IntegrationCreateWithoutApiVerificationRequests = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialsLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  credentialsLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  ipLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  ipLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  scope?: InputMaybe<Array<IntegrationScope>>;
  status?: InputMaybe<ActiveInactive>;
  tokenVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  usageLogs?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutIntegration>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutIntegrations>;
  verifierLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  verifierLimitWindow?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationCreateWithoutUsageLogs = {
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutIntegration>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialsLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  credentialsLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  ipLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  ipLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  scope?: InputMaybe<Array<IntegrationScope>>;
  status?: InputMaybe<ActiveInactive>;
  tokenVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifier?: InputMaybe<VerifierCreateRelationWithoutIntegrations>;
  verifierLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  verifierLimitWindow?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationCreateWithoutVerifier = {
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestCreateRelationListWithoutIntegration>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialsLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  credentialsLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  ipLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  ipLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  scope?: InputMaybe<Array<IntegrationScope>>;
  status?: InputMaybe<ActiveInactive>;
  tokenVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  usageLogs?: InputMaybe<IntegrationUsageLogCreateRelationListWithoutIntegration>;
  verifierLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  verifierLimitWindow?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationOrderBy = {
  clientId?: InputMaybe<SortOrder>;
  clientSecret?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credentialsLimitAttempts?: InputMaybe<SortOrder>;
  credentialsLimitWindow?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ipLimitAttempts?: InputMaybe<SortOrder>;
  ipLimitWindow?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tokenVersion?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verifier?: InputMaybe<VerifierOrderBy>;
  verifierId?: InputMaybe<SortOrderInput>;
  verifierLimitAttempts?: InputMaybe<SortOrder>;
  verifierLimitWindow?: InputMaybe<SortOrder>;
};

export type IntegrationRawCredentials = {
  __typename?: 'IntegrationRawCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export const IntegrationScope = {
  BatchUpload: 'BatchUpload',
  Employment: 'Employment',
  Government: 'Government',
  Income: 'Income',
} as const;

export type IntegrationScope = (typeof IntegrationScope)[keyof typeof IntegrationScope];
export type IntegrationScopeListFilter = {
  equals?: InputMaybe<Array<IntegrationScope>>;
  has?: InputMaybe<IntegrationScope>;
  hasEvery?: InputMaybe<Array<IntegrationScope>>;
  hasSome?: InputMaybe<Array<IntegrationScope>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationScopeListUpdate = {
  push?: InputMaybe<Array<IntegrationScope>>;
  set?: InputMaybe<Array<IntegrationScope>>;
};

export type IntegrationUpdate = {
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutIntegration>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialsLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  credentialsLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  ipLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  ipLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<IntegrationScopeListUpdate>;
  status?: InputMaybe<ActiveInactive>;
  tokenVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  usageLogs?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutIntegration>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutIntegrations>;
  verifierLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  verifierLimitWindow?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationUpdateMany = {
  clientId?: InputMaybe<StringUpdate>;
  clientSecret?: InputMaybe<StringUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  credentialsLimitAttempts?: InputMaybe<IntUpdate>;
  credentialsLimitWindow?: InputMaybe<IntUpdate>;
  ipLimitAttempts?: InputMaybe<IntUpdate>;
  ipLimitWindow?: InputMaybe<IntUpdate>;
  name?: InputMaybe<StringUpdate>;
  scope?: InputMaybe<IntegrationScopeListUpdate>;
  status?: InputMaybe<ActiveInactiveUpdate>;
  tokenVersion?: InputMaybe<IntUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  verifierId?: InputMaybe<IdUpdate>;
  verifierLimitAttempts?: InputMaybe<IntUpdate>;
  verifierLimitWindow?: InputMaybe<IntUpdate>;
};

export type IntegrationUpdateRelationListWithoutVerifier = {
  connect?: InputMaybe<Array<IntegrationWhereUnique>>;
  create?: InputMaybe<Array<IntegrationCreateWithoutVerifier>>;
  disconnect?: InputMaybe<Array<IntegrationWhereUnique>>;
  set?: InputMaybe<Array<IntegrationWhereUnique>>;
};

export type IntegrationUpdateRelationWithoutApiVerificationRequests = {
  connect?: InputMaybe<IntegrationWhereUnique>;
  create?: InputMaybe<IntegrationCreateWithoutApiVerificationRequests>;
  disconnect?: InputMaybe<IntegrationWhereUnique>;
  update?: InputMaybe<IntegrationUpdateWithoutApiVerificationRequests>;
};

export type IntegrationUpdateRelationWithoutUsageLogs = {
  connect?: InputMaybe<IntegrationWhereUnique>;
  create?: InputMaybe<IntegrationCreateWithoutUsageLogs>;
  disconnect?: InputMaybe<IntegrationWhereUnique>;
  update?: InputMaybe<IntegrationUpdateWithoutUsageLogs>;
};

export type IntegrationUpdateWithoutApiVerificationRequests = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialsLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  credentialsLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  ipLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  ipLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<IntegrationScopeListUpdate>;
  status?: InputMaybe<ActiveInactive>;
  tokenVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  usageLogs?: InputMaybe<IntegrationUsageLogUpdateRelationListWithoutIntegration>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutIntegrations>;
  verifierLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  verifierLimitWindow?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationUpdateWithoutUsageLogs = {
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestUpdateRelationListWithoutIntegration>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialsLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  credentialsLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  ipLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  ipLimitWindow?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<IntegrationScopeListUpdate>;
  status?: InputMaybe<ActiveInactive>;
  tokenVersion?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutIntegrations>;
  verifierLimitAttempts?: InputMaybe<Scalars['Int']['input']>;
  verifierLimitWindow?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationUsageLog = {
  __typename?: 'IntegrationUsageLog';
  ambiguous: Scalars['Int']['output'];
  body?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endpoint: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inputFile?: Maybe<File>;
  inputFileId?: Maybe<Scalars['ID']['output']>;
  integration: Integration;
  integrationId: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  last4Ssn?: Maybe<Scalars['String']['output']>;
  noMatch: Scalars['Int']['output'];
  outputFile?: Maybe<File>;
  outputFileId?: Maybe<Scalars['ID']['output']>;
  requestId: Scalars['String']['output'];
  requesterId?: Maybe<Scalars['String']['output']>;
  status: IntegrationUsageLogStatus;
  statusCode?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Int']['output'];
};

export const IntegrationUsageLogColumnKeyEnum = {
  Ambiguous: 'ambiguous',
  CreatedAt: 'createdAt',
  DateOfBirth: 'dateOfBirth',
  Duration: 'duration',
  Endpoint: 'endpoint',
  Last4Ssn: 'last4Ssn',
  NoMatch: 'noMatch',
  RequestId: 'requestId',
  RequesterId: 'requesterId',
  Status: 'status',
  StatusCode: 'statusCode',
  Verified: 'verified',
} as const;

export type IntegrationUsageLogColumnKeyEnum =
  (typeof IntegrationUsageLogColumnKeyEnum)[keyof typeof IntegrationUsageLogColumnKeyEnum];
export type IntegrationUsageLogCreate = {
  ambiguous?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endpoint: Scalars['String']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  inputFile?: InputMaybe<FileCreateRelationWithoutIntegrationInputFile>;
  integration: IntegrationCreateRelationWithoutUsageLogs;
  ip?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  noMatch?: InputMaybe<Scalars['Int']['input']>;
  outputFile?: InputMaybe<FileCreateRelationWithoutIntegrationOutputFile>;
  requestId: Scalars['String']['input'];
  requesterId?: InputMaybe<Scalars['String']['input']>;
  status: IntegrationUsageLogStatus;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationUsageLogCreateMany = {
  ambiguous?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endpoint: Scalars['String']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  inputFileId?: InputMaybe<Scalars['ID']['input']>;
  integrationId: Scalars['ID']['input'];
  ip?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  noMatch?: InputMaybe<Scalars['Int']['input']>;
  outputFileId?: InputMaybe<Scalars['ID']['input']>;
  requestId: Scalars['String']['input'];
  requesterId?: InputMaybe<Scalars['String']['input']>;
  status: IntegrationUsageLogStatus;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationUsageLogCreateRelationListWithoutInputFile = {
  connect?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
  create?: InputMaybe<Array<IntegrationUsageLogCreateWithoutInputFile>>;
};

export type IntegrationUsageLogCreateRelationListWithoutIntegration = {
  connect?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
  create?: InputMaybe<Array<IntegrationUsageLogCreateWithoutIntegration>>;
};

export type IntegrationUsageLogCreateRelationListWithoutOutputFile = {
  connect?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
  create?: InputMaybe<Array<IntegrationUsageLogCreateWithoutOutputFile>>;
};

export type IntegrationUsageLogCreateWithoutInputFile = {
  ambiguous?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endpoint: Scalars['String']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  integration: IntegrationCreateRelationWithoutUsageLogs;
  ip?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  noMatch?: InputMaybe<Scalars['Int']['input']>;
  outputFile?: InputMaybe<FileCreateRelationWithoutIntegrationOutputFile>;
  requestId: Scalars['String']['input'];
  requesterId?: InputMaybe<Scalars['String']['input']>;
  status: IntegrationUsageLogStatus;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationUsageLogCreateWithoutIntegration = {
  ambiguous?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endpoint: Scalars['String']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  inputFile?: InputMaybe<FileCreateRelationWithoutIntegrationInputFile>;
  ip?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  noMatch?: InputMaybe<Scalars['Int']['input']>;
  outputFile?: InputMaybe<FileCreateRelationWithoutIntegrationOutputFile>;
  requestId: Scalars['String']['input'];
  requesterId?: InputMaybe<Scalars['String']['input']>;
  status: IntegrationUsageLogStatus;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationUsageLogCreateWithoutOutputFile = {
  ambiguous?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endpoint: Scalars['String']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  inputFile?: InputMaybe<FileCreateRelationWithoutIntegrationInputFile>;
  integration: IntegrationCreateRelationWithoutUsageLogs;
  ip?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  noMatch?: InputMaybe<Scalars['Int']['input']>;
  requestId: Scalars['String']['input'];
  requesterId?: InputMaybe<Scalars['String']['input']>;
  status: IntegrationUsageLogStatus;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Int']['input']>;
};

export const IntegrationUsageLogFormatEnum = {
  Csv: 'csv',
  Json: 'json',
  Xlsx: 'xlsx',
} as const;

export type IntegrationUsageLogFormatEnum =
  (typeof IntegrationUsageLogFormatEnum)[keyof typeof IntegrationUsageLogFormatEnum];
export type IntegrationUsageLogOrderBy = {
  ambiguous?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrderInput>;
  duration?: InputMaybe<SortOrderInput>;
  endpoint?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrderInput>;
  finishedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  inputFile?: InputMaybe<FileOrderBy>;
  inputFileId?: InputMaybe<SortOrderInput>;
  integration?: InputMaybe<IntegrationOrderBy>;
  integrationId?: InputMaybe<SortOrder>;
  ip?: InputMaybe<SortOrderInput>;
  last4Ssn?: InputMaybe<SortOrderInput>;
  noMatch?: InputMaybe<SortOrder>;
  outputFile?: InputMaybe<FileOrderBy>;
  outputFileId?: InputMaybe<SortOrderInput>;
  requestId?: InputMaybe<SortOrder>;
  requesterId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  statusCode?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userAgent?: InputMaybe<SortOrderInput>;
  verified?: InputMaybe<SortOrder>;
};

export type IntegrationUsageLogStats = {
  __typename?: 'IntegrationUsageLogStats';
  failed: Scalars['Int']['output'];
  matched: Scalars['Int']['output'];
  noMatch: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export const IntegrationUsageLogStatus = {
  Failed: 'Failed',
  FileUpload: 'File_Upload',
  Processing: 'Processing',
  Succeeded: 'Succeeded',
} as const;

export type IntegrationUsageLogStatus =
  (typeof IntegrationUsageLogStatus)[keyof typeof IntegrationUsageLogStatus];
export type IntegrationUsageLogStatusFilter = {
  equals?: InputMaybe<IntegrationUsageLogStatus>;
  in?: InputMaybe<Array<IntegrationUsageLogStatus>>;
  not?: InputMaybe<IntegrationUsageLogStatusFilter>;
  notIn?: InputMaybe<Array<IntegrationUsageLogStatus>>;
};

export type IntegrationUsageLogStatusUpdate = {
  set?: InputMaybe<IntegrationUsageLogStatus>;
};

export type IntegrationUsageLogUpdate = {
  ambiguous?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  inputFile?: InputMaybe<FileUpdateRelationWithoutIntegrationInputFile>;
  integration?: InputMaybe<IntegrationUpdateRelationWithoutUsageLogs>;
  ip?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  noMatch?: InputMaybe<Scalars['Int']['input']>;
  outputFile?: InputMaybe<FileUpdateRelationWithoutIntegrationOutputFile>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  requesterId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IntegrationUsageLogStatus>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationUsageLogUpdateMany = {
  ambiguous?: InputMaybe<IntUpdate>;
  body?: InputMaybe<JsonUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  dateOfBirth?: InputMaybe<DateTimeUpdate>;
  duration?: InputMaybe<IntUpdate>;
  endpoint?: InputMaybe<StringUpdate>;
  errorMessage?: InputMaybe<StringUpdate>;
  finishedAt?: InputMaybe<DateTimeUpdate>;
  inputFileId?: InputMaybe<IdUpdate>;
  integrationId?: InputMaybe<IdUpdate>;
  ip?: InputMaybe<StringUpdate>;
  last4Ssn?: InputMaybe<StringUpdate>;
  noMatch?: InputMaybe<IntUpdate>;
  outputFileId?: InputMaybe<IdUpdate>;
  requestId?: InputMaybe<StringUpdate>;
  requesterId?: InputMaybe<StringUpdate>;
  status?: InputMaybe<IntegrationUsageLogStatusUpdate>;
  statusCode?: InputMaybe<IntUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  userAgent?: InputMaybe<StringUpdate>;
  verified?: InputMaybe<IntUpdate>;
};

export type IntegrationUsageLogUpdateRelationListWithoutInputFile = {
  connect?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
  create?: InputMaybe<Array<IntegrationUsageLogCreateWithoutInputFile>>;
  disconnect?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
  set?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
};

export type IntegrationUsageLogUpdateRelationListWithoutIntegration = {
  connect?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
  create?: InputMaybe<Array<IntegrationUsageLogCreateWithoutIntegration>>;
  disconnect?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
  set?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
};

export type IntegrationUsageLogUpdateRelationListWithoutOutputFile = {
  connect?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
  create?: InputMaybe<Array<IntegrationUsageLogCreateWithoutOutputFile>>;
  disconnect?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
  set?: InputMaybe<Array<IntegrationUsageLogWhereUnique>>;
};

export type IntegrationUsageLogWhere = {
  AND?: InputMaybe<Array<IntegrationUsageLogWhere>>;
  NOT?: InputMaybe<Array<IntegrationUsageLogWhere>>;
  OR?: InputMaybe<Array<IntegrationUsageLogWhere>>;
  ambiguous?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<DateTimeFilter>;
  duration?: InputMaybe<IntFilter>;
  endpoint?: InputMaybe<StringFilter>;
  errorMessage?: InputMaybe<StringFilter>;
  finishedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  inputFile?: InputMaybe<FileWhere>;
  inputFileId?: InputMaybe<IdFilter>;
  integration?: InputMaybe<IntegrationWhere>;
  integrationId?: InputMaybe<IdFilter>;
  ip?: InputMaybe<StringFilter>;
  last4Ssn?: InputMaybe<StringFilter>;
  noMatch?: InputMaybe<IntFilter>;
  outputFile?: InputMaybe<FileWhere>;
  outputFileId?: InputMaybe<IdFilter>;
  requestId?: InputMaybe<StringFilter>;
  requesterId?: InputMaybe<StringFilter>;
  status?: InputMaybe<IntegrationUsageLogStatusFilter>;
  statusCode?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userAgent?: InputMaybe<StringFilter>;
  verified?: InputMaybe<IntFilter>;
};

export type IntegrationUsageLogWhereRelationList = {
  every?: InputMaybe<IntegrationUsageLogWhere>;
  none?: InputMaybe<IntegrationUsageLogWhere>;
  some?: InputMaybe<IntegrationUsageLogWhere>;
};

export type IntegrationUsageLogWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationWhere = {
  AND?: InputMaybe<Array<IntegrationWhere>>;
  NOT?: InputMaybe<Array<IntegrationWhere>>;
  OR?: InputMaybe<Array<IntegrationWhere>>;
  apiVerificationRequests?: InputMaybe<ApiVerificationRequestWhereRelationList>;
  clientId?: InputMaybe<StringFilter>;
  clientSecret?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentialsLimitAttempts?: InputMaybe<IntFilter>;
  credentialsLimitWindow?: InputMaybe<IntFilter>;
  id?: InputMaybe<IdFilter>;
  ipLimitAttempts?: InputMaybe<IntFilter>;
  ipLimitWindow?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  scope?: InputMaybe<IntegrationScopeListFilter>;
  status?: InputMaybe<ActiveInactiveFilter>;
  tokenVersion?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usageLogs?: InputMaybe<IntegrationUsageLogWhereRelationList>;
  verifier?: InputMaybe<VerifierWhere>;
  verifierId?: InputMaybe<IdFilter>;
  verifierLimitAttempts?: InputMaybe<IntFilter>;
  verifierLimitWindow?: InputMaybe<IntFilter>;
};

export type IntegrationWhereRelationList = {
  every?: InputMaybe<IntegrationWhere>;
  none?: InputMaybe<IntegrationWhere>;
  some?: InputMaybe<IntegrationWhere>;
};

export type IntegrationWhereUnique = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Invite = {
  __typename?: 'Invite';
  createdAt: Scalars['DateTime']['output'];
  expiresIn: Scalars['DateTime']['output'];
  from?: Maybe<InviteFrom>;
  id: Scalars['ID']['output'];
  isBulkUploaded?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type InviteCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresIn: Scalars['DateTime']['input'];
  from?: InputMaybe<InviteFrom>;
  isBulkUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutInvite;
};

export type InviteCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresIn: Scalars['DateTime']['input'];
  from?: InputMaybe<InviteFrom>;
  isBulkUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type InviteCreateRelationWithoutUser = {
  connect?: InputMaybe<InviteWhereUnique>;
  create?: InputMaybe<InviteCreateWithoutUser>;
};

export type InviteCreateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresIn: Scalars['DateTime']['input'];
  from?: InputMaybe<InviteFrom>;
  isBulkUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export const InviteFrom = {
  Employer: 'Employer',
  Peo: 'Peo',
  PeoPayrollProvider: 'Peo_Payroll_Provider',
  Platform: 'Platform',
  Verifier: 'Verifier',
} as const;

export type InviteFrom = (typeof InviteFrom)[keyof typeof InviteFrom];
export type InviteFromFilter = {
  equals?: InputMaybe<InviteFrom>;
  in?: InputMaybe<Array<InviteFrom>>;
  not?: InputMaybe<InviteFromFilter>;
  notIn?: InputMaybe<Array<InviteFrom>>;
};

export type InviteFromUpdate = {
  set?: InputMaybe<InviteFrom>;
};

export type InviteOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  expiresIn?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isBulkUploaded?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
};

export type InviteUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresIn?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<InviteFrom>;
  isBulkUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutInvite>;
};

export type InviteUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  expiresIn?: InputMaybe<DateTimeUpdate>;
  from?: InputMaybe<InviteFromUpdate>;
  isBulkUploaded?: InputMaybe<BooleanUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  userId?: InputMaybe<IdUpdate>;
};

export type InviteUpdateRelationWithoutUser = {
  connect?: InputMaybe<InviteWhereUnique>;
  create?: InputMaybe<InviteCreateWithoutUser>;
  disconnect?: InputMaybe<InviteWhereUnique>;
  update?: InputMaybe<InviteUpdateWithoutUser>;
};

export type InviteUpdateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresIn?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<InviteFrom>;
  isBulkUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InviteWhere = {
  AND?: InputMaybe<Array<InviteWhere>>;
  NOT?: InputMaybe<Array<InviteWhere>>;
  OR?: InputMaybe<Array<InviteWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresIn?: InputMaybe<DateTimeFilter>;
  from?: InputMaybe<InviteFromFilter>;
  id?: InputMaybe<IdFilter>;
  isBulkUploaded?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
};

export type InviteWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type InvitedByCvStaffPeoData = {
  email: Scalars['String']['input'];
  isRevenueShareEnabled: Scalars['Boolean']['input'];
};

export type InvitedByCvStaffPeoPayrollProviderData = {
  email: Scalars['String']['input'];
  isRevenueShareEnabled: Scalars['Boolean']['input'];
};

export type InvitedByPeoStaffEmployer = {
  contactEmail: Scalars['String']['input'];
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  emailForInvitation?: InputMaybe<Scalars['String']['input']>;
  fein: Scalars['String']['input'];
  feinCommercialName: Scalars['String']['input'];
  feinRegisteredBusinessName: Scalars['String']['input'];
  hqAddress: Scalars['String']['input'];
  hqCity: Scalars['String']['input'];
  hqCounty?: InputMaybe<Scalars['String']['input']>;
  hqState: Scalars['String']['input'];
  hqZipCode: Scalars['String']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedEmployerAdminByCvAdminData = {
  email: Scalars['String']['input'];
  shouldCreateBillingRules: Scalars['Boolean']['input'];
};

export type InvitedEmployerByPeoPp = {
  contactEmail: Scalars['String']['input'];
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  emailForInvitation?: InputMaybe<Scalars['String']['input']>;
  employerFein: Scalars['String']['input'];
  feinCommercialName: Scalars['String']['input'];
  feinRegisteredBusinessName: Scalars['String']['input'];
  hqAddress: Scalars['String']['input'];
  hqCity: Scalars['String']['input'];
  hqCounty?: InputMaybe<Scalars['String']['input']>;
  hqState: Scalars['String']['input'];
  hqZipCode: Scalars['String']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  peoFein?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedEmployerStaff = {
  email: Scalars['String']['input'];
  locationIdList?: InputMaybe<Array<Scalars['ID']['input']>>;
  role: EmployerStaffRole;
};

export type InvitedPeoByPeoPp = {
  contactEmail: Scalars['String']['input'];
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  emailForInvitation?: InputMaybe<Scalars['String']['input']>;
  fein: Scalars['String']['input'];
  hqAddress: Scalars['String']['input'];
  hqCity: Scalars['String']['input'];
  hqCounty?: InputMaybe<Scalars['String']['input']>;
  hqState: Scalars['String']['input'];
  hqZipCode: Scalars['String']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedPeoPayrollProviderStaff = {
  email: Scalars['String']['input'];
};

export type InvitedPeoStaffData = {
  accessRestrictionMode?: InputMaybe<AccessRestrictionMode>;
  email: Scalars['String']['input'];
  employeesBlacklistList?: InputMaybe<Array<PeoStaffBlacklistedEmployeeInput>>;
  employersBlacklistIdList?: InputMaybe<Array<Scalars['ID']['input']>>;
  employersWhitelistIdList?: InputMaybe<Array<Scalars['ID']['input']>>;
  role: PeoStaffRole;
};

export type InvitedSignedAddressData = {
  city: Scalars['String']['input'];
  county?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type InvitedSignedConsumerData = {
  requestAutoApprove: Scalars['Boolean']['input'];
};

export type InvitedSignedEmployerData = {
  avatarImageFile?: InputMaybe<Scalars['FileUpload']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  headquarters?: InputMaybe<InvitedSignedAddressData>;
  industry?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedSignedPeoData = {
  avatarImageFile?: InputMaybe<Scalars['FileUpload']['input']>;
  contactEmail: Scalars['String']['input'];
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  fein: Scalars['String']['input'];
  headquarters?: InputMaybe<InvitedSignedAddressData>;
  industry?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  requestAutoAccept: Scalars['Boolean']['input'];
  signUpMethod: SignUpMethod;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedSignedPeoPayrollProviderData = {
  avatarImageFile?: InputMaybe<Scalars['FileUpload']['input']>;
  contactEmail: Scalars['String']['input'];
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  fein: Scalars['String']['input'];
  headquarters?: InputMaybe<InvitedSignedAddressData>;
  industry?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  requestAutoAccept: Scalars['Boolean']['input'];
  signUpMethod: SignUpMethod;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedSignedUserData = {
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedSignedVerifierData = {
  address: InvitedSignedAddressData;
  avatarImageFile?: InputMaybe<Scalars['FileUpload']['input']>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  companyDisplayName: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  fein: Scalars['String']['input'];
  governmentDepartment?: InputMaybe<Scalars['String']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  governmentType?: InputMaybe<VerifierTypeOfGovernment>;
  industry: Scalars['String']['input'];
  permissiblePurposeReferenceId: Scalars['ID']['input'];
  registeredBusinessName?: InputMaybe<Scalars['String']['input']>;
  type: VerifierType;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedVerifierAdminByCvAdminData = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedVerifierAdminByVerifierAdminData = {
  email: Scalars['String']['input'];
};

export type InvitedVerifierStaffByVerifierAdminData = {
  email: Scalars['String']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvitedVerifierStaffData = {
  email: Scalars['String']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JsonUpdate = {
  set?: InputMaybe<Scalars['Json']['input']>;
};

export type LastUploadRolesResponse = {
  __typename?: 'LastUploadRolesResponse';
  rolesCount: Scalars['Int']['output'];
  uploadedAt: Scalars['DateTime']['output'];
};

export type MaintenanceStatusResponse = {
  __typename?: 'MaintenanceStatusResponse';
  isMaintenanceEnabled: Scalars['Boolean']['output'];
};

export type MiddeskCreateBusinessForVerifierResponse = {
  __typename?: 'MiddeskCreateBusinessForVerifierResponse';
  middeskBusinessId?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activityLogCreate: ActivityLog;
  activityLogCreateBatch: Array<ActivityLog>;
  activityLogCreateMany: Scalars['Int']['output'];
  activityLogDelete: Scalars['Boolean']['output'];
  activityLogDeleteBatch: Scalars['Boolean']['output'];
  activityLogDeleteMany: Scalars['Int']['output'];
  activityLogUpdate: ActivityLog;
  activityLogUpdateBatch: Array<ActivityLog>;
  activityLogUpdateMany: Scalars['Int']['output'];
  addressCreate: Address;
  addressCreateBatch: Array<Address>;
  addressCreateMany: Scalars['Int']['output'];
  addressDelete: Scalars['Boolean']['output'];
  addressDeleteBatch: Scalars['Boolean']['output'];
  addressDeleteMany: Scalars['Int']['output'];
  addressUpdate: Address;
  addressUpdateBatch: Array<Address>;
  addressUpdateMany: Scalars['Int']['output'];
  apiTokenCreate: ApiToken;
  apiTokenCreateBatch: Array<ApiToken>;
  apiTokenCreateMany: Scalars['Int']['output'];
  apiTokenDelete: Scalars['Boolean']['output'];
  apiTokenDeleteBatch: Scalars['Boolean']['output'];
  apiTokenDeleteMany: Scalars['Int']['output'];
  apiTokenUpdate: ApiToken;
  apiTokenUpdateBatch: Array<ApiToken>;
  apiTokenUpdateMany: Scalars['Int']['output'];
  apiVerificationRequestCreate: ApiVerificationRequest;
  apiVerificationRequestCreateBatch: Array<ApiVerificationRequest>;
  apiVerificationRequestCreateMany: Scalars['Int']['output'];
  apiVerificationRequestDelete: Scalars['Boolean']['output'];
  apiVerificationRequestDeleteBatch: Scalars['Boolean']['output'];
  apiVerificationRequestDeleteMany: Scalars['Int']['output'];
  apiVerificationRequestUpdate: ApiVerificationRequest;
  apiVerificationRequestUpdateBatch: Array<ApiVerificationRequest>;
  apiVerificationRequestUpdateMany: Scalars['Int']['output'];
  approveVerificationRequestByEmployee: SuccessResponse;
  approveVerificationRequestByVerifier: ApproveVerificationRequestByVerifierResponse;
  attestationCreate: Attestation;
  attestationCreateBatch: Array<Attestation>;
  attestationCreateMany: Scalars['Int']['output'];
  attestationDelete: Scalars['Boolean']['output'];
  attestationDeleteBatch: Scalars['Boolean']['output'];
  attestationDeleteMany: Scalars['Int']['output'];
  attestationUpdate: Attestation;
  attestationUpdateBatch: Array<Attestation>;
  attestationUpdateMany: Scalars['Int']['output'];
  changeDataDisputeItemStatus: SuccessResponse;
  changeEmployeeUserEmailByPlatformAdmin: SuccessResponse;
  changeUserEmail: SuccessResponse;
  changeUserPassword: ChangeUserPasswordResponse;
  changeUserStatus: User;
  cognitoDisableUserMfa: SuccessResponse;
  confirmUserEmail: SuccessResponse;
  createDataDisputeByEmployee: CreateDataDisputeByEmployeeResponse;
  createDataDisputeForPosition: SuccessResponse;
  createDataDisputeOnEmployeeSignup: SuccessResponse;
  createDataDisputeOnEmployeeSignupByInvite: SuccessResponse;
  createEmployeeInviteLinkByCVStaff: ResendInviteResponse;
  createEmployeeNote: EmployeeNote;
  createPermissiblePurpose: CreatePermissiblePurposeResponse;
  createReverificationRequest: CreateReverificationRequestResponse;
  createTestVerificationRequest: CreateTestVerificationRequest;
  createUserEmailChangeRequest: SuccessResponse;
  createUserPasswordChangeRequest: SuccessResponse;
  createUserPasswordResetRequest: SuccessResponse;
  createVerificationRequest: CreateVerificationRequestResponse;
  createVerificationRequestByEmployee: SuccessResponse;
  dashboardRevenueShareDatumCreate: DashboardRevenueShareData;
  dashboardRevenueShareDatumCreateBatch: Array<DashboardRevenueShareData>;
  dashboardRevenueShareDatumCreateMany: Scalars['Int']['output'];
  dashboardRevenueShareDatumDelete: Scalars['Boolean']['output'];
  dashboardRevenueShareDatumDeleteBatch: Scalars['Boolean']['output'];
  dashboardRevenueShareDatumDeleteMany: Scalars['Int']['output'];
  dashboardRevenueShareDatumUpdate: DashboardRevenueShareData;
  dashboardRevenueShareDatumUpdateBatch: Array<DashboardRevenueShareData>;
  dashboardRevenueShareDatumUpdateMany: Scalars['Int']['output'];
  dataDisputeCreate: DataDispute;
  dataDisputeCreateBatch: Array<DataDispute>;
  dataDisputeCreateMany: Scalars['Int']['output'];
  dataDisputeDelete: Scalars['Boolean']['output'];
  dataDisputeDeleteBatch: Scalars['Boolean']['output'];
  dataDisputeDeleteMany: Scalars['Int']['output'];
  dataDisputeItemCreate: DataDisputeItem;
  dataDisputeItemCreateBatch: Array<DataDisputeItem>;
  dataDisputeItemCreateMany: Scalars['Int']['output'];
  dataDisputeItemDelete: Scalars['Boolean']['output'];
  dataDisputeItemDeleteBatch: Scalars['Boolean']['output'];
  dataDisputeItemDeleteMany: Scalars['Int']['output'];
  dataDisputeItemUpdate: DataDisputeItem;
  dataDisputeItemUpdateBatch: Array<DataDisputeItem>;
  dataDisputeItemUpdateMany: Scalars['Int']['output'];
  dataDisputeUpdate: DataDispute;
  dataDisputeUpdateBatch: Array<DataDispute>;
  dataDisputeUpdateMany: Scalars['Int']['output'];
  declineVerificationRequestByEmployee: SuccessResponse;
  declineVerificationRequestByVerifier: SuccessResponse;
  deleteClearVerifyStaff: SuccessResponse;
  deleteEmployeeAccountData: SuccessResponse;
  deleteEmployeeUser: SuccessResponse;
  deleteEmployerStaff: SuccessResponse;
  deletePeoStaff: SuccessResponse;
  deleteSuppressionFromEmail: SuccessResponse;
  deleteVerifier: SuccessResponse;
  deleteVerifierStaff: SuccessResponse;
  disclaimerCreate: Disclaimer;
  disclaimerCreateBatch: Array<Disclaimer>;
  disclaimerCreateMany: Scalars['Int']['output'];
  disclaimerDelete: Scalars['Boolean']['output'];
  disclaimerDeleteBatch: Scalars['Boolean']['output'];
  disclaimerDeleteMany: Scalars['Int']['output'];
  disclaimerUpdate: Disclaimer;
  disclaimerUpdateBatch: Array<Disclaimer>;
  disclaimerUpdateMany: Scalars['Int']['output'];
  downloadGeneratedReportFiles: Array<FileResponse>;
  downloadGeneratedReportFilesArchive?: Maybe<GeneratedReportFilesArchiveResponse>;
  employeeAnnualFreeReportCreate: EmployeeAnnualFreeReport;
  employeeAnnualFreeReportCreateBatch: Array<EmployeeAnnualFreeReport>;
  employeeAnnualFreeReportCreateMany: Scalars['Int']['output'];
  employeeAnnualFreeReportDelete: Scalars['Boolean']['output'];
  employeeAnnualFreeReportDeleteBatch: Scalars['Boolean']['output'];
  employeeAnnualFreeReportDeleteMany: Scalars['Int']['output'];
  employeeAnnualFreeReportUpdate: EmployeeAnnualFreeReport;
  employeeAnnualFreeReportUpdateBatch: Array<EmployeeAnnualFreeReport>;
  employeeAnnualFreeReportUpdateMany: Scalars['Int']['output'];
  employeeCreate: Employee;
  employeeCreateBatch: Array<Employee>;
  employeeCreateMany: Scalars['Int']['output'];
  employeeDelete: Scalars['Boolean']['output'];
  employeeDeleteBatch: Scalars['Boolean']['output'];
  employeeDeleteMany: Scalars['Int']['output'];
  employeeNoteCreate: EmployeeNote;
  employeeNoteCreateBatch: Array<EmployeeNote>;
  employeeNoteCreateMany: Scalars['Int']['output'];
  employeeNoteDelete: Scalars['Boolean']['output'];
  employeeNoteDeleteBatch: Scalars['Boolean']['output'];
  employeeNoteDeleteMany: Scalars['Int']['output'];
  employeeNoteUpdate: EmployeeNote;
  employeeNoteUpdateBatch: Array<EmployeeNote>;
  employeeNoteUpdateMany: Scalars['Int']['output'];
  employeeUpdate: Employee;
  employeeUpdateBatch: Array<Employee>;
  employeeUpdateMany: Scalars['Int']['output'];
  employeeWorkLetterCreate: EmployeeWorkLetter;
  employeeWorkLetterCreateBatch: Array<EmployeeWorkLetter>;
  employeeWorkLetterCreateMany: Scalars['Int']['output'];
  employeeWorkLetterDelete: Scalars['Boolean']['output'];
  employeeWorkLetterDeleteBatch: Scalars['Boolean']['output'];
  employeeWorkLetterDeleteMany: Scalars['Int']['output'];
  employeeWorkLetterUpdate: EmployeeWorkLetter;
  employeeWorkLetterUpdateBatch: Array<EmployeeWorkLetter>;
  employeeWorkLetterUpdateMany: Scalars['Int']['output'];
  employerCreate: Employer;
  employerCreateBatch: Array<Employer>;
  employerCreateMany: Scalars['Int']['output'];
  employerDelete: Scalars['Boolean']['output'];
  employerDeleteBatch: Scalars['Boolean']['output'];
  employerDeleteMany: Scalars['Int']['output'];
  employerStaffCreate: EmployerStaff;
  employerStaffCreateBatch: Array<EmployerStaff>;
  employerStaffCreateMany: Scalars['Int']['output'];
  employerStaffDelete: Scalars['Boolean']['output'];
  employerStaffDeleteBatch: Scalars['Boolean']['output'];
  employerStaffDeleteMany: Scalars['Int']['output'];
  employerStaffUpdate: EmployerStaff;
  employerStaffUpdateBatch: Array<EmployerStaff>;
  employerStaffUpdateMany: Scalars['Int']['output'];
  employerUpdate: Employer;
  employerUpdateBatch: Array<Employer>;
  employerUpdateMany: Scalars['Int']['output'];
  fileCreate: File;
  fileCreateBatch: Array<File>;
  fileCreateMany: Scalars['Int']['output'];
  fileDelete: Scalars['Boolean']['output'];
  fileDeleteBatch: Scalars['Boolean']['output'];
  fileDeleteMany: Scalars['Int']['output'];
  fileUpdate: File;
  fileUpdateBatch: Array<File>;
  fileUpdateMany: Scalars['Int']['output'];
  generateAnnualFreeReport: GenerateAnnualFreeReportResponse;
  generateMyDataPdf: FileResponse;
  generateRankedVerifiersReport: FileResponse;
  generateRevenueShareReport: FileResponse;
  generateVerificationRequestsReport: FileResponse;
  generateWorkLetterPdf?: Maybe<FileResponse>;
  generateWorkLetterPdfForAdmin?: Maybe<FileResponse>;
  generateYearToDateFinancialReport: FileResponse;
  generatedReportCreate: GeneratedReport;
  generatedReportCreateBatch: Array<GeneratedReport>;
  generatedReportCreateMany: Scalars['Int']['output'];
  generatedReportDelete: Scalars['Boolean']['output'];
  generatedReportDeleteBatch: Scalars['Boolean']['output'];
  generatedReportDeleteMany: Scalars['Int']['output'];
  generatedReportUpdate: GeneratedReport;
  generatedReportUpdateBatch: Array<GeneratedReport>;
  generatedReportUpdateMany: Scalars['Int']['output'];
  inboxItemCreate: InboxItem;
  inboxItemCreateBatch: Array<InboxItem>;
  inboxItemCreateMany: Scalars['Int']['output'];
  inboxItemDelete: Scalars['Boolean']['output'];
  inboxItemDeleteBatch: Scalars['Boolean']['output'];
  inboxItemDeleteMany: Scalars['Int']['output'];
  inboxItemUnreadStatusCreate: InboxItemUnreadStatus;
  inboxItemUnreadStatusCreateBatch: Array<InboxItemUnreadStatus>;
  inboxItemUnreadStatusCreateMany: Scalars['Int']['output'];
  inboxItemUnreadStatusDelete: Scalars['Boolean']['output'];
  inboxItemUnreadStatusDeleteBatch: Scalars['Boolean']['output'];
  inboxItemUnreadStatusDeleteMany: Scalars['Int']['output'];
  inboxItemUnreadStatusUpdate: InboxItemUnreadStatus;
  inboxItemUnreadStatusUpdateBatch: Array<InboxItemUnreadStatus>;
  inboxItemUnreadStatusUpdateMany: Scalars['Int']['output'];
  inboxItemUpdate: InboxItem;
  inboxItemUpdateBatch: Array<InboxItem>;
  inboxItemUpdateMany: Scalars['Int']['output'];
  initialBillingCreate: InitialBilling;
  initialBillingCreateBatch: Array<InitialBilling>;
  initialBillingCreateMany: Scalars['Int']['output'];
  initialBillingDelete: Scalars['Boolean']['output'];
  initialBillingDeleteBatch: Scalars['Boolean']['output'];
  initialBillingDeleteMany: Scalars['Int']['output'];
  initialBillingUpdate: InitialBilling;
  initialBillingUpdateBatch: Array<InitialBilling>;
  initialBillingUpdateMany: Scalars['Int']['output'];
  integrationCreate: Integration;
  integrationCreateBatch: Array<Integration>;
  integrationCreateCustom: IntegrationRawCredentials;
  integrationCreateMany: Scalars['Int']['output'];
  integrationDelete: Scalars['Boolean']['output'];
  integrationDeleteBatch: Scalars['Boolean']['output'];
  integrationDeleteMany: Scalars['Int']['output'];
  integrationRegenerateCredentials: IntegrationRawCredentials;
  integrationUpdate: Integration;
  integrationUpdateBatch: Array<Integration>;
  integrationUpdateCustom: Integration;
  integrationUpdateMany: Scalars['Int']['output'];
  integrationUsageLogCreate: IntegrationUsageLog;
  integrationUsageLogCreateBatch: Array<IntegrationUsageLog>;
  integrationUsageLogCreateMany: Scalars['Int']['output'];
  integrationUsageLogDelete: Scalars['Boolean']['output'];
  integrationUsageLogDeleteBatch: Scalars['Boolean']['output'];
  integrationUsageLogDeleteMany: Scalars['Int']['output'];
  integrationUsageLogUpdate: IntegrationUsageLog;
  integrationUsageLogUpdateBatch: Array<IntegrationUsageLog>;
  integrationUsageLogUpdateMany: Scalars['Int']['output'];
  inviteCreate: Invite;
  inviteCreateBatch: Array<Invite>;
  inviteCreateMany: Scalars['Int']['output'];
  inviteDelete: Scalars['Boolean']['output'];
  inviteDeleteBatch: Scalars['Boolean']['output'];
  inviteDeleteMany: Scalars['Int']['output'];
  inviteUpdate: Invite;
  inviteUpdateBatch: Array<Invite>;
  inviteUpdateMany: Scalars['Int']['output'];
  leaveCommentForInboxItem: SuccessResponse;
  middeskCreateBusinessForVerifier: MiddeskCreateBusinessForVerifierResponse;
  paymentTransactionCreate: PaymentTransaction;
  paymentTransactionCreateBatch: Array<PaymentTransaction>;
  paymentTransactionCreateMany: Scalars['Int']['output'];
  paymentTransactionDelete: Scalars['Boolean']['output'];
  paymentTransactionDeleteBatch: Scalars['Boolean']['output'];
  paymentTransactionDeleteMany: Scalars['Int']['output'];
  paymentTransactionUpdate: PaymentTransaction;
  paymentTransactionUpdateBatch: Array<PaymentTransaction>;
  paymentTransactionUpdateMany: Scalars['Int']['output'];
  peoCreate: Peo;
  peoCreateBatch: Array<Peo>;
  peoCreateMany: Scalars['Int']['output'];
  peoDelete: Scalars['Boolean']['output'];
  peoDeleteBatch: Scalars['Boolean']['output'];
  peoDeleteMany: Scalars['Int']['output'];
  peoPayrollProviderCreate: PeoPayrollProvider;
  peoPayrollProviderCreateBatch: Array<PeoPayrollProvider>;
  peoPayrollProviderCreateMany: Scalars['Int']['output'];
  peoPayrollProviderDelete: Scalars['Boolean']['output'];
  peoPayrollProviderDeleteBatch: Scalars['Boolean']['output'];
  peoPayrollProviderDeleteMany: Scalars['Int']['output'];
  peoPayrollProviderStaffCreate: PeoPayrollProviderStaff;
  peoPayrollProviderStaffCreateBatch: Array<PeoPayrollProviderStaff>;
  peoPayrollProviderStaffCreateMany: Scalars['Int']['output'];
  peoPayrollProviderStaffDelete: Scalars['Boolean']['output'];
  peoPayrollProviderStaffDeleteBatch: Scalars['Boolean']['output'];
  peoPayrollProviderStaffDeleteMany: Scalars['Int']['output'];
  peoPayrollProviderStaffUpdate: PeoPayrollProviderStaff;
  peoPayrollProviderStaffUpdateBatch: Array<PeoPayrollProviderStaff>;
  peoPayrollProviderStaffUpdateMany: Scalars['Int']['output'];
  peoPayrollProviderUpdate: PeoPayrollProvider;
  peoPayrollProviderUpdateBatch: Array<PeoPayrollProvider>;
  peoPayrollProviderUpdateMany: Scalars['Int']['output'];
  peoStaffCreate: PeoStaff;
  peoStaffCreateBatch: Array<PeoStaff>;
  peoStaffCreateMany: Scalars['Int']['output'];
  peoStaffDelete: Scalars['Boolean']['output'];
  peoStaffDeleteBatch: Scalars['Boolean']['output'];
  peoStaffDeleteMany: Scalars['Int']['output'];
  peoStaffUpdate: PeoStaff;
  peoStaffUpdateBatch: Array<PeoStaff>;
  peoStaffUpdateMany: Scalars['Int']['output'];
  peoUpdate: Peo;
  peoUpdateBatch: Array<Peo>;
  peoUpdateMany: Scalars['Int']['output'];
  permissiblePurposeCreate: PermissiblePurpose;
  permissiblePurposeCreateBatch: Array<PermissiblePurpose>;
  permissiblePurposeCreateMany: Scalars['Int']['output'];
  permissiblePurposeDelete: Scalars['Boolean']['output'];
  permissiblePurposeDeleteBatch: Scalars['Boolean']['output'];
  permissiblePurposeDeleteMany: Scalars['Int']['output'];
  permissiblePurposeReferenceCreate: PermissiblePurposeReference;
  permissiblePurposeReferenceCreateBatch: Array<PermissiblePurposeReference>;
  permissiblePurposeReferenceCreateMany: Scalars['Int']['output'];
  permissiblePurposeReferenceDelete: Scalars['Boolean']['output'];
  permissiblePurposeReferenceDeleteBatch: Scalars['Boolean']['output'];
  permissiblePurposeReferenceDeleteMany: Scalars['Int']['output'];
  permissiblePurposeReferenceUpdate: PermissiblePurposeReference;
  permissiblePurposeReferenceUpdateBatch: Array<PermissiblePurposeReference>;
  permissiblePurposeReferenceUpdateMany: Scalars['Int']['output'];
  permissiblePurposeUpdate: PermissiblePurpose;
  permissiblePurposeUpdateBatch: Array<PermissiblePurpose>;
  permissiblePurposeUpdateMany: Scalars['Int']['output'];
  piiDataAccessLogCreate: PiiDataAccessLog;
  piiDataAccessLogCreateBatch: Array<PiiDataAccessLog>;
  piiDataAccessLogCreateMany: Scalars['Int']['output'];
  piiDataAccessLogDelete: Scalars['Boolean']['output'];
  piiDataAccessLogDeleteBatch: Scalars['Boolean']['output'];
  piiDataAccessLogDeleteMany: Scalars['Int']['output'];
  piiDataAccessLogUpdate: PiiDataAccessLog;
  piiDataAccessLogUpdateBatch: Array<PiiDataAccessLog>;
  piiDataAccessLogUpdateMany: Scalars['Int']['output'];
  platformStaffCreate: PlatformStaff;
  platformStaffCreateBatch: Array<PlatformStaff>;
  platformStaffCreateMany: Scalars['Int']['output'];
  platformStaffDelete: Scalars['Boolean']['output'];
  platformStaffDeleteBatch: Scalars['Boolean']['output'];
  platformStaffDeleteMany: Scalars['Int']['output'];
  platformStaffUpdate: PlatformStaff;
  platformStaffUpdateBatch: Array<PlatformStaff>;
  platformStaffUpdateMany: Scalars['Int']['output'];
  positionCreate: Position;
  positionCreateBatch: Array<Position>;
  positionCreateMany: Scalars['Int']['output'];
  positionDelete: Scalars['Boolean']['output'];
  positionDeleteBatch: Scalars['Boolean']['output'];
  positionDeleteMany: Scalars['Int']['output'];
  positionUpdate: Position;
  positionUpdateBatch: Array<Position>;
  positionUpdateMany: Scalars['Int']['output'];
  reactivateEmployeeAccount: SuccessResponse;
  resendInviteToEmployerStaff: ResendInviteResponse;
  resendInviteToPeoStaff: ResendInviteResponse;
  resendInviteToPlatformStaff: ResendInviteResponse;
  resendInviteToVerifierStaff: ResendInviteResponse;
  resetUserPassword: SuccessResponse;
  resourceCreate: Resource;
  resourceCreateBatch: Array<Resource>;
  resourceCreateMany: Scalars['Int']['output'];
  resourceDelete: Scalars['Boolean']['output'];
  resourceDeleteBatch: Scalars['Boolean']['output'];
  resourceDeleteMany: Scalars['Int']['output'];
  resourceUpdate: Resource;
  resourceUpdateBatch: Array<Resource>;
  resourceUpdateMany: Scalars['Int']['output'];
  revenueShareSettingCreate: RevenueShareSetting;
  revenueShareSettingCreateBatch: Array<RevenueShareSetting>;
  revenueShareSettingCreateMany: Scalars['Int']['output'];
  revenueShareSettingDelete: Scalars['Boolean']['output'];
  revenueShareSettingDeleteBatch: Scalars['Boolean']['output'];
  revenueShareSettingDeleteMany: Scalars['Int']['output'];
  revenueShareSettingUpdate: RevenueShareSetting;
  revenueShareSettingUpdateBatch: Array<RevenueShareSetting>;
  revenueShareSettingUpdateMany: Scalars['Int']['output'];
  runTask: Scalars['String']['output'];
  sendDeleteMyDataRequest: SuccessResponse;
  sendEmailConfirmationCode: SendEmailConfirmationCodeResponse;
  sendGetHelpToClearVerifyStaff: SuccessResponse;
  sendInviteToPartnership: SuccessResponse;
  sendInvitesToClearVerifyStaff: SuccessResponse;
  sendInvitesToConsumersByCVStaff: SuccessResponse;
  sendInvitesToConsumersByEmployer: SuccessResponse;
  sendInvitesToConsumersByPeo: SuccessResponse;
  sendInvitesToConsumersByPeoPayrollProvider: SuccessResponse;
  sendInvitesToEmployerStaffs: SuccessResponse;
  sendInvitesToEmployerStaffsByEmployerAdmin: SuccessResponse;
  sendInvitesToEmployersAdminsByCVAdmin: SuccessResponse;
  sendInvitesToEmployersByPeoPp: SuccessResponse;
  sendInvitesToEmployersByPeoStaff: SuccessResponse;
  sendInvitesToEmployersUnderPeo: SuccessResponse;
  sendInvitesToPeoByCVStaff: SuccessResponse;
  sendInvitesToPeoByPeoPp: SuccessResponse;
  sendInvitesToPeoPayrollProviderByCVStaff: SuccessResponse;
  sendInvitesToPeoPayrollProviderStaffByCVStaff: SuccessResponse;
  sendInvitesToPeoPayrollProviderStaffs: SuccessResponse;
  sendInvitesToPeoStaffByCVStaff: SuccessResponse;
  sendInvitesToPeoStaffByPeoAdmin: SuccessResponse;
  sendInvitesToPeoStaffByPeoPayrollProviderStaff: SuccessResponse;
  sendInvitesToVerifierStaffByVerifierAdmin: SuccessResponse;
  sendInvitesToVerifiersAdminsByCVAdmin: SuccessResponse;
  sendInvitesToVerifiersAdminsByVerifierAdmin: SuccessResponse;
  sendInvitesToVerifiersStaff: SuccessResponse;
  sendRequestAccountIsFrozen: SuccessResponse;
  stateCreate: State;
  stateCreateBatch: Array<State>;
  stateCreateMany: Scalars['Int']['output'];
  stateDelete: Scalars['Boolean']['output'];
  stateDeleteBatch: Scalars['Boolean']['output'];
  stateDeleteMany: Scalars['Int']['output'];
  stateUpdate: State;
  stateUpdateBatch: Array<State>;
  stateUpdateMany: Scalars['Int']['output'];
  stripeCreatePaymentIntentForVerifier: StripeCreatePaymentIntentResponse;
  stripeCreatePaymentIntentForVerifierStaff: StripeCreatePaymentIntentResponse;
  stripeCreateSetupIntent: StripeCreateSetupIntentResponse;
  stripeDetachPaymentMethod: SuccessResponse;
  stripeGetAccountLink: StripeGetAccountLinkResponse;
  stripeRefundCharge: SuccessResponse;
  stripeRefundVerificationRequestCharge: SuccessResponse;
  stripeUpdateAccountPayoutSettings: SuccessResponse;
  stripeUpdateCustomerDefaultPaymentMethod: StripeUpdateCustomerDefaultPaymentMethodResponse;
  stripeUpdatePaymentMethodForVerificationRequest: StripeUpdatePaymentMethodForVerificationRequestResponse;
  testVerificationRequestCreate: TestVerificationRequest;
  testVerificationRequestCreateBatch: Array<TestVerificationRequest>;
  testVerificationRequestCreateMany: Scalars['Int']['output'];
  testVerificationRequestDelete: Scalars['Boolean']['output'];
  testVerificationRequestDeleteBatch: Scalars['Boolean']['output'];
  testVerificationRequestDeleteMany: Scalars['Int']['output'];
  testVerificationRequestUpdate: TestVerificationRequest;
  testVerificationRequestUpdateBatch: Array<TestVerificationRequest>;
  testVerificationRequestUpdateMany: Scalars['Int']['output'];
  unsafeCompleteUserDeletion: SuccessResponse;
  updateClearVerifyStaff: PlatformStaff;
  updateInboxItemUnreadStatus: SuccessResponse;
  updateInboxItemUnreadStatuses: SuccessResponse;
  updateInitialBillingRules: InitialBilling;
  updatePeoStaffDetails: SuccessResponse;
  updatePeoWithEmployers: SuccessResponse;
  updatePermissiblePurpose: PermissiblePurpose;
  updateUserRole: SuccessResponse;
  updateVerificationRequest: VerificationRequest;
  updateVerifier: Verifier;
  uploadFile: FileResponse;
  userCreate: User;
  userCreateBatch: Array<User>;
  userCreateMany: Scalars['Int']['output'];
  userDelete: Scalars['Boolean']['output'];
  userDeleteBatch: Scalars['Boolean']['output'];
  userDeleteMany: Scalars['Int']['output'];
  userEmailChangeRequestCreate: UserEmailChangeRequest;
  userEmailChangeRequestCreateBatch: Array<UserEmailChangeRequest>;
  userEmailChangeRequestCreateMany: Scalars['Int']['output'];
  userEmailChangeRequestDelete: Scalars['Boolean']['output'];
  userEmailChangeRequestDeleteBatch: Scalars['Boolean']['output'];
  userEmailChangeRequestDeleteMany: Scalars['Int']['output'];
  userEmailChangeRequestUpdate: UserEmailChangeRequest;
  userEmailChangeRequestUpdateBatch: Array<UserEmailChangeRequest>;
  userEmailChangeRequestUpdateMany: Scalars['Int']['output'];
  userPasswordChangeRequestCreate: UserPasswordChangeRequest;
  userPasswordChangeRequestCreateBatch: Array<UserPasswordChangeRequest>;
  userPasswordChangeRequestCreateMany: Scalars['Int']['output'];
  userPasswordChangeRequestDelete: Scalars['Boolean']['output'];
  userPasswordChangeRequestDeleteBatch: Scalars['Boolean']['output'];
  userPasswordChangeRequestDeleteMany: Scalars['Int']['output'];
  userPasswordChangeRequestUpdate: UserPasswordChangeRequest;
  userPasswordChangeRequestUpdateBatch: Array<UserPasswordChangeRequest>;
  userPasswordChangeRequestUpdateMany: Scalars['Int']['output'];
  userPasswordResetRequestCreate: UserPasswordResetRequest;
  userPasswordResetRequestCreateBatch: Array<UserPasswordResetRequest>;
  userPasswordResetRequestCreateMany: Scalars['Int']['output'];
  userPasswordResetRequestDelete: Scalars['Boolean']['output'];
  userPasswordResetRequestDeleteBatch: Scalars['Boolean']['output'];
  userPasswordResetRequestDeleteMany: Scalars['Int']['output'];
  userPasswordResetRequestUpdate: UserPasswordResetRequest;
  userPasswordResetRequestUpdateBatch: Array<UserPasswordResetRequest>;
  userPasswordResetRequestUpdateMany: Scalars['Int']['output'];
  userRegistrationByInvite: AuthCredentials;
  userRegistrationEmployee: AuthCredentials;
  userRegistrationVerifierAdmin: AuthCredentials;
  userRegistrationVerifierManager: AuthCredentials;
  userUpdate: User;
  userUpdateBatch: Array<User>;
  userUpdateMany: Scalars['Int']['output'];
  verificationRequestCreate: VerificationRequest;
  verificationRequestCreateBatch: Array<VerificationRequest>;
  verificationRequestCreateMany: Scalars['Int']['output'];
  verificationRequestDelete: Scalars['Boolean']['output'];
  verificationRequestDeleteBatch: Scalars['Boolean']['output'];
  verificationRequestDeleteMany: Scalars['Int']['output'];
  verificationRequestUpdate: VerificationRequest;
  verificationRequestUpdateBatch: Array<VerificationRequest>;
  verificationRequestUpdateMany: Scalars['Int']['output'];
  verifierBillingCreate: VerifierBilling;
  verifierBillingCreateBatch: Array<VerifierBilling>;
  verifierBillingCreateMany: Scalars['Int']['output'];
  verifierBillingDelete: Scalars['Boolean']['output'];
  verifierBillingDeleteBatch: Scalars['Boolean']['output'];
  verifierBillingDeleteMany: Scalars['Int']['output'];
  verifierBillingUpdate: VerifierBilling;
  verifierBillingUpdateBatch: Array<VerifierBilling>;
  verifierBillingUpdateMany: Scalars['Int']['output'];
  verifierCreate: Verifier;
  verifierCreateBatch: Array<Verifier>;
  verifierCreateMany: Scalars['Int']['output'];
  verifierDelete: Scalars['Boolean']['output'];
  verifierDeleteBatch: Scalars['Boolean']['output'];
  verifierDeleteMany: Scalars['Int']['output'];
  verifierStaffCreate: VerifierStaff;
  verifierStaffCreateBatch: Array<VerifierStaff>;
  verifierStaffCreateMany: Scalars['Int']['output'];
  verifierStaffDelete: Scalars['Boolean']['output'];
  verifierStaffDeleteBatch: Scalars['Boolean']['output'];
  verifierStaffDeleteMany: Scalars['Int']['output'];
  verifierStaffUpdate: VerifierStaff;
  verifierStaffUpdateBatch: Array<VerifierStaff>;
  verifierStaffUpdateMany: Scalars['Int']['output'];
  verifierUpdate: Verifier;
  verifierUpdateBatch: Array<Verifier>;
  verifierUpdateMany: Scalars['Int']['output'];
};

export type MutationActivityLogCreateArgs = {
  data: ActivityLogCreate;
};

export type MutationActivityLogCreateBatchArgs = {
  data: Array<ActivityLogCreate>;
};

export type MutationActivityLogCreateManyArgs = {
  data: Array<ActivityLogCreateMany>;
};

export type MutationActivityLogDeleteArgs = {
  where: ActivityLogWhereUnique;
};

export type MutationActivityLogDeleteBatchArgs = {
  where: Array<ActivityLogWhereUnique>;
};

export type MutationActivityLogDeleteManyArgs = {
  where: ActivityLogWhere;
};

export type MutationActivityLogUpdateArgs = {
  data: ActivityLogUpdate;
  where: ActivityLogWhereUnique;
};

export type MutationActivityLogUpdateBatchArgs = {
  data: Array<ActivityLogUpdate>;
  where: Array<ActivityLogWhereUnique>;
};

export type MutationActivityLogUpdateManyArgs = {
  data: ActivityLogUpdateMany;
  where: ActivityLogWhere;
};

export type MutationAddressCreateArgs = {
  data: AddressCreate;
};

export type MutationAddressCreateBatchArgs = {
  data: Array<AddressCreate>;
};

export type MutationAddressCreateManyArgs = {
  data: Array<AddressCreateMany>;
};

export type MutationAddressDeleteArgs = {
  where: AddressWhereUnique;
};

export type MutationAddressDeleteBatchArgs = {
  where: Array<AddressWhereUnique>;
};

export type MutationAddressDeleteManyArgs = {
  where: AddressWhere;
};

export type MutationAddressUpdateArgs = {
  data: AddressUpdate;
  where: AddressWhereUnique;
};

export type MutationAddressUpdateBatchArgs = {
  data: Array<AddressUpdate>;
  where: Array<AddressWhereUnique>;
};

export type MutationAddressUpdateManyArgs = {
  data: AddressUpdateMany;
  where: AddressWhere;
};

export type MutationApiTokenCreateArgs = {
  data: ApiTokenCreate;
};

export type MutationApiTokenCreateBatchArgs = {
  data: Array<ApiTokenCreate>;
};

export type MutationApiTokenCreateManyArgs = {
  data: Array<ApiTokenCreateMany>;
};

export type MutationApiTokenDeleteArgs = {
  where: ApiTokenWhereUnique;
};

export type MutationApiTokenDeleteBatchArgs = {
  where: Array<ApiTokenWhereUnique>;
};

export type MutationApiTokenDeleteManyArgs = {
  where: ApiTokenWhere;
};

export type MutationApiTokenUpdateArgs = {
  data: ApiTokenUpdate;
  where: ApiTokenWhereUnique;
};

export type MutationApiTokenUpdateBatchArgs = {
  data: Array<ApiTokenUpdate>;
  where: Array<ApiTokenWhereUnique>;
};

export type MutationApiTokenUpdateManyArgs = {
  data: ApiTokenUpdateMany;
  where: ApiTokenWhere;
};

export type MutationApiVerificationRequestCreateArgs = {
  data: ApiVerificationRequestCreate;
};

export type MutationApiVerificationRequestCreateBatchArgs = {
  data: Array<ApiVerificationRequestCreate>;
};

export type MutationApiVerificationRequestCreateManyArgs = {
  data: Array<ApiVerificationRequestCreateMany>;
};

export type MutationApiVerificationRequestDeleteArgs = {
  where: ApiVerificationRequestWhereUnique;
};

export type MutationApiVerificationRequestDeleteBatchArgs = {
  where: Array<ApiVerificationRequestWhereUnique>;
};

export type MutationApiVerificationRequestDeleteManyArgs = {
  where: ApiVerificationRequestWhere;
};

export type MutationApiVerificationRequestUpdateArgs = {
  data: ApiVerificationRequestUpdate;
  where: ApiVerificationRequestWhereUnique;
};

export type MutationApiVerificationRequestUpdateBatchArgs = {
  data: Array<ApiVerificationRequestUpdate>;
  where: Array<ApiVerificationRequestWhereUnique>;
};

export type MutationApiVerificationRequestUpdateManyArgs = {
  data: ApiVerificationRequestUpdateMany;
  where: ApiVerificationRequestWhere;
};

export type MutationApproveVerificationRequestByEmployeeArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type MutationApproveVerificationRequestByVerifierArgs = {
  inboxItemId: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeId: Scalars['ID']['input'];
  verificationRequestType?: InputMaybe<VerificationRequestType>;
};

export type MutationAttestationCreateArgs = {
  data: AttestationCreate;
};

export type MutationAttestationCreateBatchArgs = {
  data: Array<AttestationCreate>;
};

export type MutationAttestationCreateManyArgs = {
  data: Array<AttestationCreateMany>;
};

export type MutationAttestationDeleteArgs = {
  where: AttestationWhereUnique;
};

export type MutationAttestationDeleteBatchArgs = {
  where: Array<AttestationWhereUnique>;
};

export type MutationAttestationDeleteManyArgs = {
  where: AttestationWhere;
};

export type MutationAttestationUpdateArgs = {
  data: AttestationUpdate;
  where: AttestationWhereUnique;
};

export type MutationAttestationUpdateBatchArgs = {
  data: Array<AttestationUpdate>;
  where: Array<AttestationWhereUnique>;
};

export type MutationAttestationUpdateManyArgs = {
  data: AttestationUpdateMany;
  where: AttestationWhere;
};

export type MutationChangeDataDisputeItemStatusArgs = {
  dataDisputeItemId: Scalars['ID']['input'];
  status: DataDisputeItemStatus;
};

export type MutationChangeEmployeeUserEmailByPlatformAdminArgs = {
  newEmail: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationChangeUserEmailArgs = {
  newEmail: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationChangeUserPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  mfaCode?: InputMaybe<Scalars['String']['input']>;
  mfaSession?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  userPasswordChangeRequestId: Scalars['ID']['input'];
};

export type MutationChangeUserStatusArgs = {
  newStatus: UserStatus;
  userId: Scalars['ID']['input'];
};

export type MutationCognitoDisableUserMfaArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationConfirmUserEmailArgs = {
  userEmailChangeRequestId: Scalars['ID']['input'];
};

export type MutationCreateDataDisputeByEmployeeArgs = {
  employerId: Scalars['ID']['input'];
  inboxItemId?: InputMaybe<Scalars['ID']['input']>;
  reason: Scalars['String']['input'];
};

export type MutationCreateDataDisputeForPositionArgs = {
  employeeFirstName?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  employeeLastName?: InputMaybe<Scalars['String']['input']>;
  positionId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateDataDisputeOnEmployeeSignupArgs = {
  companyId: Scalars['ID']['input'];
  employeeSignupToken: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  userData: UserDataShapeForNewEmployeeOnDataDisputeCreation;
};

export type MutationCreateDataDisputeOnEmployeeSignupByInviteArgs = {
  companyId: Scalars['ID']['input'];
  inviteId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type MutationCreateEmployeeInviteLinkByCvStaffArgs = {
  employeeId: Scalars['ID']['input'];
};

export type MutationCreateEmployeeNoteArgs = {
  comment: Scalars['String']['input'];
  employeeSsnEncrypted: Scalars['String']['input'];
};

export type MutationCreatePermissiblePurposeArgs = {
  data: PermissiblePurposeCreate;
};

export type MutationCreateReverificationRequestArgs = {
  inboxItemId: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateTestVerificationRequestArgs = {
  companies: Array<VerificationRequestCompanyData>;
  employeeBirthDate: Scalars['Date']['input'];
  employeeFirstName?: InputMaybe<Scalars['String']['input']>;
  employeeLastName?: InputMaybe<Scalars['String']['input']>;
  requestType: Array<VerificationRequestType>;
  ssn: Scalars['String']['input'];
};

export type MutationCreateUserEmailChangeRequestArgs = {
  newEmail: Scalars['String']['input'];
};

export type MutationCreateUserPasswordResetRequestArgs = {
  email: Scalars['String']['input'];
};

export type MutationCreateVerificationRequestArgs = {
  companies: Array<VerificationRequestCompanyData>;
  employeeBirthDate: Scalars['Date']['input'];
  employeeFirstName?: InputMaybe<Scalars['String']['input']>;
  employeeLastName?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeId: Scalars['ID']['input'];
  requestType: VerificationRequestType;
  ssn: Scalars['String']['input'];
  verifierId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateVerificationRequestByEmployeeArgs = {
  companies: Array<VerificationRequestCompanyData>;
  companyName: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  noteToRecipient?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDashboardRevenueShareDatumCreateArgs = {
  data: DashboardRevenueShareDatumCreate;
};

export type MutationDashboardRevenueShareDatumCreateBatchArgs = {
  data: Array<DashboardRevenueShareDatumCreate>;
};

export type MutationDashboardRevenueShareDatumCreateManyArgs = {
  data: Array<DashboardRevenueShareDatumCreateMany>;
};

export type MutationDashboardRevenueShareDatumDeleteArgs = {
  where: DashboardRevenueShareDatumWhereUnique;
};

export type MutationDashboardRevenueShareDatumDeleteBatchArgs = {
  where: Array<DashboardRevenueShareDatumWhereUnique>;
};

export type MutationDashboardRevenueShareDatumDeleteManyArgs = {
  where: DashboardRevenueShareDatumWhere;
};

export type MutationDashboardRevenueShareDatumUpdateArgs = {
  data: DashboardRevenueShareDatumUpdate;
  where: DashboardRevenueShareDatumWhereUnique;
};

export type MutationDashboardRevenueShareDatumUpdateBatchArgs = {
  data: Array<DashboardRevenueShareDatumUpdate>;
  where: Array<DashboardRevenueShareDatumWhereUnique>;
};

export type MutationDashboardRevenueShareDatumUpdateManyArgs = {
  data: DashboardRevenueShareDatumUpdateMany;
  where: DashboardRevenueShareDatumWhere;
};

export type MutationDataDisputeCreateArgs = {
  data: DataDisputeCreate;
};

export type MutationDataDisputeCreateBatchArgs = {
  data: Array<DataDisputeCreate>;
};

export type MutationDataDisputeCreateManyArgs = {
  data: Array<DataDisputeCreateMany>;
};

export type MutationDataDisputeDeleteArgs = {
  where: DataDisputeWhereUnique;
};

export type MutationDataDisputeDeleteBatchArgs = {
  where: Array<DataDisputeWhereUnique>;
};

export type MutationDataDisputeDeleteManyArgs = {
  where: DataDisputeWhere;
};

export type MutationDataDisputeItemCreateArgs = {
  data: DataDisputeItemCreate;
};

export type MutationDataDisputeItemCreateBatchArgs = {
  data: Array<DataDisputeItemCreate>;
};

export type MutationDataDisputeItemCreateManyArgs = {
  data: Array<DataDisputeItemCreateMany>;
};

export type MutationDataDisputeItemDeleteArgs = {
  where: DataDisputeItemWhereUnique;
};

export type MutationDataDisputeItemDeleteBatchArgs = {
  where: Array<DataDisputeItemWhereUnique>;
};

export type MutationDataDisputeItemDeleteManyArgs = {
  where: DataDisputeItemWhere;
};

export type MutationDataDisputeItemUpdateArgs = {
  data: DataDisputeItemUpdate;
  where: DataDisputeItemWhereUnique;
};

export type MutationDataDisputeItemUpdateBatchArgs = {
  data: Array<DataDisputeItemUpdate>;
  where: Array<DataDisputeItemWhereUnique>;
};

export type MutationDataDisputeItemUpdateManyArgs = {
  data: DataDisputeItemUpdateMany;
  where: DataDisputeItemWhere;
};

export type MutationDataDisputeUpdateArgs = {
  data: DataDisputeUpdate;
  where: DataDisputeWhereUnique;
};

export type MutationDataDisputeUpdateBatchArgs = {
  data: Array<DataDisputeUpdate>;
  where: Array<DataDisputeWhereUnique>;
};

export type MutationDataDisputeUpdateManyArgs = {
  data: DataDisputeUpdateMany;
  where: DataDisputeWhere;
};

export type MutationDeclineVerificationRequestByEmployeeArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type MutationDeclineVerificationRequestByVerifierArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type MutationDeleteClearVerifyStaffArgs = {
  platformStaffId: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeAccountDataArgs = {
  employeeId: Scalars['ID']['input'];
};

export type MutationDeleteEmployeeUserArgs = {
  employeeId: Scalars['ID']['input'];
};

export type MutationDeleteEmployerStaffArgs = {
  employerStaffId: Scalars['ID']['input'];
};

export type MutationDeletePeoStaffArgs = {
  peoStaffId: Scalars['ID']['input'];
};

export type MutationDeleteSuppressionFromEmailArgs = {
  email: Scalars['String']['input'];
};

export type MutationDeleteVerifierArgs = {
  verifierId: Scalars['ID']['input'];
};

export type MutationDeleteVerifierStaffArgs = {
  verifierStaffId: Scalars['ID']['input'];
};

export type MutationDisclaimerCreateArgs = {
  data: DisclaimerCreate;
};

export type MutationDisclaimerCreateBatchArgs = {
  data: Array<DisclaimerCreate>;
};

export type MutationDisclaimerCreateManyArgs = {
  data: Array<DisclaimerCreateMany>;
};

export type MutationDisclaimerDeleteArgs = {
  where: DisclaimerWhereUnique;
};

export type MutationDisclaimerDeleteBatchArgs = {
  where: Array<DisclaimerWhereUnique>;
};

export type MutationDisclaimerDeleteManyArgs = {
  where: DisclaimerWhere;
};

export type MutationDisclaimerUpdateArgs = {
  data: DisclaimerUpdate;
  where: DisclaimerWhereUnique;
};

export type MutationDisclaimerUpdateBatchArgs = {
  data: Array<DisclaimerUpdate>;
  where: Array<DisclaimerWhereUnique>;
};

export type MutationDisclaimerUpdateManyArgs = {
  data: DisclaimerUpdateMany;
  where: DisclaimerWhere;
};

export type MutationDownloadGeneratedReportFilesArgs = {
  action: PiiDataAccessActionType;
  fileIdList: Array<Scalars['ID']['input']>;
  inboxItemId: Scalars['ID']['input'];
};

export type MutationDownloadGeneratedReportFilesArchiveArgs = {
  fileIdList: Array<Scalars['ID']['input']>;
  inboxItemId: Scalars['ID']['input'];
};

export type MutationEmployeeAnnualFreeReportCreateArgs = {
  data: EmployeeAnnualFreeReportCreate;
};

export type MutationEmployeeAnnualFreeReportCreateBatchArgs = {
  data: Array<EmployeeAnnualFreeReportCreate>;
};

export type MutationEmployeeAnnualFreeReportCreateManyArgs = {
  data: Array<EmployeeAnnualFreeReportCreateMany>;
};

export type MutationEmployeeAnnualFreeReportDeleteArgs = {
  where: EmployeeAnnualFreeReportWhereUnique;
};

export type MutationEmployeeAnnualFreeReportDeleteBatchArgs = {
  where: Array<EmployeeAnnualFreeReportWhereUnique>;
};

export type MutationEmployeeAnnualFreeReportDeleteManyArgs = {
  where: EmployeeAnnualFreeReportWhere;
};

export type MutationEmployeeAnnualFreeReportUpdateArgs = {
  data: EmployeeAnnualFreeReportUpdate;
  where: EmployeeAnnualFreeReportWhereUnique;
};

export type MutationEmployeeAnnualFreeReportUpdateBatchArgs = {
  data: Array<EmployeeAnnualFreeReportUpdate>;
  where: Array<EmployeeAnnualFreeReportWhereUnique>;
};

export type MutationEmployeeAnnualFreeReportUpdateManyArgs = {
  data: EmployeeAnnualFreeReportUpdateMany;
  where: EmployeeAnnualFreeReportWhere;
};

export type MutationEmployeeCreateArgs = {
  data: EmployeeCreate;
};

export type MutationEmployeeCreateBatchArgs = {
  data: Array<EmployeeCreate>;
};

export type MutationEmployeeCreateManyArgs = {
  data: Array<EmployeeCreateMany>;
};

export type MutationEmployeeDeleteArgs = {
  where: EmployeeWhereUnique;
};

export type MutationEmployeeDeleteBatchArgs = {
  where: Array<EmployeeWhereUnique>;
};

export type MutationEmployeeDeleteManyArgs = {
  where: EmployeeWhere;
};

export type MutationEmployeeNoteCreateArgs = {
  data: EmployeeNoteCreate;
};

export type MutationEmployeeNoteCreateBatchArgs = {
  data: Array<EmployeeNoteCreate>;
};

export type MutationEmployeeNoteCreateManyArgs = {
  data: Array<EmployeeNoteCreateMany>;
};

export type MutationEmployeeNoteDeleteArgs = {
  where: EmployeeNoteWhereUnique;
};

export type MutationEmployeeNoteDeleteBatchArgs = {
  where: Array<EmployeeNoteWhereUnique>;
};

export type MutationEmployeeNoteDeleteManyArgs = {
  where: EmployeeNoteWhere;
};

export type MutationEmployeeNoteUpdateArgs = {
  data: EmployeeNoteUpdate;
  where: EmployeeNoteWhereUnique;
};

export type MutationEmployeeNoteUpdateBatchArgs = {
  data: Array<EmployeeNoteUpdate>;
  where: Array<EmployeeNoteWhereUnique>;
};

export type MutationEmployeeNoteUpdateManyArgs = {
  data: EmployeeNoteUpdateMany;
  where: EmployeeNoteWhere;
};

export type MutationEmployeeUpdateArgs = {
  data: EmployeeUpdate;
  where: EmployeeWhereUnique;
};

export type MutationEmployeeUpdateBatchArgs = {
  data: Array<EmployeeUpdate>;
  where: Array<EmployeeWhereUnique>;
};

export type MutationEmployeeUpdateManyArgs = {
  data: EmployeeUpdateMany;
  where: EmployeeWhere;
};

export type MutationEmployeeWorkLetterCreateArgs = {
  data: EmployeeWorkLetterCreate;
};

export type MutationEmployeeWorkLetterCreateBatchArgs = {
  data: Array<EmployeeWorkLetterCreate>;
};

export type MutationEmployeeWorkLetterCreateManyArgs = {
  data: Array<EmployeeWorkLetterCreateMany>;
};

export type MutationEmployeeWorkLetterDeleteArgs = {
  where: EmployeeWorkLetterWhereUnique;
};

export type MutationEmployeeWorkLetterDeleteBatchArgs = {
  where: Array<EmployeeWorkLetterWhereUnique>;
};

export type MutationEmployeeWorkLetterDeleteManyArgs = {
  where: EmployeeWorkLetterWhere;
};

export type MutationEmployeeWorkLetterUpdateArgs = {
  data: EmployeeWorkLetterUpdate;
  where: EmployeeWorkLetterWhereUnique;
};

export type MutationEmployeeWorkLetterUpdateBatchArgs = {
  data: Array<EmployeeWorkLetterUpdate>;
  where: Array<EmployeeWorkLetterWhereUnique>;
};

export type MutationEmployeeWorkLetterUpdateManyArgs = {
  data: EmployeeWorkLetterUpdateMany;
  where: EmployeeWorkLetterWhere;
};

export type MutationEmployerCreateArgs = {
  data: EmployerCreate;
};

export type MutationEmployerCreateBatchArgs = {
  data: Array<EmployerCreate>;
};

export type MutationEmployerCreateManyArgs = {
  data: Array<EmployerCreateMany>;
};

export type MutationEmployerDeleteArgs = {
  where: EmployerWhereUnique;
};

export type MutationEmployerDeleteBatchArgs = {
  where: Array<EmployerWhereUnique>;
};

export type MutationEmployerDeleteManyArgs = {
  where: EmployerWhere;
};

export type MutationEmployerStaffCreateArgs = {
  data: EmployerStaffCreate;
};

export type MutationEmployerStaffCreateBatchArgs = {
  data: Array<EmployerStaffCreate>;
};

export type MutationEmployerStaffCreateManyArgs = {
  data: Array<EmployerStaffCreateMany>;
};

export type MutationEmployerStaffDeleteArgs = {
  where: EmployerStaffWhereUnique;
};

export type MutationEmployerStaffDeleteBatchArgs = {
  where: Array<EmployerStaffWhereUnique>;
};

export type MutationEmployerStaffDeleteManyArgs = {
  where: EmployerStaffWhere;
};

export type MutationEmployerStaffUpdateArgs = {
  data: EmployerStaffUpdate;
  where: EmployerStaffWhereUnique;
};

export type MutationEmployerStaffUpdateBatchArgs = {
  data: Array<EmployerStaffUpdate>;
  where: Array<EmployerStaffWhereUnique>;
};

export type MutationEmployerStaffUpdateManyArgs = {
  data: EmployerStaffUpdateMany;
  where: EmployerStaffWhere;
};

export type MutationEmployerUpdateArgs = {
  data: EmployerUpdate;
  where: EmployerWhereUnique;
};

export type MutationEmployerUpdateBatchArgs = {
  data: Array<EmployerUpdate>;
  where: Array<EmployerWhereUnique>;
};

export type MutationEmployerUpdateManyArgs = {
  data: EmployerUpdateMany;
  where: EmployerWhere;
};

export type MutationFileCreateArgs = {
  data: FileCreate;
};

export type MutationFileCreateBatchArgs = {
  data: Array<FileCreate>;
};

export type MutationFileCreateManyArgs = {
  data: Array<FileCreateMany>;
};

export type MutationFileDeleteArgs = {
  where: FileWhereUnique;
};

export type MutationFileDeleteBatchArgs = {
  where: Array<FileWhereUnique>;
};

export type MutationFileDeleteManyArgs = {
  where: FileWhere;
};

export type MutationFileUpdateArgs = {
  data: FileUpdate;
  where: FileWhereUnique;
};

export type MutationFileUpdateBatchArgs = {
  data: Array<FileUpdate>;
  where: Array<FileWhereUnique>;
};

export type MutationFileUpdateManyArgs = {
  data: FileUpdateMany;
  where: FileWhere;
};

export type MutationGenerateRankedVerifiersReportArgs = {
  verifierType: VerifierType;
};

export type MutationGenerateRevenueShareReportArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  companyType?: InputMaybe<CompanyType>;
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type MutationGenerateVerificationRequestsReportArgs = {
  format: VerificationRequestsReportFormat;
  orderBy?: InputMaybe<Array<VerificationRequestOrderBy>>;
  where?: InputMaybe<VerificationRequestWhere>;
};

export type MutationGenerateWorkLetterPdfArgs = {
  company: VerificationRequestCompanyData;
  letterType: EmployeeWorkLetterType;
};

export type MutationGenerateWorkLetterPdfForAdminArgs = {
  company: VerificationRequestCompanyData;
  employeeSsnEncrypted: Scalars['String']['input'];
  letterType: EmployeeWorkLetterType;
};

export type MutationGenerateYearToDateFinancialReportArgs = {
  date: Scalars['Date']['input'];
};

export type MutationGeneratedReportCreateArgs = {
  data: GeneratedReportCreate;
};

export type MutationGeneratedReportCreateBatchArgs = {
  data: Array<GeneratedReportCreate>;
};

export type MutationGeneratedReportCreateManyArgs = {
  data: Array<GeneratedReportCreateMany>;
};

export type MutationGeneratedReportDeleteArgs = {
  where: GeneratedReportWhereUnique;
};

export type MutationGeneratedReportDeleteBatchArgs = {
  where: Array<GeneratedReportWhereUnique>;
};

export type MutationGeneratedReportDeleteManyArgs = {
  where: GeneratedReportWhere;
};

export type MutationGeneratedReportUpdateArgs = {
  data: GeneratedReportUpdate;
  where: GeneratedReportWhereUnique;
};

export type MutationGeneratedReportUpdateBatchArgs = {
  data: Array<GeneratedReportUpdate>;
  where: Array<GeneratedReportWhereUnique>;
};

export type MutationGeneratedReportUpdateManyArgs = {
  data: GeneratedReportUpdateMany;
  where: GeneratedReportWhere;
};

export type MutationInboxItemCreateArgs = {
  data: InboxItemCreate;
};

export type MutationInboxItemCreateBatchArgs = {
  data: Array<InboxItemCreate>;
};

export type MutationInboxItemCreateManyArgs = {
  data: Array<InboxItemCreateMany>;
};

export type MutationInboxItemDeleteArgs = {
  where: InboxItemWhereUnique;
};

export type MutationInboxItemDeleteBatchArgs = {
  where: Array<InboxItemWhereUnique>;
};

export type MutationInboxItemDeleteManyArgs = {
  where: InboxItemWhere;
};

export type MutationInboxItemUnreadStatusCreateArgs = {
  data: InboxItemUnreadStatusCreate;
};

export type MutationInboxItemUnreadStatusCreateBatchArgs = {
  data: Array<InboxItemUnreadStatusCreate>;
};

export type MutationInboxItemUnreadStatusCreateManyArgs = {
  data: Array<InboxItemUnreadStatusCreateMany>;
};

export type MutationInboxItemUnreadStatusDeleteArgs = {
  where: InboxItemUnreadStatusWhereUnique;
};

export type MutationInboxItemUnreadStatusDeleteBatchArgs = {
  where: Array<InboxItemUnreadStatusWhereUnique>;
};

export type MutationInboxItemUnreadStatusDeleteManyArgs = {
  where: InboxItemUnreadStatusWhere;
};

export type MutationInboxItemUnreadStatusUpdateArgs = {
  data: InboxItemUnreadStatusUpdate;
  where: InboxItemUnreadStatusWhereUnique;
};

export type MutationInboxItemUnreadStatusUpdateBatchArgs = {
  data: Array<InboxItemUnreadStatusUpdate>;
  where: Array<InboxItemUnreadStatusWhereUnique>;
};

export type MutationInboxItemUnreadStatusUpdateManyArgs = {
  data: InboxItemUnreadStatusUpdateMany;
  where: InboxItemUnreadStatusWhere;
};

export type MutationInboxItemUpdateArgs = {
  data: InboxItemUpdate;
  where: InboxItemWhereUnique;
};

export type MutationInboxItemUpdateBatchArgs = {
  data: Array<InboxItemUpdate>;
  where: Array<InboxItemWhereUnique>;
};

export type MutationInboxItemUpdateManyArgs = {
  data: InboxItemUpdateMany;
  where: InboxItemWhere;
};

export type MutationInitialBillingCreateArgs = {
  data: InitialBillingCreate;
};

export type MutationInitialBillingCreateBatchArgs = {
  data: Array<InitialBillingCreate>;
};

export type MutationInitialBillingCreateManyArgs = {
  data: Array<InitialBillingCreateMany>;
};

export type MutationInitialBillingDeleteArgs = {
  where: InitialBillingWhereUnique;
};

export type MutationInitialBillingDeleteBatchArgs = {
  where: Array<InitialBillingWhereUnique>;
};

export type MutationInitialBillingDeleteManyArgs = {
  where: InitialBillingWhere;
};

export type MutationInitialBillingUpdateArgs = {
  data: InitialBillingUpdate;
  where: InitialBillingWhereUnique;
};

export type MutationInitialBillingUpdateBatchArgs = {
  data: Array<InitialBillingUpdate>;
  where: Array<InitialBillingWhereUnique>;
};

export type MutationInitialBillingUpdateManyArgs = {
  data: InitialBillingUpdateMany;
  where: InitialBillingWhere;
};

export type MutationIntegrationCreateArgs = {
  data: IntegrationCreate;
};

export type MutationIntegrationCreateBatchArgs = {
  data: Array<IntegrationCreate>;
};

export type MutationIntegrationCreateCustomArgs = {
  credentialsLimitAttempts: Scalars['Int']['input'];
  credentialsLimitWindow: Scalars['Int']['input'];
  ipLimitAttempts: Scalars['Int']['input'];
  ipLimitWindow: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  scope: Array<IntegrationScope>;
  verifierId?: InputMaybe<Scalars['ID']['input']>;
  verifierLimitAttempts: Scalars['Int']['input'];
  verifierLimitWindow: Scalars['Int']['input'];
};

export type MutationIntegrationCreateManyArgs = {
  data: Array<IntegrationCreateMany>;
};

export type MutationIntegrationDeleteArgs = {
  where: IntegrationWhereUnique;
};

export type MutationIntegrationDeleteBatchArgs = {
  where: Array<IntegrationWhereUnique>;
};

export type MutationIntegrationDeleteManyArgs = {
  where: IntegrationWhere;
};

export type MutationIntegrationRegenerateCredentialsArgs = {
  id: Scalars['ID']['input'];
};

export type MutationIntegrationUpdateArgs = {
  data: IntegrationUpdate;
  where: IntegrationWhereUnique;
};

export type MutationIntegrationUpdateBatchArgs = {
  data: Array<IntegrationUpdate>;
  where: Array<IntegrationWhereUnique>;
};

export type MutationIntegrationUpdateCustomArgs = {
  credentialsLimitAttempts: Scalars['Int']['input'];
  credentialsLimitWindow: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  ipLimitAttempts: Scalars['Int']['input'];
  ipLimitWindow: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  scope: Array<IntegrationScope>;
  status: ActiveInactive;
  verifierLimitAttempts: Scalars['Int']['input'];
  verifierLimitWindow: Scalars['Int']['input'];
};

export type MutationIntegrationUpdateManyArgs = {
  data: IntegrationUpdateMany;
  where: IntegrationWhere;
};

export type MutationIntegrationUsageLogCreateArgs = {
  data: IntegrationUsageLogCreate;
};

export type MutationIntegrationUsageLogCreateBatchArgs = {
  data: Array<IntegrationUsageLogCreate>;
};

export type MutationIntegrationUsageLogCreateManyArgs = {
  data: Array<IntegrationUsageLogCreateMany>;
};

export type MutationIntegrationUsageLogDeleteArgs = {
  where: IntegrationUsageLogWhereUnique;
};

export type MutationIntegrationUsageLogDeleteBatchArgs = {
  where: Array<IntegrationUsageLogWhereUnique>;
};

export type MutationIntegrationUsageLogDeleteManyArgs = {
  where: IntegrationUsageLogWhere;
};

export type MutationIntegrationUsageLogUpdateArgs = {
  data: IntegrationUsageLogUpdate;
  where: IntegrationUsageLogWhereUnique;
};

export type MutationIntegrationUsageLogUpdateBatchArgs = {
  data: Array<IntegrationUsageLogUpdate>;
  where: Array<IntegrationUsageLogWhereUnique>;
};

export type MutationIntegrationUsageLogUpdateManyArgs = {
  data: IntegrationUsageLogUpdateMany;
  where: IntegrationUsageLogWhere;
};

export type MutationInviteCreateArgs = {
  data: InviteCreate;
};

export type MutationInviteCreateBatchArgs = {
  data: Array<InviteCreate>;
};

export type MutationInviteCreateManyArgs = {
  data: Array<InviteCreateMany>;
};

export type MutationInviteDeleteArgs = {
  where: InviteWhereUnique;
};

export type MutationInviteDeleteBatchArgs = {
  where: Array<InviteWhereUnique>;
};

export type MutationInviteDeleteManyArgs = {
  where: InviteWhere;
};

export type MutationInviteUpdateArgs = {
  data: InviteUpdate;
  where: InviteWhereUnique;
};

export type MutationInviteUpdateBatchArgs = {
  data: Array<InviteUpdate>;
  where: Array<InviteWhereUnique>;
};

export type MutationInviteUpdateManyArgs = {
  data: InviteUpdateMany;
  where: InviteWhere;
};

export type MutationLeaveCommentForInboxItemArgs = {
  comment: Scalars['String']['input'];
  file?: InputMaybe<Scalars['FileUpload']['input']>;
  inboxItemId: Scalars['ID']['input'];
  visibleFor?: InputMaybe<Array<ActivityLogVisibleFor>>;
};

export type MutationMiddeskCreateBusinessForVerifierArgs = {
  businessFields: BusinessFields;
  verifierId: Scalars['ID']['input'];
};

export type MutationPaymentTransactionCreateArgs = {
  data: PaymentTransactionCreate;
};

export type MutationPaymentTransactionCreateBatchArgs = {
  data: Array<PaymentTransactionCreate>;
};

export type MutationPaymentTransactionCreateManyArgs = {
  data: Array<PaymentTransactionCreateMany>;
};

export type MutationPaymentTransactionDeleteArgs = {
  where: PaymentTransactionWhereUnique;
};

export type MutationPaymentTransactionDeleteBatchArgs = {
  where: Array<PaymentTransactionWhereUnique>;
};

export type MutationPaymentTransactionDeleteManyArgs = {
  where: PaymentTransactionWhere;
};

export type MutationPaymentTransactionUpdateArgs = {
  data: PaymentTransactionUpdate;
  where: PaymentTransactionWhereUnique;
};

export type MutationPaymentTransactionUpdateBatchArgs = {
  data: Array<PaymentTransactionUpdate>;
  where: Array<PaymentTransactionWhereUnique>;
};

export type MutationPaymentTransactionUpdateManyArgs = {
  data: PaymentTransactionUpdateMany;
  where: PaymentTransactionWhere;
};

export type MutationPeoCreateArgs = {
  data: PeoCreate;
};

export type MutationPeoCreateBatchArgs = {
  data: Array<PeoCreate>;
};

export type MutationPeoCreateManyArgs = {
  data: Array<PeoCreateMany>;
};

export type MutationPeoDeleteArgs = {
  where: PeoWhereUnique;
};

export type MutationPeoDeleteBatchArgs = {
  where: Array<PeoWhereUnique>;
};

export type MutationPeoDeleteManyArgs = {
  where: PeoWhere;
};

export type MutationPeoPayrollProviderCreateArgs = {
  data: PeoPayrollProviderCreate;
};

export type MutationPeoPayrollProviderCreateBatchArgs = {
  data: Array<PeoPayrollProviderCreate>;
};

export type MutationPeoPayrollProviderCreateManyArgs = {
  data: Array<PeoPayrollProviderCreateMany>;
};

export type MutationPeoPayrollProviderDeleteArgs = {
  where: PeoPayrollProviderWhereUnique;
};

export type MutationPeoPayrollProviderDeleteBatchArgs = {
  where: Array<PeoPayrollProviderWhereUnique>;
};

export type MutationPeoPayrollProviderDeleteManyArgs = {
  where: PeoPayrollProviderWhere;
};

export type MutationPeoPayrollProviderStaffCreateArgs = {
  data: PeoPayrollProviderStaffCreate;
};

export type MutationPeoPayrollProviderStaffCreateBatchArgs = {
  data: Array<PeoPayrollProviderStaffCreate>;
};

export type MutationPeoPayrollProviderStaffCreateManyArgs = {
  data: Array<PeoPayrollProviderStaffCreateMany>;
};

export type MutationPeoPayrollProviderStaffDeleteArgs = {
  where: PeoPayrollProviderStaffWhereUnique;
};

export type MutationPeoPayrollProviderStaffDeleteBatchArgs = {
  where: Array<PeoPayrollProviderStaffWhereUnique>;
};

export type MutationPeoPayrollProviderStaffDeleteManyArgs = {
  where: PeoPayrollProviderStaffWhere;
};

export type MutationPeoPayrollProviderStaffUpdateArgs = {
  data: PeoPayrollProviderStaffUpdate;
  where: PeoPayrollProviderStaffWhereUnique;
};

export type MutationPeoPayrollProviderStaffUpdateBatchArgs = {
  data: Array<PeoPayrollProviderStaffUpdate>;
  where: Array<PeoPayrollProviderStaffWhereUnique>;
};

export type MutationPeoPayrollProviderStaffUpdateManyArgs = {
  data: PeoPayrollProviderStaffUpdateMany;
  where: PeoPayrollProviderStaffWhere;
};

export type MutationPeoPayrollProviderUpdateArgs = {
  data: PeoPayrollProviderUpdate;
  where: PeoPayrollProviderWhereUnique;
};

export type MutationPeoPayrollProviderUpdateBatchArgs = {
  data: Array<PeoPayrollProviderUpdate>;
  where: Array<PeoPayrollProviderWhereUnique>;
};

export type MutationPeoPayrollProviderUpdateManyArgs = {
  data: PeoPayrollProviderUpdateMany;
  where: PeoPayrollProviderWhere;
};

export type MutationPeoStaffCreateArgs = {
  data: PeoStaffCreate;
};

export type MutationPeoStaffCreateBatchArgs = {
  data: Array<PeoStaffCreate>;
};

export type MutationPeoStaffCreateManyArgs = {
  data: Array<PeoStaffCreateMany>;
};

export type MutationPeoStaffDeleteArgs = {
  where: PeoStaffWhereUnique;
};

export type MutationPeoStaffDeleteBatchArgs = {
  where: Array<PeoStaffWhereUnique>;
};

export type MutationPeoStaffDeleteManyArgs = {
  where: PeoStaffWhere;
};

export type MutationPeoStaffUpdateArgs = {
  data: PeoStaffUpdate;
  where: PeoStaffWhereUnique;
};

export type MutationPeoStaffUpdateBatchArgs = {
  data: Array<PeoStaffUpdate>;
  where: Array<PeoStaffWhereUnique>;
};

export type MutationPeoStaffUpdateManyArgs = {
  data: PeoStaffUpdateMany;
  where: PeoStaffWhere;
};

export type MutationPeoUpdateArgs = {
  data: PeoUpdate;
  where: PeoWhereUnique;
};

export type MutationPeoUpdateBatchArgs = {
  data: Array<PeoUpdate>;
  where: Array<PeoWhereUnique>;
};

export type MutationPeoUpdateManyArgs = {
  data: PeoUpdateMany;
  where: PeoWhere;
};

export type MutationPermissiblePurposeCreateArgs = {
  data: PermissiblePurposeCreate;
};

export type MutationPermissiblePurposeCreateBatchArgs = {
  data: Array<PermissiblePurposeCreate>;
};

export type MutationPermissiblePurposeCreateManyArgs = {
  data: Array<PermissiblePurposeCreateMany>;
};

export type MutationPermissiblePurposeDeleteArgs = {
  where: PermissiblePurposeWhereUnique;
};

export type MutationPermissiblePurposeDeleteBatchArgs = {
  where: Array<PermissiblePurposeWhereUnique>;
};

export type MutationPermissiblePurposeDeleteManyArgs = {
  where: PermissiblePurposeWhere;
};

export type MutationPermissiblePurposeReferenceCreateArgs = {
  data: PermissiblePurposeReferenceCreate;
};

export type MutationPermissiblePurposeReferenceCreateBatchArgs = {
  data: Array<PermissiblePurposeReferenceCreate>;
};

export type MutationPermissiblePurposeReferenceCreateManyArgs = {
  data: Array<PermissiblePurposeReferenceCreateMany>;
};

export type MutationPermissiblePurposeReferenceDeleteArgs = {
  where: PermissiblePurposeReferenceWhereUnique;
};

export type MutationPermissiblePurposeReferenceDeleteBatchArgs = {
  where: Array<PermissiblePurposeReferenceWhereUnique>;
};

export type MutationPermissiblePurposeReferenceDeleteManyArgs = {
  where: PermissiblePurposeReferenceWhere;
};

export type MutationPermissiblePurposeReferenceUpdateArgs = {
  data: PermissiblePurposeReferenceUpdate;
  where: PermissiblePurposeReferenceWhereUnique;
};

export type MutationPermissiblePurposeReferenceUpdateBatchArgs = {
  data: Array<PermissiblePurposeReferenceUpdate>;
  where: Array<PermissiblePurposeReferenceWhereUnique>;
};

export type MutationPermissiblePurposeReferenceUpdateManyArgs = {
  data: PermissiblePurposeReferenceUpdateMany;
  where: PermissiblePurposeReferenceWhere;
};

export type MutationPermissiblePurposeUpdateArgs = {
  data: PermissiblePurposeUpdate;
  where: PermissiblePurposeWhereUnique;
};

export type MutationPermissiblePurposeUpdateBatchArgs = {
  data: Array<PermissiblePurposeUpdate>;
  where: Array<PermissiblePurposeWhereUnique>;
};

export type MutationPermissiblePurposeUpdateManyArgs = {
  data: PermissiblePurposeUpdateMany;
  where: PermissiblePurposeWhere;
};

export type MutationPiiDataAccessLogCreateArgs = {
  data: PiiDataAccessLogCreate;
};

export type MutationPiiDataAccessLogCreateBatchArgs = {
  data: Array<PiiDataAccessLogCreate>;
};

export type MutationPiiDataAccessLogCreateManyArgs = {
  data: Array<PiiDataAccessLogCreateMany>;
};

export type MutationPiiDataAccessLogDeleteArgs = {
  where: PiiDataAccessLogWhereUnique;
};

export type MutationPiiDataAccessLogDeleteBatchArgs = {
  where: Array<PiiDataAccessLogWhereUnique>;
};

export type MutationPiiDataAccessLogDeleteManyArgs = {
  where: PiiDataAccessLogWhere;
};

export type MutationPiiDataAccessLogUpdateArgs = {
  data: PiiDataAccessLogUpdate;
  where: PiiDataAccessLogWhereUnique;
};

export type MutationPiiDataAccessLogUpdateBatchArgs = {
  data: Array<PiiDataAccessLogUpdate>;
  where: Array<PiiDataAccessLogWhereUnique>;
};

export type MutationPiiDataAccessLogUpdateManyArgs = {
  data: PiiDataAccessLogUpdateMany;
  where: PiiDataAccessLogWhere;
};

export type MutationPlatformStaffCreateArgs = {
  data: PlatformStaffCreate;
};

export type MutationPlatformStaffCreateBatchArgs = {
  data: Array<PlatformStaffCreate>;
};

export type MutationPlatformStaffCreateManyArgs = {
  data: Array<PlatformStaffCreateMany>;
};

export type MutationPlatformStaffDeleteArgs = {
  where: PlatformStaffWhereUnique;
};

export type MutationPlatformStaffDeleteBatchArgs = {
  where: Array<PlatformStaffWhereUnique>;
};

export type MutationPlatformStaffDeleteManyArgs = {
  where: PlatformStaffWhere;
};

export type MutationPlatformStaffUpdateArgs = {
  data: PlatformStaffUpdate;
  where: PlatformStaffWhereUnique;
};

export type MutationPlatformStaffUpdateBatchArgs = {
  data: Array<PlatformStaffUpdate>;
  where: Array<PlatformStaffWhereUnique>;
};

export type MutationPlatformStaffUpdateManyArgs = {
  data: PlatformStaffUpdateMany;
  where: PlatformStaffWhere;
};

export type MutationPositionCreateArgs = {
  data: PositionCreate;
};

export type MutationPositionCreateBatchArgs = {
  data: Array<PositionCreate>;
};

export type MutationPositionCreateManyArgs = {
  data: Array<PositionCreateMany>;
};

export type MutationPositionDeleteArgs = {
  where: PositionWhereUnique;
};

export type MutationPositionDeleteBatchArgs = {
  where: Array<PositionWhereUnique>;
};

export type MutationPositionDeleteManyArgs = {
  where: PositionWhere;
};

export type MutationPositionUpdateArgs = {
  data: PositionUpdate;
  where: PositionWhereUnique;
};

export type MutationPositionUpdateBatchArgs = {
  data: Array<PositionUpdate>;
  where: Array<PositionWhereUnique>;
};

export type MutationPositionUpdateManyArgs = {
  data: PositionUpdateMany;
  where: PositionWhere;
};

export type MutationReactivateEmployeeAccountArgs = {
  employeeId: Scalars['ID']['input'];
};

export type MutationResendInviteToEmployerStaffArgs = {
  employerStaffId: Scalars['ID']['input'];
};

export type MutationResendInviteToPeoStaffArgs = {
  peoStaffId: Scalars['ID']['input'];
};

export type MutationResendInviteToPlatformStaffArgs = {
  platformStaffId: Scalars['ID']['input'];
};

export type MutationResendInviteToVerifierStaffArgs = {
  verifierStaffId: Scalars['ID']['input'];
};

export type MutationResetUserPasswordArgs = {
  newPassword: Scalars['String']['input'];
  userPasswordResetRequestId: Scalars['ID']['input'];
};

export type MutationResourceCreateArgs = {
  data: ResourceCreate;
};

export type MutationResourceCreateBatchArgs = {
  data: Array<ResourceCreate>;
};

export type MutationResourceCreateManyArgs = {
  data: Array<ResourceCreateMany>;
};

export type MutationResourceDeleteArgs = {
  where: ResourceWhereUnique;
};

export type MutationResourceDeleteBatchArgs = {
  where: Array<ResourceWhereUnique>;
};

export type MutationResourceDeleteManyArgs = {
  where: ResourceWhere;
};

export type MutationResourceUpdateArgs = {
  data: ResourceUpdate;
  where: ResourceWhereUnique;
};

export type MutationResourceUpdateBatchArgs = {
  data: Array<ResourceUpdate>;
  where: Array<ResourceWhereUnique>;
};

export type MutationResourceUpdateManyArgs = {
  data: ResourceUpdateMany;
  where: ResourceWhere;
};

export type MutationRevenueShareSettingCreateArgs = {
  data: RevenueShareSettingCreate;
};

export type MutationRevenueShareSettingCreateBatchArgs = {
  data: Array<RevenueShareSettingCreate>;
};

export type MutationRevenueShareSettingCreateManyArgs = {
  data: Array<RevenueShareSettingCreateMany>;
};

export type MutationRevenueShareSettingDeleteArgs = {
  where: RevenueShareSettingWhereUnique;
};

export type MutationRevenueShareSettingDeleteBatchArgs = {
  where: Array<RevenueShareSettingWhereUnique>;
};

export type MutationRevenueShareSettingDeleteManyArgs = {
  where: RevenueShareSettingWhere;
};

export type MutationRevenueShareSettingUpdateArgs = {
  data: RevenueShareSettingUpdate;
  where: RevenueShareSettingWhereUnique;
};

export type MutationRevenueShareSettingUpdateBatchArgs = {
  data: Array<RevenueShareSettingUpdate>;
  where: Array<RevenueShareSettingWhereUnique>;
};

export type MutationRevenueShareSettingUpdateManyArgs = {
  data: RevenueShareSettingUpdateMany;
  where: RevenueShareSettingWhere;
};

export type MutationRunTaskArgs = {
  args?: InputMaybe<Scalars['Json']['input']>;
  name: TaskNameEnum;
  type: TaskTypeEnum;
};

export type MutationSendEmailConfirmationCodeArgs = {
  email: Scalars['String']['input'];
};

export type MutationSendGetHelpToClearVerifyStaffArgs = {
  data: GetHelpToClearVerifyStaffData;
};

export type MutationSendInviteToPartnershipArgs = {
  companyType: CompanyType;
  staffEmail: Scalars['String']['input'];
};

export type MutationSendInvitesToClearVerifyStaffArgs = {
  access: ClearVerifyStaffAccessInput;
  managers: Array<PlatformStaffInviteItem>;
};

export type MutationSendInvitesToConsumersByCvStaffArgs = {
  employeeIds: Array<Scalars['ID']['input']>;
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
  inviteScopeEntityId?: InputMaybe<Scalars['ID']['input']>;
  inviteScopeParamKey?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSendInvitesToConsumersByEmployerArgs = {
  employeeIds: Array<Scalars['ID']['input']>;
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSendInvitesToConsumersByPeoArgs = {
  employeeIds: Array<Scalars['ID']['input']>;
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSendInvitesToConsumersByPeoPayrollProviderArgs = {
  employeeIds: Array<Scalars['ID']['input']>;
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSendInvitesToEmployerStaffsArgs = {
  employerId: Scalars['ID']['input'];
  employerStaffList: Array<InvitedEmployerStaff>;
};

export type MutationSendInvitesToEmployerStaffsByEmployerAdminArgs = {
  employerStaffList: Array<InvitedEmployerStaff>;
};

export type MutationSendInvitesToEmployersAdminsByCvAdminArgs = {
  employers: Array<InvitedEmployerAdminByCvAdminData>;
  peoId?: InputMaybe<Scalars['ID']['input']>;
  peoPayrollProviderId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSendInvitesToEmployersByPeoPpArgs = {
  input: SendInvitesToEmployersByPeoPpInput;
};

export type MutationSendInvitesToEmployersByPeoStaffArgs = {
  input: SendInvitesToEmployersByPeoStaffInput;
};

export type MutationSendInvitesToEmployersUnderPeoArgs = {
  input: SendInvitesToEmployersUnderPeoInput;
};

export type MutationSendInvitesToPeoByCvStaffArgs = {
  peoPayrollProviderId?: InputMaybe<Scalars['ID']['input']>;
  peos: Array<InvitedByCvStaffPeoData>;
};

export type MutationSendInvitesToPeoByPeoPpArgs = {
  input: SendInvitesToPeoByPeoPpInput;
};

export type MutationSendInvitesToPeoPayrollProviderByCvStaffArgs = {
  peoPayrollProviders: Array<InvitedByCvStaffPeoPayrollProviderData>;
};

export type MutationSendInvitesToPeoPayrollProviderStaffByCvStaffArgs = {
  peoPayrollProviderId: Scalars['String']['input'];
  staff: Array<InvitedPeoPayrollProviderStaff>;
};

export type MutationSendInvitesToPeoPayrollProviderStaffsArgs = {
  staff: Array<InvitedPeoPayrollProviderStaff>;
};

export type MutationSendInvitesToPeoStaffByCvStaffArgs = {
  peoId: Scalars['String']['input'];
  staff: Array<InvitedPeoStaffData>;
};

export type MutationSendInvitesToPeoStaffByPeoAdminArgs = {
  staff: Array<InvitedPeoStaffData>;
};

export type MutationSendInvitesToPeoStaffByPeoPayrollProviderStaffArgs = {
  peoId: Scalars['String']['input'];
  staff: Array<InvitedPeoStaffData>;
};

export type MutationSendInvitesToVerifierStaffByVerifierAdminArgs = {
  verifierStaff: Array<InvitedVerifierStaffByVerifierAdminData>;
};

export type MutationSendInvitesToVerifiersAdminsByCvAdminArgs = {
  verifierAdmin: InvitedVerifierAdminByCvAdminData;
};

export type MutationSendInvitesToVerifiersAdminsByVerifierAdminArgs = {
  verifiersAdmins: Array<InvitedVerifierAdminByVerifierAdminData>;
};

export type MutationSendInvitesToVerifiersStaffArgs = {
  verifierId?: InputMaybe<Scalars['ID']['input']>;
  verifierStaff: Array<InvitedVerifierStaffData>;
};

export type MutationSendRequestAccountIsFrozenArgs = {
  employeeId: Scalars['ID']['input'];
};

export type MutationStateCreateArgs = {
  data: StateCreate;
};

export type MutationStateCreateBatchArgs = {
  data: Array<StateCreate>;
};

export type MutationStateCreateManyArgs = {
  data: Array<StateCreateMany>;
};

export type MutationStateDeleteArgs = {
  where: StateWhereUnique;
};

export type MutationStateDeleteBatchArgs = {
  where: Array<StateWhereUnique>;
};

export type MutationStateDeleteManyArgs = {
  where: StateWhere;
};

export type MutationStateUpdateArgs = {
  data: StateUpdate;
  where: StateWhereUnique;
};

export type MutationStateUpdateBatchArgs = {
  data: Array<StateUpdate>;
  where: Array<StateWhereUnique>;
};

export type MutationStateUpdateManyArgs = {
  data: StateUpdateMany;
  where: StateWhere;
};

export type MutationStripeCreatePaymentIntentForVerifierArgs = {
  amount: Scalars['Float']['input'];
  metadata?: InputMaybe<Scalars['Json']['input']>;
  verifierId: Scalars['ID']['input'];
};

export type MutationStripeCreatePaymentIntentForVerifierStaffArgs = {
  amount: Scalars['Float']['input'];
  metadata?: InputMaybe<Scalars['Json']['input']>;
  verifierStaffId: Scalars['ID']['input'];
};

export type MutationStripeDetachPaymentMethodArgs = {
  connectedStripeAccountId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
};

export type MutationStripeGetAccountLinkArgs = {
  refreshUrl: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};

export type MutationStripeRefundChargeArgs = {
  stripeChargeId: Scalars['String']['input'];
};

export type MutationStripeRefundVerificationRequestChargeArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type MutationStripeUpdateAccountPayoutSettingsArgs = {
  input: StripeUpdateAccountPayoutSettingsInput;
};

export type MutationStripeUpdateCustomerDefaultPaymentMethodArgs = {
  connectedStripeAccountId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  defaultPaymentMethodId: Scalars['String']['input'];
};

export type MutationStripeUpdatePaymentMethodForVerificationRequestArgs = {
  inboxItemId: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
};

export type MutationTestVerificationRequestCreateArgs = {
  data: TestVerificationRequestCreate;
};

export type MutationTestVerificationRequestCreateBatchArgs = {
  data: Array<TestVerificationRequestCreate>;
};

export type MutationTestVerificationRequestCreateManyArgs = {
  data: Array<TestVerificationRequestCreateMany>;
};

export type MutationTestVerificationRequestDeleteArgs = {
  where: TestVerificationRequestWhereUnique;
};

export type MutationTestVerificationRequestDeleteBatchArgs = {
  where: Array<TestVerificationRequestWhereUnique>;
};

export type MutationTestVerificationRequestDeleteManyArgs = {
  where: TestVerificationRequestWhere;
};

export type MutationTestVerificationRequestUpdateArgs = {
  data: TestVerificationRequestUpdate;
  where: TestVerificationRequestWhereUnique;
};

export type MutationTestVerificationRequestUpdateBatchArgs = {
  data: Array<TestVerificationRequestUpdate>;
  where: Array<TestVerificationRequestWhereUnique>;
};

export type MutationTestVerificationRequestUpdateManyArgs = {
  data: TestVerificationRequestUpdateMany;
  where: TestVerificationRequestWhere;
};

export type MutationUnsafeCompleteUserDeletionArgs = {
  email: Scalars['String']['input'];
  iUnderstandWhatImDoing: Scalars['Boolean']['input'];
};

export type MutationUpdateClearVerifyStaffArgs = {
  access: ClearVerifyStaffAccessInput;
  platformStaffId: Scalars['ID']['input'];
  userStatus?: InputMaybe<UserStatus>;
};

export type MutationUpdateInboxItemUnreadStatusArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type MutationUpdateInboxItemUnreadStatusesArgs = {
  input: UpdateInboxItemUnreadStatusesInput;
};

export type MutationUpdateInitialBillingRulesArgs = {
  initialBilling?: InputMaybe<InitialBillingUpdate>;
};

export type MutationUpdatePeoStaffDetailsArgs = {
  data: UpdatePeoStaffDetailsInput;
  peoStaffId: Scalars['ID']['input'];
};

export type MutationUpdatePeoWithEmployersArgs = {
  data?: InputMaybe<PeoUpdate>;
  employersUpdateManyData?: InputMaybe<Array<EmployerUpdateMany>>;
  employersUpdateManyWhere?: InputMaybe<Array<EmployerWhere>>;
  id: Scalars['ID']['input'];
};

export type MutationUpdatePermissiblePurposeArgs = {
  data: PermissiblePurposeUpdate;
  id: Scalars['ID']['input'];
};

export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
  userId: Scalars['ID']['input'];
};

export type MutationUpdateVerificationRequestArgs = {
  data: VerificationRequestUpdate;
  id: Scalars['ID']['input'];
};

export type MutationUpdateVerifierArgs = {
  data: VerifierUpdate;
  id: Scalars['ID']['input'];
};

export type MutationUploadFileArgs = {
  file: Scalars['FileUpload']['input'];
  public: Scalars['Boolean']['input'];
};

export type MutationUserCreateArgs = {
  data: UserCreate;
};

export type MutationUserCreateBatchArgs = {
  data: Array<UserCreate>;
};

export type MutationUserCreateManyArgs = {
  data: Array<UserCreateMany>;
};

export type MutationUserDeleteArgs = {
  where: UserWhereUnique;
};

export type MutationUserDeleteBatchArgs = {
  where: Array<UserWhereUnique>;
};

export type MutationUserDeleteManyArgs = {
  where: UserWhere;
};

export type MutationUserEmailChangeRequestCreateArgs = {
  data: UserEmailChangeRequestCreate;
};

export type MutationUserEmailChangeRequestCreateBatchArgs = {
  data: Array<UserEmailChangeRequestCreate>;
};

export type MutationUserEmailChangeRequestCreateManyArgs = {
  data: Array<UserEmailChangeRequestCreateMany>;
};

export type MutationUserEmailChangeRequestDeleteArgs = {
  where: UserEmailChangeRequestWhereUnique;
};

export type MutationUserEmailChangeRequestDeleteBatchArgs = {
  where: Array<UserEmailChangeRequestWhereUnique>;
};

export type MutationUserEmailChangeRequestDeleteManyArgs = {
  where: UserEmailChangeRequestWhere;
};

export type MutationUserEmailChangeRequestUpdateArgs = {
  data: UserEmailChangeRequestUpdate;
  where: UserEmailChangeRequestWhereUnique;
};

export type MutationUserEmailChangeRequestUpdateBatchArgs = {
  data: Array<UserEmailChangeRequestUpdate>;
  where: Array<UserEmailChangeRequestWhereUnique>;
};

export type MutationUserEmailChangeRequestUpdateManyArgs = {
  data: UserEmailChangeRequestUpdateMany;
  where: UserEmailChangeRequestWhere;
};

export type MutationUserPasswordChangeRequestCreateArgs = {
  data: UserPasswordChangeRequestCreate;
};

export type MutationUserPasswordChangeRequestCreateBatchArgs = {
  data: Array<UserPasswordChangeRequestCreate>;
};

export type MutationUserPasswordChangeRequestCreateManyArgs = {
  data: Array<UserPasswordChangeRequestCreateMany>;
};

export type MutationUserPasswordChangeRequestDeleteArgs = {
  where: UserPasswordChangeRequestWhereUnique;
};

export type MutationUserPasswordChangeRequestDeleteBatchArgs = {
  where: Array<UserPasswordChangeRequestWhereUnique>;
};

export type MutationUserPasswordChangeRequestDeleteManyArgs = {
  where: UserPasswordChangeRequestWhere;
};

export type MutationUserPasswordChangeRequestUpdateArgs = {
  data: UserPasswordChangeRequestUpdate;
  where: UserPasswordChangeRequestWhereUnique;
};

export type MutationUserPasswordChangeRequestUpdateBatchArgs = {
  data: Array<UserPasswordChangeRequestUpdate>;
  where: Array<UserPasswordChangeRequestWhereUnique>;
};

export type MutationUserPasswordChangeRequestUpdateManyArgs = {
  data: UserPasswordChangeRequestUpdateMany;
  where: UserPasswordChangeRequestWhere;
};

export type MutationUserPasswordResetRequestCreateArgs = {
  data: UserPasswordResetRequestCreate;
};

export type MutationUserPasswordResetRequestCreateBatchArgs = {
  data: Array<UserPasswordResetRequestCreate>;
};

export type MutationUserPasswordResetRequestCreateManyArgs = {
  data: Array<UserPasswordResetRequestCreateMany>;
};

export type MutationUserPasswordResetRequestDeleteArgs = {
  where: UserPasswordResetRequestWhereUnique;
};

export type MutationUserPasswordResetRequestDeleteBatchArgs = {
  where: Array<UserPasswordResetRequestWhereUnique>;
};

export type MutationUserPasswordResetRequestDeleteManyArgs = {
  where: UserPasswordResetRequestWhere;
};

export type MutationUserPasswordResetRequestUpdateArgs = {
  data: UserPasswordResetRequestUpdate;
  where: UserPasswordResetRequestWhereUnique;
};

export type MutationUserPasswordResetRequestUpdateBatchArgs = {
  data: Array<UserPasswordResetRequestUpdate>;
  where: Array<UserPasswordResetRequestWhereUnique>;
};

export type MutationUserPasswordResetRequestUpdateManyArgs = {
  data: UserPasswordResetRequestUpdateMany;
  where: UserPasswordResetRequestWhere;
};

export type MutationUserRegistrationByInviteArgs = {
  consumer?: InputMaybe<InvitedSignedConsumerData>;
  employer?: InputMaybe<InvitedSignedEmployerData>;
  inviteId: Scalars['ID']['input'];
  peo?: InputMaybe<InvitedSignedPeoData>;
  peoPayrollProvider?: InputMaybe<InvitedSignedPeoPayrollProviderData>;
  user: InvitedSignedUserData;
  verifier?: InputMaybe<InvitedSignedVerifierData>;
};

export type MutationUserRegistrationEmployeeArgs = {
  employeeSignupToken: Scalars['String']['input'];
  requestAutoApprove: Scalars['Boolean']['input'];
  user: NewEmployeeUserData;
};

export type MutationUserRegistrationVerifierAdminArgs = {
  emailConfirmationCode: Scalars['String']['input'];
  user: VerifierAdminUserData;
  verifier: VerifierAdminVerifierData;
};

export type MutationUserRegistrationVerifierManagerArgs = {
  emailConfirmationCode: Scalars['String']['input'];
  user: VerifierManagerUserData;
  verifierId: Scalars['ID']['input'];
};

export type MutationUserUpdateArgs = {
  data: UserUpdate;
  where: UserWhereUnique;
};

export type MutationUserUpdateBatchArgs = {
  data: Array<UserUpdate>;
  where: Array<UserWhereUnique>;
};

export type MutationUserUpdateManyArgs = {
  data: UserUpdateMany;
  where: UserWhere;
};

export type MutationVerificationRequestCreateArgs = {
  data: VerificationRequestCreate;
};

export type MutationVerificationRequestCreateBatchArgs = {
  data: Array<VerificationRequestCreate>;
};

export type MutationVerificationRequestCreateManyArgs = {
  data: Array<VerificationRequestCreateMany>;
};

export type MutationVerificationRequestDeleteArgs = {
  where: VerificationRequestWhereUnique;
};

export type MutationVerificationRequestDeleteBatchArgs = {
  where: Array<VerificationRequestWhereUnique>;
};

export type MutationVerificationRequestDeleteManyArgs = {
  where: VerificationRequestWhere;
};

export type MutationVerificationRequestUpdateArgs = {
  data: VerificationRequestUpdate;
  where: VerificationRequestWhereUnique;
};

export type MutationVerificationRequestUpdateBatchArgs = {
  data: Array<VerificationRequestUpdate>;
  where: Array<VerificationRequestWhereUnique>;
};

export type MutationVerificationRequestUpdateManyArgs = {
  data: VerificationRequestUpdateMany;
  where: VerificationRequestWhere;
};

export type MutationVerifierBillingCreateArgs = {
  data: VerifierBillingCreate;
};

export type MutationVerifierBillingCreateBatchArgs = {
  data: Array<VerifierBillingCreate>;
};

export type MutationVerifierBillingCreateManyArgs = {
  data: Array<VerifierBillingCreateMany>;
};

export type MutationVerifierBillingDeleteArgs = {
  where: VerifierBillingWhereUnique;
};

export type MutationVerifierBillingDeleteBatchArgs = {
  where: Array<VerifierBillingWhereUnique>;
};

export type MutationVerifierBillingDeleteManyArgs = {
  where: VerifierBillingWhere;
};

export type MutationVerifierBillingUpdateArgs = {
  data: VerifierBillingUpdate;
  where: VerifierBillingWhereUnique;
};

export type MutationVerifierBillingUpdateBatchArgs = {
  data: Array<VerifierBillingUpdate>;
  where: Array<VerifierBillingWhereUnique>;
};

export type MutationVerifierBillingUpdateManyArgs = {
  data: VerifierBillingUpdateMany;
  where: VerifierBillingWhere;
};

export type MutationVerifierCreateArgs = {
  data: VerifierCreate;
};

export type MutationVerifierCreateBatchArgs = {
  data: Array<VerifierCreate>;
};

export type MutationVerifierCreateManyArgs = {
  data: Array<VerifierCreateMany>;
};

export type MutationVerifierDeleteArgs = {
  where: VerifierWhereUnique;
};

export type MutationVerifierDeleteBatchArgs = {
  where: Array<VerifierWhereUnique>;
};

export type MutationVerifierDeleteManyArgs = {
  where: VerifierWhere;
};

export type MutationVerifierStaffCreateArgs = {
  data: VerifierStaffCreate;
};

export type MutationVerifierStaffCreateBatchArgs = {
  data: Array<VerifierStaffCreate>;
};

export type MutationVerifierStaffCreateManyArgs = {
  data: Array<VerifierStaffCreateMany>;
};

export type MutationVerifierStaffDeleteArgs = {
  where: VerifierStaffWhereUnique;
};

export type MutationVerifierStaffDeleteBatchArgs = {
  where: Array<VerifierStaffWhereUnique>;
};

export type MutationVerifierStaffDeleteManyArgs = {
  where: VerifierStaffWhere;
};

export type MutationVerifierStaffUpdateArgs = {
  data: VerifierStaffUpdate;
  where: VerifierStaffWhereUnique;
};

export type MutationVerifierStaffUpdateBatchArgs = {
  data: Array<VerifierStaffUpdate>;
  where: Array<VerifierStaffWhereUnique>;
};

export type MutationVerifierStaffUpdateManyArgs = {
  data: VerifierStaffUpdateMany;
  where: VerifierStaffWhere;
};

export type MutationVerifierUpdateArgs = {
  data: VerifierUpdate;
  where: VerifierWhereUnique;
};

export type MutationVerifierUpdateBatchArgs = {
  data: Array<VerifierUpdate>;
  where: Array<VerifierWhereUnique>;
};

export type MutationVerifierUpdateManyArgs = {
  data: VerifierUpdateMany;
  where: VerifierWhere;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NewEmployeeUserData = {
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export const NullsOrder = {
  First: 'First',
  Last: 'Last',
} as const;

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder];
export type PartnershipItem = {
  __typename?: 'PartnershipItem';
  companyType: CompanyType;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  employerCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  status: UserStatus;
};

export const PasswordRequestType = {
  Change: 'change',
  Reset: 'reset',
} as const;

export type PasswordRequestType = (typeof PasswordRequestType)[keyof typeof PasswordRequestType];
export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  employer?: Maybe<Employer>;
  employerId?: Maybe<Scalars['ID']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  peo?: Maybe<Peo>;
  peoId?: Maybe<Scalars['ID']['output']>;
  peoPayrollProvider?: Maybe<PeoPayrollProvider>;
  peoPayrollProviderId?: Maybe<Scalars['ID']['output']>;
  processedAt: Scalars['DateTime']['output'];
  receiver: CompanyType;
  reverseIncompleteReason?: Maybe<Scalars['String']['output']>;
  status: PaymentTransactionStatus;
  stripeTransferId?: Maybe<Scalars['String']['output']>;
  type: PaymentTransactionType;
  updatedAt: Scalars['DateTime']['output'];
  verificationRequest?: Maybe<VerificationRequest>;
  verificationRequestId?: Maybe<Scalars['ID']['output']>;
};

export type PaymentTransactionCreate = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutPaymentTransactions>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  peo?: InputMaybe<PeoCreateRelationWithoutPaymentTransactions>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPaymentTransactions>;
  processedAt: Scalars['DateTime']['input'];
  receiver: CompanyType;
  reverseIncompleteReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentTransactionStatus>;
  stripeTransferId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentTransactionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutPaymentTransactions>;
};

export type PaymentTransactionCreateMany = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  peoId?: InputMaybe<Scalars['ID']['input']>;
  peoPayrollProviderId?: InputMaybe<Scalars['ID']['input']>;
  processedAt: Scalars['DateTime']['input'];
  receiver: CompanyType;
  reverseIncompleteReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentTransactionStatus>;
  stripeTransferId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentTransactionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentTransactionCreateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutEmployer>>;
};

export type PaymentTransactionCreateRelationListWithoutPeo = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutPeo>>;
};

export type PaymentTransactionCreateRelationListWithoutPeoPayrollProvider = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutPeoPayrollProvider>>;
};

export type PaymentTransactionCreateRelationListWithoutVerificationRequest = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutVerificationRequest>>;
};

export type PaymentTransactionCreateWithoutEmployer = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  peo?: InputMaybe<PeoCreateRelationWithoutPaymentTransactions>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPaymentTransactions>;
  processedAt: Scalars['DateTime']['input'];
  receiver: CompanyType;
  reverseIncompleteReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentTransactionStatus>;
  stripeTransferId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentTransactionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutPaymentTransactions>;
};

export type PaymentTransactionCreateWithoutPeo = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutPaymentTransactions>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPaymentTransactions>;
  processedAt: Scalars['DateTime']['input'];
  receiver: CompanyType;
  reverseIncompleteReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentTransactionStatus>;
  stripeTransferId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentTransactionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutPaymentTransactions>;
};

export type PaymentTransactionCreateWithoutPeoPayrollProvider = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutPaymentTransactions>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  peo?: InputMaybe<PeoCreateRelationWithoutPaymentTransactions>;
  processedAt: Scalars['DateTime']['input'];
  receiver: CompanyType;
  reverseIncompleteReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentTransactionStatus>;
  stripeTransferId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentTransactionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestCreateRelationWithoutPaymentTransactions>;
};

export type PaymentTransactionCreateWithoutVerificationRequest = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutPaymentTransactions>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  peo?: InputMaybe<PeoCreateRelationWithoutPaymentTransactions>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPaymentTransactions>;
  processedAt: Scalars['DateTime']['input'];
  receiver: CompanyType;
  reverseIncompleteReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentTransactionStatus>;
  stripeTransferId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentTransactionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentTransactionOrderBy = {
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  employer?: InputMaybe<EmployerOrderBy>;
  employerId?: InputMaybe<SortOrderInput>;
  failureReason?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  peo?: InputMaybe<PeoOrderBy>;
  peoId?: InputMaybe<SortOrderInput>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderOrderBy>;
  peoPayrollProviderId?: InputMaybe<SortOrderInput>;
  processedAt?: InputMaybe<SortOrder>;
  receiver?: InputMaybe<SortOrder>;
  reverseIncompleteReason?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  stripeTransferId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verificationRequest?: InputMaybe<VerificationRequestOrderBy>;
  verificationRequestId?: InputMaybe<SortOrderInput>;
};

export const PaymentTransactionStatus = {
  Canceled: 'Canceled',
  Completed: 'Completed',
  Failed: 'Failed',
  Owed: 'Owed',
  Pending: 'Pending',
  ReverseIncomplete: 'Reverse_Incomplete',
  Reversed: 'Reversed',
} as const;

export type PaymentTransactionStatus =
  (typeof PaymentTransactionStatus)[keyof typeof PaymentTransactionStatus];
export type PaymentTransactionStatusFilter = {
  equals?: InputMaybe<PaymentTransactionStatus>;
  in?: InputMaybe<Array<PaymentTransactionStatus>>;
  not?: InputMaybe<PaymentTransactionStatusFilter>;
  notIn?: InputMaybe<Array<PaymentTransactionStatus>>;
};

export type PaymentTransactionStatusUpdate = {
  set?: InputMaybe<PaymentTransactionStatus>;
};

export const PaymentTransactionType = {
  Payment: 'Payment',
  Transfer: 'Transfer',
} as const;

export type PaymentTransactionType =
  (typeof PaymentTransactionType)[keyof typeof PaymentTransactionType];
export type PaymentTransactionTypeFilter = {
  equals?: InputMaybe<PaymentTransactionType>;
  in?: InputMaybe<Array<PaymentTransactionType>>;
  not?: InputMaybe<PaymentTransactionTypeFilter>;
  notIn?: InputMaybe<Array<PaymentTransactionType>>;
};

export type PaymentTransactionTypeUpdate = {
  set?: InputMaybe<PaymentTransactionType>;
};

export type PaymentTransactionUpdate = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutPaymentTransactions>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  peo?: InputMaybe<PeoUpdateRelationWithoutPaymentTransactions>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutPaymentTransactions>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  receiver?: InputMaybe<CompanyType>;
  reverseIncompleteReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentTransactionStatus>;
  stripeTransferId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentTransactionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequest?: InputMaybe<VerificationRequestUpdateRelationWithoutPaymentTransactions>;
};

export type PaymentTransactionUpdateMany = {
  amount?: InputMaybe<IntUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  employerId?: InputMaybe<IdUpdate>;
  failureReason?: InputMaybe<StringUpdate>;
  peoId?: InputMaybe<IdUpdate>;
  peoPayrollProviderId?: InputMaybe<IdUpdate>;
  processedAt?: InputMaybe<DateTimeUpdate>;
  receiver?: InputMaybe<CompanyTypeUpdate>;
  reverseIncompleteReason?: InputMaybe<StringUpdate>;
  status?: InputMaybe<PaymentTransactionStatusUpdate>;
  stripeTransferId?: InputMaybe<StringUpdate>;
  type?: InputMaybe<PaymentTransactionTypeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  verificationRequestId?: InputMaybe<IdUpdate>;
};

export type PaymentTransactionUpdateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutEmployer>>;
  disconnect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  set?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
};

export type PaymentTransactionUpdateRelationListWithoutPeo = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutPeo>>;
  disconnect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  set?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
};

export type PaymentTransactionUpdateRelationListWithoutPeoPayrollProvider = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutPeoPayrollProvider>>;
  disconnect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  set?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
};

export type PaymentTransactionUpdateRelationListWithoutVerificationRequest = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutVerificationRequest>>;
  disconnect?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
  set?: InputMaybe<Array<PaymentTransactionWhereUnique>>;
};

export type PaymentTransactionWhere = {
  AND?: InputMaybe<Array<PaymentTransactionWhere>>;
  NOT?: InputMaybe<Array<PaymentTransactionWhere>>;
  OR?: InputMaybe<Array<PaymentTransactionWhere>>;
  amount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employer?: InputMaybe<EmployerWhere>;
  employerId?: InputMaybe<IdFilter>;
  failureReason?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  peo?: InputMaybe<PeoWhere>;
  peoId?: InputMaybe<IdFilter>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderWhere>;
  peoPayrollProviderId?: InputMaybe<IdFilter>;
  processedAt?: InputMaybe<DateTimeFilter>;
  receiver?: InputMaybe<CompanyTypeFilter>;
  reverseIncompleteReason?: InputMaybe<StringFilter>;
  status?: InputMaybe<PaymentTransactionStatusFilter>;
  stripeTransferId?: InputMaybe<StringFilter>;
  type?: InputMaybe<PaymentTransactionTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verificationRequest?: InputMaybe<VerificationRequestWhere>;
  verificationRequestId?: InputMaybe<IdFilter>;
};

export type PaymentTransactionWhereRelationList = {
  every?: InputMaybe<PaymentTransactionWhere>;
  none?: InputMaybe<PaymentTransactionWhere>;
  some?: InputMaybe<PaymentTransactionWhere>;
};

export type PaymentTransactionWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  stripeTransferId?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutSchedule = {
  __typename?: 'PayoutSchedule';
  delayDays: Scalars['Int']['output'];
  interval: StripePayoutScheduleInterval;
  monthlyAnchor?: Maybe<Scalars['Int']['output']>;
  weeklyAnchor?: Maybe<StripePayoutScheduleWeeklyAnchor>;
};

export type Peo = {
  __typename?: 'Peo';
  companyType: PeoCompanyType;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  corporateStructure?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dashboardRevenueShareData?: Maybe<DashboardRevenueShareData>;
  dashboardRevenueShareDataId?: Maybe<Scalars['ID']['output']>;
  defaultDisclaimer?: Maybe<Scalars['String']['output']>;
  defaultRequestAutoAccept?: Maybe<ActiveInactive>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  employersCount: Scalars['Int']['output'];
  employersList: Array<Employer>;
  employersLiveByDefaultSetAt?: Maybe<Scalars['DateTime']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  firstPinDigits?: Maybe<PinDigit>;
  headquarters?: Maybe<Address>;
  headquartersId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  isMdmSynced?: Maybe<Scalars['Boolean']['output']>;
  keepOwnRevenueShare: Scalars['Boolean']['output'];
  lastPinDigits?: Maybe<PinDigit>;
  logo?: Maybe<File>;
  logoId?: Maybe<Scalars['ID']['output']>;
  mdmApiId?: Maybe<Scalars['String']['output']>;
  mdmSyncDate?: Maybe<Scalars['DateTime']['output']>;
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  paymentTransactionsCount: Scalars['Int']['output'];
  paymentTransactionsList: Array<PaymentTransaction>;
  peoPayrollProvider?: Maybe<PeoPayrollProvider>;
  peoPayrollProviderId?: Maybe<Scalars['ID']['output']>;
  peoStaffsCount: Scalars['Int']['output'];
  peoStaffsList: Array<PeoStaff>;
  pinHint?: Maybe<Scalars['String']['output']>;
  pinLength?: Maybe<PinLength>;
  requestAutoAccept: Scalars['Boolean']['output'];
  revenueShareReportEnabled: Scalars['Boolean']['output'];
  revenueShareSetting?: Maybe<RevenueShareSetting>;
  revenueShareSettingId?: Maybe<Scalars['ID']['output']>;
  signUpMethod: SignUpMethod;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  taxYearEndDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PeoEmployersCountArgs = {
  where?: InputMaybe<EmployerWhere>;
};

export type PeoEmployersListArgs = {
  orderBy?: InputMaybe<Array<EmployerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerWhere>;
};

export type PeoPaymentTransactionsCountArgs = {
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type PeoPaymentTransactionsListArgs = {
  orderBy?: InputMaybe<Array<PaymentTransactionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type PeoPeoStaffsCountArgs = {
  where?: InputMaybe<PeoStaffWhere>;
};

export type PeoPeoStaffsListArgs = {
  orderBy?: InputMaybe<Array<PeoStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoStaffWhere>;
};

export const PeoCompanyType = {
  Partnership: 'Partnership',
  Peo: 'Peo',
} as const;

export type PeoCompanyType = (typeof PeoCompanyType)[keyof typeof PeoCompanyType];
export type PeoCompanyTypeFilter = {
  equals?: InputMaybe<PeoCompanyType>;
  in?: InputMaybe<Array<PeoCompanyType>>;
  not?: InputMaybe<PeoCompanyTypeFilter>;
  notIn?: InputMaybe<Array<PeoCompanyType>>;
};

export type PeoCompanyTypeUpdate = {
  set?: InputMaybe<PeoCompanyType>;
};

export type PeoCreate = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffCreateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoCreateMany = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareDataId?: InputMaybe<Scalars['ID']['input']>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquartersId?: InputMaybe<Scalars['ID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  peoPayrollProviderId?: InputMaybe<Scalars['ID']['input']>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSettingId?: InputMaybe<Scalars['ID']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoCreateRelationListWithoutHeadquarters = {
  connect?: InputMaybe<Array<PeoWhereUnique>>;
  create?: InputMaybe<Array<PeoCreateWithoutHeadquarters>>;
};

export type PeoCreateRelationListWithoutLogo = {
  connect?: InputMaybe<Array<PeoWhereUnique>>;
  create?: InputMaybe<Array<PeoCreateWithoutLogo>>;
};

export type PeoCreateRelationListWithoutPeoPayrollProvider = {
  connect?: InputMaybe<Array<PeoWhereUnique>>;
  create?: InputMaybe<Array<PeoCreateWithoutPeoPayrollProvider>>;
};

export type PeoCreateRelationWithoutDashboardRevenueShareData = {
  connect?: InputMaybe<PeoWhereUnique>;
  create?: InputMaybe<PeoCreateWithoutDashboardRevenueShareData>;
};

export type PeoCreateRelationWithoutEmployers = {
  connect?: InputMaybe<PeoWhereUnique>;
  create?: InputMaybe<PeoCreateWithoutEmployers>;
};

export type PeoCreateRelationWithoutPaymentTransactions = {
  connect?: InputMaybe<PeoWhereUnique>;
  create?: InputMaybe<PeoCreateWithoutPaymentTransactions>;
};

export type PeoCreateRelationWithoutPeoStaffs = {
  connect?: InputMaybe<PeoWhereUnique>;
  create?: InputMaybe<PeoCreateWithoutPeoStaffs>;
};

export type PeoCreateRelationWithoutRevenueShareSetting = {
  connect?: InputMaybe<PeoWhereUnique>;
  create?: InputMaybe<PeoCreateWithoutRevenueShareSetting>;
};

export type PeoCreateWithoutDashboardRevenueShareData = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffCreateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoCreateWithoutEmployers = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffCreateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoCreateWithoutHeadquarters = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffCreateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoCreateWithoutLogo = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffCreateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoCreateWithoutPaymentTransactions = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffCreateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoCreateWithoutPeoPayrollProvider = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeo>;
  peoStaffs?: InputMaybe<PeoStaffCreateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoCreateWithoutPeoStaffs = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPeos>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoCreateWithoutRevenueShareSetting = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffCreateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoOrderBy = {
  companyType?: InputMaybe<SortOrder>;
  contactEmail?: InputMaybe<SortOrderInput>;
  contactPhoneNumber?: InputMaybe<SortOrderInput>;
  corporateStructure?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumOrderBy>;
  dashboardRevenueShareDataId?: InputMaybe<SortOrderInput>;
  defaultDisclaimer?: InputMaybe<SortOrderInput>;
  defaultRequestAutoAccept?: InputMaybe<SortOrderInput>;
  disclaimer?: InputMaybe<SortOrderInput>;
  displayName?: InputMaybe<SortOrderInput>;
  employersLiveByDefaultSetAt?: InputMaybe<SortOrderInput>;
  fein?: InputMaybe<SortOrderInput>;
  firstPinDigits?: InputMaybe<SortOrderInput>;
  headquarters?: InputMaybe<AddressOrderBy>;
  headquartersId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  industry?: InputMaybe<SortOrderInput>;
  isMdmSynced?: InputMaybe<SortOrderInput>;
  keepOwnRevenueShare?: InputMaybe<SortOrder>;
  lastPinDigits?: InputMaybe<SortOrderInput>;
  logo?: InputMaybe<FileOrderBy>;
  logoId?: InputMaybe<SortOrderInput>;
  mdmApiId?: InputMaybe<SortOrderInput>;
  mdmSyncDate?: InputMaybe<SortOrderInput>;
  numberOfEmployees?: InputMaybe<SortOrderInput>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderOrderBy>;
  peoPayrollProviderId?: InputMaybe<SortOrderInput>;
  pinHint?: InputMaybe<SortOrderInput>;
  pinLength?: InputMaybe<SortOrderInput>;
  requestAutoAccept?: InputMaybe<SortOrder>;
  revenueShareReportEnabled?: InputMaybe<SortOrder>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingOrderBy>;
  revenueShareSettingId?: InputMaybe<SortOrderInput>;
  signUpMethod?: InputMaybe<SortOrder>;
  stripeAccountId?: InputMaybe<SortOrderInput>;
  taxYearEndDate?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PeoPayrollProvider = {
  __typename?: 'PeoPayrollProvider';
  companyType: PeoPayrollProviderCompanyType;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  corporateStructure?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dashboardRevenueShareData?: Maybe<DashboardRevenueShareData>;
  dashboardRevenueShareDataId?: Maybe<Scalars['ID']['output']>;
  defaultDisclaimer?: Maybe<Scalars['String']['output']>;
  defaultRequestAutoAccept?: Maybe<ActiveInactive>;
  displayName?: Maybe<Scalars['String']['output']>;
  employersCount: Scalars['Int']['output'];
  employersList: Array<Employer>;
  fein?: Maybe<Scalars['String']['output']>;
  firstPinDigits?: Maybe<PinDigit>;
  headquarters?: Maybe<Address>;
  headquartersId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  lastPinDigits?: Maybe<PinDigit>;
  logo?: Maybe<File>;
  logoId?: Maybe<Scalars['ID']['output']>;
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  paymentTransactionsCount: Scalars['Int']['output'];
  paymentTransactionsList: Array<PaymentTransaction>;
  peoPayrollProviderStaffsCount: Scalars['Int']['output'];
  peoPayrollProviderStaffsList: Array<PeoPayrollProviderStaff>;
  peosCount: Scalars['Int']['output'];
  peosList: Array<Peo>;
  pinHint?: Maybe<Scalars['String']['output']>;
  pinLength?: Maybe<PinLength>;
  revenueShareReportEnabled: Scalars['Boolean']['output'];
  revenueShareSetting?: Maybe<RevenueShareSetting>;
  revenueShareSettingId?: Maybe<Scalars['ID']['output']>;
  signUpMethod: SignUpMethod;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  taxYearEndDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PeoPayrollProviderEmployersCountArgs = {
  where?: InputMaybe<EmployerWhere>;
};

export type PeoPayrollProviderEmployersListArgs = {
  orderBy?: InputMaybe<Array<EmployerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerWhere>;
};

export type PeoPayrollProviderPaymentTransactionsCountArgs = {
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type PeoPayrollProviderPaymentTransactionsListArgs = {
  orderBy?: InputMaybe<Array<PaymentTransactionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type PeoPayrollProviderPeoPayrollProviderStaffsCountArgs = {
  where?: InputMaybe<PeoPayrollProviderStaffWhere>;
};

export type PeoPayrollProviderPeoPayrollProviderStaffsListArgs = {
  orderBy?: InputMaybe<Array<PeoPayrollProviderStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoPayrollProviderStaffWhere>;
};

export type PeoPayrollProviderPeosCountArgs = {
  where?: InputMaybe<PeoWhere>;
};

export type PeoPayrollProviderPeosListArgs = {
  orderBy?: InputMaybe<Array<PeoOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoWhere>;
};

export const PeoPayrollProviderCompanyType = {
  Partnership: 'Partnership',
  PeoPayrollProvider: 'Peo_Payroll_Provider',
} as const;

export type PeoPayrollProviderCompanyType =
  (typeof PeoPayrollProviderCompanyType)[keyof typeof PeoPayrollProviderCompanyType];
export type PeoPayrollProviderCompanyTypeFilter = {
  equals?: InputMaybe<PeoPayrollProviderCompanyType>;
  in?: InputMaybe<Array<PeoPayrollProviderCompanyType>>;
  not?: InputMaybe<PeoPayrollProviderCompanyTypeFilter>;
  notIn?: InputMaybe<Array<PeoPayrollProviderCompanyType>>;
};

export type PeoPayrollProviderCompanyTypeUpdate = {
  set?: InputMaybe<PeoPayrollProviderCompanyType>;
};

export type PeoPayrollProviderCreate = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffCreateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoCreateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderCreateMany = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareDataId?: InputMaybe<Scalars['ID']['input']>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquartersId?: InputMaybe<Scalars['ID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSettingId?: InputMaybe<Scalars['ID']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderCreateRelationListWithoutHeadquarters = {
  connect?: InputMaybe<Array<PeoPayrollProviderWhereUnique>>;
  create?: InputMaybe<Array<PeoPayrollProviderCreateWithoutHeadquarters>>;
};

export type PeoPayrollProviderCreateRelationListWithoutLogo = {
  connect?: InputMaybe<Array<PeoPayrollProviderWhereUnique>>;
  create?: InputMaybe<Array<PeoPayrollProviderCreateWithoutLogo>>;
};

export type PeoPayrollProviderCreateRelationWithoutDashboardRevenueShareData = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutDashboardRevenueShareData>;
};

export type PeoPayrollProviderCreateRelationWithoutEmployers = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutEmployers>;
};

export type PeoPayrollProviderCreateRelationWithoutPaymentTransactions = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutPaymentTransactions>;
};

export type PeoPayrollProviderCreateRelationWithoutPeoPayrollProviderStaffs = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutPeoPayrollProviderStaffs>;
};

export type PeoPayrollProviderCreateRelationWithoutPeos = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutPeos>;
};

export type PeoPayrollProviderCreateRelationWithoutRevenueShareSetting = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutRevenueShareSetting>;
};

export type PeoPayrollProviderCreateWithoutDashboardRevenueShareData = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffCreateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoCreateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderCreateWithoutEmployers = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffCreateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoCreateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderCreateWithoutHeadquarters = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffCreateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoCreateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderCreateWithoutLogo = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffCreateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoCreateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderCreateWithoutPaymentTransactions = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffCreateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoCreateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderCreateWithoutPeoPayrollProviderStaffs = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoCreateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderCreateWithoutPeos = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffCreateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingCreateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderCreateWithoutRevenueShareSetting = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumCreateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressCreateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileCreateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffCreateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoCreateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderOrderBy = {
  companyType?: InputMaybe<SortOrder>;
  contactEmail?: InputMaybe<SortOrderInput>;
  contactPhoneNumber?: InputMaybe<SortOrderInput>;
  corporateStructure?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumOrderBy>;
  dashboardRevenueShareDataId?: InputMaybe<SortOrderInput>;
  defaultDisclaimer?: InputMaybe<SortOrderInput>;
  defaultRequestAutoAccept?: InputMaybe<SortOrderInput>;
  displayName?: InputMaybe<SortOrderInput>;
  fein?: InputMaybe<SortOrderInput>;
  firstPinDigits?: InputMaybe<SortOrderInput>;
  headquarters?: InputMaybe<AddressOrderBy>;
  headquartersId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  industry?: InputMaybe<SortOrderInput>;
  lastPinDigits?: InputMaybe<SortOrderInput>;
  logo?: InputMaybe<FileOrderBy>;
  logoId?: InputMaybe<SortOrderInput>;
  numberOfEmployees?: InputMaybe<SortOrderInput>;
  pinHint?: InputMaybe<SortOrderInput>;
  pinLength?: InputMaybe<SortOrderInput>;
  revenueShareReportEnabled?: InputMaybe<SortOrder>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingOrderBy>;
  revenueShareSettingId?: InputMaybe<SortOrderInput>;
  signUpMethod?: InputMaybe<SortOrder>;
  stripeAccountId?: InputMaybe<SortOrderInput>;
  taxYearEndDate?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PeoPayrollProviderStaff = {
  __typename?: 'PeoPayrollProviderStaff';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  peoPayrollProvider: PeoPayrollProvider;
  peoPayrollProviderId: Scalars['ID']['output'];
  role: PeoPayrollProviderStaffRole;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type PeoPayrollProviderStaffCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peoPayrollProvider: PeoPayrollProviderCreateRelationWithoutPeoPayrollProviderStaffs;
  role?: InputMaybe<PeoPayrollProviderStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPeoPayrollProviderStaff;
};

export type PeoPayrollProviderStaffCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peoPayrollProviderId: Scalars['ID']['input'];
  role?: InputMaybe<PeoPayrollProviderStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type PeoPayrollProviderStaffCreateRelationListWithoutPeoPayrollProvider = {
  connect?: InputMaybe<Array<PeoPayrollProviderStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoPayrollProviderStaffCreateWithoutPeoPayrollProvider>>;
};

export type PeoPayrollProviderStaffCreateRelationWithoutUser = {
  connect?: InputMaybe<PeoPayrollProviderStaffWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderStaffCreateWithoutUser>;
};

export type PeoPayrollProviderStaffCreateWithoutPeoPayrollProvider = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<PeoPayrollProviderStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPeoPayrollProviderStaff;
};

export type PeoPayrollProviderStaffCreateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peoPayrollProvider: PeoPayrollProviderCreateRelationWithoutPeoPayrollProviderStaffs;
  role?: InputMaybe<PeoPayrollProviderStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderStaffOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderOrderBy>;
  peoPayrollProviderId?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
};

export const PeoPayrollProviderStaffRole = {
  PeoPayrollProviderUser: 'Peo_Payroll_Provider_User',
} as const;

export type PeoPayrollProviderStaffRole =
  (typeof PeoPayrollProviderStaffRole)[keyof typeof PeoPayrollProviderStaffRole];
export type PeoPayrollProviderStaffRoleFilter = {
  equals?: InputMaybe<PeoPayrollProviderStaffRole>;
  in?: InputMaybe<Array<PeoPayrollProviderStaffRole>>;
  not?: InputMaybe<PeoPayrollProviderStaffRoleFilter>;
  notIn?: InputMaybe<Array<PeoPayrollProviderStaffRole>>;
};

export type PeoPayrollProviderStaffUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderStaffUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type PeoPayrollProviderStaffUpdateRelationListWithoutPeoPayrollProvider = {
  connect?: InputMaybe<Array<PeoPayrollProviderStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoPayrollProviderStaffCreateWithoutPeoPayrollProvider>>;
  disconnect?: InputMaybe<Array<PeoPayrollProviderStaffWhereUnique>>;
  set?: InputMaybe<Array<PeoPayrollProviderStaffWhereUnique>>;
};

export type PeoPayrollProviderStaffUpdateRelationWithoutUser = {
  connect?: InputMaybe<PeoPayrollProviderStaffWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderStaffCreateWithoutUser>;
  disconnect?: InputMaybe<PeoPayrollProviderStaffWhereUnique>;
  update?: InputMaybe<PeoPayrollProviderStaffUpdateWithoutUser>;
};

export type PeoPayrollProviderStaffUpdateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderStaffWhere = {
  AND?: InputMaybe<Array<PeoPayrollProviderStaffWhere>>;
  NOT?: InputMaybe<Array<PeoPayrollProviderStaffWhere>>;
  OR?: InputMaybe<Array<PeoPayrollProviderStaffWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderWhere>;
  peoPayrollProviderId?: InputMaybe<IdFilter>;
  role?: InputMaybe<PeoPayrollProviderStaffRoleFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
};

export type PeoPayrollProviderStaffWhereRelationList = {
  every?: InputMaybe<PeoPayrollProviderStaffWhere>;
  none?: InputMaybe<PeoPayrollProviderStaffWhere>;
  some?: InputMaybe<PeoPayrollProviderStaffWhere>;
};

export type PeoPayrollProviderStaffWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type PeoPayrollProviderUpdate = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffUpdateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderUpdateMany = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyTypeUpdate>;
  contactEmail?: InputMaybe<StringUpdate>;
  contactPhoneNumber?: InputMaybe<StringUpdate>;
  corporateStructure?: InputMaybe<StringUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  dashboardRevenueShareDataId?: InputMaybe<IdUpdate>;
  defaultDisclaimer?: InputMaybe<StringUpdate>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactiveUpdate>;
  displayName?: InputMaybe<StringUpdate>;
  fein?: InputMaybe<StringUpdate>;
  firstPinDigits?: InputMaybe<PinDigitUpdate>;
  headquartersId?: InputMaybe<IdUpdate>;
  industry?: InputMaybe<StringUpdate>;
  lastPinDigits?: InputMaybe<PinDigitUpdate>;
  logoId?: InputMaybe<IdUpdate>;
  numberOfEmployees?: InputMaybe<IntUpdate>;
  pinHint?: InputMaybe<StringUpdate>;
  pinLength?: InputMaybe<PinLengthUpdate>;
  revenueShareReportEnabled?: InputMaybe<BooleanUpdate>;
  revenueShareSettingId?: InputMaybe<IdUpdate>;
  signUpMethod?: InputMaybe<SignUpMethodUpdate>;
  stripeAccountId?: InputMaybe<StringUpdate>;
  taxYearEndDate?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type PeoPayrollProviderUpdateRelationListWithoutHeadquarters = {
  connect?: InputMaybe<Array<PeoPayrollProviderWhereUnique>>;
  create?: InputMaybe<Array<PeoPayrollProviderCreateWithoutHeadquarters>>;
  disconnect?: InputMaybe<Array<PeoPayrollProviderWhereUnique>>;
  set?: InputMaybe<Array<PeoPayrollProviderWhereUnique>>;
};

export type PeoPayrollProviderUpdateRelationListWithoutLogo = {
  connect?: InputMaybe<Array<PeoPayrollProviderWhereUnique>>;
  create?: InputMaybe<Array<PeoPayrollProviderCreateWithoutLogo>>;
  disconnect?: InputMaybe<Array<PeoPayrollProviderWhereUnique>>;
  set?: InputMaybe<Array<PeoPayrollProviderWhereUnique>>;
};

export type PeoPayrollProviderUpdateRelationWithoutDashboardRevenueShareData = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutDashboardRevenueShareData>;
  disconnect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  update?: InputMaybe<PeoPayrollProviderUpdateWithoutDashboardRevenueShareData>;
};

export type PeoPayrollProviderUpdateRelationWithoutEmployers = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutEmployers>;
  disconnect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  update?: InputMaybe<PeoPayrollProviderUpdateWithoutEmployers>;
};

export type PeoPayrollProviderUpdateRelationWithoutPaymentTransactions = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutPaymentTransactions>;
  disconnect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  update?: InputMaybe<PeoPayrollProviderUpdateWithoutPaymentTransactions>;
};

export type PeoPayrollProviderUpdateRelationWithoutPeos = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutPeos>;
  disconnect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  update?: InputMaybe<PeoPayrollProviderUpdateWithoutPeos>;
};

export type PeoPayrollProviderUpdateRelationWithoutRevenueShareSetting = {
  connect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  create?: InputMaybe<PeoPayrollProviderCreateWithoutRevenueShareSetting>;
  disconnect?: InputMaybe<PeoPayrollProviderWhereUnique>;
  update?: InputMaybe<PeoPayrollProviderUpdateWithoutRevenueShareSetting>;
};

export type PeoPayrollProviderUpdateWithoutDashboardRevenueShareData = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffUpdateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderUpdateWithoutEmployers = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffUpdateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderUpdateWithoutPaymentTransactions = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffUpdateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderUpdateWithoutPeos = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffUpdateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutPeoPayrollProvider>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderUpdateWithoutRevenueShareSetting = {
  companyType?: InputMaybe<PeoPayrollProviderCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutPeoPayrollProvider>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutPeoPayrollProvider>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeoPayrollProviders>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoPayrollProviderLogos>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutPeoPayrollProvider>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffUpdateRelationListWithoutPeoPayrollProvider>;
  peos?: InputMaybe<PeoUpdateRelationListWithoutPeoPayrollProvider>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoPayrollProviderWhere = {
  AND?: InputMaybe<Array<PeoPayrollProviderWhere>>;
  NOT?: InputMaybe<Array<PeoPayrollProviderWhere>>;
  OR?: InputMaybe<Array<PeoPayrollProviderWhere>>;
  companyType?: InputMaybe<PeoPayrollProviderCompanyTypeFilter>;
  contactEmail?: InputMaybe<StringFilter>;
  contactPhoneNumber?: InputMaybe<StringFilter>;
  corporateStructure?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumWhere>;
  dashboardRevenueShareDataId?: InputMaybe<IdFilter>;
  defaultDisclaimer?: InputMaybe<StringFilter>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactiveFilter>;
  displayName?: InputMaybe<StringFilter>;
  employers?: InputMaybe<EmployerWhereRelationList>;
  fein?: InputMaybe<StringFilter>;
  firstPinDigits?: InputMaybe<PinDigitFilter>;
  headquarters?: InputMaybe<AddressWhere>;
  headquartersId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  industry?: InputMaybe<StringFilter>;
  lastPinDigits?: InputMaybe<PinDigitFilter>;
  logo?: InputMaybe<FileWhere>;
  logoId?: InputMaybe<IdFilter>;
  numberOfEmployees?: InputMaybe<IntFilter>;
  paymentTransactions?: InputMaybe<PaymentTransactionWhereRelationList>;
  peoPayrollProviderStaffs?: InputMaybe<PeoPayrollProviderStaffWhereRelationList>;
  peos?: InputMaybe<PeoWhereRelationList>;
  pinHint?: InputMaybe<StringFilter>;
  pinLength?: InputMaybe<PinLengthFilter>;
  revenueShareReportEnabled?: InputMaybe<BooleanFilter>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingWhere>;
  revenueShareSettingId?: InputMaybe<IdFilter>;
  signUpMethod?: InputMaybe<SignUpMethodFilter>;
  stripeAccountId?: InputMaybe<StringFilter>;
  taxYearEndDate?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PeoPayrollProviderWhereRelationList = {
  every?: InputMaybe<PeoPayrollProviderWhere>;
  none?: InputMaybe<PeoPayrollProviderWhere>;
  some?: InputMaybe<PeoPayrollProviderWhere>;
};

export type PeoPayrollProviderWhereUnique = {
  dashboardRevenueShareDataId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  revenueShareSettingId?: InputMaybe<Scalars['ID']['input']>;
};

export type PeoStaff = {
  __typename?: 'PeoStaff';
  accessRestrictionMode: AccessRestrictionMode;
  blacklistedEmployeesCount: Scalars['Int']['output'];
  blacklistedEmployeesList: Array<Employee>;
  blacklistedEmployersCount: Scalars['Int']['output'];
  blacklistedEmployersList: Array<Employer>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  peo: Peo;
  peoId: Scalars['ID']['output'];
  role: PeoStaffRole;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  whitelistedEmployersCount: Scalars['Int']['output'];
  whitelistedEmployersList: Array<Employer>;
};

export type PeoStaffBlacklistedEmployeesCountArgs = {
  where?: InputMaybe<EmployeeWhere>;
};

export type PeoStaffBlacklistedEmployeesListArgs = {
  orderBy?: InputMaybe<Array<EmployeeOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeWhere>;
};

export type PeoStaffBlacklistedEmployersCountArgs = {
  where?: InputMaybe<EmployerWhere>;
};

export type PeoStaffBlacklistedEmployersListArgs = {
  orderBy?: InputMaybe<Array<EmployerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerWhere>;
};

export type PeoStaffWhitelistedEmployersCountArgs = {
  where?: InputMaybe<EmployerWhere>;
};

export type PeoStaffWhitelistedEmployersListArgs = {
  orderBy?: InputMaybe<Array<EmployerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerWhere>;
};

export type PeoStaffAccessInfo = {
  __typename?: 'PeoStaffAccessInfo';
  accessRestrictionMode: AccessRestrictionMode;
  blacklistedEmployeesList: Array<PeoStaffAccessInfoEmployeeListItem>;
  blacklistedEmployersList: Array<PeoStaffAccessInfoEmployerListItem>;
  id: Scalars['ID']['output'];
  whitelistedEmployersList: Array<PeoStaffAccessInfoEmployerListItem>;
};

export type PeoStaffAccessInfoEmployeeListItem = {
  __typename?: 'PeoStaffAccessInfoEmployeeListItem';
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4OfSsn: Scalars['String']['output'];
};

export type PeoStaffAccessInfoEmployerListItem = {
  __typename?: 'PeoStaffAccessInfoEmployerListItem';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type PeoStaffAccessRestrictionInput = {
  accessRestrictionMode: AccessRestrictionMode;
  employeesBlacklistList: Array<PeoStaffBlacklistedEmployeeInput>;
  employersBlacklistIdList: Array<Scalars['ID']['input']>;
  employersWhitelistIdList: Array<Scalars['ID']['input']>;
};

export type PeoStaffBlacklistedEmployeeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: PeoStaffBlacklistedEmployeeKindEnum;
  token?: InputMaybe<Scalars['String']['input']>;
};

export const PeoStaffBlacklistedEmployeeKindEnum = {
  Existing: 'Existing',
  New: 'New',
} as const;

export type PeoStaffBlacklistedEmployeeKindEnum =
  (typeof PeoStaffBlacklistedEmployeeKindEnum)[keyof typeof PeoStaffBlacklistedEmployeeKindEnum];
export type PeoStaffCreate = {
  accessRestrictionMode?: InputMaybe<AccessRestrictionMode>;
  blacklistedEmployees?: InputMaybe<EmployeeCreateRelationListWithoutPeoStaffBlacklisted>;
  blacklistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffBlacklisted>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peo: PeoCreateRelationWithoutPeoStaffs;
  role: PeoStaffRole;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPeoStaff;
  whitelistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffWhitelisted>;
};

export type PeoStaffCreateMany = {
  accessRestrictionMode?: InputMaybe<AccessRestrictionMode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peoId: Scalars['ID']['input'];
  role: PeoStaffRole;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type PeoStaffCreateRelationListWithoutBlacklistedEmployees = {
  connect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoStaffCreateWithoutBlacklistedEmployees>>;
};

export type PeoStaffCreateRelationListWithoutBlacklistedEmployers = {
  connect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoStaffCreateWithoutBlacklistedEmployers>>;
};

export type PeoStaffCreateRelationListWithoutPeo = {
  connect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoStaffCreateWithoutPeo>>;
};

export type PeoStaffCreateRelationListWithoutWhitelistedEmployers = {
  connect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoStaffCreateWithoutWhitelistedEmployers>>;
};

export type PeoStaffCreateRelationWithoutUser = {
  connect?: InputMaybe<PeoStaffWhereUnique>;
  create?: InputMaybe<PeoStaffCreateWithoutUser>;
};

export type PeoStaffCreateWithoutBlacklistedEmployees = {
  accessRestrictionMode?: InputMaybe<AccessRestrictionMode>;
  blacklistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffBlacklisted>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peo: PeoCreateRelationWithoutPeoStaffs;
  role: PeoStaffRole;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPeoStaff;
  whitelistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffWhitelisted>;
};

export type PeoStaffCreateWithoutBlacklistedEmployers = {
  accessRestrictionMode?: InputMaybe<AccessRestrictionMode>;
  blacklistedEmployees?: InputMaybe<EmployeeCreateRelationListWithoutPeoStaffBlacklisted>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peo: PeoCreateRelationWithoutPeoStaffs;
  role: PeoStaffRole;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPeoStaff;
  whitelistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffWhitelisted>;
};

export type PeoStaffCreateWithoutPeo = {
  accessRestrictionMode?: InputMaybe<AccessRestrictionMode>;
  blacklistedEmployees?: InputMaybe<EmployeeCreateRelationListWithoutPeoStaffBlacklisted>;
  blacklistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffBlacklisted>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: PeoStaffRole;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPeoStaff;
  whitelistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffWhitelisted>;
};

export type PeoStaffCreateWithoutUser = {
  accessRestrictionMode?: InputMaybe<AccessRestrictionMode>;
  blacklistedEmployees?: InputMaybe<EmployeeCreateRelationListWithoutPeoStaffBlacklisted>;
  blacklistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffBlacklisted>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peo: PeoCreateRelationWithoutPeoStaffs;
  role: PeoStaffRole;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  whitelistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffWhitelisted>;
};

export type PeoStaffCreateWithoutWhitelistedEmployers = {
  accessRestrictionMode?: InputMaybe<AccessRestrictionMode>;
  blacklistedEmployees?: InputMaybe<EmployeeCreateRelationListWithoutPeoStaffBlacklisted>;
  blacklistedEmployers?: InputMaybe<EmployerCreateRelationListWithoutPeoStaffBlacklisted>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peo: PeoCreateRelationWithoutPeoStaffs;
  role: PeoStaffRole;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPeoStaff;
};

export type PeoStaffOrderBy = {
  accessRestrictionMode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  peo?: InputMaybe<PeoOrderBy>;
  peoId?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
};

export const PeoStaffRole = {
  PeoAdmin: 'Peo_Admin',
  PeoManager: 'Peo_Manager',
  PeoSuperAdmin: 'Peo_Super_Admin',
} as const;

export type PeoStaffRole = (typeof PeoStaffRole)[keyof typeof PeoStaffRole];
export type PeoStaffRoleFilter = {
  equals?: InputMaybe<PeoStaffRole>;
  in?: InputMaybe<Array<PeoStaffRole>>;
  not?: InputMaybe<PeoStaffRoleFilter>;
  notIn?: InputMaybe<Array<PeoStaffRole>>;
};

export type PeoStaffUpdate = {
  blacklistedEmployees?: InputMaybe<EmployeeUpdateRelationListWithoutPeoStaffBlacklisted>;
  blacklistedEmployers?: InputMaybe<EmployerUpdateRelationListWithoutPeoStaffBlacklisted>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  whitelistedEmployers?: InputMaybe<EmployerUpdateRelationListWithoutPeoStaffWhitelisted>;
};

export type PeoStaffUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type PeoStaffUpdateRelationListWithoutBlacklistedEmployees = {
  connect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoStaffCreateWithoutBlacklistedEmployees>>;
  disconnect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  set?: InputMaybe<Array<PeoStaffWhereUnique>>;
};

export type PeoStaffUpdateRelationListWithoutBlacklistedEmployers = {
  connect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoStaffCreateWithoutBlacklistedEmployers>>;
  disconnect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  set?: InputMaybe<Array<PeoStaffWhereUnique>>;
};

export type PeoStaffUpdateRelationListWithoutPeo = {
  connect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoStaffCreateWithoutPeo>>;
  disconnect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  set?: InputMaybe<Array<PeoStaffWhereUnique>>;
};

export type PeoStaffUpdateRelationListWithoutWhitelistedEmployers = {
  connect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  create?: InputMaybe<Array<PeoStaffCreateWithoutWhitelistedEmployers>>;
  disconnect?: InputMaybe<Array<PeoStaffWhereUnique>>;
  set?: InputMaybe<Array<PeoStaffWhereUnique>>;
};

export type PeoStaffUpdateRelationWithoutUser = {
  connect?: InputMaybe<PeoStaffWhereUnique>;
  create?: InputMaybe<PeoStaffCreateWithoutUser>;
  disconnect?: InputMaybe<PeoStaffWhereUnique>;
  update?: InputMaybe<PeoStaffUpdateWithoutUser>;
};

export type PeoStaffUpdateWithoutUser = {
  blacklistedEmployees?: InputMaybe<EmployeeUpdateRelationListWithoutPeoStaffBlacklisted>;
  blacklistedEmployers?: InputMaybe<EmployerUpdateRelationListWithoutPeoStaffBlacklisted>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  whitelistedEmployers?: InputMaybe<EmployerUpdateRelationListWithoutPeoStaffWhitelisted>;
};

export type PeoStaffWhere = {
  AND?: InputMaybe<Array<PeoStaffWhere>>;
  NOT?: InputMaybe<Array<PeoStaffWhere>>;
  OR?: InputMaybe<Array<PeoStaffWhere>>;
  accessRestrictionMode?: InputMaybe<AccessRestrictionModeFilter>;
  blacklistedEmployees?: InputMaybe<EmployeeWhereRelationList>;
  blacklistedEmployers?: InputMaybe<EmployerWhereRelationList>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  peo?: InputMaybe<PeoWhere>;
  peoId?: InputMaybe<IdFilter>;
  role?: InputMaybe<PeoStaffRoleFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
  whitelistedEmployers?: InputMaybe<EmployerWhereRelationList>;
};

export type PeoStaffWhereRelationList = {
  every?: InputMaybe<PeoStaffWhere>;
  none?: InputMaybe<PeoStaffWhere>;
  some?: InputMaybe<PeoStaffWhere>;
};

export type PeoStaffWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type PeoUpdate = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffUpdateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoUpdateMany = {
  companyType?: InputMaybe<PeoCompanyTypeUpdate>;
  contactEmail?: InputMaybe<StringUpdate>;
  contactPhoneNumber?: InputMaybe<StringUpdate>;
  corporateStructure?: InputMaybe<StringUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  dashboardRevenueShareDataId?: InputMaybe<IdUpdate>;
  defaultDisclaimer?: InputMaybe<StringUpdate>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactiveUpdate>;
  disclaimer?: InputMaybe<StringUpdate>;
  displayName?: InputMaybe<StringUpdate>;
  employersLiveByDefaultSetAt?: InputMaybe<DateTimeUpdate>;
  fein?: InputMaybe<StringUpdate>;
  firstPinDigits?: InputMaybe<PinDigitUpdate>;
  headquartersId?: InputMaybe<IdUpdate>;
  industry?: InputMaybe<StringUpdate>;
  isMdmSynced?: InputMaybe<BooleanUpdate>;
  keepOwnRevenueShare?: InputMaybe<BooleanUpdate>;
  lastPinDigits?: InputMaybe<PinDigitUpdate>;
  logoId?: InputMaybe<IdUpdate>;
  mdmApiId?: InputMaybe<StringUpdate>;
  mdmSyncDate?: InputMaybe<DateTimeUpdate>;
  numberOfEmployees?: InputMaybe<IntUpdate>;
  peoPayrollProviderId?: InputMaybe<IdUpdate>;
  pinHint?: InputMaybe<StringUpdate>;
  pinLength?: InputMaybe<PinLengthUpdate>;
  requestAutoAccept?: InputMaybe<BooleanUpdate>;
  revenueShareReportEnabled?: InputMaybe<BooleanUpdate>;
  revenueShareSettingId?: InputMaybe<IdUpdate>;
  signUpMethod?: InputMaybe<SignUpMethodUpdate>;
  stripeAccountId?: InputMaybe<StringUpdate>;
  taxYearEndDate?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type PeoUpdateRelationListWithoutHeadquarters = {
  connect?: InputMaybe<Array<PeoWhereUnique>>;
  create?: InputMaybe<Array<PeoCreateWithoutHeadquarters>>;
  disconnect?: InputMaybe<Array<PeoWhereUnique>>;
  set?: InputMaybe<Array<PeoWhereUnique>>;
};

export type PeoUpdateRelationListWithoutLogo = {
  connect?: InputMaybe<Array<PeoWhereUnique>>;
  create?: InputMaybe<Array<PeoCreateWithoutLogo>>;
  disconnect?: InputMaybe<Array<PeoWhereUnique>>;
  set?: InputMaybe<Array<PeoWhereUnique>>;
};

export type PeoUpdateRelationListWithoutPeoPayrollProvider = {
  connect?: InputMaybe<Array<PeoWhereUnique>>;
  create?: InputMaybe<Array<PeoCreateWithoutPeoPayrollProvider>>;
  disconnect?: InputMaybe<Array<PeoWhereUnique>>;
  set?: InputMaybe<Array<PeoWhereUnique>>;
};

export type PeoUpdateRelationWithoutDashboardRevenueShareData = {
  connect?: InputMaybe<PeoWhereUnique>;
  create?: InputMaybe<PeoCreateWithoutDashboardRevenueShareData>;
  disconnect?: InputMaybe<PeoWhereUnique>;
  update?: InputMaybe<PeoUpdateWithoutDashboardRevenueShareData>;
};

export type PeoUpdateRelationWithoutEmployers = {
  connect?: InputMaybe<PeoWhereUnique>;
  create?: InputMaybe<PeoCreateWithoutEmployers>;
  disconnect?: InputMaybe<PeoWhereUnique>;
  update?: InputMaybe<PeoUpdateWithoutEmployers>;
};

export type PeoUpdateRelationWithoutPaymentTransactions = {
  connect?: InputMaybe<PeoWhereUnique>;
  create?: InputMaybe<PeoCreateWithoutPaymentTransactions>;
  disconnect?: InputMaybe<PeoWhereUnique>;
  update?: InputMaybe<PeoUpdateWithoutPaymentTransactions>;
};

export type PeoUpdateRelationWithoutRevenueShareSetting = {
  connect?: InputMaybe<PeoWhereUnique>;
  create?: InputMaybe<PeoCreateWithoutRevenueShareSetting>;
  disconnect?: InputMaybe<PeoWhereUnique>;
  update?: InputMaybe<PeoUpdateWithoutRevenueShareSetting>;
};

export type PeoUpdateWithoutDashboardRevenueShareData = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffUpdateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoUpdateWithoutEmployers = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffUpdateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoUpdateWithoutPaymentTransactions = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffUpdateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingUpdateRelationWithoutPeo>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoUpdateWithoutRevenueShareSetting = {
  companyType?: InputMaybe<PeoCompanyType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporateStructure?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumUpdateRelationWithoutPeo>;
  defaultDisclaimer?: InputMaybe<Scalars['String']['input']>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactive>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutPeo>;
  employersLiveByDefaultSetAt?: InputMaybe<Scalars['DateTime']['input']>;
  fein?: InputMaybe<Scalars['String']['input']>;
  firstPinDigits?: InputMaybe<PinDigit>;
  headquarters?: InputMaybe<AddressUpdateRelationWithoutPeos>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  keepOwnRevenueShare?: InputMaybe<Scalars['Boolean']['input']>;
  lastPinDigits?: InputMaybe<PinDigit>;
  logo?: InputMaybe<FileUpdateRelationWithoutPeoLogos>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutPeo>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutPeos>;
  peoStaffs?: InputMaybe<PeoStaffUpdateRelationListWithoutPeo>;
  pinHint?: InputMaybe<Scalars['String']['input']>;
  pinLength?: InputMaybe<PinLength>;
  requestAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  revenueShareReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  signUpMethod?: InputMaybe<SignUpMethod>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  taxYearEndDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PeoWhere = {
  AND?: InputMaybe<Array<PeoWhere>>;
  NOT?: InputMaybe<Array<PeoWhere>>;
  OR?: InputMaybe<Array<PeoWhere>>;
  companyType?: InputMaybe<PeoCompanyTypeFilter>;
  contactEmail?: InputMaybe<StringFilter>;
  contactPhoneNumber?: InputMaybe<StringFilter>;
  corporateStructure?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dashboardRevenueShareData?: InputMaybe<DashboardRevenueShareDatumWhere>;
  dashboardRevenueShareDataId?: InputMaybe<IdFilter>;
  defaultDisclaimer?: InputMaybe<StringFilter>;
  defaultRequestAutoAccept?: InputMaybe<ActiveInactiveFilter>;
  disclaimer?: InputMaybe<StringFilter>;
  displayName?: InputMaybe<StringFilter>;
  employers?: InputMaybe<EmployerWhereRelationList>;
  employersLiveByDefaultSetAt?: InputMaybe<DateTimeFilter>;
  fein?: InputMaybe<StringFilter>;
  firstPinDigits?: InputMaybe<PinDigitFilter>;
  headquarters?: InputMaybe<AddressWhere>;
  headquartersId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  industry?: InputMaybe<StringFilter>;
  isMdmSynced?: InputMaybe<BooleanFilter>;
  keepOwnRevenueShare?: InputMaybe<BooleanFilter>;
  lastPinDigits?: InputMaybe<PinDigitFilter>;
  logo?: InputMaybe<FileWhere>;
  logoId?: InputMaybe<IdFilter>;
  mdmApiId?: InputMaybe<StringFilter>;
  mdmSyncDate?: InputMaybe<DateTimeFilter>;
  numberOfEmployees?: InputMaybe<IntFilter>;
  paymentTransactions?: InputMaybe<PaymentTransactionWhereRelationList>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderWhere>;
  peoPayrollProviderId?: InputMaybe<IdFilter>;
  peoStaffs?: InputMaybe<PeoStaffWhereRelationList>;
  pinHint?: InputMaybe<StringFilter>;
  pinLength?: InputMaybe<PinLengthFilter>;
  requestAutoAccept?: InputMaybe<BooleanFilter>;
  revenueShareReportEnabled?: InputMaybe<BooleanFilter>;
  revenueShareSetting?: InputMaybe<RevenueShareSettingWhere>;
  revenueShareSettingId?: InputMaybe<IdFilter>;
  signUpMethod?: InputMaybe<SignUpMethodFilter>;
  stripeAccountId?: InputMaybe<StringFilter>;
  taxYearEndDate?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PeoWhereRelationList = {
  every?: InputMaybe<PeoWhere>;
  none?: InputMaybe<PeoWhere>;
  some?: InputMaybe<PeoWhere>;
};

export type PeoWhereUnique = {
  dashboardRevenueShareDataId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mdmApiId?: InputMaybe<Scalars['String']['input']>;
  revenueShareSettingId?: InputMaybe<Scalars['ID']['input']>;
};

export type PermissiblePurpose = {
  __typename?: 'PermissiblePurpose';
  createdAt: Scalars['DateTime']['output'];
  denialReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissiblePurposeReference: PermissiblePurposeReference;
  permissiblePurposeReferenceId: Scalars['ID']['output'];
  purposeValue?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<PermissiblePurposeStatus>;
  updatedAt: Scalars['DateTime']['output'];
  verificationRequestsCount: Scalars['Int']['output'];
  verificationRequestsList: Array<VerificationRequest>;
  verifier: Verifier;
  verifierId: Scalars['ID']['output'];
};

export type PermissiblePurposeVerificationRequestsCountArgs = {
  where?: InputMaybe<VerificationRequestWhere>;
};

export type PermissiblePurposeVerificationRequestsListArgs = {
  orderBy?: InputMaybe<Array<VerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerificationRequestWhere>;
};

export type PermissiblePurposeCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeReference: PermissiblePurposeReferenceCreateRelationWithoutPermissiblePurposes;
  purposeValue?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PermissiblePurposeStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutPermissiblePurpose>;
  verifier: VerifierCreateRelationWithoutPermissiblePurposes;
};

export type PermissiblePurposeCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeReferenceId: Scalars['ID']['input'];
  purposeValue?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PermissiblePurposeStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierId: Scalars['ID']['input'];
};

export type PermissiblePurposeCreateRelationListWithoutPermissiblePurposeReference = {
  connect?: InputMaybe<Array<PermissiblePurposeWhereUnique>>;
  create?: InputMaybe<Array<PermissiblePurposeCreateWithoutPermissiblePurposeReference>>;
};

export type PermissiblePurposeCreateRelationListWithoutVerifier = {
  connect?: InputMaybe<Array<PermissiblePurposeWhereUnique>>;
  create?: InputMaybe<Array<PermissiblePurposeCreateWithoutVerifier>>;
};

export type PermissiblePurposeCreateRelationWithoutVerificationRequests = {
  connect?: InputMaybe<PermissiblePurposeWhereUnique>;
  create?: InputMaybe<PermissiblePurposeCreateWithoutVerificationRequests>;
};

export type PermissiblePurposeCreateWithoutPermissiblePurposeReference = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  purposeValue?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PermissiblePurposeStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutPermissiblePurpose>;
  verifier: VerifierCreateRelationWithoutPermissiblePurposes;
};

export type PermissiblePurposeCreateWithoutVerificationRequests = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeReference: PermissiblePurposeReferenceCreateRelationWithoutPermissiblePurposes;
  purposeValue?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PermissiblePurposeStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifier: VerifierCreateRelationWithoutPermissiblePurposes;
};

export type PermissiblePurposeCreateWithoutVerifier = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeReference: PermissiblePurposeReferenceCreateRelationWithoutPermissiblePurposes;
  purposeValue?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PermissiblePurposeStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutPermissiblePurpose>;
};

export type PermissiblePurposeOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  denialReason?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  permissiblePurposeReference?: InputMaybe<PermissiblePurposeReferenceOrderBy>;
  permissiblePurposeReferenceId?: InputMaybe<SortOrder>;
  purposeValue?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verifier?: InputMaybe<VerifierOrderBy>;
  verifierId?: InputMaybe<SortOrder>;
};

export type PermissiblePurposeReference = {
  __typename?: 'PermissiblePurposeReference';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['Int']['output']>;
  permissiblePurposesCount: Scalars['Int']['output'];
  permissiblePurposesList: Array<PermissiblePurpose>;
  updatedAt: Scalars['DateTime']['output'];
  verifierType: VerifierType;
};

export type PermissiblePurposeReferencePermissiblePurposesCountArgs = {
  where?: InputMaybe<PermissiblePurposeWhere>;
};

export type PermissiblePurposeReferencePermissiblePurposesListArgs = {
  orderBy?: InputMaybe<Array<PermissiblePurposeOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PermissiblePurposeWhere>;
};

export type PermissiblePurposeReferenceCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  oldValue?: InputMaybe<Scalars['Int']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeCreateRelationListWithoutPermissiblePurposeReference>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierType?: InputMaybe<VerifierType>;
};

export type PermissiblePurposeReferenceCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  oldValue?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierType?: InputMaybe<VerifierType>;
};

export type PermissiblePurposeReferenceCreateRelationWithoutPermissiblePurposes = {
  connect?: InputMaybe<PermissiblePurposeReferenceWhereUnique>;
  create?: InputMaybe<PermissiblePurposeReferenceCreateWithoutPermissiblePurposes>;
};

export type PermissiblePurposeReferenceCreateWithoutPermissiblePurposes = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  oldValue?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierType?: InputMaybe<VerifierType>;
};

export type PermissiblePurposeReferenceOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrderInput>;
  oldValue?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verifierType?: InputMaybe<SortOrder>;
};

export type PermissiblePurposeReferenceUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  oldValue?: InputMaybe<Scalars['Int']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeUpdateRelationListWithoutPermissiblePurposeReference>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierType?: InputMaybe<VerifierType>;
};

export type PermissiblePurposeReferenceUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  label?: InputMaybe<StringUpdate>;
  oldValue?: InputMaybe<IntUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  verifierType?: InputMaybe<VerifierTypeUpdate>;
};

export type PermissiblePurposeReferenceUpdateRelationWithoutPermissiblePurposes = {
  connect?: InputMaybe<PermissiblePurposeReferenceWhereUnique>;
  create?: InputMaybe<PermissiblePurposeReferenceCreateWithoutPermissiblePurposes>;
  disconnect?: InputMaybe<PermissiblePurposeReferenceWhereUnique>;
  update?: InputMaybe<PermissiblePurposeReferenceUpdateWithoutPermissiblePurposes>;
};

export type PermissiblePurposeReferenceUpdateWithoutPermissiblePurposes = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  oldValue?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierType?: InputMaybe<VerifierType>;
};

export type PermissiblePurposeReferenceWhere = {
  AND?: InputMaybe<Array<PermissiblePurposeReferenceWhere>>;
  NOT?: InputMaybe<Array<PermissiblePurposeReferenceWhere>>;
  OR?: InputMaybe<Array<PermissiblePurposeReferenceWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  label?: InputMaybe<StringFilter>;
  oldValue?: InputMaybe<IntFilter>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeWhereRelationList>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verifierType?: InputMaybe<VerifierTypeFilter>;
};

export type PermissiblePurposeReferenceWhereUnique = {
  id: Scalars['ID']['input'];
};

export const PermissiblePurposeStatus = {
  Approved: 'Approved',
  Declined: 'Declined',
  Pending: 'Pending',
} as const;

export type PermissiblePurposeStatus =
  (typeof PermissiblePurposeStatus)[keyof typeof PermissiblePurposeStatus];
export type PermissiblePurposeStatusFilter = {
  equals?: InputMaybe<PermissiblePurposeStatus>;
  in?: InputMaybe<Array<PermissiblePurposeStatus>>;
  not?: InputMaybe<PermissiblePurposeStatusFilter>;
  notIn?: InputMaybe<Array<PermissiblePurposeStatus>>;
};

export type PermissiblePurposeStatusUpdate = {
  set?: InputMaybe<PermissiblePurposeStatus>;
};

export type PermissiblePurposeUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeReference?: InputMaybe<PermissiblePurposeReferenceUpdateRelationWithoutPermissiblePurposes>;
  purposeValue?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PermissiblePurposeStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutPermissiblePurpose>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutPermissiblePurposes>;
};

export type PermissiblePurposeUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  denialReason?: InputMaybe<StringUpdate>;
  permissiblePurposeReferenceId?: InputMaybe<IdUpdate>;
  purposeValue?: InputMaybe<IntUpdate>;
  status?: InputMaybe<PermissiblePurposeStatusUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  verifierId?: InputMaybe<IdUpdate>;
};

export type PermissiblePurposeUpdateRelationListWithoutPermissiblePurposeReference = {
  connect?: InputMaybe<Array<PermissiblePurposeWhereUnique>>;
  create?: InputMaybe<Array<PermissiblePurposeCreateWithoutPermissiblePurposeReference>>;
  disconnect?: InputMaybe<Array<PermissiblePurposeWhereUnique>>;
  set?: InputMaybe<Array<PermissiblePurposeWhereUnique>>;
};

export type PermissiblePurposeUpdateRelationListWithoutVerifier = {
  connect?: InputMaybe<Array<PermissiblePurposeWhereUnique>>;
  create?: InputMaybe<Array<PermissiblePurposeCreateWithoutVerifier>>;
  disconnect?: InputMaybe<Array<PermissiblePurposeWhereUnique>>;
  set?: InputMaybe<Array<PermissiblePurposeWhereUnique>>;
};

export type PermissiblePurposeUpdateRelationWithoutVerificationRequests = {
  connect?: InputMaybe<PermissiblePurposeWhereUnique>;
  create?: InputMaybe<PermissiblePurposeCreateWithoutVerificationRequests>;
  disconnect?: InputMaybe<PermissiblePurposeWhereUnique>;
  update?: InputMaybe<PermissiblePurposeUpdateWithoutVerificationRequests>;
};

export type PermissiblePurposeUpdateWithoutVerificationRequests = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeReference?: InputMaybe<PermissiblePurposeReferenceUpdateRelationWithoutPermissiblePurposes>;
  purposeValue?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PermissiblePurposeStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutPermissiblePurposes>;
};

export type PermissiblePurposeWhere = {
  AND?: InputMaybe<Array<PermissiblePurposeWhere>>;
  NOT?: InputMaybe<Array<PermissiblePurposeWhere>>;
  OR?: InputMaybe<Array<PermissiblePurposeWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  denialReason?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  permissiblePurposeReference?: InputMaybe<PermissiblePurposeReferenceWhere>;
  permissiblePurposeReferenceId?: InputMaybe<IdFilter>;
  purposeValue?: InputMaybe<IntFilter>;
  status?: InputMaybe<PermissiblePurposeStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verificationRequests?: InputMaybe<VerificationRequestWhereRelationList>;
  verifier?: InputMaybe<VerifierWhere>;
  verifierId?: InputMaybe<IdFilter>;
};

export type PermissiblePurposeWhereRelationList = {
  every?: InputMaybe<PermissiblePurposeWhere>;
  none?: InputMaybe<PermissiblePurposeWhere>;
  some?: InputMaybe<PermissiblePurposeWhere>;
};

export type PermissiblePurposeWhereUnique = {
  id: Scalars['ID']['input'];
};

export const PiiDataAccessActionType = {
  Downloaded: 'Downloaded',
  Viewed: 'Viewed',
} as const;

export type PiiDataAccessActionType =
  (typeof PiiDataAccessActionType)[keyof typeof PiiDataAccessActionType];
export type PiiDataAccessActionTypeFilter = {
  equals?: InputMaybe<PiiDataAccessActionType>;
  in?: InputMaybe<Array<PiiDataAccessActionType>>;
  not?: InputMaybe<PiiDataAccessActionTypeFilter>;
  notIn?: InputMaybe<Array<PiiDataAccessActionType>>;
};

export type PiiDataAccessActionTypeUpdate = {
  set?: InputMaybe<PiiDataAccessActionType>;
};

export const PiiDataAccessDataType = {
  Employee: 'Employee',
  IntegrationUsageLog: 'Integration_Usage_Log',
  Position: 'Position',
  VerificationReport: 'Verification_Report',
} as const;

export type PiiDataAccessDataType =
  (typeof PiiDataAccessDataType)[keyof typeof PiiDataAccessDataType];
export type PiiDataAccessDataTypeFilter = {
  equals?: InputMaybe<PiiDataAccessDataType>;
  in?: InputMaybe<Array<PiiDataAccessDataType>>;
  not?: InputMaybe<PiiDataAccessDataTypeFilter>;
  notIn?: InputMaybe<Array<PiiDataAccessDataType>>;
};

export type PiiDataAccessDataTypeUpdate = {
  set?: InputMaybe<PiiDataAccessDataType>;
};

export type PiiDataAccessLog = {
  __typename?: 'PiiDataAccessLog';
  accessedEmployee?: Maybe<Employee>;
  accessedEmployeeId?: Maybe<Scalars['ID']['output']>;
  accessedGeneratedReport?: Maybe<GeneratedReport>;
  accessedGeneratedReportId?: Maybe<Scalars['ID']['output']>;
  accessedPosition?: Maybe<Position>;
  accessedPositionId?: Maybe<Scalars['ID']['output']>;
  actionType: PiiDataAccessActionType;
  createdAt: Scalars['DateTime']['output'];
  dataType: PiiDataAccessDataType;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSelfAccess: Scalars['Boolean']['output'];
  mdmMetadata?: Maybe<Scalars['Json']['output']>;
  requesterEmail: Scalars['String']['output'];
  requesterUserId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PiiDataAccessLogCreate = {
  accessedEmployee?: InputMaybe<EmployeeCreateRelationWithoutPiiDataAccessLogs>;
  accessedGeneratedReport?: InputMaybe<GeneratedReportCreateRelationWithoutPiiDataAccessLogs>;
  accessedPosition?: InputMaybe<PositionCreateRelationWithoutPiiDataAccessLogs>;
  actionType: PiiDataAccessActionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataType: PiiDataAccessDataType;
  description?: InputMaybe<Scalars['String']['input']>;
  isSelfAccess?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  requesterEmail: Scalars['String']['input'];
  requesterUserId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PiiDataAccessLogCreateMany = {
  accessedEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  accessedGeneratedReportId?: InputMaybe<Scalars['ID']['input']>;
  accessedPositionId?: InputMaybe<Scalars['ID']['input']>;
  actionType: PiiDataAccessActionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataType: PiiDataAccessDataType;
  description?: InputMaybe<Scalars['String']['input']>;
  isSelfAccess?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  requesterEmail: Scalars['String']['input'];
  requesterUserId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PiiDataAccessLogCreateRelationListWithoutAccessedEmployee = {
  connect?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
  create?: InputMaybe<Array<PiiDataAccessLogCreateWithoutAccessedEmployee>>;
};

export type PiiDataAccessLogCreateRelationListWithoutAccessedGeneratedReport = {
  connect?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
  create?: InputMaybe<Array<PiiDataAccessLogCreateWithoutAccessedGeneratedReport>>;
};

export type PiiDataAccessLogCreateRelationListWithoutAccessedPosition = {
  connect?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
  create?: InputMaybe<Array<PiiDataAccessLogCreateWithoutAccessedPosition>>;
};

export type PiiDataAccessLogCreateWithoutAccessedEmployee = {
  accessedGeneratedReport?: InputMaybe<GeneratedReportCreateRelationWithoutPiiDataAccessLogs>;
  accessedPosition?: InputMaybe<PositionCreateRelationWithoutPiiDataAccessLogs>;
  actionType: PiiDataAccessActionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataType: PiiDataAccessDataType;
  description?: InputMaybe<Scalars['String']['input']>;
  isSelfAccess?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  requesterEmail: Scalars['String']['input'];
  requesterUserId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PiiDataAccessLogCreateWithoutAccessedGeneratedReport = {
  accessedEmployee?: InputMaybe<EmployeeCreateRelationWithoutPiiDataAccessLogs>;
  accessedPosition?: InputMaybe<PositionCreateRelationWithoutPiiDataAccessLogs>;
  actionType: PiiDataAccessActionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataType: PiiDataAccessDataType;
  description?: InputMaybe<Scalars['String']['input']>;
  isSelfAccess?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  requesterEmail: Scalars['String']['input'];
  requesterUserId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PiiDataAccessLogCreateWithoutAccessedPosition = {
  accessedEmployee?: InputMaybe<EmployeeCreateRelationWithoutPiiDataAccessLogs>;
  accessedGeneratedReport?: InputMaybe<GeneratedReportCreateRelationWithoutPiiDataAccessLogs>;
  actionType: PiiDataAccessActionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataType: PiiDataAccessDataType;
  description?: InputMaybe<Scalars['String']['input']>;
  isSelfAccess?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  requesterEmail: Scalars['String']['input'];
  requesterUserId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PiiDataAccessLogOrderBy = {
  accessedEmployee?: InputMaybe<EmployeeOrderBy>;
  accessedEmployeeId?: InputMaybe<SortOrderInput>;
  accessedGeneratedReport?: InputMaybe<GeneratedReportOrderBy>;
  accessedGeneratedReportId?: InputMaybe<SortOrderInput>;
  accessedPosition?: InputMaybe<PositionOrderBy>;
  accessedPositionId?: InputMaybe<SortOrderInput>;
  actionType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dataType?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isSelfAccess?: InputMaybe<SortOrder>;
  mdmMetadata?: InputMaybe<SortOrderInput>;
  requesterEmail?: InputMaybe<SortOrder>;
  requesterUserId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PiiDataAccessLogUpdate = {
  accessedEmployee?: InputMaybe<EmployeeUpdateRelationWithoutPiiDataAccessLogs>;
  accessedGeneratedReport?: InputMaybe<GeneratedReportUpdateRelationWithoutPiiDataAccessLogs>;
  accessedPosition?: InputMaybe<PositionUpdateRelationWithoutPiiDataAccessLogs>;
  actionType?: InputMaybe<PiiDataAccessActionType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dataType?: InputMaybe<PiiDataAccessDataType>;
  description?: InputMaybe<Scalars['String']['input']>;
  isSelfAccess?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  requesterEmail?: InputMaybe<Scalars['String']['input']>;
  requesterUserId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PiiDataAccessLogUpdateMany = {
  accessedEmployeeId?: InputMaybe<IdUpdate>;
  accessedGeneratedReportId?: InputMaybe<IdUpdate>;
  accessedPositionId?: InputMaybe<IdUpdate>;
  actionType?: InputMaybe<PiiDataAccessActionTypeUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  dataType?: InputMaybe<PiiDataAccessDataTypeUpdate>;
  description?: InputMaybe<StringUpdate>;
  isSelfAccess?: InputMaybe<BooleanUpdate>;
  mdmMetadata?: InputMaybe<JsonUpdate>;
  requesterEmail?: InputMaybe<StringUpdate>;
  requesterUserId?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type PiiDataAccessLogUpdateRelationListWithoutAccessedEmployee = {
  connect?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
  create?: InputMaybe<Array<PiiDataAccessLogCreateWithoutAccessedEmployee>>;
  disconnect?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
  set?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
};

export type PiiDataAccessLogUpdateRelationListWithoutAccessedGeneratedReport = {
  connect?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
  create?: InputMaybe<Array<PiiDataAccessLogCreateWithoutAccessedGeneratedReport>>;
  disconnect?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
  set?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
};

export type PiiDataAccessLogUpdateRelationListWithoutAccessedPosition = {
  connect?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
  create?: InputMaybe<Array<PiiDataAccessLogCreateWithoutAccessedPosition>>;
  disconnect?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
  set?: InputMaybe<Array<PiiDataAccessLogWhereUnique>>;
};

export type PiiDataAccessLogWhere = {
  AND?: InputMaybe<Array<PiiDataAccessLogWhere>>;
  NOT?: InputMaybe<Array<PiiDataAccessLogWhere>>;
  OR?: InputMaybe<Array<PiiDataAccessLogWhere>>;
  accessedEmployee?: InputMaybe<EmployeeWhere>;
  accessedEmployeeId?: InputMaybe<IdFilter>;
  accessedGeneratedReport?: InputMaybe<GeneratedReportWhere>;
  accessedGeneratedReportId?: InputMaybe<IdFilter>;
  accessedPosition?: InputMaybe<PositionWhere>;
  accessedPositionId?: InputMaybe<IdFilter>;
  actionType?: InputMaybe<PiiDataAccessActionTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataType?: InputMaybe<PiiDataAccessDataTypeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isSelfAccess?: InputMaybe<BooleanFilter>;
  requesterEmail?: InputMaybe<StringFilter>;
  requesterUserId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PiiDataAccessLogWhereRelationList = {
  every?: InputMaybe<PiiDataAccessLogWhere>;
  none?: InputMaybe<PiiDataAccessLogWhere>;
  some?: InputMaybe<PiiDataAccessLogWhere>;
};

export type PiiDataAccessLogWhereUnique = {
  id: Scalars['ID']['input'];
};

export const PinDigit = {
  BirthYear: 'Birth_Year',
  LastFourOfEmployeeId: 'Last_Four_Of_Employee_ID',
  LastFourOfSsn: 'Last_Four_Of_SSN',
} as const;

export type PinDigit = (typeof PinDigit)[keyof typeof PinDigit];
export type PinDigitFilter = {
  equals?: InputMaybe<PinDigit>;
  in?: InputMaybe<Array<PinDigit>>;
  not?: InputMaybe<PinDigitFilter>;
  notIn?: InputMaybe<Array<PinDigit>>;
};

export type PinDigitUpdate = {
  set?: InputMaybe<PinDigit>;
};

export const PinLength = {
  EightDigits: 'Eight_Digits',
  FourDigits: 'Four_Digits',
} as const;

export type PinLength = (typeof PinLength)[keyof typeof PinLength];
export type PinLengthFilter = {
  equals?: InputMaybe<PinLength>;
  in?: InputMaybe<Array<PinLength>>;
  not?: InputMaybe<PinLengthFilter>;
  notIn?: InputMaybe<Array<PinLength>>;
};

export type PinLengthUpdate = {
  set?: InputMaybe<PinLength>;
};

export type PlatformStaff = {
  __typename?: 'PlatformStaff';
  activityLogsCount: Scalars['Int']['output'];
  activityLogsList: Array<ActivityLog>;
  createdAt: Scalars['DateTime']['output'];
  employersHiddenCount: Scalars['Int']['output'];
  employersHiddenList: Array<Employer>;
  employersVisibleCount: Scalars['Int']['output'];
  employersVisibleList: Array<Employer>;
  id: Scalars['ID']['output'];
  isAbleToManagePlatformStaff: Scalars['Boolean']['output'];
  isFinancialReportAvailable: Scalars['Boolean']['output'];
  isRecipientForMonthlyFinancialReport: Scalars['Boolean']['output'];
  role: PlatformStaffRole;
  testVerificationRequestsCount: Scalars['Int']['output'];
  testVerificationRequestsList: Array<TestVerificationRequest>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  verificationRequestsCount: Scalars['Int']['output'];
  verificationRequestsList: Array<VerificationRequest>;
};

export type PlatformStaffActivityLogsCountArgs = {
  where?: InputMaybe<ActivityLogWhere>;
};

export type PlatformStaffActivityLogsListArgs = {
  orderBy?: InputMaybe<Array<ActivityLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityLogWhere>;
};

export type PlatformStaffEmployersHiddenCountArgs = {
  where?: InputMaybe<EmployerWhere>;
};

export type PlatformStaffEmployersHiddenListArgs = {
  orderBy?: InputMaybe<Array<EmployerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerWhere>;
};

export type PlatformStaffEmployersVisibleCountArgs = {
  where?: InputMaybe<EmployerWhere>;
};

export type PlatformStaffEmployersVisibleListArgs = {
  orderBy?: InputMaybe<Array<EmployerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerWhere>;
};

export type PlatformStaffTestVerificationRequestsCountArgs = {
  where?: InputMaybe<TestVerificationRequestWhere>;
};

export type PlatformStaffTestVerificationRequestsListArgs = {
  orderBy?: InputMaybe<Array<TestVerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestVerificationRequestWhere>;
};

export type PlatformStaffVerificationRequestsCountArgs = {
  where?: InputMaybe<VerificationRequestWhere>;
};

export type PlatformStaffVerificationRequestsListArgs = {
  orderBy?: InputMaybe<Array<VerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerificationRequestWhere>;
};

export type PlatformStaffCreate = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PlatformStaffRole>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPlatformStaff;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PlatformStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type PlatformStaffCreateRelationListWithoutEmployersHidden = {
  connect?: InputMaybe<Array<PlatformStaffWhereUnique>>;
  create?: InputMaybe<Array<PlatformStaffCreateWithoutEmployersHidden>>;
};

export type PlatformStaffCreateRelationListWithoutEmployersVisible = {
  connect?: InputMaybe<Array<PlatformStaffWhereUnique>>;
  create?: InputMaybe<Array<PlatformStaffCreateWithoutEmployersVisible>>;
};

export type PlatformStaffCreateRelationWithoutActivityLogs = {
  connect?: InputMaybe<PlatformStaffWhereUnique>;
  create?: InputMaybe<PlatformStaffCreateWithoutActivityLogs>;
};

export type PlatformStaffCreateRelationWithoutTestVerificationRequests = {
  connect?: InputMaybe<PlatformStaffWhereUnique>;
  create?: InputMaybe<PlatformStaffCreateWithoutTestVerificationRequests>;
};

export type PlatformStaffCreateRelationWithoutUser = {
  connect?: InputMaybe<PlatformStaffWhereUnique>;
  create?: InputMaybe<PlatformStaffCreateWithoutUser>;
};

export type PlatformStaffCreateRelationWithoutVerificationRequests = {
  connect?: InputMaybe<PlatformStaffWhereUnique>;
  create?: InputMaybe<PlatformStaffCreateWithoutVerificationRequests>;
};

export type PlatformStaffCreateWithoutActivityLogs = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PlatformStaffRole>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPlatformStaff;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffCreateWithoutEmployersHidden = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersVisible?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PlatformStaffRole>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPlatformStaff;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffCreateWithoutEmployersVisible = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffHidden>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PlatformStaffRole>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPlatformStaff;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffCreateWithoutTestVerificationRequests = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PlatformStaffRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPlatformStaff;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffCreateWithoutUser = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PlatformStaffRole>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffCreateWithoutVerificationRequests = {
  activityLogs?: InputMaybe<ActivityLogCreateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerCreateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PlatformStaffRole>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestCreateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutPlatformStaff;
};

export type PlatformStaffInviteItem = {
  email: Scalars['String']['input'];
};

export type PlatformStaffOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAbleToManagePlatformStaff?: InputMaybe<SortOrder>;
  isFinancialReportAvailable?: InputMaybe<SortOrder>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
};

export const PlatformStaffRole = {
  PlatformAdmin: 'Platform_Admin',
  PlatformManager: 'Platform_Manager',
} as const;

export type PlatformStaffRole = (typeof PlatformStaffRole)[keyof typeof PlatformStaffRole];
export type PlatformStaffRoleFilter = {
  equals?: InputMaybe<PlatformStaffRole>;
  in?: InputMaybe<Array<PlatformStaffRole>>;
  not?: InputMaybe<PlatformStaffRoleFilter>;
  notIn?: InputMaybe<Array<PlatformStaffRole>>;
};

export type PlatformStaffUpdate = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutPlatformStaff>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  isAbleToManagePlatformStaff?: InputMaybe<BooleanUpdate>;
  isFinancialReportAvailable?: InputMaybe<BooleanUpdate>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<BooleanUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  userId?: InputMaybe<IdUpdate>;
};

export type PlatformStaffUpdateRelationListWithoutEmployersHidden = {
  connect?: InputMaybe<Array<PlatformStaffWhereUnique>>;
  create?: InputMaybe<Array<PlatformStaffCreateWithoutEmployersHidden>>;
  disconnect?: InputMaybe<Array<PlatformStaffWhereUnique>>;
  set?: InputMaybe<Array<PlatformStaffWhereUnique>>;
};

export type PlatformStaffUpdateRelationListWithoutEmployersVisible = {
  connect?: InputMaybe<Array<PlatformStaffWhereUnique>>;
  create?: InputMaybe<Array<PlatformStaffCreateWithoutEmployersVisible>>;
  disconnect?: InputMaybe<Array<PlatformStaffWhereUnique>>;
  set?: InputMaybe<Array<PlatformStaffWhereUnique>>;
};

export type PlatformStaffUpdateRelationWithoutActivityLogs = {
  connect?: InputMaybe<PlatformStaffWhereUnique>;
  create?: InputMaybe<PlatformStaffCreateWithoutActivityLogs>;
  disconnect?: InputMaybe<PlatformStaffWhereUnique>;
  update?: InputMaybe<PlatformStaffUpdateWithoutActivityLogs>;
};

export type PlatformStaffUpdateRelationWithoutTestVerificationRequests = {
  connect?: InputMaybe<PlatformStaffWhereUnique>;
  create?: InputMaybe<PlatformStaffCreateWithoutTestVerificationRequests>;
  disconnect?: InputMaybe<PlatformStaffWhereUnique>;
  update?: InputMaybe<PlatformStaffUpdateWithoutTestVerificationRequests>;
};

export type PlatformStaffUpdateRelationWithoutUser = {
  connect?: InputMaybe<PlatformStaffWhereUnique>;
  create?: InputMaybe<PlatformStaffCreateWithoutUser>;
  disconnect?: InputMaybe<PlatformStaffWhereUnique>;
  update?: InputMaybe<PlatformStaffUpdateWithoutUser>;
};

export type PlatformStaffUpdateRelationWithoutVerificationRequests = {
  connect?: InputMaybe<PlatformStaffWhereUnique>;
  create?: InputMaybe<PlatformStaffCreateWithoutVerificationRequests>;
  disconnect?: InputMaybe<PlatformStaffWhereUnique>;
  update?: InputMaybe<PlatformStaffUpdateWithoutVerificationRequests>;
};

export type PlatformStaffUpdateWithoutActivityLogs = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutPlatformStaff>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffUpdateWithoutTestVerificationRequests = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutPlatformStaff>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffUpdateWithoutUser = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutPlatformStaff>;
};

export type PlatformStaffUpdateWithoutVerificationRequests = {
  activityLogs?: InputMaybe<ActivityLogUpdateRelationListWithoutPlatformStaff>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employersHidden?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffHidden>;
  employersVisible?: InputMaybe<EmployerUpdateRelationListWithoutPlatformStaffVisible>;
  isAbleToManagePlatformStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialReportAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<Scalars['Boolean']['input']>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestUpdateRelationListWithoutPlatformStaff>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutPlatformStaff>;
};

export type PlatformStaffWhere = {
  AND?: InputMaybe<Array<PlatformStaffWhere>>;
  NOT?: InputMaybe<Array<PlatformStaffWhere>>;
  OR?: InputMaybe<Array<PlatformStaffWhere>>;
  activityLogs?: InputMaybe<ActivityLogWhereRelationList>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employersHidden?: InputMaybe<EmployerWhereRelationList>;
  employersVisible?: InputMaybe<EmployerWhereRelationList>;
  id?: InputMaybe<IdFilter>;
  isAbleToManagePlatformStaff?: InputMaybe<BooleanFilter>;
  isFinancialReportAvailable?: InputMaybe<BooleanFilter>;
  isRecipientForMonthlyFinancialReport?: InputMaybe<BooleanFilter>;
  role?: InputMaybe<PlatformStaffRoleFilter>;
  testVerificationRequests?: InputMaybe<TestVerificationRequestWhereRelationList>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
  verificationRequests?: InputMaybe<VerificationRequestWhereRelationList>;
};

export type PlatformStaffWhereRelationList = {
  every?: InputMaybe<PlatformStaffWhere>;
  none?: InputMaybe<PlatformStaffWhere>;
  some?: InputMaybe<PlatformStaffWhere>;
};

export type PlatformStaffWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type Position = {
  __typename?: 'Position';
  birthDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  department?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  employeeMdmApiId?: Maybe<Scalars['String']['output']>;
  employer: Employer;
  employerId: Scalars['ID']['output'];
  employmentCity?: Maybe<Scalars['String']['output']>;
  employmentState?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<PositionEmploymentStatus>;
  employmentType?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  extEmployeeId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isMdmSynced?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mdmRoleRateOfPay?: Maybe<Scalars['String']['output']>;
  mdmSyncDate?: Maybe<Scalars['DateTime']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  originalEndDate?: Maybe<Scalars['Date']['output']>;
  originalHireDate?: Maybe<Scalars['Date']['output']>;
  personalEmail?: Maybe<Scalars['String']['output']>;
  piiDataAccessLogsCount: Scalars['Int']['output'];
  piiDataAccessLogsList: Array<PiiDataAccessLog>;
  positionFein?: Maybe<Scalars['String']['output']>;
  rateOfPayType?: Maybe<PositionRateOfPayType>;
  roleMdmApiId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  systemEndDate?: Maybe<Scalars['Date']['output']>;
  systemHireDate?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workLetterPdf?: Maybe<File>;
  workLetterPdfId?: Maybe<Scalars['ID']['output']>;
  workLocationAddress?: Maybe<Address>;
  workLocationAddressId?: Maybe<Scalars['ID']['output']>;
};

export type PositionPiiDataAccessLogsCountArgs = {
  where?: InputMaybe<PiiDataAccessLogWhere>;
};

export type PositionPiiDataAccessLogsListArgs = {
  orderBy?: InputMaybe<Array<PiiDataAccessLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PiiDataAccessLogWhere>;
};

export type PositionCompoundEmployeeMdmApiIdOriginalHireDateHireDate = {
  employeeMdmApiId: Scalars['String']['input'];
  hireDate: Scalars['Date']['input'];
  originalHireDate: Scalars['Date']['input'];
};

export type PositionCreate = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employee: EmployeeCreateRelationWithoutPositions;
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employer: EmployerCreateRelationWithoutPositions;
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedPosition>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLetterPdf?: InputMaybe<FileCreateRelationWithoutPositionWorkLetterPdfs>;
  workLocationAddress?: InputMaybe<AddressCreateRelationWithoutEmployeePosition>;
};

export type PositionCreateMany = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employerId: Scalars['ID']['input'];
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLetterPdfId?: InputMaybe<Scalars['ID']['input']>;
  workLocationAddressId?: InputMaybe<Scalars['ID']['input']>;
};

export type PositionCreateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<PositionWhereUnique>>;
  create?: InputMaybe<Array<PositionCreateWithoutEmployee>>;
};

export type PositionCreateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<PositionWhereUnique>>;
  create?: InputMaybe<Array<PositionCreateWithoutEmployer>>;
};

export type PositionCreateRelationListWithoutWorkLetterPdf = {
  connect?: InputMaybe<Array<PositionWhereUnique>>;
  create?: InputMaybe<Array<PositionCreateWithoutWorkLetterPdf>>;
};

export type PositionCreateRelationWithoutPiiDataAccessLogs = {
  connect?: InputMaybe<PositionWhereUnique>;
  create?: InputMaybe<PositionCreateWithoutPiiDataAccessLogs>;
};

export type PositionCreateRelationWithoutWorkLocationAddress = {
  connect?: InputMaybe<PositionWhereUnique>;
  create?: InputMaybe<PositionCreateWithoutWorkLocationAddress>;
};

export type PositionCreateWithoutEmployee = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employer: EmployerCreateRelationWithoutPositions;
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedPosition>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLetterPdf?: InputMaybe<FileCreateRelationWithoutPositionWorkLetterPdfs>;
  workLocationAddress?: InputMaybe<AddressCreateRelationWithoutEmployeePosition>;
};

export type PositionCreateWithoutEmployer = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employee: EmployeeCreateRelationWithoutPositions;
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedPosition>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLetterPdf?: InputMaybe<FileCreateRelationWithoutPositionWorkLetterPdfs>;
  workLocationAddress?: InputMaybe<AddressCreateRelationWithoutEmployeePosition>;
};

export type PositionCreateWithoutPiiDataAccessLogs = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employee: EmployeeCreateRelationWithoutPositions;
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employer: EmployerCreateRelationWithoutPositions;
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLetterPdf?: InputMaybe<FileCreateRelationWithoutPositionWorkLetterPdfs>;
  workLocationAddress?: InputMaybe<AddressCreateRelationWithoutEmployeePosition>;
};

export type PositionCreateWithoutWorkLetterPdf = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employee: EmployeeCreateRelationWithoutPositions;
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employer: EmployerCreateRelationWithoutPositions;
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedPosition>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLocationAddress?: InputMaybe<AddressCreateRelationWithoutEmployeePosition>;
};

export type PositionCreateWithoutWorkLocationAddress = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employee: EmployeeCreateRelationWithoutPositions;
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employer: EmployerCreateRelationWithoutPositions;
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogCreateRelationListWithoutAccessedPosition>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLetterPdf?: InputMaybe<FileCreateRelationWithoutPositionWorkLetterPdfs>;
};

export const PositionEmploymentStatus = {
  Active: 'Active',
  Deceased: 'Deceased',
  Fmla: 'FMLA',
  Ifmla: 'IFMLA',
  Inactive: 'Inactive',
  Intern: 'Intern',
  OnLeave: 'On_Leave',
  Retired: 'Retired',
  Separated: 'Separated',
  SeveredWithPay: 'Severed_With_Pay',
  TemporarilyInactive: 'Temporarily_Inactive',
  Terminated: 'Terminated',
} as const;

export type PositionEmploymentStatus =
  (typeof PositionEmploymentStatus)[keyof typeof PositionEmploymentStatus];
export type PositionEmploymentStatusFilter = {
  equals?: InputMaybe<PositionEmploymentStatus>;
  in?: InputMaybe<Array<PositionEmploymentStatus>>;
  not?: InputMaybe<PositionEmploymentStatusFilter>;
  notIn?: InputMaybe<Array<PositionEmploymentStatus>>;
};

export type PositionEmploymentStatusUpdate = {
  set?: InputMaybe<PositionEmploymentStatus>;
};

export type PositionOrderBy = {
  birthDate?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  department?: InputMaybe<SortOrderInput>;
  division?: InputMaybe<SortOrderInput>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employeeId?: InputMaybe<SortOrder>;
  employeeMdmApiId?: InputMaybe<SortOrderInput>;
  employer?: InputMaybe<EmployerOrderBy>;
  employerId?: InputMaybe<SortOrder>;
  employmentCity?: InputMaybe<SortOrderInput>;
  employmentState?: InputMaybe<SortOrderInput>;
  employmentStatus?: InputMaybe<SortOrderInput>;
  employmentType?: InputMaybe<SortOrderInput>;
  endDate?: InputMaybe<SortOrderInput>;
  extEmployeeId?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrderInput>;
  fullName?: InputMaybe<SortOrderInput>;
  hireDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isMdmSynced?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrderInput>;
  mdmRoleRateOfPay?: InputMaybe<SortOrderInput>;
  mdmSyncDate?: InputMaybe<SortOrderInput>;
  middleName?: InputMaybe<SortOrderInput>;
  originalEndDate?: InputMaybe<SortOrderInput>;
  originalHireDate?: InputMaybe<SortOrderInput>;
  personalEmail?: InputMaybe<SortOrderInput>;
  positionFein?: InputMaybe<SortOrderInput>;
  rateOfPayType?: InputMaybe<SortOrderInput>;
  roleMdmApiId?: InputMaybe<SortOrderInput>;
  startDate?: InputMaybe<SortOrderInput>;
  systemEndDate?: InputMaybe<SortOrderInput>;
  systemHireDate?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  workLetterPdf?: InputMaybe<FileOrderBy>;
  workLetterPdfId?: InputMaybe<SortOrderInput>;
  workLocationAddress?: InputMaybe<AddressOrderBy>;
  workLocationAddressId?: InputMaybe<SortOrderInput>;
};

export const PositionRateOfPayType = {
  Annually: 'Annually',
  Biweekly: 'Biweekly',
  Daily: 'Daily',
  Hourly: 'Hourly',
  Monthly: 'Monthly',
  SemiMonthly: 'Semi_Monthly',
  Weekly: 'Weekly',
} as const;

export type PositionRateOfPayType =
  (typeof PositionRateOfPayType)[keyof typeof PositionRateOfPayType];
export type PositionRateOfPayTypeFilter = {
  equals?: InputMaybe<PositionRateOfPayType>;
  in?: InputMaybe<Array<PositionRateOfPayType>>;
  not?: InputMaybe<PositionRateOfPayTypeFilter>;
  notIn?: InputMaybe<Array<PositionRateOfPayType>>;
};

export type PositionRateOfPayTypeUpdate = {
  set?: InputMaybe<PositionRateOfPayType>;
};

export type PositionUpdate = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutPositions>;
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutPositions>;
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedPosition>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLetterPdf?: InputMaybe<FileUpdateRelationWithoutPositionWorkLetterPdfs>;
  workLocationAddress?: InputMaybe<AddressUpdateRelationWithoutEmployeePosition>;
};

export type PositionUpdateMany = {
  birthDate?: InputMaybe<DateUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  department?: InputMaybe<StringUpdate>;
  division?: InputMaybe<StringUpdate>;
  employeeId?: InputMaybe<IdUpdate>;
  employeeMdmApiId?: InputMaybe<StringUpdate>;
  employerId?: InputMaybe<IdUpdate>;
  employmentCity?: InputMaybe<StringUpdate>;
  employmentState?: InputMaybe<StringUpdate>;
  employmentStatus?: InputMaybe<PositionEmploymentStatusUpdate>;
  employmentType?: InputMaybe<StringUpdate>;
  endDate?: InputMaybe<DateUpdate>;
  extEmployeeId?: InputMaybe<StringUpdate>;
  firstName?: InputMaybe<StringUpdate>;
  fullName?: InputMaybe<StringUpdate>;
  hireDate?: InputMaybe<DateUpdate>;
  isMdmSynced?: InputMaybe<BooleanUpdate>;
  lastName?: InputMaybe<StringUpdate>;
  mdmRoleRateOfPay?: InputMaybe<StringUpdate>;
  mdmSyncDate?: InputMaybe<DateTimeUpdate>;
  middleName?: InputMaybe<StringUpdate>;
  originalEndDate?: InputMaybe<DateUpdate>;
  originalHireDate?: InputMaybe<DateUpdate>;
  personalEmail?: InputMaybe<StringUpdate>;
  positionFein?: InputMaybe<StringUpdate>;
  rateOfPayType?: InputMaybe<PositionRateOfPayTypeUpdate>;
  roleMdmApiId?: InputMaybe<StringUpdate>;
  startDate?: InputMaybe<DateUpdate>;
  systemEndDate?: InputMaybe<DateUpdate>;
  systemHireDate?: InputMaybe<DateUpdate>;
  title?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  workLetterPdfId?: InputMaybe<IdUpdate>;
  workLocationAddressId?: InputMaybe<IdUpdate>;
};

export type PositionUpdateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<PositionWhereUnique>>;
  create?: InputMaybe<Array<PositionCreateWithoutEmployee>>;
  disconnect?: InputMaybe<Array<PositionWhereUnique>>;
  set?: InputMaybe<Array<PositionWhereUnique>>;
};

export type PositionUpdateRelationListWithoutEmployer = {
  connect?: InputMaybe<Array<PositionWhereUnique>>;
  create?: InputMaybe<Array<PositionCreateWithoutEmployer>>;
  disconnect?: InputMaybe<Array<PositionWhereUnique>>;
  set?: InputMaybe<Array<PositionWhereUnique>>;
};

export type PositionUpdateRelationListWithoutWorkLetterPdf = {
  connect?: InputMaybe<Array<PositionWhereUnique>>;
  create?: InputMaybe<Array<PositionCreateWithoutWorkLetterPdf>>;
  disconnect?: InputMaybe<Array<PositionWhereUnique>>;
  set?: InputMaybe<Array<PositionWhereUnique>>;
};

export type PositionUpdateRelationWithoutPiiDataAccessLogs = {
  connect?: InputMaybe<PositionWhereUnique>;
  create?: InputMaybe<PositionCreateWithoutPiiDataAccessLogs>;
  disconnect?: InputMaybe<PositionWhereUnique>;
  update?: InputMaybe<PositionUpdateWithoutPiiDataAccessLogs>;
};

export type PositionUpdateRelationWithoutWorkLocationAddress = {
  connect?: InputMaybe<PositionWhereUnique>;
  create?: InputMaybe<PositionCreateWithoutWorkLocationAddress>;
  disconnect?: InputMaybe<PositionWhereUnique>;
  update?: InputMaybe<PositionUpdateWithoutWorkLocationAddress>;
};

export type PositionUpdateWithoutPiiDataAccessLogs = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutPositions>;
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutPositions>;
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLetterPdf?: InputMaybe<FileUpdateRelationWithoutPositionWorkLetterPdfs>;
  workLocationAddress?: InputMaybe<AddressUpdateRelationWithoutEmployeePosition>;
};

export type PositionUpdateWithoutWorkLocationAddress = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutPositions>;
  employeeMdmApiId?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutPositions>;
  employmentCity?: InputMaybe<Scalars['String']['input']>;
  employmentState?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<PositionEmploymentStatus>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  extEmployeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Date']['input']>;
  isMdmSynced?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdmRoleRateOfPay?: InputMaybe<Scalars['String']['input']>;
  mdmSyncDate?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  originalEndDate?: InputMaybe<Scalars['Date']['input']>;
  originalHireDate?: InputMaybe<Scalars['Date']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogUpdateRelationListWithoutAccessedPosition>;
  positionFein?: InputMaybe<Scalars['String']['input']>;
  rateOfPayType?: InputMaybe<PositionRateOfPayType>;
  roleMdmApiId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  systemEndDate?: InputMaybe<Scalars['Date']['input']>;
  systemHireDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workLetterPdf?: InputMaybe<FileUpdateRelationWithoutPositionWorkLetterPdfs>;
};

export type PositionWhere = {
  AND?: InputMaybe<Array<PositionWhere>>;
  NOT?: InputMaybe<Array<PositionWhere>>;
  OR?: InputMaybe<Array<PositionWhere>>;
  birthDate?: InputMaybe<DateFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  department?: InputMaybe<StringFilter>;
  division?: InputMaybe<StringFilter>;
  employee?: InputMaybe<EmployeeWhere>;
  employeeId?: InputMaybe<IdFilter>;
  employeeMdmApiId?: InputMaybe<StringFilter>;
  employer?: InputMaybe<EmployerWhere>;
  employerId?: InputMaybe<IdFilter>;
  employmentCity?: InputMaybe<StringFilter>;
  employmentState?: InputMaybe<StringFilter>;
  employmentStatus?: InputMaybe<PositionEmploymentStatusFilter>;
  employmentType?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateFilter>;
  extEmployeeId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  hireDate?: InputMaybe<DateFilter>;
  id?: InputMaybe<IdFilter>;
  isMdmSynced?: InputMaybe<BooleanFilter>;
  lastName?: InputMaybe<StringFilter>;
  mdmRoleRateOfPay?: InputMaybe<StringFilter>;
  mdmSyncDate?: InputMaybe<DateTimeFilter>;
  middleName?: InputMaybe<StringFilter>;
  originalEndDate?: InputMaybe<DateFilter>;
  originalHireDate?: InputMaybe<DateFilter>;
  personalEmail?: InputMaybe<StringFilter>;
  piiDataAccessLogs?: InputMaybe<PiiDataAccessLogWhereRelationList>;
  positionFein?: InputMaybe<StringFilter>;
  rateOfPayType?: InputMaybe<PositionRateOfPayTypeFilter>;
  roleMdmApiId?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateFilter>;
  systemEndDate?: InputMaybe<DateFilter>;
  systemHireDate?: InputMaybe<DateFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workLetterPdf?: InputMaybe<FileWhere>;
  workLetterPdfId?: InputMaybe<IdFilter>;
  workLocationAddress?: InputMaybe<AddressWhere>;
  workLocationAddressId?: InputMaybe<IdFilter>;
};

export type PositionWhereRelationList = {
  every?: InputMaybe<PositionWhere>;
  none?: InputMaybe<PositionWhere>;
  some?: InputMaybe<PositionWhere>;
};

export type PositionWhereUnique = {
  employeeMdmApiId_originalHireDate_hireDate?: InputMaybe<PositionCompoundEmployeeMdmApiIdOriginalHireDateHireDate>;
  id?: InputMaybe<Scalars['ID']['input']>;
  workLocationAddressId?: InputMaybe<Scalars['ID']['input']>;
};

export type Query = {
  __typename?: 'Query';
  activityLog?: Maybe<ActivityLog>;
  activityLogCount: Scalars['Int']['output'];
  activityLogList: Array<ActivityLog>;
  address?: Maybe<Address>;
  addressCount: Scalars['Int']['output'];
  addressList: Array<Address>;
  apiToken?: Maybe<ApiToken>;
  apiTokenCount: Scalars['Int']['output'];
  apiTokenList: Array<ApiToken>;
  apiVerificationRequest?: Maybe<ApiVerificationRequest>;
  apiVerificationRequestCount: Scalars['Int']['output'];
  apiVerificationRequestList: Array<ApiVerificationRequest>;
  attestation?: Maybe<Attestation>;
  attestationCount: Scalars['Int']['output'];
  attestationList: Array<Attestation>;
  buildVersion?: Maybe<Scalars['String']['output']>;
  checkDeletionClearVerifyStaff: CheckDeletionClearVerifyStaffResponse;
  checkDeletionEmployeeUser: CheckDeletionEmployeeUserResponse;
  checkDeletionEmployerStaff: CheckDeletionEmployerStaffResponse;
  checkDeletionPeoStaff: CheckDeletionPeoStaffResponse;
  checkDeletionVerifier: CheckDeletionVerifierResponse;
  checkDeletionVerifierStaff: CheckDeletionVerifierStaffResponse;
  checkEmailSuppressions: SuccessResponse;
  checkEmployee?: Maybe<CheckEmployeeResponse>;
  checkIfUserEmailChangeExist: SuccessResponse;
  checkIsAdditionalVerifierAdmin: CheckIsAdditionalVerifierAdminResponse;
  checkPasswordRequestExist: SuccessResponse;
  cognitoGetCurrentUserAuthStatus: CognitoGetCurrentUserAuthStatusResponse;
  cognitoGetSsoUrl: Scalars['String']['output'];
  cognitoGetUserMfaStatus: CognitoGetUserMfaStatusResponse;
  currentUser?: Maybe<CurrentUserResponse>;
  dashboardRevenueShareDatum?: Maybe<DashboardRevenueShareData>;
  dashboardRevenueShareDatumCount: Scalars['Int']['output'];
  dashboardRevenueShareDatumList: Array<DashboardRevenueShareData>;
  dataDispute?: Maybe<DataDispute>;
  dataDisputeCount: Scalars['Int']['output'];
  dataDisputeItem?: Maybe<DataDisputeItem>;
  dataDisputeItemCount: Scalars['Int']['output'];
  dataDisputeItemList: Array<DataDisputeItem>;
  dataDisputeList: Array<DataDispute>;
  disclaimer?: Maybe<Disclaimer>;
  disclaimerCount: Scalars['Int']['output'];
  disclaimerList: Array<Disclaimer>;
  employee?: Maybe<Employee>;
  employeeAnnualFreeReport?: Maybe<EmployeeAnnualFreeReport>;
  employeeAnnualFreeReportCount: Scalars['Int']['output'];
  employeeAnnualFreeReportList: Array<EmployeeAnnualFreeReport>;
  employeeCount: Scalars['Int']['output'];
  employeeList: Array<Employee>;
  employeeNote?: Maybe<EmployeeNote>;
  employeeNoteCount: Scalars['Int']['output'];
  employeeNoteList: Array<EmployeeNote>;
  employeeWorkLetter?: Maybe<EmployeeWorkLetter>;
  employeeWorkLetterCount: Scalars['Int']['output'];
  employeeWorkLetterList: Array<EmployeeWorkLetter>;
  employer?: Maybe<Employer>;
  employerCount: Scalars['Int']['output'];
  employerList: Array<Employer>;
  employerStaff?: Maybe<EmployerStaff>;
  employerStaffCount: Scalars['Int']['output'];
  employerStaffList: Array<EmployerStaff>;
  exportIntegrationUsageLogs: Scalars['String']['output'];
  file?: Maybe<File>;
  fileCount: Scalars['Int']['output'];
  fileList: Array<File>;
  generatedReport?: Maybe<GeneratedReport>;
  generatedReportCount: Scalars['Int']['output'];
  generatedReportList: Array<GeneratedReport>;
  getActivityLogsList: Array<ActivityLogsListItem>;
  getAnnualFreeReportData?: Maybe<AnnualFreeReportData>;
  getDashboardCVAdminVerifiersData: DashboardCvAdminVerifiersDataResponse;
  getDashboardCVRevenueByVerificationType: Array<DashboardCvRevenueByVerificationTypeItem>;
  getDashboardDataDisputeItemsCountGroupedByStatus: Array<DashboardDataDisputeItemsCountGroupByStatus>;
  getDashboardEmployeeUserStats: DashboardEmployeeUserStatsResponse;
  getDashboardLastUploadRoles?: Maybe<LastUploadRolesResponse>;
  getDashboardPlatformAdminFinancialData: DashboardPlatformAdminFinancialDataResponse;
  getDashboardPlatformAdminRevenueDistributions: Array<DashboardPlatformAdminRevenueDistributionItem>;
  getDashboardPlatformAdminTopVerifiersData: Array<DashboardPlatformAdminTopVerifierData>;
  getDashboardRecordsActivity: DashboardRecordsActivityResponse;
  getDashboardReportAndRevenue: DashboardReportAndRevenueResponse;
  getDashboardRevenueShareAccountsCount: Scalars['Int']['output'];
  getDashboardUsageReports: Array<DashboardUsageReportItem>;
  getDashboardVerificationRequestsCountGroupedByIsManual: Array<DashboardVerificationRequestsCountGroupByIsManual>;
  getDashboardVerificationRequestsCountGroupedByStatus: Array<DashboardVerificationRequestsCountGroupByStatus>;
  getDashboardVerifiersCountGroupedByCredentialStatus: Array<DashboardVerifiersCountGroupByCredentialStatus>;
  getDashboardWorkLetterUsage: Array<DashboardWorkLetterUsageItem>;
  getEmailActivity: GetEmailActivityResponse;
  getEmployeeDataForMyData: EmployeeData;
  getEmployeeDataOnEmployeeSearchForAdmin: EmployeeDataSearchResponse;
  getEmployeeDataOnEmployeeSearchForEmployerScope: EmployeeDataSearchResponse;
  getEmployeeDataOnEmployeeSignup: EmployeeData;
  getEmployeeDataOnEmployeeSignupByInvite: EmployeeData;
  getEmployeeForPeoAccessSearch?: Maybe<EmployeeForPeoAccessSearch>;
  getEmployeeInfoForVerificationRequest?: Maybe<EmployeeInfoForVerificationRequest>;
  getEmployeeInviteEmailOptionsForAdmin: Array<EmployeeInviteEmailOption>;
  getEmployeeInviteEmailOptionsForEmployerScope: Array<EmployeeInviteEmailOption>;
  getEmployeeInviteId?: Maybe<Scalars['ID']['output']>;
  getEmployeeInviteLinkScopeForAdmin?: Maybe<EmployeeDataInviteLinkScope>;
  getEmployerBasicInfo?: Maybe<GetEmployerBasicInfoResponse>;
  getEmployersListForVerificationRequest: GetEmployersListForVerificationRequestResponse;
  getEmployersListForVerificationRequestByEmployeeData: GetEmployersListForVerificationRequestByEmployeeDataResponse;
  getEmployersListForVerificationRequestForMyVerify: GetEmployersListForVerificationRequestResponseForMyVerify;
  getEmployersListForWorkLetter: GetEmployersListForWorkLetterResponse;
  getEmployersListForWorkLetterForAdmin: GetEmployersListForWorkLetterForAdminResponse;
  getEmploymentDataForEmployeeMyData?: Maybe<EmploymentData>;
  getEmploymentDataForSearchedEmployee?: Maybe<EmploymentData>;
  getEmploymentDataOnEmployeeSignup?: Maybe<EmploymentData>;
  getEmploymentDataOnEmployeeSignupByInvite?: Maybe<EmploymentData>;
  getExistingVerificationRequestTotalCharge: GetExistingVerificationRequestTotalChargeResponse;
  getGeneratedReportsMeta: Array<GeneratedReportMeta>;
  getInboxItemsList: Array<InboxListItem>;
  getInboxItemsRequests: GetInboxItemsRequestsQueryResponse;
  getInboxListItemsCount: Scalars['Int']['output'];
  getIntegrationUsageLogStats: IntegrationUsageLogStats;
  getInvite: GetInviteResponse;
  getIsEmailFree: GetIsEmailFreeQueryResponse;
  getMaintenanceStatus: MaintenanceStatusResponse;
  getMiddeskStatus: GetMiddeskStatusResponse;
  getMyVerifyRequestTotalCharge: GetVerificationRequestTotalChargeResponse;
  getPartnerships: GetPartnershipsResponse;
  getPeoBasicInfo?: Maybe<GetPeoBasicInfoResponse>;
  getPeoPayrollProviderBasicInfo?: Maybe<GetPeoPayrollProviderBasicInfoResponse>;
  getPeoStaffAccessInfo?: Maybe<PeoStaffAccessInfo>;
  getRevenueShareSettingsListWithStripeStatuses: GetRevenueShareSettingsListWithStripeStatusesResponse;
  getVerificationRequestTotalCharge: GetVerificationRequestTotalChargeResponse;
  getVerificationRequestsListForReport: Array<VerificationRequestForReport>;
  getVerifierByEmailDomain: GetVerifierByEmailDomainQueryResponse;
  getVerifierInfoByApiVerificationRequest?: Maybe<VerifierInfoByApiVerificationRequest>;
  getVerifierInfoByVerificationRequest: VerifierInfoByVerificationRequest;
  getVerifiersBasicList: Array<VerifierBasicItem>;
  hrLogicsGetUnifiedReportingInfo: HrLogicsGetUnifiedReportingInfoQueryResponse;
  inboxItem?: Maybe<InboxItem>;
  inboxItemCount: Scalars['Int']['output'];
  inboxItemList: Array<InboxItem>;
  inboxItemUnreadStatus?: Maybe<InboxItemUnreadStatus>;
  inboxItemUnreadStatusCount: Scalars['Int']['output'];
  inboxItemUnreadStatusList: Array<InboxItemUnreadStatus>;
  initialBilling?: Maybe<InitialBilling>;
  initialBillingCount: Scalars['Int']['output'];
  initialBillingList: Array<InitialBilling>;
  integration?: Maybe<Integration>;
  integrationCount: Scalars['Int']['output'];
  integrationList: Array<Integration>;
  integrationUsageLog?: Maybe<IntegrationUsageLog>;
  integrationUsageLogCount: Scalars['Int']['output'];
  integrationUsageLogList: Array<IntegrationUsageLog>;
  invite?: Maybe<Invite>;
  inviteCount: Scalars['Int']['output'];
  inviteList: Array<Invite>;
  mdmMdaTest: SuccessResponse;
  paymentTransaction?: Maybe<PaymentTransaction>;
  paymentTransactionCount: Scalars['Int']['output'];
  paymentTransactionList: Array<PaymentTransaction>;
  peo?: Maybe<Peo>;
  peoCount: Scalars['Int']['output'];
  peoList: Array<Peo>;
  peoPayrollProvider?: Maybe<PeoPayrollProvider>;
  peoPayrollProviderCount: Scalars['Int']['output'];
  peoPayrollProviderList: Array<PeoPayrollProvider>;
  peoPayrollProviderStaff?: Maybe<PeoPayrollProviderStaff>;
  peoPayrollProviderStaffCount: Scalars['Int']['output'];
  peoPayrollProviderStaffList: Array<PeoPayrollProviderStaff>;
  peoStaff?: Maybe<PeoStaff>;
  peoStaffCount: Scalars['Int']['output'];
  peoStaffList: Array<PeoStaff>;
  permissiblePurpose?: Maybe<PermissiblePurpose>;
  permissiblePurposeCount: Scalars['Int']['output'];
  permissiblePurposeList: Array<PermissiblePurpose>;
  permissiblePurposeReference?: Maybe<PermissiblePurposeReference>;
  permissiblePurposeReferenceCount: Scalars['Int']['output'];
  permissiblePurposeReferenceList: Array<PermissiblePurposeReference>;
  piiDataAccessLog?: Maybe<PiiDataAccessLog>;
  piiDataAccessLogCount: Scalars['Int']['output'];
  piiDataAccessLogList: Array<PiiDataAccessLog>;
  platformStaff?: Maybe<PlatformStaff>;
  platformStaffCount: Scalars['Int']['output'];
  platformStaffList: Array<PlatformStaff>;
  position?: Maybe<Position>;
  positionCount: Scalars['Int']['output'];
  positionList: Array<Position>;
  resource?: Maybe<Resource>;
  resourceCount: Scalars['Int']['output'];
  resourceList: Array<Resource>;
  revenueShareSetting?: Maybe<RevenueShareSetting>;
  revenueShareSettingCount: Scalars['Int']['output'];
  revenueShareSettingList: Array<RevenueShareSetting>;
  searchEmployeesForAdmin: Array<EmployeeSearchMatch>;
  searchEmployeesForEmployerScope: Array<EmployeeSearchMatch>;
  state?: Maybe<State>;
  stateCount: Scalars['Int']['output'];
  stateList: Array<State>;
  stripeGetAccountInfo: StripeGetAccountInfoResponse;
  stripeGetCustomerPaymentMethods?: Maybe<StripeGetCustomerPaymentMethodsResponse>;
  stripeGetPaymentHistory: StripeGetPaymentHistoryResponse;
  stripeGetPaymentIntentForVerificationRequest: StripeGetPaymentIntentForVerificationRequestResponse;
  stripeRetrieveStatus: StripeRetrieveStatusResponse;
  taskInfo?: Maybe<TaskInfo>;
  testVerificationRequest?: Maybe<TestVerificationRequest>;
  testVerificationRequestCount: Scalars['Int']['output'];
  testVerificationRequestList: Array<TestVerificationRequest>;
  user?: Maybe<User>;
  userCount: Scalars['Int']['output'];
  userEmailChangeRequest?: Maybe<UserEmailChangeRequest>;
  userEmailChangeRequestCount: Scalars['Int']['output'];
  userEmailChangeRequestList: Array<UserEmailChangeRequest>;
  userList: Array<User>;
  userPasswordChangeRequest?: Maybe<UserPasswordChangeRequest>;
  userPasswordChangeRequestCount: Scalars['Int']['output'];
  userPasswordChangeRequestList: Array<UserPasswordChangeRequest>;
  userPasswordResetRequest?: Maybe<UserPasswordResetRequest>;
  userPasswordResetRequestCount: Scalars['Int']['output'];
  userPasswordResetRequestList: Array<UserPasswordResetRequest>;
  validateSignupEmployeeData: ValidateSignupEmployeeDataResponse;
  validateSignupEmployeePinOrSsn: ValidateSignupEmployeePinOrSsnResponse;
  verificationRequest?: Maybe<VerificationRequest>;
  verificationRequestCount: Scalars['Int']['output'];
  verificationRequestList: Array<VerificationRequest>;
  verifier?: Maybe<Verifier>;
  verifierBilling?: Maybe<VerifierBilling>;
  verifierBillingCount: Scalars['Int']['output'];
  verifierBillingList: Array<VerifierBilling>;
  verifierCount: Scalars['Int']['output'];
  verifierList: Array<Verifier>;
  verifierStaff?: Maybe<VerifierStaff>;
  verifierStaffCount: Scalars['Int']['output'];
  verifierStaffList: Array<VerifierStaff>;
  verifyEmailConfirmationCode: SuccessResponse;
};

export type QueryActivityLogArgs = {
  where: ActivityLogWhereUnique;
};

export type QueryActivityLogCountArgs = {
  where?: InputMaybe<ActivityLogWhere>;
};

export type QueryActivityLogListArgs = {
  orderBy?: InputMaybe<Array<ActivityLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityLogWhere>;
};

export type QueryAddressArgs = {
  where: AddressWhereUnique;
};

export type QueryAddressCountArgs = {
  where?: InputMaybe<AddressWhere>;
};

export type QueryAddressListArgs = {
  orderBy?: InputMaybe<Array<AddressOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhere>;
};

export type QueryApiTokenArgs = {
  where: ApiTokenWhereUnique;
};

export type QueryApiTokenCountArgs = {
  where?: InputMaybe<ApiTokenWhere>;
};

export type QueryApiTokenListArgs = {
  orderBy?: InputMaybe<Array<ApiTokenOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiTokenWhere>;
};

export type QueryApiVerificationRequestArgs = {
  where: ApiVerificationRequestWhereUnique;
};

export type QueryApiVerificationRequestCountArgs = {
  where?: InputMaybe<ApiVerificationRequestWhere>;
};

export type QueryApiVerificationRequestListArgs = {
  orderBy?: InputMaybe<Array<ApiVerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiVerificationRequestWhere>;
};

export type QueryAttestationArgs = {
  where: AttestationWhereUnique;
};

export type QueryAttestationCountArgs = {
  where?: InputMaybe<AttestationWhere>;
};

export type QueryAttestationListArgs = {
  orderBy?: InputMaybe<Array<AttestationOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AttestationWhere>;
};

export type QueryCheckDeletionClearVerifyStaffArgs = {
  platformStaffId: Scalars['ID']['input'];
};

export type QueryCheckDeletionEmployeeUserArgs = {
  employeeId: Scalars['ID']['input'];
};

export type QueryCheckDeletionEmployerStaffArgs = {
  employerStaffId: Scalars['ID']['input'];
};

export type QueryCheckDeletionPeoStaffArgs = {
  peoStaffId: Scalars['ID']['input'];
};

export type QueryCheckDeletionVerifierArgs = {
  verifierId: Scalars['ID']['input'];
};

export type QueryCheckDeletionVerifierStaffArgs = {
  verifierStaffId: Scalars['ID']['input'];
};

export type QueryCheckEmailSuppressionsArgs = {
  email: Scalars['String']['input'];
};

export type QueryCheckEmployeeArgs = {
  employeeBirthDate: Scalars['Date']['input'];
  ssn: Scalars['String']['input'];
};

export type QueryCheckIsAdditionalVerifierAdminArgs = {
  verifierId: Scalars['ID']['input'];
};

export type QueryCheckPasswordRequestExistArgs = {
  requestId: Scalars['ID']['input'];
  requestType: PasswordRequestType;
};

export type QueryCognitoGetUserMfaStatusArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryDashboardRevenueShareDatumArgs = {
  where: DashboardRevenueShareDatumWhereUnique;
};

export type QueryDashboardRevenueShareDatumCountArgs = {
  where?: InputMaybe<DashboardRevenueShareDatumWhere>;
};

export type QueryDashboardRevenueShareDatumListArgs = {
  orderBy?: InputMaybe<Array<DashboardRevenueShareDatumOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DashboardRevenueShareDatumWhere>;
};

export type QueryDataDisputeArgs = {
  where: DataDisputeWhereUnique;
};

export type QueryDataDisputeCountArgs = {
  where?: InputMaybe<DataDisputeWhere>;
};

export type QueryDataDisputeItemArgs = {
  where: DataDisputeItemWhereUnique;
};

export type QueryDataDisputeItemCountArgs = {
  where?: InputMaybe<DataDisputeItemWhere>;
};

export type QueryDataDisputeItemListArgs = {
  orderBy?: InputMaybe<Array<DataDisputeItemOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataDisputeItemWhere>;
};

export type QueryDataDisputeListArgs = {
  orderBy?: InputMaybe<Array<DataDisputeOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataDisputeWhere>;
};

export type QueryDisclaimerArgs = {
  where: DisclaimerWhereUnique;
};

export type QueryDisclaimerCountArgs = {
  where?: InputMaybe<DisclaimerWhere>;
};

export type QueryDisclaimerListArgs = {
  orderBy?: InputMaybe<Array<DisclaimerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclaimerWhere>;
};

export type QueryEmployeeArgs = {
  where: EmployeeWhereUnique;
};

export type QueryEmployeeAnnualFreeReportArgs = {
  where: EmployeeAnnualFreeReportWhereUnique;
};

export type QueryEmployeeAnnualFreeReportCountArgs = {
  where?: InputMaybe<EmployeeAnnualFreeReportWhere>;
};

export type QueryEmployeeAnnualFreeReportListArgs = {
  orderBy?: InputMaybe<Array<EmployeeAnnualFreeReportOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeAnnualFreeReportWhere>;
};

export type QueryEmployeeCountArgs = {
  where?: InputMaybe<EmployeeWhere>;
};

export type QueryEmployeeListArgs = {
  orderBy?: InputMaybe<Array<EmployeeOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeWhere>;
};

export type QueryEmployeeNoteArgs = {
  where: EmployeeNoteWhereUnique;
};

export type QueryEmployeeNoteCountArgs = {
  where?: InputMaybe<EmployeeNoteWhere>;
};

export type QueryEmployeeNoteListArgs = {
  orderBy?: InputMaybe<Array<EmployeeNoteOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeNoteWhere>;
};

export type QueryEmployeeWorkLetterArgs = {
  where: EmployeeWorkLetterWhereUnique;
};

export type QueryEmployeeWorkLetterCountArgs = {
  where?: InputMaybe<EmployeeWorkLetterWhere>;
};

export type QueryEmployeeWorkLetterListArgs = {
  orderBy?: InputMaybe<Array<EmployeeWorkLetterOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeWorkLetterWhere>;
};

export type QueryEmployerArgs = {
  where: EmployerWhereUnique;
};

export type QueryEmployerCountArgs = {
  where?: InputMaybe<EmployerWhere>;
};

export type QueryEmployerListArgs = {
  orderBy?: InputMaybe<Array<EmployerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerWhere>;
};

export type QueryEmployerStaffArgs = {
  where: EmployerStaffWhereUnique;
};

export type QueryEmployerStaffCountArgs = {
  where?: InputMaybe<EmployerStaffWhere>;
};

export type QueryEmployerStaffListArgs = {
  orderBy?: InputMaybe<Array<EmployerStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerStaffWhere>;
};

export type QueryExportIntegrationUsageLogsArgs = {
  input: ExportIntegrationUsageLogInput;
};

export type QueryFileArgs = {
  where: FileWhereUnique;
};

export type QueryFileCountArgs = {
  where?: InputMaybe<FileWhere>;
};

export type QueryFileListArgs = {
  orderBy?: InputMaybe<Array<FileOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhere>;
};

export type QueryGeneratedReportArgs = {
  where: GeneratedReportWhereUnique;
};

export type QueryGeneratedReportCountArgs = {
  where?: InputMaybe<GeneratedReportWhere>;
};

export type QueryGeneratedReportListArgs = {
  orderBy?: InputMaybe<Array<GeneratedReportOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GeneratedReportWhere>;
};

export type QueryGetActivityLogsListArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type QueryGetDashboardCvRevenueByVerificationTypeArgs = {
  employerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from: Scalars['Date']['input'];
  peoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  to: Scalars['Date']['input'];
};

export type QueryGetDashboardDataDisputeItemsCountGroupedByStatusArgs = {
  asOfDate: Scalars['DateTime']['input'];
  employerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  peoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetDashboardLastUploadRolesArgs = {
  employerId?: InputMaybe<Scalars['ID']['input']>;
  peoId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetDashboardPlatformAdminFinancialDataArgs = {
  asOfDate: Scalars['DateTime']['input'];
  employerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
  peoIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryGetDashboardPlatformAdminRevenueDistributionsArgs = {
  employerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from: Scalars['DateTime']['input'];
  peoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  to: Scalars['DateTime']['input'];
};

export type QueryGetDashboardPlatformAdminTopVerifiersDataArgs = {
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetDashboardRecordsActivityArgs = {
  employerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
  peoIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryGetDashboardReportAndRevenueArgs = {
  employerIds: Array<Scalars['ID']['input']>;
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetDashboardRevenueShareAccountsCountArgs = {
  asOfDate: Scalars['Date']['input'];
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetDashboardUsageReportsArgs = {
  employerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from: Scalars['DateTime']['input'];
  peoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  to: Scalars['DateTime']['input'];
};

export type QueryGetDashboardVerificationRequestsCountGroupedByIsManualArgs = {
  asOfDate: Scalars['DateTime']['input'];
  employerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  peoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetDashboardVerificationRequestsCountGroupedByStatusArgs = {
  asOfDate: Scalars['DateTime']['input'];
  employerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  peoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetDashboardVerifiersCountGroupedByCredentialStatusArgs = {
  verifierWhere?: InputMaybe<VerifierWhere>;
};

export type QueryGetDashboardWorkLetterUsageArgs = {
  employerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from: Scalars['DateTime']['input'];
  peoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  to: Scalars['DateTime']['input'];
};

export type QueryGetEmailActivityArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<EmailDeliveryStatus>;
  toEmailFilter?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetEmployeeDataOnEmployeeSearchForAdminArgs = {
  companyFilter?: InputMaybe<EmployeeSearchCompanyFilterInput>;
  cursor?: InputMaybe<Scalars['ID']['input']>;
  employeeSsnEncrypted: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};

export type QueryGetEmployeeDataOnEmployeeSearchForEmployerScopeArgs = {
  companyFilter?: InputMaybe<EmployeeSearchCompanyFilterInput>;
  cursor?: InputMaybe<Scalars['ID']['input']>;
  employeeSsnEncrypted: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};

export type QueryGetEmployeeDataOnEmployeeSignupArgs = {
  employeeSignupToken: Scalars['String']['input'];
};

export type QueryGetEmployeeDataOnEmployeeSignupByInviteArgs = {
  inviteId: Scalars['ID']['input'];
};

export type QueryGetEmployeeForPeoAccessSearchArgs = {
  employeeSsn: Scalars['String']['input'];
  peoId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetEmployeeInfoForVerificationRequestArgs = {
  employeeId: Scalars['ID']['input'];
};

export type QueryGetEmployeeInviteEmailOptionsForAdminArgs = {
  employeeSsnEncrypted: Scalars['String']['input'];
};

export type QueryGetEmployeeInviteEmailOptionsForEmployerScopeArgs = {
  employeeSsnEncrypted: Scalars['String']['input'];
};

export type QueryGetEmployeeInviteIdArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryGetEmployeeInviteLinkScopeForAdminArgs = {
  employeeSsnEncrypted: Scalars['String']['input'];
};

export type QueryGetEmployerBasicInfoArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetEmployersListForVerificationRequestArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type QueryGetEmployersListForVerificationRequestByEmployeeDataArgs = {
  employeeBirthDate: Scalars['Date']['input'];
  employeeSsn: Scalars['String']['input'];
  showInactiveEmployers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetEmployersListForWorkLetterForAdminArgs = {
  employeeSsnEncrypted: Scalars['String']['input'];
};

export type QueryGetEmploymentDataForEmployeeMyDataArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetEmploymentDataForSearchedEmployeeArgs = {
  companyId: Scalars['ID']['input'];
  employeeSsnEncrypted: Scalars['String']['input'];
};

export type QueryGetEmploymentDataOnEmployeeSignupArgs = {
  companyId: Scalars['ID']['input'];
  employeeSignupToken: Scalars['String']['input'];
};

export type QueryGetEmploymentDataOnEmployeeSignupByInviteArgs = {
  companyId: Scalars['ID']['input'];
  inviteId: Scalars['ID']['input'];
};

export type QueryGetExistingVerificationRequestTotalChargeArgs = {
  inboxItemId: Scalars['ID']['input'];
  reason: ExistingVerificationRequestTotalChargeReason;
};

export type QueryGetGeneratedReportsMetaArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type QueryGetInboxItemsListArgs = {
  cursorId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InboxItemsListWhere>;
};

export type QueryGetInboxItemsRequestsArgs = {
  orderBy?: InputMaybe<Array<InboxItemOrderBy>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetInboxListItemsCountArgs = {
  where?: InputMaybe<InboxItemsListWhere>;
};

export type QueryGetIntegrationUsageLogStatsArgs = {
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type QueryGetInviteArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetIsEmailFreeArgs = {
  email: Scalars['String']['input'];
};

export type QueryGetMyVerifyRequestTotalChargeArgs = {
  inboxItemId: Scalars['ID']['input'];
  permissiblePurposeId: Scalars['ID']['input'];
  verificationReportType?: InputMaybe<VerificationRequestType>;
};

export type QueryGetPartnershipsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GetPartnershipsWhere>;
};

export type QueryGetPeoBasicInfoArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPeoPayrollProviderBasicInfoArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPeoStaffAccessInfoArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetRevenueShareSettingsListWithStripeStatusesArgs = {
  orderBy?: InputMaybe<Array<RevenueShareSettingOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RevenueShareSettingWhere>;
};

export type QueryGetVerificationRequestTotalChargeArgs = {
  companies: Array<VerificationRequestCompanyData>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employeeSsn?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeId: Scalars['ID']['input'];
  requestType: VerificationRequestType;
  verificationRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetVerificationRequestsListForReportArgs = {
  orderBy?: InputMaybe<Array<VerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerificationRequestWhere>;
};

export type QueryGetVerifierByEmailDomainArgs = {
  email: Scalars['String']['input'];
  emailConfirmationCode: Scalars['String']['input'];
};

export type QueryGetVerifierInfoByApiVerificationRequestArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type QueryGetVerifierInfoByVerificationRequestArgs = {
  verificationRequestId: Scalars['ID']['input'];
};

export type QueryGetVerifiersBasicListArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryHrLogicsGetUnifiedReportingInfoArgs = {
  email: Scalars['String']['input'];
};

export type QueryInboxItemArgs = {
  where: InboxItemWhereUnique;
};

export type QueryInboxItemCountArgs = {
  where?: InputMaybe<InboxItemWhere>;
};

export type QueryInboxItemListArgs = {
  orderBy?: InputMaybe<Array<InboxItemOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InboxItemWhere>;
};

export type QueryInboxItemUnreadStatusArgs = {
  where: InboxItemUnreadStatusWhereUnique;
};

export type QueryInboxItemUnreadStatusCountArgs = {
  where?: InputMaybe<InboxItemUnreadStatusWhere>;
};

export type QueryInboxItemUnreadStatusListArgs = {
  orderBy?: InputMaybe<Array<InboxItemUnreadStatusOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InboxItemUnreadStatusWhere>;
};

export type QueryInitialBillingArgs = {
  where: InitialBillingWhereUnique;
};

export type QueryInitialBillingCountArgs = {
  where?: InputMaybe<InitialBillingWhere>;
};

export type QueryInitialBillingListArgs = {
  orderBy?: InputMaybe<Array<InitialBillingOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InitialBillingWhere>;
};

export type QueryIntegrationArgs = {
  where: IntegrationWhereUnique;
};

export type QueryIntegrationCountArgs = {
  where?: InputMaybe<IntegrationWhere>;
};

export type QueryIntegrationListArgs = {
  orderBy?: InputMaybe<Array<IntegrationOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntegrationWhere>;
};

export type QueryIntegrationUsageLogArgs = {
  where: IntegrationUsageLogWhereUnique;
};

export type QueryIntegrationUsageLogCountArgs = {
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type QueryIntegrationUsageLogListArgs = {
  orderBy?: InputMaybe<Array<IntegrationUsageLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntegrationUsageLogWhere>;
};

export type QueryInviteArgs = {
  where: InviteWhereUnique;
};

export type QueryInviteCountArgs = {
  where?: InputMaybe<InviteWhere>;
};

export type QueryInviteListArgs = {
  orderBy?: InputMaybe<Array<InviteOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InviteWhere>;
};

export type QueryMdmMdaTestArgs = {
  ssn: Scalars['String']['input'];
};

export type QueryPaymentTransactionArgs = {
  where: PaymentTransactionWhereUnique;
};

export type QueryPaymentTransactionCountArgs = {
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type QueryPaymentTransactionListArgs = {
  orderBy?: InputMaybe<Array<PaymentTransactionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type QueryPeoArgs = {
  where: PeoWhereUnique;
};

export type QueryPeoCountArgs = {
  where?: InputMaybe<PeoWhere>;
};

export type QueryPeoListArgs = {
  orderBy?: InputMaybe<Array<PeoOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoWhere>;
};

export type QueryPeoPayrollProviderArgs = {
  where: PeoPayrollProviderWhereUnique;
};

export type QueryPeoPayrollProviderCountArgs = {
  where?: InputMaybe<PeoPayrollProviderWhere>;
};

export type QueryPeoPayrollProviderListArgs = {
  orderBy?: InputMaybe<Array<PeoPayrollProviderOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoPayrollProviderWhere>;
};

export type QueryPeoPayrollProviderStaffArgs = {
  where: PeoPayrollProviderStaffWhereUnique;
};

export type QueryPeoPayrollProviderStaffCountArgs = {
  where?: InputMaybe<PeoPayrollProviderStaffWhere>;
};

export type QueryPeoPayrollProviderStaffListArgs = {
  orderBy?: InputMaybe<Array<PeoPayrollProviderStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoPayrollProviderStaffWhere>;
};

export type QueryPeoStaffArgs = {
  where: PeoStaffWhereUnique;
};

export type QueryPeoStaffCountArgs = {
  where?: InputMaybe<PeoStaffWhere>;
};

export type QueryPeoStaffListArgs = {
  orderBy?: InputMaybe<Array<PeoStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PeoStaffWhere>;
};

export type QueryPermissiblePurposeArgs = {
  where: PermissiblePurposeWhereUnique;
};

export type QueryPermissiblePurposeCountArgs = {
  where?: InputMaybe<PermissiblePurposeWhere>;
};

export type QueryPermissiblePurposeListArgs = {
  orderBy?: InputMaybe<Array<PermissiblePurposeOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PermissiblePurposeWhere>;
};

export type QueryPermissiblePurposeReferenceArgs = {
  where: PermissiblePurposeReferenceWhereUnique;
};

export type QueryPermissiblePurposeReferenceCountArgs = {
  where?: InputMaybe<PermissiblePurposeReferenceWhere>;
};

export type QueryPermissiblePurposeReferenceListArgs = {
  orderBy?: InputMaybe<Array<PermissiblePurposeReferenceOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PermissiblePurposeReferenceWhere>;
};

export type QueryPiiDataAccessLogArgs = {
  where: PiiDataAccessLogWhereUnique;
};

export type QueryPiiDataAccessLogCountArgs = {
  where?: InputMaybe<PiiDataAccessLogWhere>;
};

export type QueryPiiDataAccessLogListArgs = {
  orderBy?: InputMaybe<Array<PiiDataAccessLogOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PiiDataAccessLogWhere>;
};

export type QueryPlatformStaffArgs = {
  where: PlatformStaffWhereUnique;
};

export type QueryPlatformStaffCountArgs = {
  where?: InputMaybe<PlatformStaffWhere>;
};

export type QueryPlatformStaffListArgs = {
  orderBy?: InputMaybe<Array<PlatformStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlatformStaffWhere>;
};

export type QueryPositionArgs = {
  where: PositionWhereUnique;
};

export type QueryPositionCountArgs = {
  where?: InputMaybe<PositionWhere>;
};

export type QueryPositionListArgs = {
  orderBy?: InputMaybe<Array<PositionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PositionWhere>;
};

export type QueryResourceArgs = {
  where: ResourceWhereUnique;
};

export type QueryResourceCountArgs = {
  where?: InputMaybe<ResourceWhere>;
};

export type QueryResourceListArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ResourceWhere>;
};

export type QueryRevenueShareSettingArgs = {
  where: RevenueShareSettingWhereUnique;
};

export type QueryRevenueShareSettingCountArgs = {
  where?: InputMaybe<RevenueShareSettingWhere>;
};

export type QueryRevenueShareSettingListArgs = {
  orderBy?: InputMaybe<Array<RevenueShareSettingOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RevenueShareSettingWhere>;
};

export type QuerySearchEmployeesForAdminArgs = {
  companyFilter?: InputMaybe<EmployeeSearchCompanyFilterInput>;
  input: EmployeeSearchInput;
};

export type QuerySearchEmployeesForEmployerScopeArgs = {
  companyFilter?: InputMaybe<EmployeeSearchCompanyFilterInput>;
  input: EmployeeSearchInput;
};

export type QueryStateArgs = {
  where: StateWhereUnique;
};

export type QueryStateCountArgs = {
  where?: InputMaybe<StateWhere>;
};

export type QueryStateListArgs = {
  orderBy?: InputMaybe<Array<StateOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StateWhere>;
};

export type QueryStripeGetAccountInfoArgs = {
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryStripeGetCustomerPaymentMethodsArgs = {
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryStripeGetPaymentHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  verifierId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryStripeGetPaymentIntentForVerificationRequestArgs = {
  inboxItemId: Scalars['ID']['input'];
};

export type QueryStripeRetrieveStatusArgs = {
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTaskInfoArgs = {
  id: Scalars['String']['input'];
};

export type QueryTestVerificationRequestArgs = {
  where: TestVerificationRequestWhereUnique;
};

export type QueryTestVerificationRequestCountArgs = {
  where?: InputMaybe<TestVerificationRequestWhere>;
};

export type QueryTestVerificationRequestListArgs = {
  orderBy?: InputMaybe<Array<TestVerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestVerificationRequestWhere>;
};

export type QueryUserArgs = {
  where: UserWhereUnique;
};

export type QueryUserCountArgs = {
  where?: InputMaybe<UserWhere>;
};

export type QueryUserEmailChangeRequestArgs = {
  where: UserEmailChangeRequestWhereUnique;
};

export type QueryUserEmailChangeRequestCountArgs = {
  where?: InputMaybe<UserEmailChangeRequestWhere>;
};

export type QueryUserEmailChangeRequestListArgs = {
  orderBy?: InputMaybe<Array<UserEmailChangeRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserEmailChangeRequestWhere>;
};

export type QueryUserListArgs = {
  orderBy?: InputMaybe<Array<UserOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhere>;
};

export type QueryUserPasswordChangeRequestArgs = {
  where: UserPasswordChangeRequestWhereUnique;
};

export type QueryUserPasswordChangeRequestCountArgs = {
  where?: InputMaybe<UserPasswordChangeRequestWhere>;
};

export type QueryUserPasswordChangeRequestListArgs = {
  orderBy?: InputMaybe<Array<UserPasswordChangeRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPasswordChangeRequestWhere>;
};

export type QueryUserPasswordResetRequestArgs = {
  where: UserPasswordResetRequestWhereUnique;
};

export type QueryUserPasswordResetRequestCountArgs = {
  where?: InputMaybe<UserPasswordResetRequestWhere>;
};

export type QueryUserPasswordResetRequestListArgs = {
  orderBy?: InputMaybe<Array<UserPasswordResetRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPasswordResetRequestWhere>;
};

export type QueryValidateSignupEmployeeDataArgs = {
  email: Scalars['String']['input'];
  employeeSignupToken?: InputMaybe<Scalars['String']['input']>;
  employeeSsn: Scalars['String']['input'];
  inviteId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryValidateSignupEmployeePinOrSsnArgs = {
  companyId: Scalars['ID']['input'];
  companyType: CompanyType;
  pinOrSsn: Scalars['String']['input'];
};

export type QueryVerificationRequestArgs = {
  where: VerificationRequestWhereUnique;
};

export type QueryVerificationRequestCountArgs = {
  where?: InputMaybe<VerificationRequestWhere>;
};

export type QueryVerificationRequestListArgs = {
  orderBy?: InputMaybe<Array<VerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerificationRequestWhere>;
};

export type QueryVerifierArgs = {
  where: VerifierWhereUnique;
};

export type QueryVerifierBillingArgs = {
  where: VerifierBillingWhereUnique;
};

export type QueryVerifierBillingCountArgs = {
  where?: InputMaybe<VerifierBillingWhere>;
};

export type QueryVerifierBillingListArgs = {
  orderBy?: InputMaybe<Array<VerifierBillingOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerifierBillingWhere>;
};

export type QueryVerifierCountArgs = {
  where?: InputMaybe<VerifierWhere>;
};

export type QueryVerifierListArgs = {
  orderBy?: InputMaybe<Array<VerifierOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerifierWhere>;
};

export type QueryVerifierStaffArgs = {
  where: VerifierStaffWhereUnique;
};

export type QueryVerifierStaffCountArgs = {
  where?: InputMaybe<VerifierStaffWhere>;
};

export type QueryVerifierStaffListArgs = {
  orderBy?: InputMaybe<Array<VerifierStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerifierStaffWhere>;
};

export type QueryVerifyEmailConfirmationCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export const QueryMode = {
  Default: 'Default',
  Insensitive: 'Insensitive',
} as const;

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode];
export type ResendInviteResponse = {
  __typename?: 'ResendInviteResponse';
  inviteLinkUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Resource = {
  __typename?: 'Resource';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['ID']['output']>;
  iconName: ResourceIconName;
  id: Scalars['ID']['output'];
  originType?: Maybe<ResourceOriginType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  userRoleCategory: Array<ResourceUserRoleCategory>;
};

export type ResourceCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  file?: InputMaybe<FileCreateRelationWithoutResourceFiles>;
  iconName: ResourceIconName;
  originType?: InputMaybe<ResourceOriginType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userRoleCategory: Array<ResourceUserRoleCategory>;
};

export type ResourceCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  fileId?: InputMaybe<Scalars['ID']['input']>;
  iconName: ResourceIconName;
  originType?: InputMaybe<ResourceOriginType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userRoleCategory: Array<ResourceUserRoleCategory>;
};

export type ResourceCreateRelationListWithoutFile = {
  connect?: InputMaybe<Array<ResourceWhereUnique>>;
  create?: InputMaybe<Array<ResourceCreateWithoutFile>>;
};

export type ResourceCreateWithoutFile = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  iconName: ResourceIconName;
  originType?: InputMaybe<ResourceOriginType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userRoleCategory: Array<ResourceUserRoleCategory>;
};

export const ResourceIconName = {
  Apartment: 'Apartment',
  CollectionsBookmark: 'Collections_Bookmark',
  ConnectedTv: 'Connected_Tv',
  HrLogics: 'HR_Logics',
  Inbox: 'Inbox',
  InfoOutlined: 'Info_Outlined',
  LaptopWindows: 'Laptop_Windows',
  Launch: 'Launch',
  LiveTv: 'Live_Tv',
  Logout: 'Logout',
  MailOutline: 'Mail_Outline',
  PinDrop: 'Pin_Drop',
  School: 'School',
  TextSnippet: 'Text_Snippet',
  Work: 'Work',
} as const;

export type ResourceIconName = (typeof ResourceIconName)[keyof typeof ResourceIconName];
export type ResourceIconNameFilter = {
  equals?: InputMaybe<ResourceIconName>;
  in?: InputMaybe<Array<ResourceIconName>>;
  not?: InputMaybe<ResourceIconNameFilter>;
  notIn?: InputMaybe<Array<ResourceIconName>>;
};

export type ResourceIconNameUpdate = {
  set?: InputMaybe<ResourceIconName>;
};

export type ResourceOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  file?: InputMaybe<FileOrderBy>;
  fileId?: InputMaybe<SortOrderInput>;
  iconName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  originType?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export const ResourceOriginType = {
  External: 'External',
  Internal: 'Internal',
} as const;

export type ResourceOriginType = (typeof ResourceOriginType)[keyof typeof ResourceOriginType];
export type ResourceOriginTypeFilter = {
  equals?: InputMaybe<ResourceOriginType>;
  in?: InputMaybe<Array<ResourceOriginType>>;
  not?: InputMaybe<ResourceOriginTypeFilter>;
  notIn?: InputMaybe<Array<ResourceOriginType>>;
};

export type ResourceOriginTypeUpdate = {
  set?: InputMaybe<ResourceOriginType>;
};

export type ResourceUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<FileUpdateRelationWithoutResourceFiles>;
  iconName?: InputMaybe<ResourceIconName>;
  originType?: InputMaybe<ResourceOriginType>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userRoleCategory?: InputMaybe<ResourceUserRoleCategoryListUpdate>;
};

export type ResourceUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  description?: InputMaybe<StringUpdate>;
  fileId?: InputMaybe<IdUpdate>;
  iconName?: InputMaybe<ResourceIconNameUpdate>;
  originType?: InputMaybe<ResourceOriginTypeUpdate>;
  title?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  url?: InputMaybe<StringUpdate>;
  userRoleCategory?: InputMaybe<ResourceUserRoleCategoryListUpdate>;
};

export type ResourceUpdateRelationListWithoutFile = {
  connect?: InputMaybe<Array<ResourceWhereUnique>>;
  create?: InputMaybe<Array<ResourceCreateWithoutFile>>;
  disconnect?: InputMaybe<Array<ResourceWhereUnique>>;
  set?: InputMaybe<Array<ResourceWhereUnique>>;
};

export const ResourceUserRoleCategory = {
  Employee: 'Employee',
  Employer: 'Employer',
  Peo: 'Peo',
  PeoPayrollProvider: 'Peo_Payroll_Provider',
  Verifier: 'Verifier',
} as const;

export type ResourceUserRoleCategory =
  (typeof ResourceUserRoleCategory)[keyof typeof ResourceUserRoleCategory];
export type ResourceUserRoleCategoryListFilter = {
  equals?: InputMaybe<Array<ResourceUserRoleCategory>>;
  has?: InputMaybe<ResourceUserRoleCategory>;
  hasEvery?: InputMaybe<Array<ResourceUserRoleCategory>>;
  hasSome?: InputMaybe<Array<ResourceUserRoleCategory>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceUserRoleCategoryListUpdate = {
  push?: InputMaybe<Array<ResourceUserRoleCategory>>;
  set?: InputMaybe<Array<ResourceUserRoleCategory>>;
};

export type ResourceWhere = {
  AND?: InputMaybe<Array<ResourceWhere>>;
  NOT?: InputMaybe<Array<ResourceWhere>>;
  OR?: InputMaybe<Array<ResourceWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  file?: InputMaybe<FileWhere>;
  fileId?: InputMaybe<IdFilter>;
  iconName?: InputMaybe<ResourceIconNameFilter>;
  id?: InputMaybe<IdFilter>;
  originType?: InputMaybe<ResourceOriginTypeFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
  userRoleCategory?: InputMaybe<ResourceUserRoleCategoryListFilter>;
};

export type ResourceWhereRelationList = {
  every?: InputMaybe<ResourceWhere>;
  none?: InputMaybe<ResourceWhere>;
  some?: InputMaybe<ResourceWhere>;
};

export type ResourceWhereUnique = {
  id: Scalars['ID']['input'];
};

export type RevenueShareSetting = {
  __typename?: 'RevenueShareSetting';
  createdAt: Scalars['DateTime']['output'];
  employer?: Maybe<Employer>;
  id: Scalars['ID']['output'];
  peo?: Maybe<Peo>;
  peoPayrollProvider?: Maybe<PeoPayrollProvider>;
  revenueShareFlat?: Maybe<Scalars['Int']['output']>;
  revenueSharePercents?: Maybe<Scalars['Decimal']['output']>;
  revenueShareRecipient: CompanyType;
  revenueShareType: RevenueShareType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RevenueShareSettingCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutRevenueShareSetting>;
  peo?: InputMaybe<PeoCreateRelationWithoutRevenueShareSetting>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutRevenueShareSetting>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareRecipient?: InputMaybe<CompanyType>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RevenueShareSettingCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareRecipient?: InputMaybe<CompanyType>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RevenueShareSettingCreateRelationWithoutEmployer = {
  connect?: InputMaybe<RevenueShareSettingWhereUnique>;
  create?: InputMaybe<RevenueShareSettingCreateWithoutEmployer>;
};

export type RevenueShareSettingCreateRelationWithoutPeo = {
  connect?: InputMaybe<RevenueShareSettingWhereUnique>;
  create?: InputMaybe<RevenueShareSettingCreateWithoutPeo>;
};

export type RevenueShareSettingCreateRelationWithoutPeoPayrollProvider = {
  connect?: InputMaybe<RevenueShareSettingWhereUnique>;
  create?: InputMaybe<RevenueShareSettingCreateWithoutPeoPayrollProvider>;
};

export type RevenueShareSettingCreateWithoutEmployer = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peo?: InputMaybe<PeoCreateRelationWithoutRevenueShareSetting>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutRevenueShareSetting>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareRecipient?: InputMaybe<CompanyType>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RevenueShareSettingCreateWithoutPeo = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutRevenueShareSetting>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderCreateRelationWithoutRevenueShareSetting>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareRecipient?: InputMaybe<CompanyType>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RevenueShareSettingCreateWithoutPeoPayrollProvider = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerCreateRelationWithoutRevenueShareSetting>;
  peo?: InputMaybe<PeoCreateRelationWithoutRevenueShareSetting>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareRecipient?: InputMaybe<CompanyType>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RevenueShareSettingOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  employer?: InputMaybe<EmployerOrderBy>;
  id?: InputMaybe<SortOrder>;
  peo?: InputMaybe<PeoOrderBy>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderOrderBy>;
  revenueShareFlat?: InputMaybe<SortOrderInput>;
  revenueSharePercents?: InputMaybe<SortOrderInput>;
  revenueShareRecipient?: InputMaybe<SortOrder>;
  revenueShareType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RevenueShareSettingUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutRevenueShareSetting>;
  peo?: InputMaybe<PeoUpdateRelationWithoutRevenueShareSetting>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutRevenueShareSetting>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareRecipient?: InputMaybe<CompanyType>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RevenueShareSettingUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  revenueShareFlat?: InputMaybe<IntUpdate>;
  revenueSharePercents?: InputMaybe<DecimalUpdate>;
  revenueShareRecipient?: InputMaybe<CompanyTypeUpdate>;
  revenueShareType?: InputMaybe<RevenueShareTypeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type RevenueShareSettingUpdateRelationWithoutEmployer = {
  connect?: InputMaybe<RevenueShareSettingWhereUnique>;
  create?: InputMaybe<RevenueShareSettingCreateWithoutEmployer>;
  disconnect?: InputMaybe<RevenueShareSettingWhereUnique>;
  update?: InputMaybe<RevenueShareSettingUpdateWithoutEmployer>;
};

export type RevenueShareSettingUpdateRelationWithoutPeo = {
  connect?: InputMaybe<RevenueShareSettingWhereUnique>;
  create?: InputMaybe<RevenueShareSettingCreateWithoutPeo>;
  disconnect?: InputMaybe<RevenueShareSettingWhereUnique>;
  update?: InputMaybe<RevenueShareSettingUpdateWithoutPeo>;
};

export type RevenueShareSettingUpdateRelationWithoutPeoPayrollProvider = {
  connect?: InputMaybe<RevenueShareSettingWhereUnique>;
  create?: InputMaybe<RevenueShareSettingCreateWithoutPeoPayrollProvider>;
  disconnect?: InputMaybe<RevenueShareSettingWhereUnique>;
  update?: InputMaybe<RevenueShareSettingUpdateWithoutPeoPayrollProvider>;
};

export type RevenueShareSettingUpdateWithoutEmployer = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  peo?: InputMaybe<PeoUpdateRelationWithoutRevenueShareSetting>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutRevenueShareSetting>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareRecipient?: InputMaybe<CompanyType>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RevenueShareSettingUpdateWithoutPeo = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutRevenueShareSetting>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderUpdateRelationWithoutRevenueShareSetting>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareRecipient?: InputMaybe<CompanyType>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RevenueShareSettingUpdateWithoutPeoPayrollProvider = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employer?: InputMaybe<EmployerUpdateRelationWithoutRevenueShareSetting>;
  peo?: InputMaybe<PeoUpdateRelationWithoutRevenueShareSetting>;
  revenueShareFlat?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePercents?: InputMaybe<Scalars['Decimal']['input']>;
  revenueShareRecipient?: InputMaybe<CompanyType>;
  revenueShareType?: InputMaybe<RevenueShareType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RevenueShareSettingWhere = {
  AND?: InputMaybe<Array<RevenueShareSettingWhere>>;
  NOT?: InputMaybe<Array<RevenueShareSettingWhere>>;
  OR?: InputMaybe<Array<RevenueShareSettingWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employer?: InputMaybe<EmployerWhere>;
  id?: InputMaybe<IdFilter>;
  peo?: InputMaybe<PeoWhere>;
  peoPayrollProvider?: InputMaybe<PeoPayrollProviderWhere>;
  revenueShareFlat?: InputMaybe<IntFilter>;
  revenueSharePercents?: InputMaybe<DecimalFilter>;
  revenueShareRecipient?: InputMaybe<CompanyTypeFilter>;
  revenueShareType?: InputMaybe<RevenueShareTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RevenueShareSettingWhereUnique = {
  id: Scalars['ID']['input'];
};

export const RevenueShareType = {
  Flat: 'Flat',
  Percents: 'Percents',
} as const;

export type RevenueShareType = (typeof RevenueShareType)[keyof typeof RevenueShareType];
export type RevenueShareTypeFilter = {
  equals?: InputMaybe<RevenueShareType>;
  in?: InputMaybe<Array<RevenueShareType>>;
  not?: InputMaybe<RevenueShareTypeFilter>;
  notIn?: InputMaybe<Array<RevenueShareType>>;
};

export type RevenueShareTypeUpdate = {
  set?: InputMaybe<RevenueShareType>;
};

export type SendEmailConfirmationCodeResponse = {
  __typename?: 'SendEmailConfirmationCodeResponse';
  pendingInviteResent: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type SendInvitesToEmployersByPeoPpInput = {
  employers: Array<InvitedEmployerByPeoPp>;
  peoPayrollProviderId?: InputMaybe<Scalars['String']['input']>;
};

export type SendInvitesToEmployersByPeoStaffInput = {
  employers: Array<InvitedByPeoStaffEmployer>;
};

export type SendInvitesToEmployersUnderPeoInput = {
  employers: Array<InvitedByPeoStaffEmployer>;
  peoId: Scalars['String']['input'];
};

export type SendInvitesToPeoByPeoPpInput = {
  peoPayrollProviderId?: InputMaybe<Scalars['String']['input']>;
  peos: Array<InvitedPeoByPeoPp>;
};

export const SignUpMethod = {
  Pin: 'PIN',
  Ssn: 'SSN',
} as const;

export type SignUpMethod = (typeof SignUpMethod)[keyof typeof SignUpMethod];
export type SignUpMethodFilter = {
  equals?: InputMaybe<SignUpMethod>;
  in?: InputMaybe<Array<SignUpMethod>>;
  not?: InputMaybe<SignUpMethodFilter>;
  notIn?: InputMaybe<Array<SignUpMethod>>;
};

export type SignUpMethodUpdate = {
  set?: InputMaybe<SignUpMethod>;
};

export const SortOrder = {
  Asc: 'Asc',
  Desc: 'Desc',
} as const;

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];
export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type State = {
  __typename?: 'State';
  abbreviation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deleteRequest?: Maybe<ActiveInactive>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  privacySetting?: Maybe<ActiveInactive>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StateCreate = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleteRequest?: InputMaybe<ActiveInactive>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<ActiveInactive>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateCreateMany = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleteRequest?: InputMaybe<ActiveInactive>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<ActiveInactive>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateOrderBy = {
  abbreviation?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deleteRequest?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrderInput>;
  privacySetting?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StateUpdate = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleteRequest?: InputMaybe<ActiveInactive>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<ActiveInactive>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateUpdateMany = {
  abbreviation?: InputMaybe<StringUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  deleteRequest?: InputMaybe<ActiveInactiveUpdate>;
  name?: InputMaybe<StringUpdate>;
  privacySetting?: InputMaybe<ActiveInactiveUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type StateWhere = {
  AND?: InputMaybe<Array<StateWhere>>;
  NOT?: InputMaybe<Array<StateWhere>>;
  OR?: InputMaybe<Array<StateWhere>>;
  abbreviation?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deleteRequest?: InputMaybe<ActiveInactiveFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  privacySetting?: InputMaybe<ActiveInactiveFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StateWhereUnique = {
  id: Scalars['ID']['input'];
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringListUpdate = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StringUpdate = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export const StripeAccountStatus = {
  Completed: 'Completed',
  NotConnected: 'Not_Connected',
  Pending: 'Pending',
  Restricted: 'Restricted',
} as const;

export type StripeAccountStatus = (typeof StripeAccountStatus)[keyof typeof StripeAccountStatus];
export type StripeBillingTransaction = {
  __typename?: 'StripeBillingTransaction';
  amount: Scalars['Int']['output'];
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRefunded: Scalars['Boolean']['output'];
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status: StripeBillingTransactionStatus;
  verifierDisplayName?: Maybe<Scalars['String']['output']>;
  verifierEmail?: Maybe<Scalars['String']['output']>;
};

export const StripeBillingTransactionStatus = {
  Failed: 'failed',
  Pending: 'pending',
  Succeeded: 'succeeded',
} as const;

export type StripeBillingTransactionStatus =
  (typeof StripeBillingTransactionStatus)[keyof typeof StripeBillingTransactionStatus];
export type StripeCreatePaymentIntentResponse = {
  __typename?: 'StripeCreatePaymentIntentResponse';
  customerId: Scalars['String']['output'];
  paymentIntent?: Maybe<Scalars['Json']['output']>;
};

export type StripeCreateSetupIntentResponse = {
  __typename?: 'StripeCreateSetupIntentResponse';
  clientSecret: Scalars['String']['output'];
  stripeCustomerId: Scalars['String']['output'];
};

export const StripeExternalAccountType = {
  BankAccount: 'bank_account',
  Card: 'card',
} as const;

export type StripeExternalAccountType =
  (typeof StripeExternalAccountType)[keyof typeof StripeExternalAccountType];
export type StripeGetAccountInfoResponse = {
  __typename?: 'StripeGetAccountInfoResponse';
  balance: Scalars['Int']['output'];
  externalAccounts?: Maybe<Array<ExternalAccounts>>;
  payoutSettingsSchedule: PayoutSchedule;
  status: StripeAccountStatus;
};

export type StripeGetAccountLinkResponse = {
  __typename?: 'StripeGetAccountLinkResponse';
  accountId: Scalars['String']['output'];
  accountLinkUrl: Scalars['String']['output'];
};

export type StripeGetCustomerPaymentMethodsResponse = {
  __typename?: 'StripeGetCustomerPaymentMethodsResponse';
  achPaymentMethods?: Maybe<Scalars['Json']['output']>;
  cardPaymentMethods?: Maybe<Scalars['Json']['output']>;
  defaultPaymentMethodId?: Maybe<Scalars['String']['output']>;
};

export type StripeGetPaymentHistoryResponse = {
  __typename?: 'StripeGetPaymentHistoryResponse';
  nextPageId?: Maybe<Scalars['String']['output']>;
  paymentHistoryCharges: Array<StripeBillingTransaction>;
};

export type StripeGetPaymentIntentForVerificationRequestResponse = {
  __typename?: 'StripeGetPaymentIntentForVerificationRequestResponse';
  paymentIntentId: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
};

export const StripePayoutScheduleInterval = {
  Daily: 'daily',
  Manual: 'manual',
  Monthly: 'monthly',
  Weekly: 'weekly',
} as const;

export type StripePayoutScheduleInterval =
  (typeof StripePayoutScheduleInterval)[keyof typeof StripePayoutScheduleInterval];
export const StripePayoutScheduleWeeklyAnchor = {
  Friday: 'friday',
  Monday: 'monday',
  Saturday: 'saturday',
  Sunday: 'sunday',
  Thursday: 'thursday',
  Tuesday: 'tuesday',
  Wednesday: 'wednesday',
} as const;

export type StripePayoutScheduleWeeklyAnchor =
  (typeof StripePayoutScheduleWeeklyAnchor)[keyof typeof StripePayoutScheduleWeeklyAnchor];
export type StripeRetrieveStatusResponse = {
  __typename?: 'StripeRetrieveStatusResponse';
  status: StripeAccountStatus;
};

export type StripeUpdateAccountPayoutSettingsInput = {
  interval: StripePayoutScheduleInterval;
  monthlyAnchor?: InputMaybe<Scalars['Int']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  weeklyAnchor?: InputMaybe<StripePayoutScheduleWeeklyAnchor>;
};

export type StripeUpdateCustomerDefaultPaymentMethodResponse = {
  __typename?: 'StripeUpdateCustomerDefaultPaymentMethodResponse';
  defaultPaymentMethodId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StripeUpdatePaymentMethodForVerificationRequestResponse = {
  __typename?: 'StripeUpdatePaymentMethodForVerificationRequestResponse';
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean']['output'];
};

export type TaskInfo = TaskInfoFailed | TaskInfoFinished | TaskInfoPending | TaskInfoProcessing;

export type TaskInfoFailed = {
  __typename?: 'TaskInfoFailed';
  args?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['DateTime']['output'];
  name: TaskNameEnum;
  result: Scalars['String']['output'];
  status: TaskStatusEnum;
  type: TaskTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskInfoFinished = {
  __typename?: 'TaskInfoFinished';
  args?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['DateTime']['output'];
  name: TaskNameEnum;
  result?: Maybe<Scalars['Json']['output']>;
  status: TaskStatusEnum;
  type: TaskTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskInfoPending = {
  __typename?: 'TaskInfoPending';
  args?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['DateTime']['output'];
  name: TaskNameEnum;
  status: TaskStatusEnum;
  type: TaskTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskInfoProcessing = {
  __typename?: 'TaskInfoProcessing';
  args?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['DateTime']['output'];
  name: TaskNameEnum;
  status: TaskStatusEnum;
  type: TaskTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export const TaskNameEnum = {
  CalculateDashboardRevenueShareData: 'calculateDashboardRevenueShareData',
  ClearStripeConnectedAccounts: 'clearStripeConnectedAccounts',
  DeleteUnreviewedVerificationRequests: 'deleteUnreviewedVerificationRequests',
  ExpiredInviteRemove: 'expiredInviteRemove',
  FillAllVerificationRequestsChargeAmountFromStripe:
    'fillAllVerificationRequestsChargeAmountFromStripe',
  InvitationsReminder: 'invitationsReminder',
  MiddeskSetupWebhooks: 'middeskSetupWebhooks',
  NotifyAfterDataDisputeItemStatusChange: 'notifyAfterDataDisputeItemStatusChange',
  NotifyUnresolvedDataDisputes: 'notifyUnresolvedDataDisputes',
  NotifyUnreviewedVerificationRequests: 'notifyUnreviewedVerificationRequests',
  NullifyCredentialStatus: 'nullifyCredentialStatus',
  ReencryptSsNs: 'reencryptSSNs',
  SendMonthlyFinancialReportToPlatformStaff: 'sendMonthlyFinancialReportToPlatformStaff',
  SendNotificationsCreateDataDisputeByEmployee: 'sendNotificationsCreateDataDisputeByEmployee',
  SendNotificationsCreateVerificationRequest: 'sendNotificationsCreateVerificationRequest',
  SendNotificationsDeleteEmployeeAccountData: 'sendNotificationsDeleteEmployeeAccountData',
  SendNotificationsGenerateVerificationRequest: 'sendNotificationsGenerateVerificationRequest',
  SendNotificationsInboxItemCommentedByPlatformStaff:
    'sendNotificationsInboxItemCommentedByPlatformStaff',
  SendNotificationsUserRegistrationByInvite: 'sendNotificationsUserRegistrationByInvite',
  StripeProcessRevenueShare: 'stripeProcessRevenueShare',
  UpdateVerifiersDeniedByMiddeskCredentialStatus: 'updateVerifiersDeniedByMiddeskCredentialStatus',
  UserAuthDataChangeRequestsCleanup: 'userAuthDataChangeRequestsCleanup',
} as const;

export type TaskNameEnum = (typeof TaskNameEnum)[keyof typeof TaskNameEnum];
export const TaskStatusEnum = {
  Failed: 'Failed',
  Finished: 'Finished',
  Pending: 'Pending',
  Processing: 'Processing',
} as const;

export type TaskStatusEnum = (typeof TaskStatusEnum)[keyof typeof TaskStatusEnum];
export const TaskTypeEnum = {
  Fargate: 'Fargate',
  Lambda: 'Lambda',
} as const;

export type TaskTypeEnum = (typeof TaskTypeEnum)[keyof typeof TaskTypeEnum];
export type TestVerificationRequest = {
  __typename?: 'TestVerificationRequest';
  createdAt: Scalars['DateTime']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  generatedReportsCount: Scalars['Int']['output'];
  generatedReportsList: Array<GeneratedReport>;
  id: Scalars['ID']['output'];
  inboxItem: InboxItem;
  inboxItemId: Scalars['ID']['output'];
  mdmMetadata?: Maybe<Scalars['Json']['output']>;
  mdmMetadataObjectHash?: Maybe<Scalars['String']['output']>;
  platformStaff: PlatformStaff;
  platformStaffId: Scalars['ID']['output'];
  type: Array<VerificationRequestType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TestVerificationRequestGeneratedReportsCountArgs = {
  where?: InputMaybe<GeneratedReportWhere>;
};

export type TestVerificationRequestGeneratedReportsListArgs = {
  orderBy?: InputMaybe<Array<GeneratedReportOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GeneratedReportWhere>;
};

export type TestVerificationRequestCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutTestVerificationRequests;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutTestVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutTestVerificationRequest;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  platformStaff: PlatformStaffCreateRelationWithoutTestVerificationRequests;
  type: Array<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestVerificationRequestCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId: Scalars['ID']['input'];
  inboxItemId: Scalars['ID']['input'];
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  platformStaffId: Scalars['ID']['input'];
  type: Array<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestVerificationRequestCreateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<TestVerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<TestVerificationRequestCreateWithoutEmployee>>;
};

export type TestVerificationRequestCreateRelationListWithoutPlatformStaff = {
  connect?: InputMaybe<Array<TestVerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<TestVerificationRequestCreateWithoutPlatformStaff>>;
};

export type TestVerificationRequestCreateRelationWithoutGeneratedReports = {
  connect?: InputMaybe<TestVerificationRequestWhereUnique>;
  create?: InputMaybe<TestVerificationRequestCreateWithoutGeneratedReports>;
};

export type TestVerificationRequestCreateRelationWithoutInboxItem = {
  connect?: InputMaybe<TestVerificationRequestWhereUnique>;
  create?: InputMaybe<TestVerificationRequestCreateWithoutInboxItem>;
};

export type TestVerificationRequestCreateWithoutEmployee = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutTestVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutTestVerificationRequest;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  platformStaff: PlatformStaffCreateRelationWithoutTestVerificationRequests;
  type: Array<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestVerificationRequestCreateWithoutGeneratedReports = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutTestVerificationRequests;
  inboxItem: InboxItemCreateRelationWithoutTestVerificationRequest;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  platformStaff: PlatformStaffCreateRelationWithoutTestVerificationRequests;
  type: Array<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestVerificationRequestCreateWithoutInboxItem = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutTestVerificationRequests;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutTestVerificationRequest>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  platformStaff: PlatformStaffCreateRelationWithoutTestVerificationRequests;
  type: Array<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestVerificationRequestCreateWithoutPlatformStaff = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee: EmployeeCreateRelationWithoutTestVerificationRequests;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutTestVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutTestVerificationRequest;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  type: Array<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestVerificationRequestOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inboxItem?: InputMaybe<InboxItemOrderBy>;
  inboxItemId?: InputMaybe<SortOrder>;
  mdmMetadata?: InputMaybe<SortOrderInput>;
  mdmMetadataObjectHash?: InputMaybe<SortOrderInput>;
  platformStaff?: InputMaybe<PlatformStaffOrderBy>;
  platformStaffId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TestVerificationRequestUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutTestVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutTestVerificationRequest>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutTestVerificationRequest>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutTestVerificationRequests>;
  type?: InputMaybe<VerificationRequestTypeListUpdate>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestVerificationRequestUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  employeeId?: InputMaybe<IdUpdate>;
  inboxItemId?: InputMaybe<IdUpdate>;
  mdmMetadata?: InputMaybe<JsonUpdate>;
  mdmMetadataObjectHash?: InputMaybe<StringUpdate>;
  platformStaffId?: InputMaybe<IdUpdate>;
  type?: InputMaybe<VerificationRequestTypeListUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type TestVerificationRequestUpdateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<TestVerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<TestVerificationRequestCreateWithoutEmployee>>;
  disconnect?: InputMaybe<Array<TestVerificationRequestWhereUnique>>;
  set?: InputMaybe<Array<TestVerificationRequestWhereUnique>>;
};

export type TestVerificationRequestUpdateRelationListWithoutPlatformStaff = {
  connect?: InputMaybe<Array<TestVerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<TestVerificationRequestCreateWithoutPlatformStaff>>;
  disconnect?: InputMaybe<Array<TestVerificationRequestWhereUnique>>;
  set?: InputMaybe<Array<TestVerificationRequestWhereUnique>>;
};

export type TestVerificationRequestUpdateRelationWithoutGeneratedReports = {
  connect?: InputMaybe<TestVerificationRequestWhereUnique>;
  create?: InputMaybe<TestVerificationRequestCreateWithoutGeneratedReports>;
  disconnect?: InputMaybe<TestVerificationRequestWhereUnique>;
  update?: InputMaybe<TestVerificationRequestUpdateWithoutGeneratedReports>;
};

export type TestVerificationRequestUpdateRelationWithoutInboxItem = {
  connect?: InputMaybe<TestVerificationRequestWhereUnique>;
  create?: InputMaybe<TestVerificationRequestCreateWithoutInboxItem>;
  disconnect?: InputMaybe<TestVerificationRequestWhereUnique>;
  update?: InputMaybe<TestVerificationRequestUpdateWithoutInboxItem>;
};

export type TestVerificationRequestUpdateWithoutGeneratedReports = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutTestVerificationRequests>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutTestVerificationRequest>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutTestVerificationRequests>;
  type?: InputMaybe<VerificationRequestTypeListUpdate>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestVerificationRequestUpdateWithoutInboxItem = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutTestVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutTestVerificationRequest>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutTestVerificationRequests>;
  type?: InputMaybe<VerificationRequestTypeListUpdate>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestVerificationRequestWhere = {
  AND?: InputMaybe<Array<TestVerificationRequestWhere>>;
  NOT?: InputMaybe<Array<TestVerificationRequestWhere>>;
  OR?: InputMaybe<Array<TestVerificationRequestWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  employee?: InputMaybe<EmployeeWhere>;
  employeeId?: InputMaybe<IdFilter>;
  generatedReports?: InputMaybe<GeneratedReportWhereRelationList>;
  id?: InputMaybe<IdFilter>;
  inboxItem?: InputMaybe<InboxItemWhere>;
  inboxItemId?: InputMaybe<IdFilter>;
  mdmMetadataObjectHash?: InputMaybe<StringFilter>;
  platformStaff?: InputMaybe<PlatformStaffWhere>;
  platformStaffId?: InputMaybe<IdFilter>;
  type?: InputMaybe<VerificationRequestTypeListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TestVerificationRequestWhereRelationList = {
  every?: InputMaybe<TestVerificationRequestWhere>;
  none?: InputMaybe<TestVerificationRequestWhere>;
  some?: InputMaybe<TestVerificationRequestWhere>;
};

export type TestVerificationRequestWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  inboxItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateInboxItemUnreadStatusesInput = {
  inboxItemId: Scalars['ID']['input'];
};

export type UpdatePeoStaffDetailsInput = {
  accessRestriction?: InputMaybe<PeoStaffAccessRestrictionInput>;
  role?: InputMaybe<PeoStaffRole>;
  userStatus?: InputMaybe<UserStatus>;
};

export type UpdateUserRoleInput = {
  employerStaffRole?: InputMaybe<EmployerStaffRole>;
  status?: InputMaybe<UserStatus>;
  verifierStaffRole?: InputMaybe<VerifierStaffRole>;
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['ID']['output']>;
  avatar?: Maybe<File>;
  avatarId?: Maybe<Scalars['ID']['output']>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  employee?: Maybe<Employee>;
  employerStaff?: Maybe<EmployerStaff>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inboxItemUnreadStatusesCount: Scalars['Int']['output'];
  inboxItemUnreadStatusesList: Array<InboxItemUnreadStatus>;
  invite?: Maybe<Invite>;
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPasswordChangeAt?: Maybe<Scalars['DateTime']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  notificationSettings: Array<UsersNotificationSetting>;
  peoPayrollProviderStaff?: Maybe<PeoPayrollProviderStaff>;
  peoStaff?: Maybe<PeoStaff>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  platformStaff?: Maybe<PlatformStaff>;
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  role: UserRole;
  status: UserStatus;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userEmailChangeRequest?: Maybe<UserEmailChangeRequest>;
  userPasswordChangeRequest?: Maybe<UserPasswordChangeRequest>;
  userPasswordResetRequest?: Maybe<UserPasswordResetRequest>;
  verifierStaff?: Maybe<VerifierStaff>;
};

export type UserInboxItemUnreadStatusesCountArgs = {
  where?: InputMaybe<InboxItemUnreadStatusWhere>;
};

export type UserInboxItemUnreadStatusesListArgs = {
  orderBy?: InputMaybe<Array<InboxItemUnreadStatusOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InboxItemUnreadStatusWhere>;
};

export type UserCreate = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateMany = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserCreateRelationListWithoutAvatar = {
  connect?: InputMaybe<Array<UserWhereUnique>>;
  create?: InputMaybe<Array<UserCreateWithoutAvatar>>;
};

export type UserCreateRelationWithoutAddress = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutAddress>;
};

export type UserCreateRelationWithoutEmployee = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutEmployee>;
};

export type UserCreateRelationWithoutEmployerStaff = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutEmployerStaff>;
};

export type UserCreateRelationWithoutInboxItemUnreadStatuses = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutInboxItemUnreadStatuses>;
};

export type UserCreateRelationWithoutInvite = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutInvite>;
};

export type UserCreateRelationWithoutPeoPayrollProviderStaff = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutPeoPayrollProviderStaff>;
};

export type UserCreateRelationWithoutPeoStaff = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutPeoStaff>;
};

export type UserCreateRelationWithoutPlatformStaff = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutPlatformStaff>;
};

export type UserCreateRelationWithoutUserEmailChangeRequest = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutUserEmailChangeRequest>;
};

export type UserCreateRelationWithoutUserPasswordChangeRequest = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutUserPasswordChangeRequest>;
};

export type UserCreateRelationWithoutUserPasswordResetRequest = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutUserPasswordResetRequest>;
};

export type UserCreateRelationWithoutVerifierStaff = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutVerifierStaff>;
};

export type UserCreateWithoutAddress = {
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutAvatar = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutEmployee = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutEmployerStaff = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutInboxItemUnreadStatuses = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutInvite = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutPeoPayrollProviderStaff = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutPeoStaff = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutPlatformStaff = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutUserEmailChangeRequest = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutUserPasswordChangeRequest = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutUserPasswordResetRequest = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffCreateRelationWithoutUser>;
};

export type UserCreateWithoutVerifierStaff = {
  address?: InputMaybe<AddressCreateRelationWithoutUser>;
  avatar?: InputMaybe<FileCreateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employee?: InputMaybe<EmployeeCreateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffCreateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusCreateRelationListWithoutUser>;
  invite?: InputMaybe<InviteCreateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPasswordChangeAt?: InputMaybe<Scalars['DateTime']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<Array<UsersNotificationSetting>>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffCreateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffCreateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutUser>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: UserRole;
  status?: InputMaybe<UserStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestCreateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestCreateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestCreateRelationWithoutUser>;
};

export type UserDataShapeForNewEmployeeOnDataDisputeCreation = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type UserEmailChangeRequest = {
  __typename?: 'UserEmailChangeRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  newEmail: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserEmailChangeRequestCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  newEmail: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutUserEmailChangeRequest;
};

export type UserEmailChangeRequestCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  newEmail: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type UserEmailChangeRequestCreateRelationWithoutUser = {
  connect?: InputMaybe<UserEmailChangeRequestWhereUnique>;
  create?: InputMaybe<UserEmailChangeRequestCreateWithoutUser>;
};

export type UserEmailChangeRequestCreateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  newEmail: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserEmailChangeRequestOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  newEmail?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
};

export type UserEmailChangeRequestUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  newEmail?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutUserEmailChangeRequest>;
};

export type UserEmailChangeRequestUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  newEmail?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  userId?: InputMaybe<IdUpdate>;
};

export type UserEmailChangeRequestUpdateRelationWithoutUser = {
  connect?: InputMaybe<UserEmailChangeRequestWhereUnique>;
  create?: InputMaybe<UserEmailChangeRequestCreateWithoutUser>;
  disconnect?: InputMaybe<UserEmailChangeRequestWhereUnique>;
  update?: InputMaybe<UserEmailChangeRequestUpdateWithoutUser>;
};

export type UserEmailChangeRequestUpdateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  newEmail?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserEmailChangeRequestWhere = {
  AND?: InputMaybe<Array<UserEmailChangeRequestWhere>>;
  NOT?: InputMaybe<Array<UserEmailChangeRequestWhere>>;
  OR?: InputMaybe<Array<UserEmailChangeRequestWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  newEmail?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
};

export type UserEmailChangeRequestWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  newEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserOrderBy = {
  address?: InputMaybe<AddressOrderBy>;
  addressId?: InputMaybe<SortOrderInput>;
  avatar?: InputMaybe<FileOrderBy>;
  avatarId?: InputMaybe<SortOrderInput>;
  birthDate?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employerStaff?: InputMaybe<EmployerStaffOrderBy>;
  firstName?: InputMaybe<SortOrderInput>;
  fullName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  invite?: InputMaybe<InviteOrderBy>;
  invitedAt?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrderInput>;
  lastPasswordChangeAt?: InputMaybe<SortOrderInput>;
  middleName?: InputMaybe<SortOrderInput>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffOrderBy>;
  peoStaff?: InputMaybe<PeoStaffOrderBy>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  platformStaff?: InputMaybe<PlatformStaffOrderBy>;
  registeredAt?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestOrderBy>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestOrderBy>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestOrderBy>;
  verifierStaff?: InputMaybe<VerifierStaffOrderBy>;
};

export type UserPasswordChangeRequest = {
  __typename?: 'UserPasswordChangeRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserPasswordChangeRequestCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutUserPasswordChangeRequest;
};

export type UserPasswordChangeRequestCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type UserPasswordChangeRequestCreateRelationWithoutUser = {
  connect?: InputMaybe<UserPasswordChangeRequestWhereUnique>;
  create?: InputMaybe<UserPasswordChangeRequestCreateWithoutUser>;
};

export type UserPasswordChangeRequestCreateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserPasswordChangeRequestOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPasswordChangeRequestUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutUserPasswordChangeRequest>;
};

export type UserPasswordChangeRequestUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  userId?: InputMaybe<IdUpdate>;
};

export type UserPasswordChangeRequestUpdateRelationWithoutUser = {
  connect?: InputMaybe<UserPasswordChangeRequestWhereUnique>;
  create?: InputMaybe<UserPasswordChangeRequestCreateWithoutUser>;
  disconnect?: InputMaybe<UserPasswordChangeRequestWhereUnique>;
  update?: InputMaybe<UserPasswordChangeRequestUpdateWithoutUser>;
};

export type UserPasswordChangeRequestUpdateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserPasswordChangeRequestWhere = {
  AND?: InputMaybe<Array<UserPasswordChangeRequestWhere>>;
  NOT?: InputMaybe<Array<UserPasswordChangeRequestWhere>>;
  OR?: InputMaybe<Array<UserPasswordChangeRequestWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
};

export type UserPasswordChangeRequestWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserPasswordResetRequest = {
  __typename?: 'UserPasswordResetRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserPasswordResetRequestCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutUserPasswordResetRequest;
};

export type UserPasswordResetRequestCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type UserPasswordResetRequestCreateRelationWithoutUser = {
  connect?: InputMaybe<UserPasswordResetRequestWhereUnique>;
  create?: InputMaybe<UserPasswordResetRequestCreateWithoutUser>;
};

export type UserPasswordResetRequestCreateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserPasswordResetRequestOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPasswordResetRequestUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateRelationWithoutUserPasswordResetRequest>;
};

export type UserPasswordResetRequestUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  userId?: InputMaybe<IdUpdate>;
};

export type UserPasswordResetRequestUpdateRelationWithoutUser = {
  connect?: InputMaybe<UserPasswordResetRequestWhereUnique>;
  create?: InputMaybe<UserPasswordResetRequestCreateWithoutUser>;
  disconnect?: InputMaybe<UserPasswordResetRequestWhereUnique>;
  update?: InputMaybe<UserPasswordResetRequestUpdateWithoutUser>;
};

export type UserPasswordResetRequestUpdateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserPasswordResetRequestWhere = {
  AND?: InputMaybe<Array<UserPasswordResetRequestWhere>>;
  NOT?: InputMaybe<Array<UserPasswordResetRequestWhere>>;
  OR?: InputMaybe<Array<UserPasswordResetRequestWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
};

export type UserPasswordResetRequestWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export const UserRole = {
  Administrator: 'Administrator',
  Employee: 'Employee',
  EmployerAdmin: 'Employer_Admin',
  EmployerManager: 'Employer_Manager',
  Guest: 'Guest',
  PeoAdmin: 'Peo_Admin',
  PeoManager: 'Peo_Manager',
  PeoPayrollProviderUser: 'Peo_Payroll_Provider_User',
  PeoSuperAdmin: 'Peo_Super_Admin',
  PlatformAdmin: 'Platform_Admin',
  PlatformManager: 'Platform_Manager',
  VerifierAdmin: 'Verifier_Admin',
  VerifierManager: 'Verifier_Manager',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];
export type UserRoleFilter = {
  equals?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<UserRole>>;
  not?: InputMaybe<UserRoleFilter>;
  notIn?: InputMaybe<Array<UserRole>>;
};

export type UserRoleUpdate = {
  set?: InputMaybe<UserRole>;
};

export const UserStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  Pending: 'Pending',
} as const;

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];
export type UserStatusFilter = {
  equals?: InputMaybe<UserStatus>;
  in?: InputMaybe<Array<UserStatus>>;
  not?: InputMaybe<UserStatusFilter>;
  notIn?: InputMaybe<Array<UserStatus>>;
};

export type UserType = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UserUpdate = {
  address?: InputMaybe<AddressUpdateRelationWithoutUser>;
  avatar?: InputMaybe<FileUpdateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffUpdateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutUser>;
  invite?: InputMaybe<InviteUpdateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffUpdateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffUpdateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutUser>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestUpdateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestUpdateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestUpdateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutUser>;
};

export type UserUpdateMany = {
  addressId?: InputMaybe<IdUpdate>;
  avatarId?: InputMaybe<IdUpdate>;
  birthDate?: InputMaybe<DateTimeUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  firstName?: InputMaybe<StringUpdate>;
  fullName?: InputMaybe<StringUpdate>;
  invitedAt?: InputMaybe<DateTimeUpdate>;
  lastName?: InputMaybe<StringUpdate>;
  middleName?: InputMaybe<StringUpdate>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  phoneNumber?: InputMaybe<StringUpdate>;
  timezone?: InputMaybe<StringUpdate>;
  title?: InputMaybe<StringUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type UserUpdateRelationListWithoutAvatar = {
  connect?: InputMaybe<Array<UserWhereUnique>>;
  create?: InputMaybe<Array<UserCreateWithoutAvatar>>;
  disconnect?: InputMaybe<Array<UserWhereUnique>>;
  set?: InputMaybe<Array<UserWhereUnique>>;
};

export type UserUpdateRelationWithoutAddress = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutAddress>;
  disconnect?: InputMaybe<UserWhereUnique>;
  update?: InputMaybe<UserUpdateWithoutAddress>;
};

export type UserUpdateRelationWithoutEmployee = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutEmployee>;
  disconnect?: InputMaybe<UserWhereUnique>;
  update?: InputMaybe<UserUpdateWithoutEmployee>;
};

export type UserUpdateRelationWithoutInboxItemUnreadStatuses = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutInboxItemUnreadStatuses>;
  disconnect?: InputMaybe<UserWhereUnique>;
  update?: InputMaybe<UserUpdateWithoutInboxItemUnreadStatuses>;
};

export type UserUpdateRelationWithoutInvite = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutInvite>;
  disconnect?: InputMaybe<UserWhereUnique>;
  update?: InputMaybe<UserUpdateWithoutInvite>;
};

export type UserUpdateRelationWithoutPlatformStaff = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutPlatformStaff>;
  disconnect?: InputMaybe<UserWhereUnique>;
  update?: InputMaybe<UserUpdateWithoutPlatformStaff>;
};

export type UserUpdateRelationWithoutUserEmailChangeRequest = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutUserEmailChangeRequest>;
  disconnect?: InputMaybe<UserWhereUnique>;
  update?: InputMaybe<UserUpdateWithoutUserEmailChangeRequest>;
};

export type UserUpdateRelationWithoutUserPasswordChangeRequest = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutUserPasswordChangeRequest>;
  disconnect?: InputMaybe<UserWhereUnique>;
  update?: InputMaybe<UserUpdateWithoutUserPasswordChangeRequest>;
};

export type UserUpdateRelationWithoutUserPasswordResetRequest = {
  connect?: InputMaybe<UserWhereUnique>;
  create?: InputMaybe<UserCreateWithoutUserPasswordResetRequest>;
  disconnect?: InputMaybe<UserWhereUnique>;
  update?: InputMaybe<UserUpdateWithoutUserPasswordResetRequest>;
};

export type UserUpdateWithoutAddress = {
  avatar?: InputMaybe<FileUpdateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffUpdateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutUser>;
  invite?: InputMaybe<InviteUpdateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffUpdateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffUpdateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutUser>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestUpdateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestUpdateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestUpdateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutUser>;
};

export type UserUpdateWithoutEmployee = {
  address?: InputMaybe<AddressUpdateRelationWithoutUser>;
  avatar?: InputMaybe<FileUpdateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employerStaff?: InputMaybe<EmployerStaffUpdateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutUser>;
  invite?: InputMaybe<InviteUpdateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffUpdateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffUpdateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutUser>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestUpdateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestUpdateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestUpdateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutUser>;
};

export type UserUpdateWithoutInboxItemUnreadStatuses = {
  address?: InputMaybe<AddressUpdateRelationWithoutUser>;
  avatar?: InputMaybe<FileUpdateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffUpdateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<InviteUpdateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffUpdateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffUpdateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutUser>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestUpdateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestUpdateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestUpdateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutUser>;
};

export type UserUpdateWithoutInvite = {
  address?: InputMaybe<AddressUpdateRelationWithoutUser>;
  avatar?: InputMaybe<FileUpdateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffUpdateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffUpdateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffUpdateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutUser>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestUpdateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestUpdateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestUpdateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutUser>;
};

export type UserUpdateWithoutPlatformStaff = {
  address?: InputMaybe<AddressUpdateRelationWithoutUser>;
  avatar?: InputMaybe<FileUpdateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffUpdateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutUser>;
  invite?: InputMaybe<InviteUpdateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffUpdateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffUpdateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestUpdateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestUpdateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestUpdateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutUser>;
};

export type UserUpdateWithoutUserEmailChangeRequest = {
  address?: InputMaybe<AddressUpdateRelationWithoutUser>;
  avatar?: InputMaybe<FileUpdateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffUpdateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutUser>;
  invite?: InputMaybe<InviteUpdateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffUpdateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffUpdateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutUser>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestUpdateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestUpdateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutUser>;
};

export type UserUpdateWithoutUserPasswordChangeRequest = {
  address?: InputMaybe<AddressUpdateRelationWithoutUser>;
  avatar?: InputMaybe<FileUpdateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffUpdateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutUser>;
  invite?: InputMaybe<InviteUpdateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffUpdateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffUpdateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutUser>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestUpdateRelationWithoutUser>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestUpdateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutUser>;
};

export type UserUpdateWithoutUserPasswordResetRequest = {
  address?: InputMaybe<AddressUpdateRelationWithoutUser>;
  avatar?: InputMaybe<FileUpdateRelationWithoutUserAvatars>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutUser>;
  employerStaff?: InputMaybe<EmployerStaffUpdateRelationWithoutUser>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusUpdateRelationListWithoutUser>;
  invite?: InputMaybe<InviteUpdateRelationWithoutUser>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListUpdate>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffUpdateRelationWithoutUser>;
  peoStaff?: InputMaybe<PeoStaffUpdateRelationWithoutUser>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutUser>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestUpdateRelationWithoutUser>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestUpdateRelationWithoutUser>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutUser>;
};

export type UserWhere = {
  AND?: InputMaybe<Array<UserWhere>>;
  NOT?: InputMaybe<Array<UserWhere>>;
  OR?: InputMaybe<Array<UserWhere>>;
  address?: InputMaybe<AddressWhere>;
  addressId?: InputMaybe<IdFilter>;
  avatar?: InputMaybe<FileWhere>;
  avatarId?: InputMaybe<IdFilter>;
  birthDate?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  employee?: InputMaybe<EmployeeWhere>;
  employerStaff?: InputMaybe<EmployerStaffWhere>;
  firstName?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  inboxItemUnreadStatuses?: InputMaybe<InboxItemUnreadStatusWhereRelationList>;
  invite?: InputMaybe<InviteWhere>;
  invitedAt?: InputMaybe<DateTimeFilter>;
  lastName?: InputMaybe<StringFilter>;
  lastPasswordChangeAt?: InputMaybe<DateTimeFilter>;
  middleName?: InputMaybe<StringFilter>;
  notificationSettings?: InputMaybe<UsersNotificationSettingListFilter>;
  peoPayrollProviderStaff?: InputMaybe<PeoPayrollProviderStaffWhere>;
  peoStaff?: InputMaybe<PeoStaffWhere>;
  phoneNumber?: InputMaybe<StringFilter>;
  platformStaff?: InputMaybe<PlatformStaffWhere>;
  registeredAt?: InputMaybe<DateTimeFilter>;
  role?: InputMaybe<UserRoleFilter>;
  status?: InputMaybe<UserStatusFilter>;
  timezone?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userEmailChangeRequest?: InputMaybe<UserEmailChangeRequestWhere>;
  userPasswordChangeRequest?: InputMaybe<UserPasswordChangeRequestWhere>;
  userPasswordResetRequest?: InputMaybe<UserPasswordResetRequestWhere>;
  verifierStaff?: InputMaybe<VerifierStaffWhere>;
};

export type UserWhereRelationList = {
  every?: InputMaybe<UserWhere>;
  none?: InputMaybe<UserWhere>;
  some?: InputMaybe<UserWhere>;
};

export type UserWhereUnique = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export const UsersNotificationSetting = {
  ComVerifierPaymentDeclined: 'com_verifier_payment_declined',
  ComVerifierReportGenerated: 'com_verifier_report_generated',
  ComVerifierRequestApproved: 'com_verifier_request_approved',
  ComVerifierRequestDeclined: 'com_verifier_request_declined',
  ComVerifierRequestSent: 'com_verifier_request_sent',
  CvDataDisputeInitiated: 'cv_data_dispute_initiated',
  CvEmployeeSentMyVerify: 'cv_employee_sent_my_verify',
  CvEmployerInvited: 'cv_employer_invited',
  CvEmployerSignedUp: 'cv_employer_signed_up',
  CvInboxItemCommented: 'cv_inbox_item_commented',
  CvNewDataDeleteRequest: 'cv_new_data_delete_request',
  CvNewGetHelpRequest: 'cv_new_get_help_request',
  CvPaymentDeclined: 'cv_payment_declined',
  CvPaymentReceived: 'cv_payment_received',
  CvReportCreatedStatus: 'cv_report_created_status',
  CvVerifierInvited: 'cv_verifier_invited',
  CvVerifierSignedUp: 'cv_verifier_signed_up',
  EmployeeAskForApproval: 'employee_ask_for_approval',
  EmployeeDeclinedByVerifier: 'employee_declined_by_verifier',
  EmployeeDisputeStarted: 'employee_dispute_started',
  EmployeeMyVerifySent: 'employee_my_verify_sent',
  EmployeeReportGenerated: 'employee_report_generated',
  EmployeeReportReviewed: 'employee_report_reviewed',
  EmployeeRespondedToRequest: 'employee_responded_to_request',
  EmployeeSmsAskForApproval: 'employee_sms_ask_for_approval',
  EmployerDisputeStarted: 'employer_dispute_started',
  EmployerRevenueShareReceived: 'employer_revenue_share_received',
  EmployerUnderPeoDisputeResolved: 'employer_under_peo_dispute_resolved',
  EmployerUnderPeoDisputeStarted: 'employer_under_peo_dispute_started',
  ErrorSendingRevenueSharePeoPayrollProvider: 'error_sending_revenue_share_peo_payroll_provider',
  ErrorSendingRevenueShareToEmployer: 'error_sending_revenue_share_to_employer',
  ErrorSendingRevenueShareToPeo: 'error_sending_revenue_share_to_peo',
  GetHelpNotificationSent: 'get_help_notification_sent',
  GovVerifierReportGenerated: 'gov_verifier_report_generated',
  GovVerifierRequestSent: 'gov_verifier_request_sent',
  InboxItemCommentedByPlatformStaff: 'inbox_item_commented_by_platform_staff',
  PeoDisputeStarted: 'peo_dispute_started',
  PeoPayrollProviderInvited: 'peo_payroll_provider_invited',
  PeoRevenueShareReceived: 'peo_revenue_share_received',
  PpProviderDataDisputeStarted: 'pp_provider_data_dispute_started',
  PpProviderEmployersAddedByPeo: 'pp_provider_employers_added_by_peo',
  PpProviderFeinsAddedByPeo: 'pp_provider_feins_added_by_peo',
  PpProviderLocationsAddedByPeo: 'pp_provider_locations_added_by_peo',
  PpProviderRevenueShareReceived: 'pp_provider_revenue_share_received',
} as const;

export type UsersNotificationSetting =
  (typeof UsersNotificationSetting)[keyof typeof UsersNotificationSetting];
export type UsersNotificationSettingListFilter = {
  equals?: InputMaybe<Array<UsersNotificationSetting>>;
  has?: InputMaybe<UsersNotificationSetting>;
  hasEvery?: InputMaybe<Array<UsersNotificationSetting>>;
  hasSome?: InputMaybe<Array<UsersNotificationSetting>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UsersNotificationSettingListUpdate = {
  push?: InputMaybe<Array<UsersNotificationSetting>>;
  set?: InputMaybe<Array<UsersNotificationSetting>>;
};

export type ValidateSignupEmployeeDataResponse = {
  __typename?: 'ValidateSignupEmployeeDataResponse';
  employeeSignupToken: Scalars['String']['output'];
};

export type ValidateSignupEmployeePinOrSsnResponse = {
  __typename?: 'ValidateSignupEmployeePinOrSsnResponse';
  employeeSignupToken: Scalars['String']['output'];
};

export type VerificationRequest = {
  __typename?: 'VerificationRequest';
  createdAt: Scalars['DateTime']['output'];
  creator: VerificationRequestCreator;
  dataDisputesCount: Scalars['Int']['output'];
  dataDisputesList: Array<DataDispute>;
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  employersCount: Scalars['Int']['output'];
  employersList: Array<Employer>;
  generatedReportsCount: Scalars['Int']['output'];
  generatedReportsList: Array<GeneratedReport>;
  id: Scalars['ID']['output'];
  inboxItem: InboxItem;
  inboxItemId: Scalars['ID']['output'];
  isManual: Scalars['Boolean']['output'];
  isMyVerifyRequest: Scalars['Boolean']['output'];
  isReverification: Scalars['Boolean']['output'];
  mdmMetadata?: Maybe<Scalars['Json']['output']>;
  mdmMetadataObjectHash?: Maybe<Scalars['String']['output']>;
  noteToEmployee?: Maybe<Scalars['String']['output']>;
  paymentTransactionsCount: Scalars['Int']['output'];
  paymentTransactionsList: Array<PaymentTransaction>;
  permissiblePurpose?: Maybe<PermissiblePurpose>;
  permissiblePurposeId?: Maybe<Scalars['ID']['output']>;
  permissiblePurposeValue?: Maybe<Scalars['Int']['output']>;
  platformStaff?: Maybe<PlatformStaff>;
  platformStaffId?: Maybe<Scalars['ID']['output']>;
  status: VerificationRequestStatus;
  stripeFailedPaymentMessage?: Maybe<Scalars['String']['output']>;
  stripePaymentStatus?: Maybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<VerificationRequestType>;
  updatedAt: Scalars['DateTime']['output'];
  verifierStaff: VerifierStaff;
  verifierStaffId: Scalars['ID']['output'];
};

export type VerificationRequestDataDisputesCountArgs = {
  where?: InputMaybe<DataDisputeWhere>;
};

export type VerificationRequestDataDisputesListArgs = {
  orderBy?: InputMaybe<Array<DataDisputeOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataDisputeWhere>;
};

export type VerificationRequestEmployersCountArgs = {
  where?: InputMaybe<EmployerWhere>;
};

export type VerificationRequestEmployersListArgs = {
  orderBy?: InputMaybe<Array<EmployerOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployerWhere>;
};

export type VerificationRequestGeneratedReportsCountArgs = {
  where?: InputMaybe<GeneratedReportWhere>;
};

export type VerificationRequestGeneratedReportsListArgs = {
  orderBy?: InputMaybe<Array<GeneratedReportOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GeneratedReportWhere>;
};

export type VerificationRequestPaymentTransactionsCountArgs = {
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type VerificationRequestPaymentTransactionsListArgs = {
  orderBy?: InputMaybe<Array<PaymentTransactionOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentTransactionWhere>;
};

export type VerificationRequestCompanyData = {
  checksum: Scalars['String']['input'];
  employeeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  topLevelCompanyId: Scalars['ID']['input'];
};

export type VerificationRequestCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutVerificationRequest>;
  employee: EmployeeCreateRelationWithoutVerificationRequests;
  employers?: InputMaybe<EmployerCreateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutVerificationRequest;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeCreateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff: VerifierStaffCreateRelationWithoutVerificationRequests;
};

export type VerificationRequestCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  employeeId: Scalars['ID']['input'];
  inboxItemId: Scalars['ID']['input'];
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  permissiblePurposeId?: InputMaybe<Scalars['ID']['input']>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaffId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaffId: Scalars['ID']['input'];
};

export type VerificationRequestCreateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutEmployee>>;
};

export type VerificationRequestCreateRelationListWithoutEmployers = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutEmployers>>;
};

export type VerificationRequestCreateRelationListWithoutPermissiblePurpose = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutPermissiblePurpose>>;
};

export type VerificationRequestCreateRelationListWithoutPlatformStaff = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutPlatformStaff>>;
};

export type VerificationRequestCreateRelationListWithoutVerifierStaff = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutVerifierStaff>>;
};

export type VerificationRequestCreateRelationWithoutDataDisputes = {
  connect?: InputMaybe<VerificationRequestWhereUnique>;
  create?: InputMaybe<VerificationRequestCreateWithoutDataDisputes>;
};

export type VerificationRequestCreateRelationWithoutGeneratedReports = {
  connect?: InputMaybe<VerificationRequestWhereUnique>;
  create?: InputMaybe<VerificationRequestCreateWithoutGeneratedReports>;
};

export type VerificationRequestCreateRelationWithoutInboxItem = {
  connect?: InputMaybe<VerificationRequestWhereUnique>;
  create?: InputMaybe<VerificationRequestCreateWithoutInboxItem>;
};

export type VerificationRequestCreateRelationWithoutPaymentTransactions = {
  connect?: InputMaybe<VerificationRequestWhereUnique>;
  create?: InputMaybe<VerificationRequestCreateWithoutPaymentTransactions>;
};

export type VerificationRequestCreateWithoutDataDisputes = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  employee: EmployeeCreateRelationWithoutVerificationRequests;
  employers?: InputMaybe<EmployerCreateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutVerificationRequest;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeCreateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff: VerifierStaffCreateRelationWithoutVerificationRequests;
};

export type VerificationRequestCreateWithoutEmployee = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutVerificationRequest>;
  employers?: InputMaybe<EmployerCreateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutVerificationRequest;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeCreateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff: VerifierStaffCreateRelationWithoutVerificationRequests;
};

export type VerificationRequestCreateWithoutEmployers = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutVerificationRequest>;
  employee: EmployeeCreateRelationWithoutVerificationRequests;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutVerificationRequest;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeCreateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff: VerifierStaffCreateRelationWithoutVerificationRequests;
};

export type VerificationRequestCreateWithoutGeneratedReports = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutVerificationRequest>;
  employee: EmployeeCreateRelationWithoutVerificationRequests;
  employers?: InputMaybe<EmployerCreateRelationListWithoutVerificationRequests>;
  inboxItem: InboxItemCreateRelationWithoutVerificationRequest;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeCreateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff: VerifierStaffCreateRelationWithoutVerificationRequests;
};

export type VerificationRequestCreateWithoutInboxItem = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutVerificationRequest>;
  employee: EmployeeCreateRelationWithoutVerificationRequests;
  employers?: InputMaybe<EmployerCreateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutVerificationRequest>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeCreateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff: VerifierStaffCreateRelationWithoutVerificationRequests;
};

export type VerificationRequestCreateWithoutPaymentTransactions = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutVerificationRequest>;
  employee: EmployeeCreateRelationWithoutVerificationRequests;
  employers?: InputMaybe<EmployerCreateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutVerificationRequest;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeCreateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff: VerifierStaffCreateRelationWithoutVerificationRequests;
};

export type VerificationRequestCreateWithoutPermissiblePurpose = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutVerificationRequest>;
  employee: EmployeeCreateRelationWithoutVerificationRequests;
  employers?: InputMaybe<EmployerCreateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutVerificationRequest;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutVerificationRequest>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff: VerifierStaffCreateRelationWithoutVerificationRequests;
};

export type VerificationRequestCreateWithoutPlatformStaff = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutVerificationRequest>;
  employee: EmployeeCreateRelationWithoutVerificationRequests;
  employers?: InputMaybe<EmployerCreateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutVerificationRequest;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeCreateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff: VerifierStaffCreateRelationWithoutVerificationRequests;
};

export type VerificationRequestCreateWithoutVerifierStaff = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeCreateRelationListWithoutVerificationRequest>;
  employee: EmployeeCreateRelationWithoutVerificationRequests;
  employers?: InputMaybe<EmployerCreateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportCreateRelationListWithoutVerificationRequest>;
  inboxItem: InboxItemCreateRelationWithoutVerificationRequest;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeCreateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffCreateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export const VerificationRequestCreator = {
  Employee: 'Employee',
  PlatformStaff: 'Platform_Staff',
  VerifierStaff: 'Verifier_Staff',
} as const;

export type VerificationRequestCreator =
  (typeof VerificationRequestCreator)[keyof typeof VerificationRequestCreator];
export type VerificationRequestCreatorFilter = {
  equals?: InputMaybe<VerificationRequestCreator>;
  in?: InputMaybe<Array<VerificationRequestCreator>>;
  not?: InputMaybe<VerificationRequestCreatorFilter>;
  notIn?: InputMaybe<Array<VerificationRequestCreator>>;
};

export type VerificationRequestCreatorUpdate = {
  set?: InputMaybe<VerificationRequestCreator>;
};

export type VerificationRequestForReport = {
  __typename?: 'VerificationRequestForReport';
  createdAt: Scalars['DateTime']['output'];
  employeeAvatar?: Maybe<FileResponse>;
  employeeFullName?: Maybe<Scalars['String']['output']>;
  employers?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inboxItemId: Scalars['ID']['output'];
  peos?: Maybe<Scalars['String']['output']>;
  permissiblePurposeLabel?: Maybe<Scalars['String']['output']>;
  status: VerificationRequestStatus;
  type?: Maybe<VerificationRequestType>;
  verifierDisplayName?: Maybe<Scalars['String']['output']>;
  verifierStaffFullName?: Maybe<Scalars['String']['output']>;
};

export type VerificationRequestOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  creator?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderBy>;
  employeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inboxItem?: InputMaybe<InboxItemOrderBy>;
  inboxItemId?: InputMaybe<SortOrder>;
  isManual?: InputMaybe<SortOrder>;
  isMyVerifyRequest?: InputMaybe<SortOrder>;
  isReverification?: InputMaybe<SortOrder>;
  mdmMetadata?: InputMaybe<SortOrderInput>;
  mdmMetadataObjectHash?: InputMaybe<SortOrderInput>;
  noteToEmployee?: InputMaybe<SortOrderInput>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeOrderBy>;
  permissiblePurposeId?: InputMaybe<SortOrderInput>;
  permissiblePurposeValue?: InputMaybe<SortOrderInput>;
  platformStaff?: InputMaybe<PlatformStaffOrderBy>;
  platformStaffId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  stripeFailedPaymentMessage?: InputMaybe<SortOrderInput>;
  stripePaymentStatus?: InputMaybe<SortOrderInput>;
  totalChargeAmount?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verifierStaff?: InputMaybe<VerifierStaffOrderBy>;
  verifierStaffId?: InputMaybe<SortOrder>;
};

export const VerificationRequestStatus = {
  DeclinedByEmployee: 'Declined_By_Employee',
  DeclinedByVerifier: 'Declined_By_Verifier',
  EmployeeToRespond: 'Employee_To_Respond',
  ReportCreated: 'Report_Created',
  ReviewedByVerifier: 'Reviewed_By_Verifier',
  VerifierToRespond: 'Verifier_To_Respond',
} as const;

export type VerificationRequestStatus =
  (typeof VerificationRequestStatus)[keyof typeof VerificationRequestStatus];
export type VerificationRequestStatusFilter = {
  equals?: InputMaybe<VerificationRequestStatus>;
  in?: InputMaybe<Array<VerificationRequestStatus>>;
  not?: InputMaybe<VerificationRequestStatusFilter>;
  notIn?: InputMaybe<Array<VerificationRequestStatus>>;
};

export type VerificationRequestStatusUpdate = {
  set?: InputMaybe<VerificationRequestStatus>;
};

export const VerificationRequestStripePaymentStatus = {
  Canceled: 'Canceled',
  Processing: 'Processing',
  Refunded: 'Refunded',
  Succeeded: 'Succeeded',
} as const;

export type VerificationRequestStripePaymentStatus =
  (typeof VerificationRequestStripePaymentStatus)[keyof typeof VerificationRequestStripePaymentStatus];
export type VerificationRequestStripePaymentStatusFilter = {
  equals?: InputMaybe<VerificationRequestStripePaymentStatus>;
  in?: InputMaybe<Array<VerificationRequestStripePaymentStatus>>;
  not?: InputMaybe<VerificationRequestStripePaymentStatusFilter>;
  notIn?: InputMaybe<Array<VerificationRequestStripePaymentStatus>>;
};

export type VerificationRequestStripePaymentStatusUpdate = {
  set?: InputMaybe<VerificationRequestStripePaymentStatus>;
};

export const VerificationRequestType = {
  GovernmentalVerification: 'Governmental_Verification',
  VerificationOfEmployment: 'Verification_Of_Employment',
  VerificationOfIncome: 'Verification_Of_Income',
} as const;

export type VerificationRequestType =
  (typeof VerificationRequestType)[keyof typeof VerificationRequestType];
export type VerificationRequestTypeFilter = {
  equals?: InputMaybe<VerificationRequestType>;
  in?: InputMaybe<Array<VerificationRequestType>>;
  not?: InputMaybe<VerificationRequestTypeFilter>;
  notIn?: InputMaybe<Array<VerificationRequestType>>;
};

export type VerificationRequestTypeListFilter = {
  equals?: InputMaybe<Array<VerificationRequestType>>;
  has?: InputMaybe<VerificationRequestType>;
  hasEvery?: InputMaybe<Array<VerificationRequestType>>;
  hasSome?: InputMaybe<Array<VerificationRequestType>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerificationRequestTypeListUpdate = {
  push?: InputMaybe<Array<VerificationRequestType>>;
  set?: InputMaybe<Array<VerificationRequestType>>;
};

export type VerificationRequestTypeUpdate = {
  set?: InputMaybe<VerificationRequestType>;
};

export type VerificationRequestUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutVerificationRequest>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutVerificationRequests>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutVerificationRequest>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutVerificationRequest>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeUpdateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutVerificationRequests>;
};

export type VerificationRequestUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  creator?: InputMaybe<VerificationRequestCreatorUpdate>;
  employeeId?: InputMaybe<IdUpdate>;
  inboxItemId?: InputMaybe<IdUpdate>;
  isManual?: InputMaybe<BooleanUpdate>;
  isMyVerifyRequest?: InputMaybe<BooleanUpdate>;
  isReverification?: InputMaybe<BooleanUpdate>;
  mdmMetadata?: InputMaybe<JsonUpdate>;
  mdmMetadataObjectHash?: InputMaybe<StringUpdate>;
  noteToEmployee?: InputMaybe<StringUpdate>;
  permissiblePurposeId?: InputMaybe<IdUpdate>;
  permissiblePurposeValue?: InputMaybe<IntUpdate>;
  platformStaffId?: InputMaybe<IdUpdate>;
  status?: InputMaybe<VerificationRequestStatusUpdate>;
  stripeFailedPaymentMessage?: InputMaybe<StringUpdate>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatusUpdate>;
  totalChargeAmount?: InputMaybe<IntUpdate>;
  type?: InputMaybe<VerificationRequestTypeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  verifierStaffId?: InputMaybe<IdUpdate>;
};

export type VerificationRequestUpdateRelationListWithoutEmployee = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutEmployee>>;
  disconnect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  set?: InputMaybe<Array<VerificationRequestWhereUnique>>;
};

export type VerificationRequestUpdateRelationListWithoutEmployers = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutEmployers>>;
  disconnect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  set?: InputMaybe<Array<VerificationRequestWhereUnique>>;
};

export type VerificationRequestUpdateRelationListWithoutPermissiblePurpose = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutPermissiblePurpose>>;
  disconnect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  set?: InputMaybe<Array<VerificationRequestWhereUnique>>;
};

export type VerificationRequestUpdateRelationListWithoutPlatformStaff = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutPlatformStaff>>;
  disconnect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  set?: InputMaybe<Array<VerificationRequestWhereUnique>>;
};

export type VerificationRequestUpdateRelationListWithoutVerifierStaff = {
  connect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  create?: InputMaybe<Array<VerificationRequestCreateWithoutVerifierStaff>>;
  disconnect?: InputMaybe<Array<VerificationRequestWhereUnique>>;
  set?: InputMaybe<Array<VerificationRequestWhereUnique>>;
};

export type VerificationRequestUpdateRelationWithoutDataDisputes = {
  connect?: InputMaybe<VerificationRequestWhereUnique>;
  create?: InputMaybe<VerificationRequestCreateWithoutDataDisputes>;
  disconnect?: InputMaybe<VerificationRequestWhereUnique>;
  update?: InputMaybe<VerificationRequestUpdateWithoutDataDisputes>;
};

export type VerificationRequestUpdateRelationWithoutGeneratedReports = {
  connect?: InputMaybe<VerificationRequestWhereUnique>;
  create?: InputMaybe<VerificationRequestCreateWithoutGeneratedReports>;
  disconnect?: InputMaybe<VerificationRequestWhereUnique>;
  update?: InputMaybe<VerificationRequestUpdateWithoutGeneratedReports>;
};

export type VerificationRequestUpdateRelationWithoutInboxItem = {
  connect?: InputMaybe<VerificationRequestWhereUnique>;
  create?: InputMaybe<VerificationRequestCreateWithoutInboxItem>;
  disconnect?: InputMaybe<VerificationRequestWhereUnique>;
  update?: InputMaybe<VerificationRequestUpdateWithoutInboxItem>;
};

export type VerificationRequestUpdateRelationWithoutPaymentTransactions = {
  connect?: InputMaybe<VerificationRequestWhereUnique>;
  create?: InputMaybe<VerificationRequestCreateWithoutPaymentTransactions>;
  disconnect?: InputMaybe<VerificationRequestWhereUnique>;
  update?: InputMaybe<VerificationRequestUpdateWithoutPaymentTransactions>;
};

export type VerificationRequestUpdateWithoutDataDisputes = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutVerificationRequests>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutVerificationRequest>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutVerificationRequest>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeUpdateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutVerificationRequests>;
};

export type VerificationRequestUpdateWithoutGeneratedReports = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutVerificationRequest>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutVerificationRequests>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutVerificationRequests>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutVerificationRequest>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeUpdateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutVerificationRequests>;
};

export type VerificationRequestUpdateWithoutInboxItem = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutVerificationRequest>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutVerificationRequests>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutVerificationRequest>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateRelationListWithoutVerificationRequest>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeUpdateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutVerificationRequests>;
};

export type VerificationRequestUpdateWithoutPaymentTransactions = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<VerificationRequestCreator>;
  dataDisputes?: InputMaybe<DataDisputeUpdateRelationListWithoutVerificationRequest>;
  employee?: InputMaybe<EmployeeUpdateRelationWithoutVerificationRequests>;
  employers?: InputMaybe<EmployerUpdateRelationListWithoutVerificationRequests>;
  generatedReports?: InputMaybe<GeneratedReportUpdateRelationListWithoutVerificationRequest>;
  inboxItem?: InputMaybe<InboxItemUpdateRelationWithoutVerificationRequest>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVerifyRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isReverification?: InputMaybe<Scalars['Boolean']['input']>;
  mdmMetadata?: InputMaybe<Scalars['Json']['input']>;
  mdmMetadataObjectHash?: InputMaybe<Scalars['String']['input']>;
  noteToEmployee?: InputMaybe<Scalars['String']['input']>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeUpdateRelationWithoutVerificationRequests>;
  permissiblePurposeValue?: InputMaybe<Scalars['Int']['input']>;
  platformStaff?: InputMaybe<PlatformStaffUpdateRelationWithoutVerificationRequests>;
  status?: InputMaybe<VerificationRequestStatus>;
  stripeFailedPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatus>;
  totalChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VerificationRequestType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaff?: InputMaybe<VerifierStaffUpdateRelationWithoutVerificationRequests>;
};

export type VerificationRequestWhere = {
  AND?: InputMaybe<Array<VerificationRequestWhere>>;
  NOT?: InputMaybe<Array<VerificationRequestWhere>>;
  OR?: InputMaybe<Array<VerificationRequestWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<VerificationRequestCreatorFilter>;
  dataDisputes?: InputMaybe<DataDisputeWhereRelationList>;
  employee?: InputMaybe<EmployeeWhere>;
  employeeId?: InputMaybe<IdFilter>;
  employers?: InputMaybe<EmployerWhereRelationList>;
  generatedReports?: InputMaybe<GeneratedReportWhereRelationList>;
  id?: InputMaybe<IdFilter>;
  inboxItem?: InputMaybe<InboxItemWhere>;
  inboxItemId?: InputMaybe<IdFilter>;
  isManual?: InputMaybe<BooleanFilter>;
  isMyVerifyRequest?: InputMaybe<BooleanFilter>;
  isReverification?: InputMaybe<BooleanFilter>;
  mdmMetadataObjectHash?: InputMaybe<StringFilter>;
  noteToEmployee?: InputMaybe<StringFilter>;
  paymentTransactions?: InputMaybe<PaymentTransactionWhereRelationList>;
  permissiblePurpose?: InputMaybe<PermissiblePurposeWhere>;
  permissiblePurposeId?: InputMaybe<IdFilter>;
  permissiblePurposeValue?: InputMaybe<IntFilter>;
  platformStaff?: InputMaybe<PlatformStaffWhere>;
  platformStaffId?: InputMaybe<IdFilter>;
  status?: InputMaybe<VerificationRequestStatusFilter>;
  stripeFailedPaymentMessage?: InputMaybe<StringFilter>;
  stripePaymentStatus?: InputMaybe<VerificationRequestStripePaymentStatusFilter>;
  totalChargeAmount?: InputMaybe<IntFilter>;
  type?: InputMaybe<VerificationRequestTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verifierStaff?: InputMaybe<VerifierStaffWhere>;
  verifierStaffId?: InputMaybe<IdFilter>;
};

export type VerificationRequestWhereRelationList = {
  every?: InputMaybe<VerificationRequestWhere>;
  none?: InputMaybe<VerificationRequestWhere>;
  some?: InputMaybe<VerificationRequestWhere>;
};

export type VerificationRequestWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  inboxItemId?: InputMaybe<Scalars['ID']['input']>;
};

export const VerificationRequestsReportFormat = {
  Csv: 'CSV',
  Xlsx: 'XLSX',
} as const;

export type VerificationRequestsReportFormat =
  (typeof VerificationRequestsReportFormat)[keyof typeof VerificationRequestsReportFormat];
export type Verifier = {
  __typename?: 'Verifier';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['ID']['output']>;
  commercialName?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentialStatus: VerifierCredentialStatus;
  credentialedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialedTimes?: Maybe<Scalars['Decimal']['output']>;
  denialReason?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fEIN?: Maybe<Scalars['String']['output']>;
  firstAdminRegisteredAt?: Maybe<Scalars['DateTime']['output']>;
  governmentEntityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  integrationsCount: Scalars['Int']['output'];
  integrationsList: Array<Integration>;
  legalBusinessName?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<File>;
  logoId?: Maybe<Scalars['ID']['output']>;
  middeskBusinessId?: Maybe<Scalars['String']['output']>;
  middeskDeniedAt?: Maybe<Scalars['DateTime']['output']>;
  permissiblePurposesCount: Scalars['Int']['output'];
  permissiblePurposesList: Array<PermissiblePurpose>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<VerifierType>;
  typeOfGovernment?: Maybe<VerifierTypeOfGovernment>;
  updatedAt: Scalars['DateTime']['output'];
  verifierBilling?: Maybe<VerifierBilling>;
  verifierStaffsCount: Scalars['Int']['output'];
  verifierStaffsList: Array<VerifierStaff>;
  websiteURL?: Maybe<Scalars['String']['output']>;
};

export type VerifierIntegrationsCountArgs = {
  where?: InputMaybe<IntegrationWhere>;
};

export type VerifierIntegrationsListArgs = {
  orderBy?: InputMaybe<Array<IntegrationOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntegrationWhere>;
};

export type VerifierPermissiblePurposesCountArgs = {
  where?: InputMaybe<PermissiblePurposeWhere>;
};

export type VerifierPermissiblePurposesListArgs = {
  orderBy?: InputMaybe<Array<PermissiblePurposeOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PermissiblePurposeWhere>;
};

export type VerifierVerifierStaffsCountArgs = {
  where?: InputMaybe<VerifierStaffWhere>;
};

export type VerifierVerifierStaffsListArgs = {
  orderBy?: InputMaybe<Array<VerifierStaffOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerifierStaffWhere>;
};

export type VerifierAddressData = {
  __typename?: 'VerifierAddressData';
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type VerifierAdminAddressData = {
  city: Scalars['String']['input'];
  county?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type VerifierAdminUserData = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type VerifierAdminVerifierData = {
  address: VerifierAdminAddressData;
  avatarImageFile?: InputMaybe<Scalars['FileUpload']['input']>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  companyDisplayName: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactEmail: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  fein: Scalars['String']['input'];
  governmentDepartment?: InputMaybe<Scalars['String']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  governmentType?: InputMaybe<VerifierTypeOfGovernment>;
  industry: Scalars['String']['input'];
  permissiblePurposeReferenceId: Scalars['ID']['input'];
  registeredBusinessName?: InputMaybe<Scalars['String']['input']>;
  type: VerifierType;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierBasicItem = {
  __typename?: 'VerifierBasicItem';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type VerifierBilling = {
  __typename?: 'VerifierBilling';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reverification: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verifier: Verifier;
  verifierId: Scalars['ID']['output'];
  voE: Scalars['Int']['output'];
  voI: Scalars['Int']['output'];
};

export type VerifierBillingCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  reverification: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifier: VerifierCreateRelationWithoutVerifierBilling;
  voE: Scalars['Int']['input'];
  voI: Scalars['Int']['input'];
};

export type VerifierBillingCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  reverification: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierId: Scalars['ID']['input'];
  voE: Scalars['Int']['input'];
  voI: Scalars['Int']['input'];
};

export type VerifierBillingCreateRelationWithoutVerifier = {
  connect?: InputMaybe<VerifierBillingWhereUnique>;
  create?: InputMaybe<VerifierBillingCreateWithoutVerifier>;
};

export type VerifierBillingCreateWithoutVerifier = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  reverification: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voE: Scalars['Int']['input'];
  voI: Scalars['Int']['input'];
};

export type VerifierBillingOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reverification?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verifier?: InputMaybe<VerifierOrderBy>;
  verifierId?: InputMaybe<SortOrder>;
  voE?: InputMaybe<SortOrder>;
  voI?: InputMaybe<SortOrder>;
};

export type VerifierBillingUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  reverification?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifier?: InputMaybe<VerifierUpdateRelationWithoutVerifierBilling>;
  voE?: InputMaybe<Scalars['Int']['input']>;
  voI?: InputMaybe<Scalars['Int']['input']>;
};

export type VerifierBillingUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  reverification?: InputMaybe<IntUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  verifierId?: InputMaybe<IdUpdate>;
  voE?: InputMaybe<IntUpdate>;
  voI?: InputMaybe<IntUpdate>;
};

export type VerifierBillingUpdateRelationWithoutVerifier = {
  connect?: InputMaybe<VerifierBillingWhereUnique>;
  create?: InputMaybe<VerifierBillingCreateWithoutVerifier>;
  disconnect?: InputMaybe<VerifierBillingWhereUnique>;
  update?: InputMaybe<VerifierBillingUpdateWithoutVerifier>;
};

export type VerifierBillingUpdateWithoutVerifier = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  reverification?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voE?: InputMaybe<Scalars['Int']['input']>;
  voI?: InputMaybe<Scalars['Int']['input']>;
};

export type VerifierBillingWhere = {
  AND?: InputMaybe<Array<VerifierBillingWhere>>;
  NOT?: InputMaybe<Array<VerifierBillingWhere>>;
  OR?: InputMaybe<Array<VerifierBillingWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  reverification?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verifier?: InputMaybe<VerifierWhere>;
  verifierId?: InputMaybe<IdFilter>;
  voE?: InputMaybe<IntFilter>;
  voI?: InputMaybe<IntFilter>;
};

export type VerifierBillingWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  verifierId?: InputMaybe<Scalars['ID']['input']>;
};

export type VerifierCreate = {
  address?: InputMaybe<AddressCreateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationCreateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeCreateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingCreateRelationWithoutVerifier>;
  verifierStaffs?: InputMaybe<VerifierStaffCreateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierCreateMany = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierCreateRelationListWithoutLogo = {
  connect?: InputMaybe<Array<VerifierWhereUnique>>;
  create?: InputMaybe<Array<VerifierCreateWithoutLogo>>;
};

export type VerifierCreateRelationWithoutAddress = {
  connect?: InputMaybe<VerifierWhereUnique>;
  create?: InputMaybe<VerifierCreateWithoutAddress>;
};

export type VerifierCreateRelationWithoutIntegrations = {
  connect?: InputMaybe<VerifierWhereUnique>;
  create?: InputMaybe<VerifierCreateWithoutIntegrations>;
};

export type VerifierCreateRelationWithoutPermissiblePurposes = {
  connect?: InputMaybe<VerifierWhereUnique>;
  create?: InputMaybe<VerifierCreateWithoutPermissiblePurposes>;
};

export type VerifierCreateRelationWithoutVerifierBilling = {
  connect?: InputMaybe<VerifierWhereUnique>;
  create?: InputMaybe<VerifierCreateWithoutVerifierBilling>;
};

export type VerifierCreateRelationWithoutVerifierStaffs = {
  connect?: InputMaybe<VerifierWhereUnique>;
  create?: InputMaybe<VerifierCreateWithoutVerifierStaffs>;
};

export type VerifierCreateWithoutAddress = {
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationCreateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeCreateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingCreateRelationWithoutVerifier>;
  verifierStaffs?: InputMaybe<VerifierStaffCreateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierCreateWithoutIntegrations = {
  address?: InputMaybe<AddressCreateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeCreateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingCreateRelationWithoutVerifier>;
  verifierStaffs?: InputMaybe<VerifierStaffCreateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierCreateWithoutLogo = {
  address?: InputMaybe<AddressCreateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationCreateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeCreateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingCreateRelationWithoutVerifier>;
  verifierStaffs?: InputMaybe<VerifierStaffCreateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierCreateWithoutPermissiblePurposes = {
  address?: InputMaybe<AddressCreateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationCreateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingCreateRelationWithoutVerifier>;
  verifierStaffs?: InputMaybe<VerifierStaffCreateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierCreateWithoutVerifierBilling = {
  address?: InputMaybe<AddressCreateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationCreateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeCreateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaffs?: InputMaybe<VerifierStaffCreateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierCreateWithoutVerifierStaffs = {
  address?: InputMaybe<AddressCreateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationCreateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeCreateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingCreateRelationWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export const VerifierCredentialStatus = {
  AwaitingApprovalByCv: 'Awaiting_Approval_By_CV',
  Credentialed: 'Credentialed',
  Denied: 'Denied',
  DeniedByMiddesk: 'Denied_By_Middesk',
  MiddeskPending: 'Middesk_Pending',
  NotCredentialed: 'Not_Credentialed',
  Referred: 'Referred',
} as const;

export type VerifierCredentialStatus =
  (typeof VerifierCredentialStatus)[keyof typeof VerifierCredentialStatus];
export type VerifierCredentialStatusFilter = {
  equals?: InputMaybe<VerifierCredentialStatus>;
  in?: InputMaybe<Array<VerifierCredentialStatus>>;
  not?: InputMaybe<VerifierCredentialStatusFilter>;
  notIn?: InputMaybe<Array<VerifierCredentialStatus>>;
};

export type VerifierCredentialStatusUpdate = {
  set?: InputMaybe<VerifierCredentialStatus>;
};

export type VerifierInfoByApiVerificationRequest = {
  __typename?: 'VerifierInfoByApiVerificationRequest';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  credentialStatus: VerifierCredentialStatus;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<FileResponse>;
  type?: Maybe<VerifierType>;
};

export type VerifierInfoByVerificationRequest = {
  __typename?: 'VerifierInfoByVerificationRequest';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  credentialStatus: VerifierCredentialStatus;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<FileResponse>;
  type?: Maybe<VerifierType>;
};

export type VerifierItem = {
  __typename?: 'VerifierItem';
  address?: Maybe<VerifierAddressData>;
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<FileResponse>;
  type?: Maybe<VerifierType>;
};

export type VerifierManagerUserData = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type VerifierOrderBy = {
  address?: InputMaybe<AddressOrderBy>;
  addressId?: InputMaybe<SortOrderInput>;
  commercialName?: InputMaybe<SortOrderInput>;
  contactEmail?: InputMaybe<SortOrderInput>;
  contactPhone?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  credentialStatus?: InputMaybe<SortOrder>;
  credentialedAt?: InputMaybe<SortOrderInput>;
  credentialedTimes?: InputMaybe<SortOrderInput>;
  denialReason?: InputMaybe<SortOrderInput>;
  department?: InputMaybe<SortOrderInput>;
  displayName?: InputMaybe<SortOrderInput>;
  fEIN?: InputMaybe<SortOrderInput>;
  firstAdminRegisteredAt?: InputMaybe<SortOrderInput>;
  governmentEntityName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  industry?: InputMaybe<SortOrderInput>;
  legalBusinessName?: InputMaybe<SortOrderInput>;
  logo?: InputMaybe<FileOrderBy>;
  logoId?: InputMaybe<SortOrderInput>;
  middeskBusinessId?: InputMaybe<SortOrderInput>;
  middeskDeniedAt?: InputMaybe<SortOrderInput>;
  stripeCustomerId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  typeOfGovernment?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verifierBilling?: InputMaybe<VerifierBillingOrderBy>;
  websiteURL?: InputMaybe<SortOrderInput>;
};

export type VerifierStaff = {
  __typename?: 'VerifierStaff';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: VerifierStaffRole;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  verificationRequestsCount: Scalars['Int']['output'];
  verificationRequestsList: Array<VerificationRequest>;
  verifier: Verifier;
  verifierId: Scalars['ID']['output'];
};

export type VerifierStaffVerificationRequestsCountArgs = {
  where?: InputMaybe<VerificationRequestWhere>;
};

export type VerifierStaffVerificationRequestsListArgs = {
  orderBy?: InputMaybe<Array<VerificationRequestOrderBy>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerificationRequestWhere>;
};

export type VerifierStaffCreate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<VerifierStaffRole>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutVerifierStaff;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutVerifierStaff>;
  verifier: VerifierCreateRelationWithoutVerifierStaffs;
};

export type VerifierStaffCreateMany = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<VerifierStaffRole>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
  verifierId: Scalars['ID']['input'];
};

export type VerifierStaffCreateRelationListWithoutVerifier = {
  connect?: InputMaybe<Array<VerifierStaffWhereUnique>>;
  create?: InputMaybe<Array<VerifierStaffCreateWithoutVerifier>>;
};

export type VerifierStaffCreateRelationWithoutUser = {
  connect?: InputMaybe<VerifierStaffWhereUnique>;
  create?: InputMaybe<VerifierStaffCreateWithoutUser>;
};

export type VerifierStaffCreateRelationWithoutVerificationRequests = {
  connect?: InputMaybe<VerifierStaffWhereUnique>;
  create?: InputMaybe<VerifierStaffCreateWithoutVerificationRequests>;
};

export type VerifierStaffCreateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<VerifierStaffRole>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutVerifierStaff>;
  verifier: VerifierCreateRelationWithoutVerifierStaffs;
};

export type VerifierStaffCreateWithoutVerificationRequests = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<VerifierStaffRole>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutVerifierStaff;
  verifier: VerifierCreateRelationWithoutVerifierStaffs;
};

export type VerifierStaffCreateWithoutVerifier = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<VerifierStaffRole>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateRelationWithoutVerifierStaff;
  verificationRequests?: InputMaybe<VerificationRequestCreateRelationListWithoutVerifierStaff>;
};

export type VerifierStaffOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<SortOrder>;
  verifier?: InputMaybe<VerifierOrderBy>;
  verifierId?: InputMaybe<SortOrder>;
};

export const VerifierStaffRole = {
  VerifierAdmin: 'Verifier_Admin',
  VerifierManager: 'Verifier_Manager',
} as const;

export type VerifierStaffRole = (typeof VerifierStaffRole)[keyof typeof VerifierStaffRole];
export type VerifierStaffRoleFilter = {
  equals?: InputMaybe<VerifierStaffRole>;
  in?: InputMaybe<Array<VerifierStaffRole>>;
  not?: InputMaybe<VerifierStaffRoleFilter>;
  notIn?: InputMaybe<Array<VerifierStaffRole>>;
};

export type VerifierStaffUpdate = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutVerifierStaff>;
};

export type VerifierStaffUpdateMany = {
  createdAt?: InputMaybe<DateTimeUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
};

export type VerifierStaffUpdateRelationListWithoutVerifier = {
  connect?: InputMaybe<Array<VerifierStaffWhereUnique>>;
  create?: InputMaybe<Array<VerifierStaffCreateWithoutVerifier>>;
  disconnect?: InputMaybe<Array<VerifierStaffWhereUnique>>;
  set?: InputMaybe<Array<VerifierStaffWhereUnique>>;
};

export type VerifierStaffUpdateRelationWithoutUser = {
  connect?: InputMaybe<VerifierStaffWhereUnique>;
  create?: InputMaybe<VerifierStaffCreateWithoutUser>;
  disconnect?: InputMaybe<VerifierStaffWhereUnique>;
  update?: InputMaybe<VerifierStaffUpdateWithoutUser>;
};

export type VerifierStaffUpdateRelationWithoutVerificationRequests = {
  connect?: InputMaybe<VerifierStaffWhereUnique>;
  create?: InputMaybe<VerifierStaffCreateWithoutVerificationRequests>;
  disconnect?: InputMaybe<VerifierStaffWhereUnique>;
  update?: InputMaybe<VerifierStaffUpdateWithoutVerificationRequests>;
};

export type VerifierStaffUpdateWithoutUser = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationRequests?: InputMaybe<VerificationRequestUpdateRelationListWithoutVerifierStaff>;
};

export type VerifierStaffUpdateWithoutVerificationRequests = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerifierStaffWhere = {
  AND?: InputMaybe<Array<VerifierStaffWhere>>;
  NOT?: InputMaybe<Array<VerifierStaffWhere>>;
  OR?: InputMaybe<Array<VerifierStaffWhere>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  role?: InputMaybe<VerifierStaffRoleFilter>;
  stripeCustomerId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserWhere>;
  userId?: InputMaybe<IdFilter>;
  verificationRequests?: InputMaybe<VerificationRequestWhereRelationList>;
  verifier?: InputMaybe<VerifierWhere>;
  verifierId?: InputMaybe<IdFilter>;
};

export type VerifierStaffWhereRelationList = {
  every?: InputMaybe<VerifierStaffWhere>;
  none?: InputMaybe<VerifierStaffWhere>;
  some?: InputMaybe<VerifierStaffWhere>;
};

export type VerifierStaffWhereUnique = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export const VerifierType = {
  Commercial: 'Commercial',
  Government: 'Government',
} as const;

export type VerifierType = (typeof VerifierType)[keyof typeof VerifierType];
export type VerifierTypeFilter = {
  equals?: InputMaybe<VerifierType>;
  in?: InputMaybe<Array<VerifierType>>;
  not?: InputMaybe<VerifierTypeFilter>;
  notIn?: InputMaybe<Array<VerifierType>>;
};

export const VerifierTypeOfGovernment = {
  Federal: 'Federal',
  Local: 'Local',
  State: 'State',
} as const;

export type VerifierTypeOfGovernment =
  (typeof VerifierTypeOfGovernment)[keyof typeof VerifierTypeOfGovernment];
export type VerifierTypeOfGovernmentFilter = {
  equals?: InputMaybe<VerifierTypeOfGovernment>;
  in?: InputMaybe<Array<VerifierTypeOfGovernment>>;
  not?: InputMaybe<VerifierTypeOfGovernmentFilter>;
  notIn?: InputMaybe<Array<VerifierTypeOfGovernment>>;
};

export type VerifierTypeOfGovernmentUpdate = {
  set?: InputMaybe<VerifierTypeOfGovernment>;
};

export type VerifierTypeUpdate = {
  set?: InputMaybe<VerifierType>;
};

export type VerifierUpdate = {
  address?: InputMaybe<AddressUpdateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationUpdateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeUpdateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingUpdateRelationWithoutVerifier>;
  verifierStaffs?: InputMaybe<VerifierStaffUpdateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierUpdateMany = {
  addressId?: InputMaybe<IdUpdate>;
  commercialName?: InputMaybe<StringUpdate>;
  contactEmail?: InputMaybe<StringUpdate>;
  contactPhone?: InputMaybe<StringUpdate>;
  createdAt?: InputMaybe<DateTimeUpdate>;
  credentialStatus?: InputMaybe<VerifierCredentialStatusUpdate>;
  credentialedAt?: InputMaybe<DateTimeUpdate>;
  credentialedTimes?: InputMaybe<DecimalUpdate>;
  denialReason?: InputMaybe<StringUpdate>;
  department?: InputMaybe<StringUpdate>;
  displayName?: InputMaybe<StringUpdate>;
  fEIN?: InputMaybe<StringUpdate>;
  firstAdminRegisteredAt?: InputMaybe<DateTimeUpdate>;
  governmentEntityName?: InputMaybe<StringUpdate>;
  industry?: InputMaybe<StringUpdate>;
  legalBusinessName?: InputMaybe<StringUpdate>;
  logoId?: InputMaybe<IdUpdate>;
  middeskBusinessId?: InputMaybe<StringUpdate>;
  middeskDeniedAt?: InputMaybe<DateTimeUpdate>;
  stripeCustomerId?: InputMaybe<StringUpdate>;
  type?: InputMaybe<VerifierTypeUpdate>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernmentUpdate>;
  updatedAt?: InputMaybe<DateTimeUpdate>;
  websiteURL?: InputMaybe<StringUpdate>;
};

export type VerifierUpdateRelationListWithoutLogo = {
  connect?: InputMaybe<Array<VerifierWhereUnique>>;
  create?: InputMaybe<Array<VerifierCreateWithoutLogo>>;
  disconnect?: InputMaybe<Array<VerifierWhereUnique>>;
  set?: InputMaybe<Array<VerifierWhereUnique>>;
};

export type VerifierUpdateRelationWithoutAddress = {
  connect?: InputMaybe<VerifierWhereUnique>;
  create?: InputMaybe<VerifierCreateWithoutAddress>;
  disconnect?: InputMaybe<VerifierWhereUnique>;
  update?: InputMaybe<VerifierUpdateWithoutAddress>;
};

export type VerifierUpdateRelationWithoutIntegrations = {
  connect?: InputMaybe<VerifierWhereUnique>;
  create?: InputMaybe<VerifierCreateWithoutIntegrations>;
  disconnect?: InputMaybe<VerifierWhereUnique>;
  update?: InputMaybe<VerifierUpdateWithoutIntegrations>;
};

export type VerifierUpdateRelationWithoutPermissiblePurposes = {
  connect?: InputMaybe<VerifierWhereUnique>;
  create?: InputMaybe<VerifierCreateWithoutPermissiblePurposes>;
  disconnect?: InputMaybe<VerifierWhereUnique>;
  update?: InputMaybe<VerifierUpdateWithoutPermissiblePurposes>;
};

export type VerifierUpdateRelationWithoutVerifierBilling = {
  connect?: InputMaybe<VerifierWhereUnique>;
  create?: InputMaybe<VerifierCreateWithoutVerifierBilling>;
  disconnect?: InputMaybe<VerifierWhereUnique>;
  update?: InputMaybe<VerifierUpdateWithoutVerifierBilling>;
};

export type VerifierUpdateWithoutAddress = {
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationUpdateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeUpdateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingUpdateRelationWithoutVerifier>;
  verifierStaffs?: InputMaybe<VerifierStaffUpdateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierUpdateWithoutIntegrations = {
  address?: InputMaybe<AddressUpdateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeUpdateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingUpdateRelationWithoutVerifier>;
  verifierStaffs?: InputMaybe<VerifierStaffUpdateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierUpdateWithoutPermissiblePurposes = {
  address?: InputMaybe<AddressUpdateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationUpdateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierBilling?: InputMaybe<VerifierBillingUpdateRelationWithoutVerifier>;
  verifierStaffs?: InputMaybe<VerifierStaffUpdateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierUpdateWithoutVerifierBilling = {
  address?: InputMaybe<AddressUpdateRelationWithoutVerifier>;
  commercialName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialStatus?: InputMaybe<VerifierCredentialStatus>;
  credentialedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialedTimes?: InputMaybe<Scalars['Decimal']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fEIN?: InputMaybe<Scalars['String']['input']>;
  firstAdminRegisteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  governmentEntityName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationUpdateRelationListWithoutVerifier>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileUpdateRelationWithoutVerifierLogos>;
  middeskBusinessId?: InputMaybe<Scalars['String']['input']>;
  middeskDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeUpdateRelationListWithoutVerifier>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VerifierType>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernment>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifierStaffs?: InputMaybe<VerifierStaffUpdateRelationListWithoutVerifier>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type VerifierWhere = {
  AND?: InputMaybe<Array<VerifierWhere>>;
  NOT?: InputMaybe<Array<VerifierWhere>>;
  OR?: InputMaybe<Array<VerifierWhere>>;
  address?: InputMaybe<AddressWhere>;
  addressId?: InputMaybe<IdFilter>;
  commercialName?: InputMaybe<StringFilter>;
  contactEmail?: InputMaybe<StringFilter>;
  contactPhone?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentialStatus?: InputMaybe<VerifierCredentialStatusFilter>;
  credentialedAt?: InputMaybe<DateTimeFilter>;
  credentialedTimes?: InputMaybe<DecimalFilter>;
  denialReason?: InputMaybe<StringFilter>;
  department?: InputMaybe<StringFilter>;
  displayName?: InputMaybe<StringFilter>;
  fEIN?: InputMaybe<StringFilter>;
  firstAdminRegisteredAt?: InputMaybe<DateTimeFilter>;
  governmentEntityName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  industry?: InputMaybe<StringFilter>;
  integrations?: InputMaybe<IntegrationWhereRelationList>;
  legalBusinessName?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileWhere>;
  logoId?: InputMaybe<IdFilter>;
  middeskBusinessId?: InputMaybe<StringFilter>;
  middeskDeniedAt?: InputMaybe<DateTimeFilter>;
  permissiblePurposes?: InputMaybe<PermissiblePurposeWhereRelationList>;
  stripeCustomerId?: InputMaybe<StringFilter>;
  type?: InputMaybe<VerifierTypeFilter>;
  typeOfGovernment?: InputMaybe<VerifierTypeOfGovernmentFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verifierBilling?: InputMaybe<VerifierBillingWhere>;
  verifierStaffs?: InputMaybe<VerifierStaffWhereRelationList>;
  websiteURL?: InputMaybe<StringFilter>;
};

export type VerifierWhereRelationList = {
  every?: InputMaybe<VerifierWhere>;
  none?: InputMaybe<VerifierWhere>;
  some?: InputMaybe<VerifierWhere>;
};

export type VerifierWhereUnique = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};
